import { inject as ge, ref as A, computed as E, defineComponent as z, toRefs as at, openBlock as f, createElementBlock as y, normalizeClass as O, Fragment as K, createTextVNode as ce, toDisplayString as R, createBlock as j, resolveDynamicComponent as Le, renderSlot as G, createCommentVNode as P, createElementVNode as m, unref as T, shallowRef as zr, watch as he, triggerRef as Mi, onScopeDispose as Fs, watchEffect as $e, onMounted as ae, cloneVNode as Hs, h as oe, provide as xe, reactive as Nr, onUnmounted as Me, nextTick as ke, toRaw as we, getCurrentInstance as vo, Teleport as jr, createVNode as B, withCtx as F, normalizeStyle as De, withDirectives as ze, mergeProps as _t, vModelText as rn, renderList as se, Transition as Gt, useSlots as Kt, readonly as fu, getCurrentScope as hu, isRef as mo, createStaticVNode as vu, resolveComponent as ne, vShow as At, withModifiers as ft, onUpdated as Us, useAttrs as Ws, vModelCheckbox as mu, vModelRadio as gu, withKeys as Yo, createSlots as bu } from "vue";
const Vt = (e) => e.target.value, qs = (e) => {
  const t = e.target;
  return t.checked ? t.value : "";
}, yu = (e) => {
  const t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? {
    r: parseInt(t[1], 16),
    g: parseInt(t[2], 16),
    b: parseInt(t[3], 16)
  } : null;
}, W = (e) => {
  const t = ge("$themeColor") || A("blue"), { type: n, value: o, prefix: r, forceHover: i, variant: s } = e;
  return t.value === "primary" || t.value === "secondary" ? s && (s === "primary" || s === "secondary") ? `${r ? `${r}:` : ""}${n}-${r === "hover" && !i ? `${s}Hover` : s}` : s ? `${r ? `${r}:` : ""}${n}-${s || t.value}-${o}` : `${r ? `${r}:` : ""}${n}-${r === "hover" && !i ? `${t.value}Hover` : t.value}` : `${r ? `${r}:` : ""}${n}-${s || t.value}-${o}`;
};
function wu({
  disabled: e,
  outlined: t,
  white: n,
  light: o,
  ghost: r,
  isFixed: i,
  variant: s,
  variantShade: a,
  isText: l
}) {
  return {
    classes: E(() => {
      let c = l.value ? `${W({
        type: "text",
        value: "800",
        variant: s.value
      })} ${W({
        type: "text",
        value: "600",
        variant: s.value,
        prefix: "hover"
      })}` : `text-white ${W({
        type: "bg",
        value: "800",
        variant: s.value
      })} ${W({
        type: "bg",
        value: "600",
        prefix: "hover",
        variant: s.value
      })} ${W({ type: "ring", value: "600", prefix: "focus", variant: s.value })}`;
      return e.value && !l.value && (c = "text-white bg-gray-300 focus:ring-gray-500"), t.value && (c = `bg-white border ${W({
        type: "border",
        value: a.value,
        variant: s.value
      })} ${W({
        type: "text",
        value: a.value,
        variant: s.value
      })} ${W({
        type: "bg",
        value: a.value,
        prefix: "hover",
        forceHover: !0,
        variant: s.value
      })} ${W({
        type: "border",
        value: a.value,
        prefix: "hover",
        variant: s.value
      })} hover:!text-white
      ${W({ type: "ring", value: a.value, prefix: "focus", variant: s.value })}`), n.value && (c = `bg-white border-gray-300 hover:bg-gray-50 ${W({
        type: "ring",
        value: "500",
        prefix: "focus",
        variant: s.value
      })} text-gray-700`), o.value && (c = `${W({ type: "bg", value: "200" })} border-gray-300 hover:bg-gray-50 ${W({
        type: "ring",
        value: "800",
        prefix: "focus",
        variant: s.value
      })} ${W({ type: "text", value: "700" })}`), i.value && (c = `${c} fixed sm:static bottom-0 left-0 w-screen rounded-none sm:w-auto py-4 sm:py-2 sm:rounded-md`), r.value ? c = `border-transparent ${W({
        type: "text",
        value: "800",
        variant: s.value
      })} ${W({
        type: "bg",
        value: "50",
        prefix: "hover",
        forceHover: !0,
        variant: s.value
      })}` : c = `${c} focus:ring-2 focus:ring-offset-2`, c;
    })
  };
}
const xu = z({
  props: {
    outlined: {
      type: Boolean,
      default: !1
    },
    disabled: Boolean,
    processingLabel: {
      type: String,
      default: null
    },
    isFixed: {
      type: Boolean,
      default: !1
    },
    processing: {
      type: Boolean,
      default: !1
    },
    white: {
      type: Boolean,
      default: !1
    },
    light: {
      type: Boolean,
      default: !1
    },
    ghost: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: null
    },
    variantShade: {
      type: String,
      default: "800"
    },
    roundedSize: {
      type: String,
      default: "rounded-md"
    },
    type: {
      type: String,
      default: "button"
    },
    icon: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Function,
      default: null
    },
    isText: {
      type: Boolean,
      default: !1
    }
  },
  setup(e, t) {
    const { classes: n } = wu(at(e)), o = !!t.slots["icon-left"], r = !!t.slots["icon-right"], i = E(() => e.icon ? "p-2" : e.isText ? "px-0 py-2" : "py-2 px-5"), s = E(() => `inline-flex justify-center border px-5 py-2 shadow-sm ${e.roundedSize} ${W({ type: "bg", value: "800" })} text-base font-medium text-white ${W({ type: "bg", value: "600", prefix: "hover" })} focus:outline-none focus:ring-2 focus:ring-offset-2 ${W(
      {
        type: "ring",
        value: "800",
        prefix: "focus"
      }
    )} sm:col-start-2 sm:text-sm`);
    return {
      classes: n,
      hasIconLeft: o,
      hasIconRight: r,
      getColorClass: W,
      shapeClass: i,
      processingClass: s
    };
  }
}), Ee = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, $u = ["disabled", "type"], Cu = /* @__PURE__ */ m("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1), Su = /* @__PURE__ */ m("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1), ku = [
  Cu,
  Su
], Eu = {
  key: 0,
  class: "mr-2"
}, Ou = {
  key: 1,
  class: "ml-2"
};
function Au(e, t, n, o, r, i) {
  return f(), y("button", {
    disabled: e.disabled || e.processing,
    class: O(["inline-flex items-center justify-center text-sm font-medium focus:outline-none", [e.processing ? e.processingClass : e.classes, e.shapeClass, e.roundedSize]]),
    type: e.type
  }, [
    e.processing ? (f(), y(K, { key: 0 }, [
      (f(), y("svg", {
        class: O(["h-5 w-5 animate-spin text-white", e.processingLabel && "-ml-1 mr-3"]),
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
      }, ku, 2)),
      ce(" " + R(e.processingLabel), 1)
    ], 64)) : e.icon ? (f(), j(Le(e.icon), {
      key: 1,
      class: "h-5 w-5"
    })) : e.hasIconLeft || e.hasIconRight ? (f(), y(K, { key: 2 }, [
      e.hasIconLeft ? (f(), y("span", Eu, [
        G(e.$slots, "icon-left")
      ])) : P("", !0),
      G(e.$slots, "default"),
      e.hasIconRight ? (f(), y("span", Ou, [
        G(e.$slots, "icon-right")
      ])) : P("", !0)
    ], 64)) : G(e.$slots, "default", { key: 3 })
  ], 10, $u);
}
const rt = /* @__PURE__ */ Ee(xu, [["render", Au]]);
function _u(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M17 2.75a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5ZM17 15.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5ZM3.75 15a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75ZM4.5 2.75a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0v-5.5ZM10 11a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0v-5.5A.75.75 0 0 1 10 11ZM10.75 2.75a.75.75 0 0 0-1.5 0v1.5a.75.75 0 0 0 1.5 0v-1.5ZM10 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM3.75 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM16.25 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" })
  ]);
}
function Ti(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M17 10a.75.75 0 0 1-.75.75H5.612l4.158 3.96a.75.75 0 1 1-1.04 1.08l-5.5-5.25a.75.75 0 0 1 0-1.08l5.5-5.25a.75.75 0 1 1 1.04 1.08L5.612 9.25H16.25A.75.75 0 0 1 17 10Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Zs(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M2 10a.75.75 0 0 1 .75-.75h12.59l-2.1-1.95a.75.75 0 1 1 1.02-1.1l3.5 3.25a.75.75 0 0 1 0 1.1l-3.5 3.25a.75.75 0 1 1-1.02-1.1l2.1-1.95H2.75A.75.75 0 0 1 2 10Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Ru(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M3 10a.75.75 0 0 1 .75-.75h10.638L10.23 5.29a.75.75 0 1 1 1.04-1.08l5.5 5.25a.75.75 0 0 1 0 1.08l-5.5 5.25a.75.75 0 1 1-1.04-1.08l4.158-3.96H3.75A.75.75 0 0 1 3 10Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Mu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M4.25 5.5a.75.75 0 0 0-.75.75v8.5c0 .414.336.75.75.75h8.5a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 1 1.5 0v4A2.25 2.25 0 0 1 12.75 17h-8.5A2.25 2.25 0 0 1 2 14.75v-8.5A2.25 2.25 0 0 1 4.25 4h5a.75.75 0 0 1 0 1.5h-5Z",
      "clip-rule": "evenodd"
    }),
    m("path", {
      "fill-rule": "evenodd",
      d: "M6.194 12.753a.75.75 0 0 0 1.06.053L16.5 4.44v2.81a.75.75 0 0 0 1.5 0v-4.5a.75.75 0 0 0-.75-.75h-4.5a.75.75 0 0 0 0 1.5h2.553l-9.056 8.194a.75.75 0 0 0-.053 1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Pi(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M2.24 6.8a.75.75 0 0 0 1.06-.04l1.95-2.1v8.59a.75.75 0 0 0 1.5 0V4.66l1.95 2.1a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0L2.2 5.74a.75.75 0 0 0 .04 1.06Zm8 6.4a.75.75 0 0 0-.04 1.06l3.25 3.5a.75.75 0 0 0 1.1 0l3.25-3.5a.75.75 0 1 0-1.1-1.02l-1.95 2.1V6.75a.75.75 0 0 0-1.5 0v8.59l-1.95-2.1a.75.75 0 0 0-1.06-.04Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Tu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M11.983 1.907a.75.75 0 0 0-1.292-.657l-8.5 9.5A.75.75 0 0 0 2.75 12h6.572l-1.305 6.093a.75.75 0 0 0 1.292.657l8.5-9.5A.75.75 0 0 0 17.25 8h-6.572l1.305-6.093Z" })
  ]);
}
function Pu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M10 1c-1.716 0-3.408.106-5.07.31C3.806 1.45 3 2.414 3 3.517V16.75A2.25 2.25 0 0 0 5.25 19h9.5A2.25 2.25 0 0 0 17 16.75V3.517c0-1.103-.806-2.068-1.93-2.207A41.403 41.403 0 0 0 10 1ZM5.99 8.75A.75.75 0 0 1 6.74 8h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm-.75 2.916a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm1.417-5.75a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm-.75 2.916a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm1.42-5.75a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm-.75 2.916a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01ZM12.5 8.75a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-.75.75h-.01a.75.75 0 0 1-.75-.75v-.01Zm.75 1.417a.75.75 0 0 0-.75.75v.01c0 .414.336.75.75.75h.01a.75.75 0 0 0 .75-.75v-.01a.75.75 0 0 0-.75-.75h-.01Zm0 2.166a.75.75 0 0 1 .75.75v2.167a.75.75 0 1 1-1.5 0v-2.167a.75.75 0 0 1 .75-.75ZM6.75 4a.75.75 0 0 0-.75.75v.5c0 .414.336.75.75.75h6.5a.75.75 0 0 0 .75-.75v-.5a.75.75 0 0 0-.75-.75h-6.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Ii(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Iu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Gs(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Vr(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M10.53 3.47a.75.75 0 0 0-1.06 0L6.22 6.72a.75.75 0 0 0 1.06 1.06L10 5.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-3.25-3.25Zm-4.31 9.81 3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 1 0-1.06-1.06L10 14.94l-2.72-2.72a.75.75 0 0 0-1.06 1.06Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Lu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M9.47 6.47a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 1 1-1.06 1.06L10 8.06l-3.72 3.72a.75.75 0 0 1-1.06-1.06l4.25-4.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Du(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M13.887 3.182c.396.037.79.08 1.183.128C16.194 3.45 17 4.414 17 5.517V16.75A2.25 2.25 0 0 1 14.75 19h-9.5A2.25 2.25 0 0 1 3 16.75V5.517c0-1.103.806-2.068 1.93-2.207.393-.048.787-.09 1.183-.128A3.001 3.001 0 0 1 9 1h2c1.373 0 2.531.923 2.887 2.182ZM7.5 4A1.5 1.5 0 0 1 9 2.5h2A1.5 1.5 0 0 1 12.5 4v.5h-5V4Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Bu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M13.024 9.25c.47 0 .827-.433.637-.863a4 4 0 0 0-4.094-2.364c-.468.05-.665.576-.43.984l1.08 1.868a.75.75 0 0 0 .649.375h2.158ZM7.84 7.758c-.236-.408-.79-.5-1.068-.12A3.982 3.982 0 0 0 6 10c0 .884.287 1.7.772 2.363.278.38.832.287 1.068-.12l1.078-1.868a.75.75 0 0 0 0-.75L7.839 7.758ZM9.138 12.993c-.235.408-.039.934.43.984a4 4 0 0 0 4.094-2.364c.19-.43-.168-.863-.638-.863h-2.158a.75.75 0 0 0-.65.375l-1.078 1.868Z" }),
    m("path", {
      "fill-rule": "evenodd",
      d: "m14.13 4.347.644-1.117a.75.75 0 0 0-1.299-.75l-.644 1.116a6.954 6.954 0 0 0-2.081-.556V1.75a.75.75 0 0 0-1.5 0v1.29a6.954 6.954 0 0 0-2.081.556L6.525 2.48a.75.75 0 1 0-1.3.75l.645 1.117A7.04 7.04 0 0 0 4.347 5.87L3.23 5.225a.75.75 0 1 0-.75 1.3l1.116.644A6.954 6.954 0 0 0 3.04 9.25H1.75a.75.75 0 0 0 0 1.5h1.29c.078.733.27 1.433.556 2.081l-1.116.645a.75.75 0 1 0 .75 1.298l1.117-.644a7.04 7.04 0 0 0 1.523 1.523l-.645 1.117a.75.75 0 1 0 1.3.75l.644-1.116a6.954 6.954 0 0 0 2.081.556v1.29a.75.75 0 0 0 1.5 0v-1.29a6.954 6.954 0 0 0 2.081-.556l.645 1.116a.75.75 0 0 0 1.299-.75l-.645-1.117a7.042 7.042 0 0 0 1.523-1.523l1.117.644a.75.75 0 0 0 .75-1.298l-1.116-.645a6.954 6.954 0 0 0 .556-2.081h1.29a.75.75 0 0 0 0-1.5h-1.29a6.954 6.954 0 0 0-.556-2.081l1.116-.644a.75.75 0 0 0-.75-1.3l-1.117.645a7.04 7.04 0 0 0-1.524-1.523ZM10 4.5a5.475 5.475 0 0 0-2.781.754A5.527 5.527 0 0 0 5.22 7.277 5.475 5.475 0 0 0 4.5 10a5.475 5.475 0 0 0 .752 2.777 5.527 5.527 0 0 0 2.028 2.004c.802.458 1.73.719 2.72.719a5.474 5.474 0 0 0 2.78-.753 5.527 5.527 0 0 0 2.001-2.027c.458-.802.719-1.73.719-2.72a5.475 5.475 0 0 0-.753-2.78 5.528 5.528 0 0 0-2.028-2.002A5.475 5.475 0 0 0 10 4.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function zu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M3 4a2 2 0 0 0-2 2v1.161l8.441 4.221a1.25 1.25 0 0 0 1.118 0L19 7.162V6a2 2 0 0 0-2-2H3Z" }),
    m("path", { d: "m19 8.839-7.77 3.885a2.75 2.75 0 0 1-2.46 0L1 8.839V14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.839Z" })
  ]);
}
function Nu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M3.28 2.22a.75.75 0 0 0-1.06 1.06l14.5 14.5a.75.75 0 1 0 1.06-1.06l-1.745-1.745a10.029 10.029 0 0 0 3.3-4.38 1.651 1.651 0 0 0 0-1.185A10.004 10.004 0 0 0 9.999 3a9.956 9.956 0 0 0-4.744 1.194L3.28 2.22ZM7.752 6.69l1.092 1.092a2.5 2.5 0 0 1 3.374 3.373l1.091 1.092a4 4 0 0 0-5.557-5.557Z",
      "clip-rule": "evenodd"
    }),
    m("path", { d: "m10.748 13.93 2.523 2.523a9.987 9.987 0 0 1-3.27.547c-4.258 0-7.894-2.66-9.337-6.41a1.651 1.651 0 0 1 0-1.186A10.007 10.007 0 0 1 2.839 6.02L6.07 9.252a4 4 0 0 0 4.678 4.678Z" })
  ]);
}
function Ks(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z" }),
    m("path", {
      "fill-rule": "evenodd",
      d: "M.664 10.59a1.651 1.651 0 0 1 0-1.186A10.004 10.004 0 0 1 10 3c4.257 0 7.893 2.66 9.336 6.41.147.381.146.804 0 1.186A10.004 10.004 0 0 1 10 17c-4.257 0-7.893-2.66-9.336-6.41ZM14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function ju(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M14 6a2.5 2.5 0 0 0-4-3 2.5 2.5 0 0 0-4 3H3.25C2.56 6 2 6.56 2 7.25v.5C2 8.44 2.56 9 3.25 9h6V6h1.5v3h6C17.44 9 18 8.44 18 7.75v-.5C18 6.56 17.44 6 16.75 6H14Zm-1-1.5a1 1 0 0 1-1 1h-1v-1a1 1 0 1 1 2 0Zm-6 0a1 1 0 0 0 1 1h1v-1a1 1 0 0 0-2 0Z",
      "clip-rule": "evenodd"
    }),
    m("path", { d: "M9.25 10.5H3v4.75A2.75 2.75 0 0 0 5.75 18h3.5v-7.5ZM10.75 18v-7.5H17v4.75A2.75 2.75 0 0 1 14.25 18h-3.5Z" })
  ]);
}
function Vu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M9.293 2.293a1 1 0 0 1 1.414 0l7 7A1 1 0 0 1 17 11h-1v6a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-6H3a1 1 0 0 1-.707-1.707l7-7Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Fu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Hu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M9 3.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11ZM2 9a7 7 0 1 1 12.452 4.391l3.328 3.329a.75.75 0 1 1-1.06 1.06l-3.329-3.328A7 7 0 0 1 2 9Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Uu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "m2.695 14.762-1.262 3.155a.5.5 0 0 0 .65.65l3.155-1.262a4 4 0 0 0 1.343-.886L17.5 5.501a2.121 2.121 0 0 0-3-3L3.58 13.419a4 4 0 0 0-.885 1.343Z" })
  ]);
}
function Wu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M1 5.25A2.25 2.25 0 0 1 3.25 3h13.5A2.25 2.25 0 0 1 19 5.25v9.5A2.25 2.25 0 0 1 16.75 17H3.25A2.25 2.25 0 0 1 1 14.75v-9.5Zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-2.69l-2.22-2.219a.75.75 0 0 0-1.06 0l-1.91 1.909.47.47a.75.75 0 1 1-1.06 1.06L6.53 8.091a.75.75 0 0 0-1.06 0l-2.97 2.97ZM12 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function qu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm.75-11.25a.75.75 0 0 0-1.5 0v2.5h-2.5a.75.75 0 0 0 0 1.5h2.5v2.5a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5v-2.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Zu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z" })
  ]);
}
function Gu(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M2 4.25A2.25 2.25 0 0 1 4.25 2h6.5A2.25 2.25 0 0 1 13 4.25V5.5H9.25A3.75 3.75 0 0 0 5.5 9.25V13H4.25A2.25 2.25 0 0 1 2 10.75v-6.5Z" }),
    m("path", { d: "M9.25 7A2.25 2.25 0 0 0 7 9.25v6.5A2.25 2.25 0 0 0 9.25 18h6.5A2.25 2.25 0 0 0 18 15.75v-6.5A2.25 2.25 0 0 0 15.75 7h-6.5Z" })
  ]);
}
function Ku(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM8.28 7.22a.75.75 0 0 0-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 1 0 1.06 1.06L10 11.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L11.06 10l1.72-1.72a.75.75 0 0 0-1.06-1.06L10 8.94 8.28 7.22Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function bt(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M6.28 5.22a.75.75 0 0 0-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 1 0 1.06 1.06L10 11.06l3.72 3.72a.75.75 0 1 0 1.06-1.06L11.06 10l3.72-3.72a.75.75 0 0 0-1.06-1.06L10 8.94 6.28 5.22Z" })
  ]);
}
/**
 * vue-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function io() {
  return io = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, io.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function so() {
  return so = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, so.apply(this, arguments);
}
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function Jt(e, t, n) {
  var o, r = (o = n.initialDeps) != null ? o : [], i;
  return function() {
    var s;
    n.key && n.debug != null && n.debug() && (s = Date.now());
    var a = e(), l = a.length !== r.length || a.some(function(x, b) {
      return r[b] !== x;
    });
    if (!l)
      return i;
    r = a;
    var u;
    if (n.key && n.debug != null && n.debug() && (u = Date.now()), i = t.apply(void 0, a), n.key && n.debug != null && n.debug()) {
      var c = Math.round((Date.now() - s) * 100) / 100, d = Math.round((Date.now() - u) * 100) / 100, p = d / 16, v = function(b, h) {
        for (b = String(b); b.length < h; )
          b = " " + b;
        return b;
      };
      console.info("%c⏱ " + v(d, 5) + " /" + v(c, 5) + " ms", `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(` + Math.max(0, Math.min(120 - 120 * p, 120)) + "deg 100% 31%);", n == null ? void 0 : n.key);
    }
    return n == null || n.onChange == null || n.onChange(i), i;
  };
}
function Xo(e, t) {
  if (e === void 0)
    throw new Error("Unexpected undefined" + (t ? ": " + t : ""));
  return e;
}
var Yu = function(t, n) {
  return Math.abs(t - n) < 1;
};
/**
 * virtual-core
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
var Xu = function(t) {
  return t;
}, Qu = function(t) {
  for (var n = Math.max(t.startIndex - t.overscan, 0), o = Math.min(t.endIndex + t.overscan, t.count - 1), r = [], i = n; i <= o; i++)
    r.push(i);
  return r;
}, Ju = function(t, n) {
  var o = t.scrollElement;
  if (o) {
    var r = function(a) {
      var l = a.width, u = a.height;
      n({
        width: Math.round(l),
        height: Math.round(u)
      });
    };
    r(o.getBoundingClientRect());
    var i = new ResizeObserver(function(s) {
      var a = s[0];
      if (a != null && a.borderBoxSize) {
        var l = a.borderBoxSize[0];
        if (l) {
          r({
            width: l.inlineSize,
            height: l.blockSize
          });
          return;
        }
      }
      r(o.getBoundingClientRect());
    });
    return i.observe(o, {
      box: "border-box"
    }), function() {
      i.unobserve(o);
    };
  }
}, ec = function(t, n) {
  var o = t.scrollElement;
  if (o) {
    var r = function() {
      n(o[t.options.horizontal ? "scrollLeft" : "scrollTop"]);
    };
    return r(), o.addEventListener("scroll", r, {
      passive: !0
    }), function() {
      o.removeEventListener("scroll", r);
    };
  }
}, tc = function(t, n, o) {
  if (n != null && n.borderBoxSize) {
    var r = n.borderBoxSize[0];
    if (r) {
      var i = Math.round(r[o.options.horizontal ? "inlineSize" : "blockSize"]);
      return i;
    }
  }
  return Math.round(t.getBoundingClientRect()[o.options.horizontal ? "width" : "height"]);
}, nc = function(t, n, o) {
  var r, i, s = n.adjustments, a = s === void 0 ? 0 : s, l = n.behavior, u = t + a;
  (r = o.scrollElement) == null || r.scrollTo == null || r.scrollTo((i = {}, i[o.options.horizontal ? "left" : "top"] = u, i.behavior = l, i));
}, oc = function(t) {
  var n = this;
  this.unsubs = [], this.scrollElement = null, this.isScrolling = !1, this.isScrollingTimeoutId = null, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollDirection = null, this.scrollAdjustments = 0, this.measureElementCache = /* @__PURE__ */ new Map(), this.observer = function() {
    var o = null, r = function() {
      return o || (typeof ResizeObserver < "u" ? o = new ResizeObserver(function(s) {
        s.forEach(function(a) {
          n._measureElement(a.target, a);
        });
      }) : null);
    };
    return {
      disconnect: function() {
        var s;
        return (s = r()) == null ? void 0 : s.disconnect();
      },
      observe: function(s) {
        var a;
        return (a = r()) == null ? void 0 : a.observe(s, {
          box: "border-box"
        });
      },
      unobserve: function(s) {
        var a;
        return (a = r()) == null ? void 0 : a.unobserve(s);
      }
    };
  }(), this.range = null, this.setOptions = function(o) {
    Object.entries(o).forEach(function(r) {
      var i = r[0], s = r[1];
      typeof s > "u" && delete o[i];
    }), n.options = so({
      debug: !1,
      initialOffset: 0,
      overscan: 1,
      paddingStart: 0,
      paddingEnd: 0,
      scrollPaddingStart: 0,
      scrollPaddingEnd: 0,
      horizontal: !1,
      getItemKey: Xu,
      rangeExtractor: Qu,
      onChange: function() {
      },
      measureElement: tc,
      initialRect: {
        width: 0,
        height: 0
      },
      scrollMargin: 0,
      scrollingDelay: 150,
      indexAttribute: "data-index",
      initialMeasurementsCache: [],
      lanes: 1
    }, o);
  }, this.notify = function(o) {
    n.options.onChange == null || n.options.onChange(n, o);
  }, this.maybeNotify = Jt(function() {
    return n.calculateRange(), [n.isScrolling, n.range ? n.range.startIndex : null, n.range ? n.range.endIndex : null];
  }, function(o) {
    n.notify(o);
  }, {
    key: process.env.NODE_ENV !== "production" && "maybeNotify",
    debug: function() {
      return n.options.debug;
    },
    initialDeps: [this.isScrolling, this.range ? this.range.startIndex : null, this.range ? this.range.endIndex : null]
  }), this.cleanup = function() {
    n.unsubs.filter(Boolean).forEach(function(o) {
      return o();
    }), n.unsubs = [], n.scrollElement = null;
  }, this._didMount = function() {
    return n.measureElementCache.forEach(n.observer.observe), function() {
      n.observer.disconnect(), n.cleanup();
    };
  }, this._willUpdate = function() {
    var o = n.options.getScrollElement();
    n.scrollElement !== o && (n.cleanup(), n.scrollElement = o, n._scrollToOffset(n.scrollOffset, {
      adjustments: void 0,
      behavior: void 0
    }), n.unsubs.push(n.options.observeElementRect(n, function(r) {
      n.scrollRect = r, n.maybeNotify();
    })), n.unsubs.push(n.options.observeElementOffset(n, function(r) {
      n.scrollAdjustments = 0, n.scrollOffset !== r && (n.isScrollingTimeoutId !== null && (clearTimeout(n.isScrollingTimeoutId), n.isScrollingTimeoutId = null), n.isScrolling = !0, n.scrollDirection = n.scrollOffset < r ? "forward" : "backward", n.scrollOffset = r, n.maybeNotify(), n.isScrollingTimeoutId = setTimeout(function() {
        n.isScrollingTimeoutId = null, n.isScrolling = !1, n.scrollDirection = null, n.maybeNotify();
      }, n.options.scrollingDelay));
    })));
  }, this.getSize = function() {
    return n.scrollRect[n.options.horizontal ? "width" : "height"];
  }, this.memoOptions = Jt(function() {
    return [n.options.count, n.options.paddingStart, n.options.scrollMargin, n.options.getItemKey];
  }, function(o, r, i, s) {
    return n.pendingMeasuredCacheIndexes = [], {
      count: o,
      paddingStart: r,
      scrollMargin: i,
      getItemKey: s
    };
  }, {
    key: !1
  }), this.getFurthestMeasurement = function(o, r) {
    for (var i = /* @__PURE__ */ new Map(), s = /* @__PURE__ */ new Map(), a = r - 1; a >= 0; a--) {
      var l = o[a];
      if (!i.has(l.lane)) {
        var u = s.get(l.lane);
        if (u == null || l.end > u.end ? s.set(l.lane, l) : l.end < u.end && i.set(l.lane, !0), i.size === n.options.lanes)
          break;
      }
    }
    return s.size === n.options.lanes ? Array.from(s.values()).sort(function(c, d) {
      return c.end - d.end;
    })[0] : void 0;
  }, this.getMeasurements = Jt(function() {
    return [n.memoOptions(), n.itemSizeCache];
  }, function(o, r) {
    var i = o.count, s = o.paddingStart, a = o.scrollMargin, l = o.getItemKey, u = n.pendingMeasuredCacheIndexes.length > 0 ? Math.min.apply(Math, n.pendingMeasuredCacheIndexes) : 0;
    n.pendingMeasuredCacheIndexes = [];
    for (var c = n.measurementsCache.slice(0, u), d = u; d < i; d++) {
      var p = l(d), v = n.options.lanes === 1 ? c[d - 1] : n.getFurthestMeasurement(c, d), x = v ? v.end : s + a, b = r.get(p), h = typeof b == "number" ? b : n.options.estimateSize(d), S = x + h, g = v ? v.lane : d % n.options.lanes;
      c[d] = {
        index: d,
        start: x,
        size: h,
        end: S,
        key: p,
        lane: g
      };
    }
    return n.measurementsCache = c, c;
  }, {
    key: process.env.NODE_ENV !== "production" && "getMeasurements",
    debug: function() {
      return n.options.debug;
    }
  }), this.calculateRange = Jt(function() {
    return [n.getMeasurements(), n.getSize(), n.scrollOffset];
  }, function(o, r, i) {
    return n.range = o.length > 0 && r > 0 ? rc({
      measurements: o,
      outerSize: r,
      scrollOffset: i
    }) : null;
  }, {
    key: process.env.NODE_ENV !== "production" && "calculateRange",
    debug: function() {
      return n.options.debug;
    }
  }), this.getIndexes = Jt(function() {
    return [n.options.rangeExtractor, n.calculateRange(), n.options.overscan, n.options.count];
  }, function(o, r, i, s) {
    return r === null ? [] : o(so({}, r, {
      overscan: i,
      count: s
    }));
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function() {
      return n.options.debug;
    }
  }), this.indexFromElement = function(o) {
    var r = n.options.indexAttribute, i = o.getAttribute(r);
    return i ? parseInt(i, 10) : (console.warn("Missing attribute name '" + r + "={index}' on measured element."), -1);
  }, this._measureElement = function(o, r) {
    var i = n.measurementsCache[n.indexFromElement(o)];
    if (!i || !o.isConnected) {
      n.measureElementCache.forEach(function(l, u) {
        l === o && (n.observer.unobserve(o), n.measureElementCache.delete(u));
      });
      return;
    }
    var s = n.measureElementCache.get(i.key);
    s !== o && (s && n.observer.unobserve(s), n.observer.observe(o), n.measureElementCache.set(i.key, o));
    var a = n.options.measureElement(o, r, n);
    n.resizeItem(i, a);
  }, this.resizeItem = function(o, r) {
    var i, s = (i = n.itemSizeCache.get(o.key)) != null ? i : o.size, a = r - s;
    a !== 0 && (o.start < n.scrollOffset && (process.env.NODE_ENV !== "production" && n.options.debug && console.info("correction", a), n._scrollToOffset(n.scrollOffset, {
      adjustments: n.scrollAdjustments += a,
      behavior: void 0
    })), n.pendingMeasuredCacheIndexes.push(o.index), n.itemSizeCache = new Map(n.itemSizeCache.set(o.key, r)), n.notify(!1));
  }, this.measureElement = function(o) {
    o && n._measureElement(o, void 0);
  }, this.getVirtualItems = Jt(function() {
    return [n.getIndexes(), n.getMeasurements()];
  }, function(o, r) {
    for (var i = [], s = 0, a = o.length; s < a; s++) {
      var l = o[s], u = r[l];
      i.push(u);
    }
    return i;
  }, {
    key: process.env.NODE_ENV !== "production" && "getIndexes",
    debug: function() {
      return n.options.debug;
    }
  }), this.getVirtualItemForOffset = function(o) {
    var r = n.getMeasurements();
    return Xo(r[Ys(0, r.length - 1, function(i) {
      return Xo(r[i]).start;
    }, o)]);
  }, this.getOffsetForAlignment = function(o, r) {
    var i = n.getSize();
    r === "auto" && (o <= n.scrollOffset ? r = "start" : o >= n.scrollOffset + i ? r = "end" : r = "start"), r === "start" ? o = o : r === "end" ? o = o - i : r === "center" && (o = o - i / 2);
    var s = n.options.horizontal ? "scrollWidth" : "scrollHeight", a = n.scrollElement ? "document" in n.scrollElement ? n.scrollElement.document.documentElement[s] : n.scrollElement[s] : 0, l = a - n.getSize();
    return Math.max(Math.min(l, o), 0);
  }, this.getOffsetForIndex = function(o, r) {
    r === void 0 && (r = "auto"), o = Math.max(0, Math.min(o, n.options.count - 1));
    var i = Xo(n.getMeasurements()[o]);
    if (r === "auto")
      if (i.end >= n.scrollOffset + n.getSize() - n.options.scrollPaddingEnd)
        r = "end";
      else if (i.start <= n.scrollOffset + n.options.scrollPaddingStart)
        r = "start";
      else
        return [n.scrollOffset, r];
    var s = r === "end" ? i.end + n.options.scrollPaddingEnd : i.start - n.options.scrollPaddingStart;
    return [n.getOffsetForAlignment(s, r), r];
  }, this.isDynamicMode = function() {
    return n.measureElementCache.size > 0;
  }, this.cancelScrollToIndex = function() {
    n.scrollToIndexTimeoutId !== null && (clearTimeout(n.scrollToIndexTimeoutId), n.scrollToIndexTimeoutId = null);
  }, this.scrollToOffset = function(o, r) {
    var i = r === void 0 ? {} : r, s = i.align, a = s === void 0 ? "start" : s, l = i.behavior;
    n.cancelScrollToIndex(), l === "smooth" && n.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size."), n._scrollToOffset(n.getOffsetForAlignment(o, a), {
      adjustments: void 0,
      behavior: l
    });
  }, this.scrollToIndex = function(o, r) {
    var i = r === void 0 ? {} : r, s = i.align, a = s === void 0 ? "auto" : s, l = i.behavior;
    o = Math.max(0, Math.min(o, n.options.count - 1)), n.cancelScrollToIndex(), l === "smooth" && n.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
    var u = n.getOffsetForIndex(o, a), c = u[0], d = u[1];
    n._scrollToOffset(c, {
      adjustments: void 0,
      behavior: l
    }), l !== "smooth" && n.isDynamicMode() && (n.scrollToIndexTimeoutId = setTimeout(function() {
      n.scrollToIndexTimeoutId = null;
      var p = n.measureElementCache.has(n.options.getItemKey(o));
      if (p) {
        var v = n.getOffsetForIndex(o, d), x = v[0];
        Yu(x, n.scrollOffset) || n.scrollToIndex(o, {
          align: d,
          behavior: l
        });
      } else
        n.scrollToIndex(o, {
          align: d,
          behavior: l
        });
    }));
  }, this.scrollBy = function(o, r) {
    var i = r === void 0 ? {} : r, s = i.behavior;
    n.cancelScrollToIndex(), s === "smooth" && n.isDynamicMode() && console.warn("The `smooth` scroll behavior is not fully supported with dynamic size."), n._scrollToOffset(n.scrollOffset + o, {
      adjustments: void 0,
      behavior: s
    });
  }, this.getTotalSize = function() {
    var o;
    return (((o = n.getMeasurements()[n.options.count - 1]) == null ? void 0 : o.end) || n.options.paddingStart) - n.options.scrollMargin + n.options.paddingEnd;
  }, this._scrollToOffset = function(o, r) {
    var i = r.adjustments, s = r.behavior;
    n.options.scrollToFn(o, {
      behavior: s,
      adjustments: i
    }, n);
  }, this.measure = function() {
    n.itemSizeCache = /* @__PURE__ */ new Map(), n.notify(!1);
  }, this.setOptions(t), this.scrollRect = this.options.initialRect, this.scrollOffset = this.options.initialOffset, this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach(function(o) {
    n.itemSizeCache.set(o.key, o.size);
  }), this.maybeNotify();
}, Ys = function(t, n, o, r) {
  for (; t <= n; ) {
    var i = (t + n) / 2 | 0, s = o(i);
    if (s < r)
      t = i + 1;
    else if (s > r)
      n = i - 1;
    else
      return i;
  }
  return t > 0 ? t - 1 : 0;
};
function rc(e) {
  for (var t = e.measurements, n = e.outerSize, o = e.scrollOffset, r = t.length - 1, i = function(u) {
    return t[u].start;
  }, s = Ys(0, r, i, o), a = s; a < r && t[a].end < o + n; )
    a++;
  return {
    startIndex: s,
    endIndex: a
  };
}
/**
 * vue-virtual
 *
 * Copyright (c) TanStack
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
function ic(e) {
  var t = new oc(T(e)), n = zr(t), o = t._didMount();
  return he(function() {
    return T(e).getScrollElement();
  }, function(r) {
    r && t._willUpdate();
  }, {
    immediate: !0
  }), he(function() {
    return T(e);
  }, function(r) {
    t.setOptions(io({}, r, {
      onChange: function(s, a) {
        Mi(n), r.onChange == null || r.onChange(s, a);
      }
    })), t._willUpdate(), Mi(n);
  }, {
    immediate: !0
  }), Fs(o), n;
}
function sc(e) {
  return ic(E(function() {
    return io({
      observeElementRect: Ju,
      observeElementOffset: ec,
      scrollToFn: nc
    }, T(e));
  }));
}
function go(e, t, n) {
  let o = A(n == null ? void 0 : n.value), r = E(() => e.value !== void 0);
  return [E(() => r.value ? e.value : o.value), function(i) {
    return r.value || (o.value = i), t == null ? void 0 : t(i);
  }];
}
let ac = Symbol("headlessui.useid"), lc = 0;
function be() {
  return ge(ac, () => `${++lc}`)();
}
function D(e) {
  var t;
  if (e == null || e.value == null)
    return null;
  let n = (t = e.value.$el) != null ? t : e.value;
  return n instanceof Node ? n : null;
}
function fe(e, t, ...n) {
  if (e in t) {
    let r = t[e];
    return typeof r == "function" ? r(...n) : r;
  }
  let o = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((r) => `"${r}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(o, fe), o;
}
var uc = Object.defineProperty, cc = (e, t, n) => t in e ? uc(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Li = (e, t, n) => (cc(e, typeof t != "symbol" ? t + "" : t, n), n);
let dc = class {
  constructor() {
    Li(this, "current", this.detect()), Li(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, _n = new dc();
function Ve(e) {
  if (_n.isServer)
    return null;
  if (e instanceof Node)
    return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = D(e);
    if (t)
      return t.ownerDocument;
  }
  return document;
}
let fr = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Ae = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Ae || {}), Ft = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Ft || {}), pc = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(pc || {});
function bo(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(fr)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var yo = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(yo || {});
function Fr(e, t = 0) {
  var n;
  return e === ((n = Ve(e)) == null ? void 0 : n.body) ? !1 : fe(t, { 0() {
    return e.matches(fr);
  }, 1() {
    let o = e;
    for (; o !== null; ) {
      if (o.matches(fr))
        return !0;
      o = o.parentElement;
    }
    return !1;
  } });
}
var fc = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(fc || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function zt(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let hc = ["textarea", "input"].join(",");
function vc(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, hc)) != null ? n : !1;
}
function wo(e, t = (n) => n) {
  return e.slice().sort((n, o) => {
    let r = t(n), i = t(o);
    if (r === null || i === null)
      return 0;
    let s = r.compareDocumentPosition(i);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Ze(e, t, { sorted: n = !0, relativeTo: o = null, skipElements: r = [] } = {}) {
  var i;
  let s = (i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? i : document, a = Array.isArray(e) ? n ? wo(e) : e : bo(e);
  r.length > 0 && a.length > 1 && (a = a.filter((x) => !r.includes(x))), o = o ?? s.activeElement;
  let l = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, a.indexOf(o)) - 1;
    if (t & 4)
      return Math.max(0, a.indexOf(o)) + 1;
    if (t & 8)
      return a.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = t & 32 ? { preventScroll: !0 } : {}, d = 0, p = a.length, v;
  do {
    if (d >= p || d + p <= 0)
      return 0;
    let x = u + d;
    if (t & 16)
      x = (x + p) % p;
    else {
      if (x < 0)
        return 3;
      if (x >= p)
        return 1;
    }
    v = a[x], v == null || v.focus(c), d += l;
  } while (v !== s.activeElement);
  return t & 6 && vc(v) && v.select(), 2;
}
function Xs() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function mc() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Qs() {
  return Xs() || mc();
}
function Nn(e, t, n) {
  _n.isServer || $e((o) => {
    document.addEventListener(e, t, n), o(() => document.removeEventListener(e, t, n));
  });
}
function Js(e, t, n) {
  _n.isServer || $e((o) => {
    window.addEventListener(e, t, n), o(() => window.removeEventListener(e, t, n));
  });
}
function xo(e, t, n = E(() => !0)) {
  function o(i, s) {
    if (!n.value || i.defaultPrevented)
      return;
    let a = s(i);
    if (a === null || !a.getRootNode().contains(a))
      return;
    let l = function u(c) {
      return typeof c == "function" ? u(c()) : Array.isArray(c) || c instanceof Set ? c : [c];
    }(e);
    for (let u of l) {
      if (u === null)
        continue;
      let c = u instanceof HTMLElement ? u : D(u);
      if (c != null && c.contains(a) || i.composed && i.composedPath().includes(c))
        return;
    }
    return !Fr(a, yo.Loose) && a.tabIndex !== -1 && i.preventDefault(), t(i, a);
  }
  let r = A(null);
  Nn("pointerdown", (i) => {
    var s, a;
    n.value && (r.value = ((a = (s = i.composedPath) == null ? void 0 : s.call(i)) == null ? void 0 : a[0]) || i.target);
  }, !0), Nn("mousedown", (i) => {
    var s, a;
    n.value && (r.value = ((a = (s = i.composedPath) == null ? void 0 : s.call(i)) == null ? void 0 : a[0]) || i.target);
  }, !0), Nn("click", (i) => {
    Qs() || r.value && (o(i, () => r.value), r.value = null);
  }, !0), Nn("touchend", (i) => o(i, () => i.target instanceof HTMLElement ? i.target : null), !0), Js("blur", (i) => o(i, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function Di(e, t) {
  if (e)
    return e;
  let n = t ?? "button";
  if (typeof n == "string" && n.toLowerCase() === "button")
    return "button";
}
function Rn(e, t) {
  let n = A(Di(e.value.type, e.value.as));
  return ae(() => {
    n.value = Di(e.value.type, e.value.as);
  }), $e(() => {
    var o;
    n.value || D(t) && D(t) instanceof HTMLButtonElement && !((o = D(t)) != null && o.hasAttribute("type")) && (n.value = "button");
  }), n;
}
function Bi(e) {
  return [e.screenX, e.screenY];
}
function ea() {
  let e = A([-1, -1]);
  return { wasMoved(t) {
    let n = Bi(t);
    return e.value[0] === n[0] && e.value[1] === n[1] ? !1 : (e.value = n, !0);
  }, update(t) {
    e.value = Bi(t);
  } };
}
function ta({ container: e, accept: t, walk: n, enabled: o }) {
  $e(() => {
    let r = e.value;
    if (!r || o !== void 0 && !o.value)
      return;
    let i = Ve(e);
    if (!i)
      return;
    let s = Object.assign((l) => t(l), { acceptNode: t }), a = i.createTreeWalker(r, NodeFilter.SHOW_ELEMENT, s, !1);
    for (; a.nextNode(); )
      n(a.currentNode);
  });
}
var Ne = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Ne || {}), Ot = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Ot || {});
function le({ visible: e = !0, features: t = 0, ourProps: n, theirProps: o, ...r }) {
  var i;
  let s = oa(o, n), a = Object.assign(r, { props: s });
  if (e || t & 2 && s.static)
    return Qo(a);
  if (t & 1) {
    let l = (i = s.unmount) == null || i ? 0 : 1;
    return fe(l, { 0() {
      return null;
    }, 1() {
      return Qo({ ...r, props: { ...s, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Qo(a);
}
function Qo({ props: e, attrs: t, slots: n, slot: o, name: r }) {
  var i, s;
  let { as: a, ...l } = Rt(e, ["unmount", "static"]), u = (i = n.default) == null ? void 0 : i.call(n, o), c = {};
  if (o) {
    let d = !1, p = [];
    for (let [v, x] of Object.entries(o))
      typeof x == "boolean" && (d = !0), x === !0 && p.push(v);
    d && (c["data-headlessui-state"] = p.join(" "));
  }
  if (a === "template") {
    if (u = na(u ?? []), Object.keys(l).length > 0 || Object.keys(t).length > 0) {
      let [d, ...p] = u ?? [];
      if (!gc(d) || p.length > 0)
        throw new Error(['Passing props on "template"!', "", `The current component <${r} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(l).concat(Object.keys(t)).map((b) => b.trim()).filter((b, h, S) => S.indexOf(b) === h).sort((b, h) => b.localeCompare(h)).map((b) => `  - ${b}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((b) => `  - ${b}`).join(`
`)].join(`
`));
      let v = oa((s = d.props) != null ? s : {}, l, c), x = Hs(d, v, !0);
      for (let b in v)
        b.startsWith("on") && (x.props || (x.props = {}), x.props[b] = v[b]);
      return x;
    }
    return Array.isArray(u) && u.length === 1 ? u[0] : u;
  }
  return oe(a, Object.assign({}, l, c), { default: () => u });
}
function na(e) {
  return e.flatMap((t) => t.type === K ? na(t.children) : [t]);
}
function oa(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let o of e)
    for (let r in o)
      r.startsWith("on") && typeof o[r] == "function" ? (n[r] != null || (n[r] = []), n[r].push(o[r])) : t[r] = o[r];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(n).map((o) => [o, void 0])));
  for (let o in n)
    Object.assign(t, { [o](r, ...i) {
      let s = n[o];
      for (let a of s) {
        if (r instanceof Event && r.defaultPrevented)
          return;
        a(r, ...i);
      }
    } });
  return t;
}
function $o(e) {
  let t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function Rt(e, t = []) {
  let n = Object.assign({}, e);
  for (let o of t)
    o in n && delete n[o];
  return n;
}
function gc(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var et = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(et || {});
let it = z({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: n }) {
  return () => {
    var o;
    let { features: r, ...i } = e, s = { "aria-hidden": (r & 2) === 2 ? !0 : (o = i["aria-hidden"]) != null ? o : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(r & 4) === 4 && (r & 2) !== 2 && { display: "none" } } };
    return le({ ourProps: s, theirProps: i, slot: {}, attrs: n, slots: t, name: "Hidden" });
  };
} }), ra = Symbol("Context");
var me = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(me || {});
function bc() {
  return Mt() !== null;
}
function Mt() {
  return ge(ra, null);
}
function Mn(e) {
  xe(ra, e);
}
var Q = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(Q || {});
function yc(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let Ct = [];
yc(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && Ct[0] !== t.target && (Ct.unshift(t.target), Ct = Ct.filter((n) => n != null && n.isConnected), Ct.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function wc(e) {
  throw new Error("Unexpected object: " + e);
}
var ve = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(ve || {});
function hr(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0)
    return null;
  let o = t.resolveActiveIndex(), r = o ?? -1;
  switch (e.focus) {
    case 0: {
      for (let i = 0; i < n.length; ++i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return o;
    }
    case 1: {
      r === -1 && (r = n.length);
      for (let i = r - 1; i >= 0; --i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return o;
    }
    case 2: {
      for (let i = r + 1; i < n.length; ++i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return o;
    }
    case 3: {
      for (let i = n.length - 1; i >= 0; --i)
        if (!t.resolveDisabled(n[i], i, n))
          return i;
      return o;
    }
    case 4: {
      for (let i = 0; i < n.length; ++i)
        if (t.resolveId(n[i], i, n) === e.id)
          return i;
      return o;
    }
    case 5:
      return null;
    default:
      wc(e);
  }
}
function Hr(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Ht() {
  let e = [], t = { addEventListener(n, o, r, i) {
    return n.addEventListener(o, r, i), t.add(() => n.removeEventListener(o, r, i));
  }, requestAnimationFrame(...n) {
    let o = requestAnimationFrame(...n);
    t.add(() => cancelAnimationFrame(o));
  }, nextFrame(...n) {
    t.requestAnimationFrame(() => {
      t.requestAnimationFrame(...n);
    });
  }, setTimeout(...n) {
    let o = setTimeout(...n);
    t.add(() => clearTimeout(o));
  }, microTask(...n) {
    let o = { current: !0 };
    return Hr(() => {
      o.current && n[0]();
    }), t.add(() => {
      o.current = !1;
    });
  }, style(n, o, r) {
    let i = n.style.getPropertyValue(o);
    return Object.assign(n.style, { [o]: r }), this.add(() => {
      Object.assign(n.style, { [o]: i });
    });
  }, group(n) {
    let o = Ht();
    return n(o), this.add(() => o.dispose());
  }, add(n) {
    return e.push(n), () => {
      let o = e.indexOf(n);
      if (o >= 0)
        for (let r of e.splice(o, 1))
          r();
    };
  }, dispose() {
    for (let n of e.splice(0))
      n();
  } };
  return t;
}
function Co(e = {}, t = null, n = []) {
  for (let [o, r] of Object.entries(e))
    sa(n, ia(t, o), r);
  return n;
}
function ia(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function sa(e, t, n) {
  if (Array.isArray(n))
    for (let [o, r] of n.entries())
      sa(e, ia(t, o.toString()), r);
  else
    n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : Co(n, t, e);
}
function aa(e) {
  var t, n;
  let o = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (o) {
    for (let r of o.elements)
      if (r !== e && (r.tagName === "INPUT" && r.type === "submit" || r.tagName === "BUTTON" && r.type === "submit" || r.nodeName === "INPUT" && r.type === "image")) {
        r.click();
        return;
      }
    (n = o.requestSubmit) == null || n.call(o);
  }
}
function xc(e, t) {
  return e === t;
}
var $c = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))($c || {}), Cc = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(Cc || {}), Sc = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Focus = 1] = "Focus", e[e.Other = 2] = "Other", e))(Sc || {});
let la = Symbol("ComboboxContext");
function Yt(e) {
  let t = ge(la, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Yt), n;
  }
  return t;
}
let ua = Symbol("VirtualContext"), kc = z({ name: "VirtualProvider", setup(e, { slots: t }) {
  let n = Yt("VirtualProvider"), o = E(() => {
    let a = D(n.optionsRef);
    if (!a)
      return { start: 0, end: 0 };
    let l = window.getComputedStyle(a);
    return { start: parseFloat(l.paddingBlockStart || l.paddingTop), end: parseFloat(l.paddingBlockEnd || l.paddingBottom) };
  }), r = sc(E(() => ({ scrollPaddingStart: o.value.start, scrollPaddingEnd: o.value.end, count: n.virtual.value.options.length, estimateSize() {
    return 40;
  }, getScrollElement() {
    return D(n.optionsRef);
  }, overscan: 12 }))), i = E(() => {
    var a;
    return (a = n.virtual.value) == null ? void 0 : a.options;
  }), s = A(0);
  return he([i], () => {
    s.value += 1;
  }), xe(ua, n.virtual.value ? r : null), () => [oe("div", { style: { position: "relative", width: "100%", height: `${r.value.getTotalSize()}px` }, ref: (a) => {
    if (a) {
      if (typeof process < "u" && process.env.JEST_WORKER_ID !== void 0 || n.activationTrigger.value === 0)
        return;
      n.activeOptionIndex.value !== null && n.virtual.value.options.length > n.activeOptionIndex.value && r.value.scrollToIndex(n.activeOptionIndex.value);
    }
  } }, r.value.getVirtualItems().map((a) => Hs(t.default({ option: n.virtual.value.options[a.index], open: n.comboboxState.value === 0 })[0], { key: `${s.value}-${a.index}`, "data-index": a.index, "aria-setsize": n.virtual.value.options.length, "aria-posinset": a.index + 1, style: { position: "absolute", top: 0, left: 0, transform: `translateY(${a.start}px)`, overflowAnchor: "none" } })))];
} }), Ec = z({ name: "Combobox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], nullable: !0, default: null }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, nullable: { type: Boolean, default: !1 }, multiple: { type: [Boolean], default: !1 }, immediate: { type: [Boolean], default: !1 }, virtual: { type: Object, default: null } }, inheritAttrs: !1, setup(e, { slots: t, attrs: n, emit: o }) {
  let r = A(1), i = A(null), s = A(null), a = A(null), l = A(null), u = A({ static: !1, hold: !1 }), c = A([]), d = A(null), p = A(2), v = A(!1);
  function x(L = (N) => N) {
    let N = d.value !== null ? c.value[d.value] : null, Z = L(c.value.slice()), H = Z.length > 0 && Z[0].dataRef.order.value !== null ? Z.sort((X, ie) => X.dataRef.order.value - ie.dataRef.order.value) : wo(Z, (X) => D(X.dataRef.domRef)), J = N ? H.indexOf(N) : null;
    return J === -1 && (J = null), { options: H, activeOptionIndex: J };
  }
  let b = E(() => e.multiple ? 1 : 0), h = E(() => e.nullable), [S, g] = go(E(() => e.modelValue), (L) => o("update:modelValue", L), E(() => e.defaultValue)), C = E(() => S.value === void 0 ? fe(b.value, { 1: [], 0: void 0 }) : S.value), w = null, $ = null;
  function k(L) {
    return fe(b.value, { 0() {
      return g == null ? void 0 : g(L);
    }, 1: () => {
      let N = we(M.value.value).slice(), Z = we(L), H = N.findIndex((J) => M.compare(Z, we(J)));
      return H === -1 ? N.push(Z) : N.splice(H, 1), g == null ? void 0 : g(N);
    } });
  }
  let _ = E(() => {
  });
  he([_], ([L], [N]) => {
    if (M.virtual.value && L && N && d.value !== null) {
      let Z = L.indexOf(N[d.value]);
      Z !== -1 ? d.value = Z : d.value = null;
    }
  });
  let M = { comboboxState: r, value: C, mode: b, compare(L, N) {
    if (typeof e.by == "string") {
      let Z = e.by;
      return (L == null ? void 0 : L[Z]) === (N == null ? void 0 : N[Z]);
    }
    return e.by === null ? xc(L, N) : e.by(L, N);
  }, calculateIndex(L) {
    return M.virtual.value ? e.by === null ? M.virtual.value.options.indexOf(L) : M.virtual.value.options.findIndex((N) => M.compare(N, L)) : c.value.findIndex((N) => M.compare(N.dataRef.value, L));
  }, defaultValue: E(() => e.defaultValue), nullable: h, immediate: E(() => !1), virtual: E(() => null), inputRef: s, labelRef: i, buttonRef: a, optionsRef: l, disabled: E(() => e.disabled), options: c, change(L) {
    g(L);
  }, activeOptionIndex: E(() => {
    if (v.value && d.value === null && (M.virtual.value ? M.virtual.value.options.length > 0 : c.value.length > 0)) {
      if (M.virtual.value) {
        let N = M.virtual.value.options.findIndex((Z) => {
          var H;
          return !((H = M.virtual.value) != null && H.disabled(Z));
        });
        if (N !== -1)
          return N;
      }
      let L = c.value.findIndex((N) => !N.dataRef.disabled);
      if (L !== -1)
        return L;
    }
    return d.value;
  }), activationTrigger: p, optionsPropsRef: u, closeCombobox() {
    v.value = !1, !e.disabled && r.value !== 1 && (r.value = 1, d.value = null);
  }, openCombobox() {
    if (v.value = !0, !e.disabled && r.value !== 0) {
      if (M.value.value) {
        let L = M.calculateIndex(M.value.value);
        L !== -1 && (d.value = L);
      }
      r.value = 0;
    }
  }, setActivationTrigger(L) {
    p.value = L;
  }, goToOption(L, N, Z) {
    v.value = !1, w !== null && cancelAnimationFrame(w), w = requestAnimationFrame(() => {
      if (e.disabled || l.value && !u.value.static && r.value === 1)
        return;
      if (M.virtual.value) {
        d.value = L === ve.Specific ? N : hr({ focus: L }, { resolveItems: () => M.virtual.value.options, resolveActiveIndex: () => {
          var X, ie;
          return (ie = (X = M.activeOptionIndex.value) != null ? X : M.virtual.value.options.findIndex((ye) => {
            var Se;
            return !((Se = M.virtual.value) != null && Se.disabled(ye));
          })) != null ? ie : null;
        }, resolveDisabled: (X) => M.virtual.value.disabled(X), resolveId() {
          throw new Error("Function not implemented.");
        } }), p.value = Z ?? 2;
        return;
      }
      let H = x();
      if (H.activeOptionIndex === null) {
        let X = H.options.findIndex((ie) => !ie.dataRef.disabled);
        X !== -1 && (H.activeOptionIndex = X);
      }
      let J = L === ve.Specific ? N : hr({ focus: L }, { resolveItems: () => H.options, resolveActiveIndex: () => H.activeOptionIndex, resolveId: (X) => X.id, resolveDisabled: (X) => X.dataRef.disabled });
      d.value = J, p.value = Z ?? 2, c.value = H.options;
    });
  }, selectOption(L) {
    let N = c.value.find((H) => H.id === L);
    if (!N)
      return;
    let { dataRef: Z } = N;
    k(Z.value);
  }, selectActiveOption() {
    if (M.activeOptionIndex.value !== null) {
      if (M.virtual.value)
        k(M.virtual.value.options[M.activeOptionIndex.value]);
      else {
        let { dataRef: L } = c.value[M.activeOptionIndex.value];
        k(L.value);
      }
      M.goToOption(ve.Specific, M.activeOptionIndex.value);
    }
  }, registerOption(L, N) {
    let Z = Nr({ id: L, dataRef: N });
    if (M.virtual.value) {
      c.value.push(Z);
      return;
    }
    $ && cancelAnimationFrame($);
    let H = x((J) => (J.push(Z), J));
    d.value === null && M.isSelected(N.value.value) && (H.activeOptionIndex = H.options.indexOf(Z)), c.value = H.options, d.value = H.activeOptionIndex, p.value = 2, H.options.some((J) => !D(J.dataRef.domRef)) && ($ = requestAnimationFrame(() => {
      let J = x();
      c.value = J.options, d.value = J.activeOptionIndex;
    }));
  }, unregisterOption(L, N) {
    if (w !== null && cancelAnimationFrame(w), N && (v.value = !0), M.virtual.value) {
      c.value = c.value.filter((H) => H.id !== L);
      return;
    }
    let Z = x((H) => {
      let J = H.findIndex((X) => X.id === L);
      return J !== -1 && H.splice(J, 1), H;
    });
    c.value = Z.options, d.value = Z.activeOptionIndex, p.value = 2;
  }, isSelected(L) {
    return fe(b.value, { 0: () => M.compare(we(M.value.value), we(L)), 1: () => we(M.value.value).some((N) => M.compare(we(N), we(L))) });
  }, isActive(L) {
    return d.value === M.calculateIndex(L);
  } };
  xo([s, a, l], () => M.closeCombobox(), E(() => r.value === 0)), xe(la, M), Mn(E(() => fe(r.value, { 0: me.Open, 1: me.Closed })));
  let U = E(() => {
    var L;
    return (L = D(s)) == null ? void 0 : L.closest("form");
  });
  return ae(() => {
    he([U], () => {
      if (!U.value || e.defaultValue === void 0)
        return;
      function L() {
        M.change(e.defaultValue);
      }
      return U.value.addEventListener("reset", L), () => {
        var N;
        (N = U.value) == null || N.removeEventListener("reset", L);
      };
    }, { immediate: !0 });
  }), () => {
    var L, N, Z;
    let { name: H, disabled: J, form: X, ...ie } = e, ye = { open: r.value === 0, disabled: J, activeIndex: M.activeOptionIndex.value, activeOption: M.activeOptionIndex.value === null ? null : M.virtual.value ? M.virtual.value.options[(L = M.activeOptionIndex.value) != null ? L : 0] : (Z = (N = M.options.value[M.activeOptionIndex.value]) == null ? void 0 : N.dataRef.value) != null ? Z : null, value: C.value };
    return oe(K, [...H != null && C.value != null ? Co({ [H]: C.value }).map(([Se, Oe]) => oe(it, $o({ features: et.Hidden, key: Se, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: X, name: Se, value: Oe }))) : [], le({ theirProps: { ...n, ...Rt(ie, ["by", "defaultValue", "immediate", "modelValue", "multiple", "nullable", "onUpdate:modelValue", "virtual"]) }, ourProps: {}, slot: ye, slots: t, attrs: n, name: "Combobox" })]);
  };
} });
z({ name: "ComboboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var o;
  let r = (o = e.id) != null ? o : `headlessui-combobox-label-${be()}`, i = Yt("ComboboxLabel");
  function s() {
    var a;
    (a = D(i.inputRef)) == null || a.focus({ preventScroll: !0 });
  }
  return () => {
    let a = { open: i.comboboxState.value === 0, disabled: i.disabled.value }, { ...l } = e, u = { id: r, ref: i.labelRef, onClick: s };
    return le({ ourProps: u, theirProps: l, slot: a, attrs: t, slots: n, name: "ComboboxLabel" });
  };
} });
let Oc = z({ name: "ComboboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: o }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-combobox-button-${be()}`, s = Yt("ComboboxButton");
  o({ el: s.buttonRef, $el: s.buttonRef });
  function a(c) {
    s.disabled.value || (s.comboboxState.value === 0 ? s.closeCombobox() : (c.preventDefault(), s.openCombobox()), ke(() => {
      var d;
      return (d = D(s.inputRef)) == null ? void 0 : d.focus({ preventScroll: !0 });
    }));
  }
  function l(c) {
    switch (c.key) {
      case Q.ArrowDown:
        c.preventDefault(), c.stopPropagation(), s.comboboxState.value === 1 && s.openCombobox(), ke(() => {
          var d;
          return (d = s.inputRef.value) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        return;
      case Q.ArrowUp:
        c.preventDefault(), c.stopPropagation(), s.comboboxState.value === 1 && (s.openCombobox(), ke(() => {
          s.value.value || s.goToOption(ve.Last);
        })), ke(() => {
          var d;
          return (d = s.inputRef.value) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        return;
      case Q.Escape:
        if (s.comboboxState.value !== 0)
          return;
        c.preventDefault(), s.optionsRef.value && !s.optionsPropsRef.value.static && c.stopPropagation(), s.closeCombobox(), ke(() => {
          var d;
          return (d = s.inputRef.value) == null ? void 0 : d.focus({ preventScroll: !0 });
        });
        return;
    }
  }
  let u = Rn(E(() => ({ as: e.as, type: t.type })), s.buttonRef);
  return () => {
    var c, d;
    let p = { open: s.comboboxState.value === 0, disabled: s.disabled.value, value: s.value.value }, { ...v } = e, x = { ref: s.buttonRef, id: i, type: u.value, tabindex: "-1", "aria-haspopup": "listbox", "aria-controls": (c = D(s.optionsRef)) == null ? void 0 : c.id, "aria-expanded": s.comboboxState.value === 0, "aria-labelledby": s.labelRef.value ? [(d = D(s.labelRef)) == null ? void 0 : d.id, i].join(" ") : void 0, disabled: s.disabled.value === !0 ? !0 : void 0, onKeydown: l, onClick: a };
    return le({ ourProps: x, theirProps: v, slot: p, attrs: t, slots: n, name: "ComboboxButton" });
  };
} });
z({ name: "ComboboxInput", props: { as: { type: [Object, String], default: "input" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, displayValue: { type: Function }, defaultValue: { type: String, default: void 0 }, id: { type: String, default: null } }, emits: { change: (e) => !0 }, setup(e, { emit: t, attrs: n, slots: o, expose: r }) {
  var i;
  let s = (i = e.id) != null ? i : `headlessui-combobox-input-${be()}`, a = Yt("ComboboxInput"), l = E(() => Ve(D(a.inputRef))), u = { value: !1 };
  r({ el: a.inputRef, $el: a.inputRef });
  function c() {
    a.change(null);
    let w = D(a.optionsRef);
    w && (w.scrollTop = 0), a.goToOption(ve.Nothing);
  }
  let d = E(() => {
    var w;
    let $ = a.value.value;
    return D(a.inputRef) ? typeof e.displayValue < "u" && $ !== void 0 ? (w = e.displayValue($)) != null ? w : "" : typeof $ == "string" ? $ : "" : "";
  });
  ae(() => {
    he([d, a.comboboxState, l], ([w, $], [k, _]) => {
      if (u.value)
        return;
      let M = D(a.inputRef);
      M && ((_ === 0 && $ === 1 || w !== k) && (M.value = w), requestAnimationFrame(() => {
        var U;
        if (u.value || !M || ((U = l.value) == null ? void 0 : U.activeElement) !== M)
          return;
        let { selectionStart: L, selectionEnd: N } = M;
        Math.abs((N ?? 0) - (L ?? 0)) === 0 && L === 0 && M.setSelectionRange(M.value.length, M.value.length);
      }));
    }, { immediate: !0 }), he([a.comboboxState], ([w], [$]) => {
      if (w === 0 && $ === 1) {
        if (u.value)
          return;
        let k = D(a.inputRef);
        if (!k)
          return;
        let _ = k.value, { selectionStart: M, selectionEnd: U, selectionDirection: L } = k;
        k.value = "", k.value = _, L !== null ? k.setSelectionRange(M, U, L) : k.setSelectionRange(M, U);
      }
    });
  });
  let p = A(!1);
  function v() {
    p.value = !0;
  }
  function x() {
    Ht().nextFrame(() => {
      p.value = !1;
    });
  }
  function b(w) {
    switch (u.value = !0, w.key) {
      case Q.Enter:
        if (u.value = !1, a.comboboxState.value !== 0 || p.value)
          return;
        if (w.preventDefault(), w.stopPropagation(), a.activeOptionIndex.value === null) {
          a.closeCombobox();
          return;
        }
        a.selectActiveOption(), a.mode.value === 0 && a.closeCombobox();
        break;
      case Q.ArrowDown:
        return u.value = !1, w.preventDefault(), w.stopPropagation(), fe(a.comboboxState.value, { 0: () => a.goToOption(ve.Next), 1: () => a.openCombobox() });
      case Q.ArrowUp:
        return u.value = !1, w.preventDefault(), w.stopPropagation(), fe(a.comboboxState.value, { 0: () => a.goToOption(ve.Previous), 1: () => {
          a.openCombobox(), ke(() => {
            a.value.value || a.goToOption(ve.Last);
          });
        } });
      case Q.Home:
        if (w.shiftKey)
          break;
        return u.value = !1, w.preventDefault(), w.stopPropagation(), a.goToOption(ve.First);
      case Q.PageUp:
        return u.value = !1, w.preventDefault(), w.stopPropagation(), a.goToOption(ve.First);
      case Q.End:
        if (w.shiftKey)
          break;
        return u.value = !1, w.preventDefault(), w.stopPropagation(), a.goToOption(ve.Last);
      case Q.PageDown:
        return u.value = !1, w.preventDefault(), w.stopPropagation(), a.goToOption(ve.Last);
      case Q.Escape:
        if (u.value = !1, a.comboboxState.value !== 0)
          return;
        w.preventDefault(), a.optionsRef.value && !a.optionsPropsRef.value.static && w.stopPropagation(), a.nullable.value && a.mode.value === 0 && a.value.value === null && c(), a.closeCombobox();
        break;
      case Q.Tab:
        if (u.value = !1, a.comboboxState.value !== 0)
          return;
        a.mode.value === 0 && a.activationTrigger.value !== 1 && a.selectActiveOption(), a.closeCombobox();
        break;
    }
  }
  function h(w) {
    t("change", w), a.nullable.value && a.mode.value === 0 && w.target.value === "" && c(), a.openCombobox();
  }
  function S(w) {
    var $, k, _;
    let M = ($ = w.relatedTarget) != null ? $ : Ct.find((U) => U !== w.currentTarget);
    if (u.value = !1, !((k = D(a.optionsRef)) != null && k.contains(M)) && !((_ = D(a.buttonRef)) != null && _.contains(M)) && a.comboboxState.value === 0)
      return w.preventDefault(), a.mode.value === 0 && (a.nullable.value && a.value.value === null ? c() : a.activationTrigger.value !== 1 && a.selectActiveOption()), a.closeCombobox();
  }
  function g(w) {
    var $, k, _;
    let M = ($ = w.relatedTarget) != null ? $ : Ct.find((U) => U !== w.currentTarget);
    (k = D(a.buttonRef)) != null && k.contains(M) || (_ = D(a.optionsRef)) != null && _.contains(M) || a.disabled.value || a.immediate.value && a.comboboxState.value !== 0 && (a.openCombobox(), Ht().nextFrame(() => {
      a.setActivationTrigger(1);
    }));
  }
  let C = E(() => {
    var w, $, k, _;
    return (_ = (k = ($ = e.defaultValue) != null ? $ : a.defaultValue.value !== void 0 ? (w = e.displayValue) == null ? void 0 : w.call(e, a.defaultValue.value) : null) != null ? k : a.defaultValue.value) != null ? _ : "";
  });
  return () => {
    var w, $, k, _, M, U, L;
    let N = { open: a.comboboxState.value === 0 }, { displayValue: Z, onChange: H, ...J } = e, X = { "aria-controls": (w = a.optionsRef.value) == null ? void 0 : w.id, "aria-expanded": a.comboboxState.value === 0, "aria-activedescendant": a.activeOptionIndex.value === null ? void 0 : a.virtual.value ? ($ = a.options.value.find((ie) => !a.virtual.value.disabled(ie.dataRef.value) && a.compare(ie.dataRef.value, a.virtual.value.options[a.activeOptionIndex.value]))) == null ? void 0 : $.id : (k = a.options.value[a.activeOptionIndex.value]) == null ? void 0 : k.id, "aria-labelledby": (U = (_ = D(a.labelRef)) == null ? void 0 : _.id) != null ? U : (M = D(a.buttonRef)) == null ? void 0 : M.id, "aria-autocomplete": "list", id: s, onCompositionstart: v, onCompositionend: x, onKeydown: b, onInput: h, onFocus: g, onBlur: S, role: "combobox", type: (L = n.type) != null ? L : "text", tabIndex: 0, ref: a.inputRef, defaultValue: C.value, disabled: a.disabled.value === !0 ? !0 : void 0 };
    return le({ ourProps: X, theirProps: J, slot: N, attrs: n, slots: o, features: Ne.RenderStrategy | Ne.Static, name: "ComboboxInput" });
  };
} });
let Ac = z({ name: "ComboboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, hold: { type: [Boolean], default: !1 } }, setup(e, { attrs: t, slots: n, expose: o }) {
  let r = Yt("ComboboxOptions"), i = `headlessui-combobox-options-${be()}`;
  o({ el: r.optionsRef, $el: r.optionsRef }), $e(() => {
    r.optionsPropsRef.value.static = e.static;
  }), $e(() => {
    r.optionsPropsRef.value.hold = e.hold;
  });
  let s = Mt(), a = E(() => s !== null ? (s.value & me.Open) === me.Open : r.comboboxState.value === 0);
  return ta({ container: E(() => D(r.optionsRef)), enabled: E(() => r.comboboxState.value === 0), accept(l) {
    return l.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : l.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(l) {
    l.setAttribute("role", "none");
  } }), () => {
    var l, u, c;
    let d = { open: r.comboboxState.value === 0 }, p = { "aria-labelledby": (c = (l = D(r.labelRef)) == null ? void 0 : l.id) != null ? c : (u = D(r.buttonRef)) == null ? void 0 : u.id, id: i, ref: r.optionsRef, role: "listbox", "aria-multiselectable": r.mode.value === 1 ? !0 : void 0 }, v = Rt(e, ["hold"]);
    return le({ ourProps: p, theirProps: v, slot: d, attrs: t, slots: r.virtual.value && r.comboboxState.value === 0 ? { ...n, default: () => [oe(kc, {}, n.default)] } : n, features: Ne.RenderStrategy | Ne.Static, visible: a.value, name: "ComboboxOptions" });
  };
} }), zi = z({ name: "ComboboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, order: { type: [Number], default: null } }, setup(e, { slots: t, attrs: n, expose: o }) {
  let r = Yt("ComboboxOption"), i = `headlessui-combobox-option-${be()}`, s = A(null);
  o({ el: s, $el: s });
  let a = E(() => {
    var S;
    return r.virtual.value ? r.activeOptionIndex.value === r.calculateIndex(e.value) : r.activeOptionIndex.value === null ? !1 : ((S = r.options.value[r.activeOptionIndex.value]) == null ? void 0 : S.id) === i;
  }), l = E(() => r.isSelected(e.value)), u = ge(ua, null), c = E(() => ({ disabled: e.disabled, value: e.value, domRef: s, order: E(() => e.order) }));
  ae(() => r.registerOption(i, c)), Me(() => r.unregisterOption(i, a.value)), $e(() => {
    let S = D(s);
    S && (u == null || u.value.measureElement(S));
  }), $e(() => {
    r.comboboxState.value === 0 && a.value && (r.virtual.value || r.activationTrigger.value !== 0 && ke(() => {
      var S, g;
      return (g = (S = D(s)) == null ? void 0 : S.scrollIntoView) == null ? void 0 : g.call(S, { block: "nearest" });
    }));
  });
  function d(S) {
    var g;
    if (e.disabled || (g = r.virtual.value) != null && g.disabled(e.value))
      return S.preventDefault();
    r.selectOption(i), Qs() || requestAnimationFrame(() => {
      var C;
      return (C = D(r.inputRef)) == null ? void 0 : C.focus({ preventScroll: !0 });
    }), r.mode.value === 0 && requestAnimationFrame(() => r.closeCombobox());
  }
  function p() {
    var S;
    if (e.disabled || (S = r.virtual.value) != null && S.disabled(e.value))
      return r.goToOption(ve.Nothing);
    let g = r.calculateIndex(e.value);
    r.goToOption(ve.Specific, g);
  }
  let v = ea();
  function x(S) {
    v.update(S);
  }
  function b(S) {
    var g;
    if (!v.wasMoved(S) || e.disabled || (g = r.virtual.value) != null && g.disabled(e.value) || a.value)
      return;
    let C = r.calculateIndex(e.value);
    r.goToOption(ve.Specific, C, 0);
  }
  function h(S) {
    var g;
    v.wasMoved(S) && (e.disabled || (g = r.virtual.value) != null && g.disabled(e.value) || a.value && (r.optionsPropsRef.value.hold || r.goToOption(ve.Nothing)));
  }
  return () => {
    let { disabled: S } = e, g = { active: a.value, selected: l.value, disabled: S }, C = { id: i, ref: s, role: "option", tabIndex: S === !0 ? void 0 : -1, "aria-disabled": S === !0 ? !0 : void 0, "aria-selected": l.value, disabled: void 0, onClick: d, onFocus: p, onPointerenter: x, onMouseenter: x, onPointermove: b, onMousemove: b, onPointerleave: h, onMouseleave: h }, w = Rt(e, ["order", "value"]);
    return le({ ourProps: C, theirProps: w, slot: g, attrs: n, slots: t, name: "ComboboxOption" });
  };
} });
function Ur(e, t, n, o) {
  _n.isServer || $e((r) => {
    e = e ?? window, e.addEventListener(t, n, o), r(() => e.removeEventListener(t, n, o));
  });
}
var Ge = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Ge || {});
function Wr() {
  let e = A(0);
  return Js("keydown", (t) => {
    t.key === "Tab" && (e.value = t.shiftKey ? 1 : 0);
  }), e;
}
function ca(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let n of e.value) {
    let o = D(n);
    o instanceof HTMLElement && t.add(o);
  }
  return t;
}
var da = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(da || {});
let gn = Object.assign(z({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: A(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: o }) {
  let r = A(null);
  o({ el: r, $el: r });
  let i = E(() => Ve(r)), s = A(!1);
  ae(() => s.value = !0), Me(() => s.value = !1), Rc({ ownerDocument: i }, E(() => s.value && !!(e.features & 16)));
  let a = Mc({ ownerDocument: i, container: r, initialFocus: E(() => e.initialFocus) }, E(() => s.value && !!(e.features & 2)));
  Tc({ ownerDocument: i, container: r, containers: e.containers, previousActiveElement: a }, E(() => s.value && !!(e.features & 8)));
  let l = Wr();
  function u(v) {
    let x = D(r);
    x && ((b) => b())(() => {
      fe(l.value, { [Ge.Forwards]: () => {
        Ze(x, Ae.First, { skipElements: [v.relatedTarget] });
      }, [Ge.Backwards]: () => {
        Ze(x, Ae.Last, { skipElements: [v.relatedTarget] });
      } });
    });
  }
  let c = A(!1);
  function d(v) {
    v.key === "Tab" && (c.value = !0, requestAnimationFrame(() => {
      c.value = !1;
    }));
  }
  function p(v) {
    if (!s.value)
      return;
    let x = ca(e.containers);
    D(r) instanceof HTMLElement && x.add(D(r));
    let b = v.relatedTarget;
    b instanceof HTMLElement && b.dataset.headlessuiFocusGuard !== "true" && (pa(x, b) || (c.value ? Ze(D(r), fe(l.value, { [Ge.Forwards]: () => Ae.Next, [Ge.Backwards]: () => Ae.Previous }) | Ae.WrapAround, { relativeTo: v.target }) : v.target instanceof HTMLElement && zt(v.target)));
  }
  return () => {
    let v = {}, x = { ref: r, onKeydown: d, onFocusout: p }, { features: b, initialFocus: h, containers: S, ...g } = e;
    return oe(K, [!!(b & 4) && oe(it, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: et.Focusable }), le({ ourProps: x, theirProps: { ...t, ...g }, slot: v, attrs: t, slots: n, name: "FocusTrap" }), !!(b & 4) && oe(it, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: u, features: et.Focusable })]);
  };
} }), { features: da });
function _c(e) {
  let t = A(Ct.slice());
  return he([e], ([n], [o]) => {
    o === !0 && n === !1 ? Hr(() => {
      t.value.splice(0);
    }) : o === !1 && n === !0 && (t.value = Ct.slice());
  }, { flush: "post" }), () => {
    var n;
    return (n = t.value.find((o) => o != null && o.isConnected)) != null ? n : null;
  };
}
function Rc({ ownerDocument: e }, t) {
  let n = _c(t);
  ae(() => {
    $e(() => {
      var o, r;
      t.value || ((o = e.value) == null ? void 0 : o.activeElement) === ((r = e.value) == null ? void 0 : r.body) && zt(n());
    }, { flush: "post" });
  }), Me(() => {
    t.value && zt(n());
  });
}
function Mc({ ownerDocument: e, container: t, initialFocus: n }, o) {
  let r = A(null), i = A(!1);
  return ae(() => i.value = !0), Me(() => i.value = !1), ae(() => {
    he([t, n, o], (s, a) => {
      if (s.every((u, c) => (a == null ? void 0 : a[c]) === u) || !o.value)
        return;
      let l = D(t);
      l && Hr(() => {
        var u, c;
        if (!i.value)
          return;
        let d = D(n), p = (u = e.value) == null ? void 0 : u.activeElement;
        if (d) {
          if (d === p) {
            r.value = p;
            return;
          }
        } else if (l.contains(p)) {
          r.value = p;
          return;
        }
        d ? zt(d) : Ze(l, Ae.First | Ae.NoScroll) === Ft.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), r.value = (c = e.value) == null ? void 0 : c.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), r;
}
function Tc({ ownerDocument: e, container: t, containers: n, previousActiveElement: o }, r) {
  var i;
  Ur((i = e.value) == null ? void 0 : i.defaultView, "focus", (s) => {
    if (!r.value)
      return;
    let a = ca(n);
    D(t) instanceof HTMLElement && a.add(D(t));
    let l = o.value;
    if (!l)
      return;
    let u = s.target;
    u && u instanceof HTMLElement ? pa(a, u) ? (o.value = u, zt(u)) : (s.preventDefault(), s.stopPropagation(), zt(l)) : zt(o.value);
  }, !0);
}
function pa(e, t) {
  for (let n of e)
    if (n.contains(t))
      return !0;
  return !1;
}
function Pc(e) {
  let t = zr(e.getSnapshot());
  return Me(e.subscribe(() => {
    t.value = e.getSnapshot();
  })), t;
}
function Ic(e, t) {
  let n = e(), o = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(r) {
    return o.add(r), () => o.delete(r);
  }, dispatch(r, ...i) {
    let s = t[r].call(n, ...i);
    s && (n = s, o.forEach((a) => a()));
  } };
}
function Lc() {
  let e;
  return { before({ doc: t }) {
    var n;
    let o = t.documentElement;
    e = ((n = t.defaultView) != null ? n : window).innerWidth - o.clientWidth;
  }, after({ doc: t, d: n }) {
    let o = t.documentElement, r = o.clientWidth - o.offsetWidth, i = e - r;
    n.style(o, "paddingRight", `${i}px`);
  } };
}
function Dc() {
  return Xs() ? { before({ doc: e, d: t, meta: n }) {
    function o(r) {
      return n.containers.flatMap((i) => i()).some((i) => i.contains(r));
    }
    t.microTask(() => {
      var r;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let a = Ht();
        a.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => a.dispose()));
      }
      let i = (r = window.scrollY) != null ? r : window.pageYOffset, s = null;
      t.addEventListener(e, "click", (a) => {
        if (a.target instanceof HTMLElement)
          try {
            let l = a.target.closest("a");
            if (!l)
              return;
            let { hash: u } = new URL(l.href), c = e.querySelector(u);
            c && !o(c) && (s = c);
          } catch {
          }
      }, !0), t.addEventListener(e, "touchstart", (a) => {
        if (a.target instanceof HTMLElement)
          if (o(a.target)) {
            let l = a.target;
            for (; l.parentElement && o(l.parentElement); )
              l = l.parentElement;
            t.style(l, "overscrollBehavior", "contain");
          } else
            t.style(a.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (a) => {
        if (a.target instanceof HTMLElement)
          if (o(a.target)) {
            let l = a.target;
            for (; l.parentElement && l.dataset.headlessuiPortal !== "" && !(l.scrollHeight > l.clientHeight || l.scrollWidth > l.clientWidth); )
              l = l.parentElement;
            l.dataset.headlessuiPortal === "" && a.preventDefault();
          } else
            a.preventDefault();
      }, { passive: !1 }), t.add(() => {
        var a;
        let l = (a = window.scrollY) != null ? a : window.pageYOffset;
        i !== l && window.scrollTo(0, i), s && s.isConnected && (s.scrollIntoView({ block: "nearest" }), s = null);
      });
    });
  } } : {};
}
function Bc() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function zc(e) {
  let t = {};
  for (let n of e)
    Object.assign(t, n(t));
  return t;
}
let Dt = Ic(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let o = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: Ht(), meta: /* @__PURE__ */ new Set() };
  return o.count++, o.meta.add(t), this.set(e, o), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let o = { doc: e, d: t, meta: zc(n) }, r = [Dc(), Lc(), Bc()];
  r.forEach(({ before: i }) => i == null ? void 0 : i(o)), r.forEach(({ after: i }) => i == null ? void 0 : i(o));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
Dt.subscribe(() => {
  let e = Dt.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e)
    t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let o = t.get(n.doc) === "hidden", r = n.count !== 0;
    (r && !o || !r && o) && Dt.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && Dt.dispatch("TEARDOWN", n);
  }
});
function Nc(e, t, n) {
  let o = Pc(Dt), r = E(() => {
    let i = e.value ? o.value.get(e.value) : void 0;
    return i ? i.count > 0 : !1;
  });
  return he([e, t], ([i, s], [a], l) => {
    if (!i || !s)
      return;
    Dt.dispatch("PUSH", i, n);
    let u = !1;
    l(() => {
      u || (Dt.dispatch("POP", a ?? i, n), u = !0);
    });
  }, { immediate: !0 }), r;
}
let Jo = /* @__PURE__ */ new Map(), bn = /* @__PURE__ */ new Map();
function Ni(e, t = A(!0)) {
  $e((n) => {
    var o;
    if (!t.value)
      return;
    let r = D(e);
    if (!r)
      return;
    n(function() {
      var s;
      if (!r)
        return;
      let a = (s = bn.get(r)) != null ? s : 1;
      if (a === 1 ? bn.delete(r) : bn.set(r, a - 1), a !== 1)
        return;
      let l = Jo.get(r);
      l && (l["aria-hidden"] === null ? r.removeAttribute("aria-hidden") : r.setAttribute("aria-hidden", l["aria-hidden"]), r.inert = l.inert, Jo.delete(r));
    });
    let i = (o = bn.get(r)) != null ? o : 0;
    bn.set(r, i + 1), i === 0 && (Jo.set(r, { "aria-hidden": r.getAttribute("aria-hidden"), inert: r.inert }), r.setAttribute("aria-hidden", "true"), r.inert = !0);
  });
}
function fa({ defaultContainers: e = [], portals: t, mainTreeNodeRef: n } = {}) {
  let o = A(null), r = Ve(o);
  function i() {
    var s, a, l;
    let u = [];
    for (let c of e)
      c !== null && (c instanceof HTMLElement ? u.push(c) : "value" in c && c.value instanceof HTMLElement && u.push(c.value));
    if (t != null && t.value)
      for (let c of t.value)
        u.push(c);
    for (let c of (s = r == null ? void 0 : r.querySelectorAll("html > *, body > *")) != null ? s : [])
      c !== document.body && c !== document.head && c instanceof HTMLElement && c.id !== "headlessui-portal-root" && (c.contains(D(o)) || c.contains((l = (a = D(o)) == null ? void 0 : a.getRootNode()) == null ? void 0 : l.host) || u.some((d) => c.contains(d)) || u.push(c));
    return u;
  }
  return { resolveContainers: i, contains(s) {
    return i().some((a) => a.contains(s));
  }, mainTreeNodeRef: o, MainTreeNode() {
    return n != null ? null : oe(it, { features: et.Hidden, ref: o });
  } };
}
function jc() {
  let e = A(null);
  return { mainTreeNodeRef: e, MainTreeNode() {
    return oe(it, { features: et.Hidden, ref: e });
  } };
}
let ha = Symbol("ForcePortalRootContext");
function Vc() {
  return ge(ha, !1);
}
let vr = z({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: t, attrs: n }) {
  return xe(ha, e.force), () => {
    let { force: o, ...r } = e;
    return le({ theirProps: r, ourProps: {}, slot: {}, slots: t, attrs: n, name: "ForcePortalRoot" });
  };
} }), va = Symbol("StackContext");
var mr = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(mr || {});
function Fc() {
  return ge(va, () => {
  });
}
function Hc({ type: e, enabled: t, element: n, onUpdate: o }) {
  let r = Fc();
  function i(...s) {
    o == null || o(...s), r(...s);
  }
  ae(() => {
    he(t, (s, a) => {
      s ? i(0, e, n) : a === !0 && i(1, e, n);
    }, { immediate: !0, flush: "sync" });
  }), Me(() => {
    t.value && i(1, e, n);
  }), xe(va, i);
}
let ma = Symbol("DescriptionContext");
function Uc() {
  let e = ge(ma, null);
  if (e === null)
    throw new Error("Missing parent");
  return e;
}
function So({ slot: e = A({}), name: t = "Description", props: n = {} } = {}) {
  let o = A([]);
  function r(i) {
    return o.value.push(i), () => {
      let s = o.value.indexOf(i);
      s !== -1 && o.value.splice(s, 1);
    };
  }
  return xe(ma, { register: r, slot: e, name: t, props: n }), E(() => o.value.length > 0 ? o.value.join(" ") : void 0);
}
let ga = z({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var o;
  let r = (o = e.id) != null ? o : `headlessui-description-${be()}`, i = Uc();
  return ae(() => Me(i.register(r))), () => {
    let { name: s = "Description", slot: a = A({}), props: l = {} } = i, { ...u } = e, c = { ...Object.entries(l).reduce((d, [p, v]) => Object.assign(d, { [p]: T(v) }), {}), id: r };
    return le({ ourProps: c, theirProps: u, slot: a.value, attrs: t, slots: n, name: s });
  };
} });
function Wc(e) {
  let t = Ve(e);
  if (!t) {
    if (e === null)
      return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let n = t.getElementById("headlessui-portal-root");
  if (n)
    return n;
  let o = t.createElement("div");
  return o.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(o);
}
let ba = z({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: n }) {
  let o = A(null), r = E(() => Ve(o)), i = Vc(), s = ge(wa, null), a = A(i === !0 || s == null ? Wc(o.value) : s.resolveTarget()), l = A(!1);
  ae(() => {
    l.value = !0;
  }), $e(() => {
    i || s != null && (a.value = s.resolveTarget());
  });
  let u = ge(gr, null), c = !1, d = vo();
  return he(o, () => {
    if (c || !u)
      return;
    let p = D(o);
    p && (Me(u.register(p), d), c = !0);
  }), Me(() => {
    var p, v;
    let x = (p = r.value) == null ? void 0 : p.getElementById("headlessui-portal-root");
    x && a.value === x && a.value.children.length <= 0 && ((v = a.value.parentElement) == null || v.removeChild(a.value));
  }), () => {
    if (!l.value || a.value === null)
      return null;
    let p = { ref: o, "data-headlessui-portal": "" };
    return oe(jr, { to: a.value }, le({ ourProps: p, theirProps: e, slot: {}, attrs: n, slots: t, name: "Portal" }));
  };
} }), gr = Symbol("PortalParentContext");
function ya() {
  let e = ge(gr, null), t = A([]);
  function n(i) {
    return t.value.push(i), e && e.register(i), () => o(i);
  }
  function o(i) {
    let s = t.value.indexOf(i);
    s !== -1 && t.value.splice(s, 1), e && e.unregister(i);
  }
  let r = { register: n, unregister: o, portals: t };
  return [t, z({ name: "PortalWrapper", setup(i, { slots: s }) {
    return xe(gr, r), () => {
      var a;
      return (a = s.default) == null ? void 0 : a.call(s);
    };
  } })];
}
let wa = Symbol("PortalGroupContext"), qc = z({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: t, slots: n }) {
  let o = Nr({ resolveTarget() {
    return e.target;
  } });
  return xe(wa, o), () => {
    let { target: r, ...i } = e;
    return le({ theirProps: i, ourProps: {}, slot: {}, attrs: t, slots: n, name: "PortalGroup" });
  };
} });
var Zc = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Zc || {});
let br = Symbol("DialogContext");
function Tn(e) {
  let t = ge(br, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Tn), n;
  }
  return t;
}
let jn = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", xa = z({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: jn }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (e) => !0 }, setup(e, { emit: t, attrs: n, slots: o, expose: r }) {
  var i, s;
  let a = (i = e.id) != null ? i : `headlessui-dialog-${be()}`, l = A(!1);
  ae(() => {
    l.value = !0;
  });
  let u = !1, c = E(() => e.role === "dialog" || e.role === "alertdialog" ? e.role : (u || (u = !0, console.warn(`Invalid role [${c}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), d = A(0), p = Mt(), v = E(() => e.open === jn && p !== null ? (p.value & me.Open) === me.Open : e.open), x = A(null), b = E(() => Ve(x));
  if (r({ el: x, $el: x }), !(e.open !== jn || p !== null))
    throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof v.value != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${v.value === jn ? void 0 : e.open}`);
  let h = E(() => l.value && v.value ? 0 : 1), S = E(() => h.value === 0), g = E(() => d.value > 1), C = ge(br, null) !== null, [w, $] = ya(), { resolveContainers: k, mainTreeNodeRef: _, MainTreeNode: M } = fa({ portals: w, defaultContainers: [E(() => {
    var V;
    return (V = ye.panelRef.value) != null ? V : x.value;
  })] }), U = E(() => g.value ? "parent" : "leaf"), L = E(() => p !== null ? (p.value & me.Closing) === me.Closing : !1), N = E(() => C || L.value ? !1 : S.value), Z = E(() => {
    var V, q, ee;
    return (ee = Array.from((q = (V = b.value) == null ? void 0 : V.querySelectorAll("body > *")) != null ? q : []).find((ue) => ue.id === "headlessui-portal-root" ? !1 : ue.contains(D(_)) && ue instanceof HTMLElement)) != null ? ee : null;
  });
  Ni(Z, N);
  let H = E(() => g.value ? !0 : S.value), J = E(() => {
    var V, q, ee;
    return (ee = Array.from((q = (V = b.value) == null ? void 0 : V.querySelectorAll("[data-headlessui-portal]")) != null ? q : []).find((ue) => ue.contains(D(_)) && ue instanceof HTMLElement)) != null ? ee : null;
  });
  Ni(J, H), Hc({ type: "Dialog", enabled: E(() => h.value === 0), element: x, onUpdate: (V, q) => {
    if (q === "Dialog")
      return fe(V, { [mr.Add]: () => d.value += 1, [mr.Remove]: () => d.value -= 1 });
  } });
  let X = So({ name: "DialogDescription", slot: E(() => ({ open: v.value })) }), ie = A(null), ye = { titleId: ie, panelRef: A(null), dialogState: h, setTitleId(V) {
    ie.value !== V && (ie.value = V);
  }, close() {
    t("close", !1);
  } };
  xe(br, ye);
  let Se = E(() => !(!S.value || g.value));
  xo(k, (V, q) => {
    ye.close(), ke(() => q == null ? void 0 : q.focus());
  }, Se);
  let Oe = E(() => !(g.value || h.value !== 0));
  Ur((s = b.value) == null ? void 0 : s.defaultView, "keydown", (V) => {
    Oe.value && (V.defaultPrevented || V.key === Q.Escape && (V.preventDefault(), V.stopPropagation(), ye.close()));
  });
  let qe = E(() => !(L.value || h.value !== 0 || C));
  return Nc(b, qe, (V) => {
    var q;
    return { containers: [...(q = V.containers) != null ? q : [], k] };
  }), $e((V) => {
    if (h.value !== 0)
      return;
    let q = D(x);
    if (!q)
      return;
    let ee = new ResizeObserver((ue) => {
      for (let te of ue) {
        let Ce = te.target.getBoundingClientRect();
        Ce.x === 0 && Ce.y === 0 && Ce.width === 0 && Ce.height === 0 && ye.close();
      }
    });
    ee.observe(q), V(() => ee.disconnect());
  }), () => {
    let { open: V, initialFocus: q, ...ee } = e, ue = { ...n, ref: x, id: a, role: c.value, "aria-modal": h.value === 0 ? !0 : void 0, "aria-labelledby": ie.value, "aria-describedby": X.value }, te = { open: h.value === 0 };
    return oe(vr, { force: !0 }, () => [oe(ba, () => oe(qc, { target: x.value }, () => oe(vr, { force: !1 }, () => oe(gn, { initialFocus: q, containers: k, features: S.value ? fe(U.value, { parent: gn.features.RestoreFocus, leaf: gn.features.All & ~gn.features.FocusLock }) : gn.features.None }, () => oe($, {}, () => le({ ourProps: ue, theirProps: { ...ee, ...n }, slot: te, attrs: n, slots: o, visible: h.value === 0, features: Ne.RenderStrategy | Ne.Static, name: "Dialog" })))))), oe(M)]);
  };
} }), $a = z({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var o;
  let r = (o = e.id) != null ? o : `headlessui-dialog-overlay-${be()}`, i = Tn("DialogOverlay");
  function s(a) {
    a.target === a.currentTarget && (a.preventDefault(), a.stopPropagation(), i.close());
  }
  return () => {
    let { ...a } = e;
    return le({ ourProps: { id: r, "aria-hidden": !0, onClick: s }, theirProps: a, slot: { open: i.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogOverlay" });
  };
} });
z({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: o }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-dialog-backdrop-${be()}`, s = Tn("DialogBackdrop"), a = A(null);
  return o({ el: a, $el: a }), ae(() => {
    if (s.panelRef.value === null)
      throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...l } = e, u = { id: i, ref: a, "aria-hidden": !0 };
    return oe(vr, { force: !0 }, () => oe(ba, () => le({ ourProps: u, theirProps: { ...t, ...l }, slot: { open: s.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogBackdrop" })));
  };
} });
z({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: o }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-dialog-panel-${be()}`, s = Tn("DialogPanel");
  o({ el: s.panelRef, $el: s.panelRef });
  function a(l) {
    l.stopPropagation();
  }
  return () => {
    let { ...l } = e, u = { id: i, ref: s.panelRef, onClick: a };
    return le({ ourProps: u, theirProps: l, slot: { open: s.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogPanel" });
  };
} });
let Ca = z({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var o;
  let r = (o = e.id) != null ? o : `headlessui-dialog-title-${be()}`, i = Tn("DialogTitle");
  return ae(() => {
    i.setTitleId(r), Me(() => i.setTitleId(null));
  }), () => {
    let { ...s } = e;
    return le({ ourProps: { id: r }, theirProps: s, slot: { open: i.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogTitle" });
  };
} });
var Gc = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Gc || {});
let Sa = Symbol("DisclosureContext");
function qr(e) {
  let t = ge(Sa, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, qr), n;
  }
  return t;
}
let ka = Symbol("DisclosurePanelContext");
function Kc() {
  return ge(ka, null);
}
let Yc = z({ name: "Disclosure", props: { as: { type: [Object, String], default: "template" }, defaultOpen: { type: [Boolean], default: !1 } }, setup(e, { slots: t, attrs: n }) {
  let o = A(e.defaultOpen ? 0 : 1), r = A(null), i = A(null), s = { buttonId: A(`headlessui-disclosure-button-${be()}`), panelId: A(`headlessui-disclosure-panel-${be()}`), disclosureState: o, panel: r, button: i, toggleDisclosure() {
    o.value = fe(o.value, { 0: 1, 1: 0 });
  }, closeDisclosure() {
    o.value !== 1 && (o.value = 1);
  }, close(a) {
    s.closeDisclosure();
    let l = (() => a ? a instanceof HTMLElement ? a : a.value instanceof HTMLElement ? D(a) : D(s.button) : D(s.button))();
    l == null || l.focus();
  } };
  return xe(Sa, s), Mn(E(() => fe(o.value, { 0: me.Open, 1: me.Closed }))), () => {
    let { defaultOpen: a, ...l } = e, u = { open: o.value === 0, close: s.close };
    return le({ theirProps: l, ourProps: {}, slot: u, slots: t, attrs: n, name: "Disclosure" });
  };
} }), Xc = z({ name: "DisclosureButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: o }) {
  let r = qr("DisclosureButton"), i = Kc(), s = E(() => i === null ? !1 : i.value === r.panelId.value);
  ae(() => {
    s.value || e.id !== null && (r.buttonId.value = e.id);
  }), Me(() => {
    s.value || (r.buttonId.value = null);
  });
  let a = A(null);
  o({ el: a, $el: a }), s.value || $e(() => {
    r.button.value = a.value;
  });
  let l = Rn(E(() => ({ as: e.as, type: t.type })), a);
  function u() {
    var p;
    e.disabled || (s.value ? (r.toggleDisclosure(), (p = D(r.button)) == null || p.focus()) : r.toggleDisclosure());
  }
  function c(p) {
    var v;
    if (!e.disabled)
      if (s.value)
        switch (p.key) {
          case Q.Space:
          case Q.Enter:
            p.preventDefault(), p.stopPropagation(), r.toggleDisclosure(), (v = D(r.button)) == null || v.focus();
            break;
        }
      else
        switch (p.key) {
          case Q.Space:
          case Q.Enter:
            p.preventDefault(), p.stopPropagation(), r.toggleDisclosure();
            break;
        }
  }
  function d(p) {
    switch (p.key) {
      case Q.Space:
        p.preventDefault();
        break;
    }
  }
  return () => {
    var p;
    let v = { open: r.disclosureState.value === 0 }, { id: x, ...b } = e, h = s.value ? { ref: a, type: l.value, onClick: u, onKeydown: c } : { id: (p = r.buttonId.value) != null ? p : x, ref: a, type: l.value, "aria-expanded": r.disclosureState.value === 0, "aria-controls": r.disclosureState.value === 0 || D(r.panel) ? r.panelId.value : void 0, disabled: e.disabled ? !0 : void 0, onClick: u, onKeydown: c, onKeyup: d };
    return le({ ourProps: h, theirProps: b, slot: v, attrs: t, slots: n, name: "DisclosureButton" });
  };
} });
z({ name: "DisclosurePanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: o }) {
  let r = qr("DisclosurePanel");
  ae(() => {
    e.id !== null && (r.panelId.value = e.id);
  }), Me(() => {
    r.panelId.value = null;
  }), o({ el: r.panel, $el: r.panel }), xe(ka, r.panelId);
  let i = Mt(), s = E(() => i !== null ? (i.value & me.Open) === me.Open : r.disclosureState.value === 0);
  return () => {
    var a;
    let l = { open: r.disclosureState.value === 0, close: r.close }, { id: u, ...c } = e, d = { id: (a = r.panelId.value) != null ? a : u, ref: r.panel };
    return le({ ourProps: d, theirProps: c, slot: l, attrs: t, slots: n, features: Ne.RenderStrategy | Ne.Static, visible: s.value, name: "DisclosurePanel" });
  };
} });
let ji = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function Vi(e) {
  var t, n;
  let o = (t = e.innerText) != null ? t : "", r = e.cloneNode(!0);
  if (!(r instanceof HTMLElement))
    return o;
  let i = !1;
  for (let a of r.querySelectorAll('[hidden],[aria-hidden],[role="img"]'))
    a.remove(), i = !0;
  let s = i ? (n = r.innerText) != null ? n : "" : o;
  return ji.test(s) && (s = s.replace(ji, "")), s;
}
function Qc(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string")
    return t.trim();
  let n = e.getAttribute("aria-labelledby");
  if (n) {
    let o = n.split(" ").map((r) => {
      let i = document.getElementById(r);
      if (i) {
        let s = i.getAttribute("aria-label");
        return typeof s == "string" ? s.trim() : Vi(i).trim();
      }
      return null;
    }).filter(Boolean);
    if (o.length > 0)
      return o.join(", ");
  }
  return Vi(e).trim();
}
function Jc(e) {
  let t = A(""), n = A("");
  return () => {
    let o = D(e);
    if (!o)
      return "";
    let r = o.innerText;
    if (t.value === r)
      return n.value;
    let i = Qc(o).trim().toLowerCase();
    return t.value = r, n.value = i, i;
  };
}
function ed(e, t) {
  return e === t;
}
var td = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(td || {}), nd = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(nd || {}), od = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(od || {});
function rd(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let Ea = Symbol("ListboxContext");
function Pn(e) {
  let t = ge(Ea, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Pn), n;
  }
  return t;
}
let ko = z({ name: "Listbox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => ed }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: t, attrs: n, emit: o }) {
  let r = A(1), i = A(null), s = A(null), a = A(null), l = A([]), u = A(""), c = A(null), d = A(1);
  function p(C = (w) => w) {
    let w = c.value !== null ? l.value[c.value] : null, $ = wo(C(l.value.slice()), (_) => D(_.dataRef.domRef)), k = w ? $.indexOf(w) : null;
    return k === -1 && (k = null), { options: $, activeOptionIndex: k };
  }
  let v = E(() => e.multiple ? 1 : 0), [x, b] = go(E(() => e.modelValue), (C) => o("update:modelValue", C), E(() => e.defaultValue)), h = E(() => x.value === void 0 ? fe(v.value, { 1: [], 0: void 0 }) : x.value), S = { listboxState: r, value: h, mode: v, compare(C, w) {
    if (typeof e.by == "string") {
      let $ = e.by;
      return (C == null ? void 0 : C[$]) === (w == null ? void 0 : w[$]);
    }
    return e.by(C, w);
  }, orientation: E(() => e.horizontal ? "horizontal" : "vertical"), labelRef: i, buttonRef: s, optionsRef: a, disabled: E(() => e.disabled), options: l, searchQuery: u, activeOptionIndex: c, activationTrigger: d, closeListbox() {
    e.disabled || r.value !== 1 && (r.value = 1, c.value = null);
  }, openListbox() {
    e.disabled || r.value !== 0 && (r.value = 0);
  }, goToOption(C, w, $) {
    if (e.disabled || r.value === 1)
      return;
    let k = p(), _ = hr(C === ve.Specific ? { focus: ve.Specific, id: w } : { focus: C }, { resolveItems: () => k.options, resolveActiveIndex: () => k.activeOptionIndex, resolveId: (M) => M.id, resolveDisabled: (M) => M.dataRef.disabled });
    u.value = "", c.value = _, d.value = $ ?? 1, l.value = k.options;
  }, search(C) {
    if (e.disabled || r.value === 1)
      return;
    let w = u.value !== "" ? 0 : 1;
    u.value += C.toLowerCase();
    let $ = (c.value !== null ? l.value.slice(c.value + w).concat(l.value.slice(0, c.value + w)) : l.value).find((_) => _.dataRef.textValue.startsWith(u.value) && !_.dataRef.disabled), k = $ ? l.value.indexOf($) : -1;
    k === -1 || k === c.value || (c.value = k, d.value = 1);
  }, clearSearch() {
    e.disabled || r.value !== 1 && u.value !== "" && (u.value = "");
  }, registerOption(C, w) {
    let $ = p((k) => [...k, { id: C, dataRef: w }]);
    l.value = $.options, c.value = $.activeOptionIndex;
  }, unregisterOption(C) {
    let w = p(($) => {
      let k = $.findIndex((_) => _.id === C);
      return k !== -1 && $.splice(k, 1), $;
    });
    l.value = w.options, c.value = w.activeOptionIndex, d.value = 1;
  }, theirOnChange(C) {
    e.disabled || b(C);
  }, select(C) {
    e.disabled || b(fe(v.value, { 0: () => C, 1: () => {
      let w = we(S.value.value).slice(), $ = we(C), k = w.findIndex((_) => S.compare($, we(_)));
      return k === -1 ? w.push($) : w.splice(k, 1), w;
    } }));
  } };
  xo([s, a], (C, w) => {
    var $;
    S.closeListbox(), Fr(w, yo.Loose) || (C.preventDefault(), ($ = D(s)) == null || $.focus());
  }, E(() => r.value === 0)), xe(Ea, S), Mn(E(() => fe(r.value, { 0: me.Open, 1: me.Closed })));
  let g = E(() => {
    var C;
    return (C = D(s)) == null ? void 0 : C.closest("form");
  });
  return ae(() => {
    he([g], () => {
      if (!g.value || e.defaultValue === void 0)
        return;
      function C() {
        S.theirOnChange(e.defaultValue);
      }
      return g.value.addEventListener("reset", C), () => {
        var w;
        (w = g.value) == null || w.removeEventListener("reset", C);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: C, modelValue: w, disabled: $, form: k, ..._ } = e, M = { open: r.value === 0, disabled: $, value: h.value };
    return oe(K, [...C != null && h.value != null ? Co({ [C]: h.value }).map(([U, L]) => oe(it, $o({ features: et.Hidden, key: U, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: k, name: U, value: L }))) : [], le({ ourProps: {}, theirProps: { ...n, ...Rt(_, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: M, slots: t, attrs: n, name: "Listbox" })]);
  };
} }), Oa = z({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var o;
  let r = (o = e.id) != null ? o : `headlessui-listbox-label-${be()}`, i = Pn("ListboxLabel");
  function s() {
    var a;
    (a = D(i.buttonRef)) == null || a.focus({ preventScroll: !0 });
  }
  return () => {
    let a = { open: i.listboxState.value === 0, disabled: i.disabled.value }, { ...l } = e, u = { id: r, ref: i.labelRef, onClick: s };
    return le({ ourProps: u, theirProps: l, slot: a, attrs: t, slots: n, name: "ListboxLabel" });
  };
} }), Zr = z({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: o }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-listbox-button-${be()}`, s = Pn("ListboxButton");
  o({ el: s.buttonRef, $el: s.buttonRef });
  function a(d) {
    switch (d.key) {
      case Q.Space:
      case Q.Enter:
      case Q.ArrowDown:
        d.preventDefault(), s.openListbox(), ke(() => {
          var p;
          (p = D(s.optionsRef)) == null || p.focus({ preventScroll: !0 }), s.value.value || s.goToOption(ve.First);
        });
        break;
      case Q.ArrowUp:
        d.preventDefault(), s.openListbox(), ke(() => {
          var p;
          (p = D(s.optionsRef)) == null || p.focus({ preventScroll: !0 }), s.value.value || s.goToOption(ve.Last);
        });
        break;
    }
  }
  function l(d) {
    switch (d.key) {
      case Q.Space:
        d.preventDefault();
        break;
    }
  }
  function u(d) {
    s.disabled.value || (s.listboxState.value === 0 ? (s.closeListbox(), ke(() => {
      var p;
      return (p = D(s.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
    })) : (d.preventDefault(), s.openListbox(), rd(() => {
      var p;
      return (p = D(s.optionsRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
    })));
  }
  let c = Rn(E(() => ({ as: e.as, type: t.type })), s.buttonRef);
  return () => {
    var d, p;
    let v = { open: s.listboxState.value === 0, disabled: s.disabled.value, value: s.value.value }, { ...x } = e, b = { ref: s.buttonRef, id: i, type: c.value, "aria-haspopup": "listbox", "aria-controls": (d = D(s.optionsRef)) == null ? void 0 : d.id, "aria-expanded": s.listboxState.value === 0, "aria-labelledby": s.labelRef.value ? [(p = D(s.labelRef)) == null ? void 0 : p.id, i].join(" ") : void 0, disabled: s.disabled.value === !0 ? !0 : void 0, onKeydown: a, onKeyup: l, onClick: u };
    return le({ ourProps: b, theirProps: x, slot: v, attrs: t, slots: n, name: "ListboxButton" });
  };
} }), Eo = z({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: o }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-listbox-options-${be()}`, s = Pn("ListboxOptions"), a = A(null);
  o({ el: s.optionsRef, $el: s.optionsRef });
  function l(d) {
    switch (a.value && clearTimeout(a.value), d.key) {
      case Q.Space:
        if (s.searchQuery.value !== "")
          return d.preventDefault(), d.stopPropagation(), s.search(d.key);
      case Q.Enter:
        if (d.preventDefault(), d.stopPropagation(), s.activeOptionIndex.value !== null) {
          let p = s.options.value[s.activeOptionIndex.value];
          s.select(p.dataRef.value);
        }
        s.mode.value === 0 && (s.closeListbox(), ke(() => {
          var p;
          return (p = D(s.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
        }));
        break;
      case fe(s.orientation.value, { vertical: Q.ArrowDown, horizontal: Q.ArrowRight }):
        return d.preventDefault(), d.stopPropagation(), s.goToOption(ve.Next);
      case fe(s.orientation.value, { vertical: Q.ArrowUp, horizontal: Q.ArrowLeft }):
        return d.preventDefault(), d.stopPropagation(), s.goToOption(ve.Previous);
      case Q.Home:
      case Q.PageUp:
        return d.preventDefault(), d.stopPropagation(), s.goToOption(ve.First);
      case Q.End:
      case Q.PageDown:
        return d.preventDefault(), d.stopPropagation(), s.goToOption(ve.Last);
      case Q.Escape:
        d.preventDefault(), d.stopPropagation(), s.closeListbox(), ke(() => {
          var p;
          return (p = D(s.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
        });
        break;
      case Q.Tab:
        d.preventDefault(), d.stopPropagation();
        break;
      default:
        d.key.length === 1 && (s.search(d.key), a.value = setTimeout(() => s.clearSearch(), 350));
        break;
    }
  }
  let u = Mt(), c = E(() => u !== null ? (u.value & me.Open) === me.Open : s.listboxState.value === 0);
  return () => {
    var d, p;
    let v = { open: s.listboxState.value === 0 }, { ...x } = e, b = { "aria-activedescendant": s.activeOptionIndex.value === null || (d = s.options.value[s.activeOptionIndex.value]) == null ? void 0 : d.id, "aria-multiselectable": s.mode.value === 1 ? !0 : void 0, "aria-labelledby": (p = D(s.buttonRef)) == null ? void 0 : p.id, "aria-orientation": s.orientation.value, id: i, onKeydown: l, role: "listbox", tabIndex: 0, ref: s.optionsRef };
    return le({ ourProps: b, theirProps: x, slot: v, attrs: t, slots: n, features: Ne.RenderStrategy | Ne.Static, visible: c.value, name: "ListboxOptions" });
  };
} }), In = z({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: n, expose: o }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-listbox-option-${be()}`, s = Pn("ListboxOption"), a = A(null);
  o({ el: a, $el: a });
  let l = E(() => s.activeOptionIndex.value !== null ? s.options.value[s.activeOptionIndex.value].id === i : !1), u = E(() => fe(s.mode.value, { 0: () => s.compare(we(s.value.value), we(e.value)), 1: () => we(s.value.value).some((C) => s.compare(we(C), we(e.value))) })), c = E(() => fe(s.mode.value, { 1: () => {
    var C;
    let w = we(s.value.value);
    return ((C = s.options.value.find(($) => w.some((k) => s.compare(we(k), we($.dataRef.value))))) == null ? void 0 : C.id) === i;
  }, 0: () => u.value })), d = Jc(a), p = E(() => ({ disabled: e.disabled, value: e.value, get textValue() {
    return d();
  }, domRef: a }));
  ae(() => s.registerOption(i, p)), Me(() => s.unregisterOption(i)), ae(() => {
    he([s.listboxState, u], () => {
      s.listboxState.value === 0 && u.value && fe(s.mode.value, { 1: () => {
        c.value && s.goToOption(ve.Specific, i);
      }, 0: () => {
        s.goToOption(ve.Specific, i);
      } });
    }, { immediate: !0 });
  }), $e(() => {
    s.listboxState.value === 0 && l.value && s.activationTrigger.value !== 0 && ke(() => {
      var C, w;
      return (w = (C = D(a)) == null ? void 0 : C.scrollIntoView) == null ? void 0 : w.call(C, { block: "nearest" });
    });
  });
  function v(C) {
    if (e.disabled)
      return C.preventDefault();
    s.select(e.value), s.mode.value === 0 && (s.closeListbox(), ke(() => {
      var w;
      return (w = D(s.buttonRef)) == null ? void 0 : w.focus({ preventScroll: !0 });
    }));
  }
  function x() {
    if (e.disabled)
      return s.goToOption(ve.Nothing);
    s.goToOption(ve.Specific, i);
  }
  let b = ea();
  function h(C) {
    b.update(C);
  }
  function S(C) {
    b.wasMoved(C) && (e.disabled || l.value || s.goToOption(ve.Specific, i, 0));
  }
  function g(C) {
    b.wasMoved(C) && (e.disabled || l.value && s.goToOption(ve.Nothing));
  }
  return () => {
    let { disabled: C } = e, w = { active: l.value, selected: u.value, disabled: C }, { value: $, disabled: k, ..._ } = e, M = { id: i, ref: a, role: "option", tabIndex: C === !0 ? void 0 : -1, "aria-disabled": C === !0 ? !0 : void 0, "aria-selected": u.value, disabled: void 0, onClick: v, onFocus: x, onPointerenter: h, onMouseenter: h, onPointermove: S, onMousemove: S, onPointerleave: g, onMouseleave: g };
    return le({ ourProps: M, theirProps: _, slot: w, attrs: n, slots: t, name: "ListboxOption" });
  };
} });
var id = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(id || {});
let Aa = Symbol("PopoverContext");
function Oo(e) {
  let t = ge(Aa, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <${Gr.name} /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, Oo), n;
  }
  return t;
}
let _a = Symbol("PopoverGroupContext");
function Ra() {
  return ge(_a, null);
}
let Ma = Symbol("PopoverPanelContext");
function sd() {
  return ge(Ma, null);
}
let Gr = z({ name: "Popover", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: n, expose: o }) {
  var r;
  let i = A(null);
  o({ el: i, $el: i });
  let s = A(1), a = A(null), l = A(null), u = A(null), c = A(null), d = E(() => Ve(i)), p = E(() => {
    var $, k;
    if (!D(a) || !D(c))
      return !1;
    for (let H of document.querySelectorAll("body > *"))
      if (Number(H == null ? void 0 : H.contains(D(a))) ^ Number(H == null ? void 0 : H.contains(D(c))))
        return !0;
    let _ = bo(), M = _.indexOf(D(a)), U = (M + _.length - 1) % _.length, L = (M + 1) % _.length, N = _[U], Z = _[L];
    return !(($ = D(c)) != null && $.contains(N)) && !((k = D(c)) != null && k.contains(Z));
  }), v = { popoverState: s, buttonId: A(null), panelId: A(null), panel: c, button: a, isPortalled: p, beforePanelSentinel: l, afterPanelSentinel: u, togglePopover() {
    s.value = fe(s.value, { 0: 1, 1: 0 });
  }, closePopover() {
    s.value !== 1 && (s.value = 1);
  }, close($) {
    v.closePopover();
    let k = (() => $ ? $ instanceof HTMLElement ? $ : $.value instanceof HTMLElement ? D($) : D(v.button) : D(v.button))();
    k == null || k.focus();
  } };
  xe(Aa, v), Mn(E(() => fe(s.value, { 0: me.Open, 1: me.Closed })));
  let x = { buttonId: v.buttonId, panelId: v.panelId, close() {
    v.closePopover();
  } }, b = Ra(), h = b == null ? void 0 : b.registerPopover, [S, g] = ya(), C = fa({ mainTreeNodeRef: b == null ? void 0 : b.mainTreeNodeRef, portals: S, defaultContainers: [a, c] });
  function w() {
    var $, k, _, M;
    return (M = b == null ? void 0 : b.isFocusWithinPopoverGroup()) != null ? M : (($ = d.value) == null ? void 0 : $.activeElement) && (((k = D(a)) == null ? void 0 : k.contains(d.value.activeElement)) || ((_ = D(c)) == null ? void 0 : _.contains(d.value.activeElement)));
  }
  return $e(() => h == null ? void 0 : h(x)), Ur((r = d.value) == null ? void 0 : r.defaultView, "focus", ($) => {
    var k, _;
    $.target !== window && $.target instanceof HTMLElement && s.value === 0 && (w() || a && c && (C.contains($.target) || (k = D(v.beforePanelSentinel)) != null && k.contains($.target) || (_ = D(v.afterPanelSentinel)) != null && _.contains($.target) || v.closePopover()));
  }, !0), xo(C.resolveContainers, ($, k) => {
    var _;
    v.closePopover(), Fr(k, yo.Loose) || ($.preventDefault(), (_ = D(a)) == null || _.focus());
  }, E(() => s.value === 0)), () => {
    let $ = { open: s.value === 0, close: v.close };
    return oe(K, [oe(g, {}, () => le({ theirProps: { ...e, ...n }, ourProps: { ref: i }, slot: $, slots: t, attrs: n, name: "Popover" })), oe(C.MainTreeNode)]);
  };
} }), Ta = z({ name: "PopoverButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: o }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-popover-button-${be()}`, s = Oo("PopoverButton"), a = E(() => Ve(s.button));
  o({ el: s.button, $el: s.button }), ae(() => {
    s.buttonId.value = i;
  }), Me(() => {
    s.buttonId.value = null;
  });
  let l = Ra(), u = l == null ? void 0 : l.closeOthers, c = sd(), d = E(() => c === null ? !1 : c.value === s.panelId.value), p = A(null), v = `headlessui-focus-sentinel-${be()}`;
  d.value || $e(() => {
    s.button.value = D(p);
  });
  let x = Rn(E(() => ({ as: e.as, type: t.type })), p);
  function b($) {
    var k, _, M, U, L;
    if (d.value) {
      if (s.popoverState.value === 1)
        return;
      switch ($.key) {
        case Q.Space:
        case Q.Enter:
          $.preventDefault(), (_ = (k = $.target).click) == null || _.call(k), s.closePopover(), (M = D(s.button)) == null || M.focus();
          break;
      }
    } else
      switch ($.key) {
        case Q.Space:
        case Q.Enter:
          $.preventDefault(), $.stopPropagation(), s.popoverState.value === 1 && (u == null || u(s.buttonId.value)), s.togglePopover();
          break;
        case Q.Escape:
          if (s.popoverState.value !== 0)
            return u == null ? void 0 : u(s.buttonId.value);
          if (!D(s.button) || (U = a.value) != null && U.activeElement && !((L = D(s.button)) != null && L.contains(a.value.activeElement)))
            return;
          $.preventDefault(), $.stopPropagation(), s.closePopover();
          break;
      }
  }
  function h($) {
    d.value || $.key === Q.Space && $.preventDefault();
  }
  function S($) {
    var k, _;
    e.disabled || (d.value ? (s.closePopover(), (k = D(s.button)) == null || k.focus()) : ($.preventDefault(), $.stopPropagation(), s.popoverState.value === 1 && (u == null || u(s.buttonId.value)), s.togglePopover(), (_ = D(s.button)) == null || _.focus()));
  }
  function g($) {
    $.preventDefault(), $.stopPropagation();
  }
  let C = Wr();
  function w() {
    let $ = D(s.panel);
    if (!$)
      return;
    function k() {
      fe(C.value, { [Ge.Forwards]: () => Ze($, Ae.First), [Ge.Backwards]: () => Ze($, Ae.Last) }) === Ft.Error && Ze(bo().filter((_) => _.dataset.headlessuiFocusGuard !== "true"), fe(C.value, { [Ge.Forwards]: Ae.Next, [Ge.Backwards]: Ae.Previous }), { relativeTo: D(s.button) });
    }
    k();
  }
  return () => {
    let $ = s.popoverState.value === 0, k = { open: $ }, { ..._ } = e, M = d.value ? { ref: p, type: x.value, onKeydown: b, onClick: S } : { ref: p, id: i, type: x.value, "aria-expanded": s.popoverState.value === 0, "aria-controls": D(s.panel) ? s.panelId.value : void 0, disabled: e.disabled ? !0 : void 0, onKeydown: b, onKeyup: h, onClick: S, onMousedown: g };
    return oe(K, [le({ ourProps: M, theirProps: { ...t, ..._ }, slot: k, attrs: t, slots: n, name: "PopoverButton" }), $ && !d.value && s.isPortalled.value && oe(it, { id: v, features: et.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: w })]);
  };
} });
z({ name: "PopoverOverlay", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 } }, setup(e, { attrs: t, slots: n }) {
  let o = Oo("PopoverOverlay"), r = `headlessui-popover-overlay-${be()}`, i = Mt(), s = E(() => i !== null ? (i.value & me.Open) === me.Open : o.popoverState.value === 0);
  function a() {
    o.closePopover();
  }
  return () => {
    let l = { open: o.popoverState.value === 0 };
    return le({ ourProps: { id: r, "aria-hidden": !0, onClick: a }, theirProps: e, slot: l, attrs: t, slots: n, features: Ne.RenderStrategy | Ne.Static, visible: s.value, name: "PopoverOverlay" });
  };
} });
let Pa = z({ name: "PopoverPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, focus: { type: Boolean, default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: o }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-popover-panel-${be()}`, { focus: s } = e, a = Oo("PopoverPanel"), l = E(() => Ve(a.panel)), u = `headlessui-focus-sentinel-before-${be()}`, c = `headlessui-focus-sentinel-after-${be()}`;
  o({ el: a.panel, $el: a.panel }), ae(() => {
    a.panelId.value = i;
  }), Me(() => {
    a.panelId.value = null;
  }), xe(Ma, a.panelId), $e(() => {
    var g, C;
    if (!s || a.popoverState.value !== 0 || !a.panel)
      return;
    let w = (g = l.value) == null ? void 0 : g.activeElement;
    (C = D(a.panel)) != null && C.contains(w) || Ze(D(a.panel), Ae.First);
  });
  let d = Mt(), p = E(() => d !== null ? (d.value & me.Open) === me.Open : a.popoverState.value === 0);
  function v(g) {
    var C, w;
    switch (g.key) {
      case Q.Escape:
        if (a.popoverState.value !== 0 || !D(a.panel) || l.value && !((C = D(a.panel)) != null && C.contains(l.value.activeElement)))
          return;
        g.preventDefault(), g.stopPropagation(), a.closePopover(), (w = D(a.button)) == null || w.focus();
        break;
    }
  }
  function x(g) {
    var C, w, $, k, _;
    let M = g.relatedTarget;
    M && D(a.panel) && ((C = D(a.panel)) != null && C.contains(M) || (a.closePopover(), (($ = (w = D(a.beforePanelSentinel)) == null ? void 0 : w.contains) != null && $.call(w, M) || (_ = (k = D(a.afterPanelSentinel)) == null ? void 0 : k.contains) != null && _.call(k, M)) && M.focus({ preventScroll: !0 })));
  }
  let b = Wr();
  function h() {
    let g = D(a.panel);
    if (!g)
      return;
    function C() {
      fe(b.value, { [Ge.Forwards]: () => {
        var w;
        Ze(g, Ae.First) === Ft.Error && ((w = D(a.afterPanelSentinel)) == null || w.focus());
      }, [Ge.Backwards]: () => {
        var w;
        (w = D(a.button)) == null || w.focus({ preventScroll: !0 });
      } });
    }
    C();
  }
  function S() {
    let g = D(a.panel);
    if (!g)
      return;
    function C() {
      fe(b.value, { [Ge.Forwards]: () => {
        let w = D(a.button), $ = D(a.panel);
        if (!w)
          return;
        let k = bo(), _ = k.indexOf(w), M = k.slice(0, _ + 1), U = [...k.slice(_ + 1), ...M];
        for (let L of U.slice())
          if (L.dataset.headlessuiFocusGuard === "true" || $ != null && $.contains(L)) {
            let N = U.indexOf(L);
            N !== -1 && U.splice(N, 1);
          }
        Ze(U, Ae.First, { sorted: !1 });
      }, [Ge.Backwards]: () => {
        var w;
        Ze(g, Ae.Previous) === Ft.Error && ((w = D(a.button)) == null || w.focus());
      } });
    }
    C();
  }
  return () => {
    let g = { open: a.popoverState.value === 0, close: a.close }, { focus: C, ...w } = e, $ = { ref: a.panel, id: i, onKeydown: v, onFocusout: s && a.popoverState.value === 0 ? x : void 0, tabIndex: -1 };
    return le({ ourProps: $, theirProps: { ...t, ...w }, attrs: t, slot: g, slots: { ...n, default: (...k) => {
      var _;
      return [oe(K, [p.value && a.isPortalled.value && oe(it, { id: u, ref: a.beforePanelSentinel, features: et.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: h }), (_ = n.default) == null ? void 0 : _.call(n, ...k), p.value && a.isPortalled.value && oe(it, { id: c, ref: a.afterPanelSentinel, features: et.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: S })])];
    } }, features: Ne.RenderStrategy | Ne.Static, visible: p.value, name: "PopoverPanel" });
  };
} });
z({ name: "PopoverGroup", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(e, { attrs: t, slots: n, expose: o }) {
  let r = A(null), i = zr([]), s = E(() => Ve(r)), a = jc();
  o({ el: r, $el: r });
  function l(p) {
    let v = i.value.indexOf(p);
    v !== -1 && i.value.splice(v, 1);
  }
  function u(p) {
    return i.value.push(p), () => {
      l(p);
    };
  }
  function c() {
    var p;
    let v = s.value;
    if (!v)
      return !1;
    let x = v.activeElement;
    return (p = D(r)) != null && p.contains(x) ? !0 : i.value.some((b) => {
      var h, S;
      return ((h = v.getElementById(b.buttonId.value)) == null ? void 0 : h.contains(x)) || ((S = v.getElementById(b.panelId.value)) == null ? void 0 : S.contains(x));
    });
  }
  function d(p) {
    for (let v of i.value)
      v.buttonId.value !== p && v.close();
  }
  return xe(_a, { registerPopover: u, unregisterPopover: l, isFocusWithinPopoverGroup: c, closeOthers: d, mainTreeNodeRef: a.mainTreeNodeRef }), () => oe(K, [le({ ourProps: { ref: r }, theirProps: { ...e, ...t }, slot: {}, attrs: t, slots: n, name: "PopoverGroup" }), oe(a.MainTreeNode)]);
} });
let Ia = Symbol("LabelContext");
function La() {
  let e = ge(Ia, null);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, La), t;
  }
  return e;
}
function Kr({ slot: e = {}, name: t = "Label", props: n = {} } = {}) {
  let o = A([]);
  function r(i) {
    return o.value.push(i), () => {
      let s = o.value.indexOf(i);
      s !== -1 && o.value.splice(s, 1);
    };
  }
  return xe(Ia, { register: r, slot: e, name: t, props: n }), E(() => o.value.length > 0 ? o.value.join(" ") : void 0);
}
let Da = z({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: n }) {
  var o;
  let r = (o = e.id) != null ? o : `headlessui-label-${be()}`, i = La();
  return ae(() => Me(i.register(r))), () => {
    let { name: s = "Label", slot: a = {}, props: l = {} } = i, { passive: u, ...c } = e, d = { ...Object.entries(l).reduce((p, [v, x]) => Object.assign(p, { [v]: T(x) }), {}), id: r };
    return u && (delete d.onClick, delete d.htmlFor, delete c.onClick), le({ ourProps: d, theirProps: c, slot: a, attrs: n, slots: t, name: s });
  };
} });
function ad(e, t) {
  return e === t;
}
let Ba = Symbol("RadioGroupContext");
function za(e) {
  let t = ge(Ba, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, za), n;
  }
  return t;
}
let ld = z({ name: "RadioGroup", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "div" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => ad }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { emit: t, attrs: n, slots: o, expose: r }) {
  var i;
  let s = (i = e.id) != null ? i : `headlessui-radiogroup-${be()}`, a = A(null), l = A([]), u = Kr({ name: "RadioGroupLabel" }), c = So({ name: "RadioGroupDescription" });
  r({ el: a, $el: a });
  let [d, p] = go(E(() => e.modelValue), (h) => t("update:modelValue", h), E(() => e.defaultValue)), v = { options: l, value: d, disabled: E(() => e.disabled), firstOption: E(() => l.value.find((h) => !h.propsRef.disabled)), containsCheckedOption: E(() => l.value.some((h) => v.compare(we(h.propsRef.value), we(e.modelValue)))), compare(h, S) {
    if (typeof e.by == "string") {
      let g = e.by;
      return (h == null ? void 0 : h[g]) === (S == null ? void 0 : S[g]);
    }
    return e.by(h, S);
  }, change(h) {
    var S;
    if (e.disabled || v.compare(we(d.value), we(h)))
      return !1;
    let g = (S = l.value.find((C) => v.compare(we(C.propsRef.value), we(h)))) == null ? void 0 : S.propsRef;
    return g != null && g.disabled ? !1 : (p(h), !0);
  }, registerOption(h) {
    l.value.push(h), l.value = wo(l.value, (S) => S.element);
  }, unregisterOption(h) {
    let S = l.value.findIndex((g) => g.id === h);
    S !== -1 && l.value.splice(S, 1);
  } };
  xe(Ba, v), ta({ container: E(() => D(a)), accept(h) {
    return h.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : h.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(h) {
    h.setAttribute("role", "none");
  } });
  function x(h) {
    if (!a.value || !a.value.contains(h.target))
      return;
    let S = l.value.filter((g) => g.propsRef.disabled === !1).map((g) => g.element);
    switch (h.key) {
      case Q.Enter:
        aa(h.currentTarget);
        break;
      case Q.ArrowLeft:
      case Q.ArrowUp:
        if (h.preventDefault(), h.stopPropagation(), Ze(S, Ae.Previous | Ae.WrapAround) === Ft.Success) {
          let g = l.value.find((C) => {
            var w;
            return C.element === ((w = Ve(a)) == null ? void 0 : w.activeElement);
          });
          g && v.change(g.propsRef.value);
        }
        break;
      case Q.ArrowRight:
      case Q.ArrowDown:
        if (h.preventDefault(), h.stopPropagation(), Ze(S, Ae.Next | Ae.WrapAround) === Ft.Success) {
          let g = l.value.find((C) => {
            var w;
            return C.element === ((w = Ve(C.element)) == null ? void 0 : w.activeElement);
          });
          g && v.change(g.propsRef.value);
        }
        break;
      case Q.Space:
        {
          h.preventDefault(), h.stopPropagation();
          let g = l.value.find((C) => {
            var w;
            return C.element === ((w = Ve(C.element)) == null ? void 0 : w.activeElement);
          });
          g && v.change(g.propsRef.value);
        }
        break;
    }
  }
  let b = E(() => {
    var h;
    return (h = D(a)) == null ? void 0 : h.closest("form");
  });
  return ae(() => {
    he([b], () => {
      if (!b.value || e.defaultValue === void 0)
        return;
      function h() {
        v.change(e.defaultValue);
      }
      return b.value.addEventListener("reset", h), () => {
        var S;
        (S = b.value) == null || S.removeEventListener("reset", h);
      };
    }, { immediate: !0 });
  }), () => {
    let { disabled: h, name: S, form: g, ...C } = e, w = { ref: a, id: s, role: "radiogroup", "aria-labelledby": u.value, "aria-describedby": c.value, onKeydown: x };
    return oe(K, [...S != null && d.value != null ? Co({ [S]: d.value }).map(([$, k]) => oe(it, $o({ features: et.Hidden, key: $, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: g, name: $, value: k }))) : [], le({ ourProps: w, theirProps: { ...n, ...Rt(C, ["modelValue", "defaultValue", "by"]) }, slot: {}, attrs: n, slots: o, name: "RadioGroup" })]);
  };
} });
var ud = ((e) => (e[e.Empty = 1] = "Empty", e[e.Active = 2] = "Active", e))(ud || {});
let cd = z({ name: "RadioGroupOption", props: { as: { type: [Object, String], default: "div" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: o }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-radiogroup-option-${be()}`, s = za("RadioGroupOption"), a = Kr({ name: "RadioGroupLabel" }), l = So({ name: "RadioGroupDescription" }), u = A(null), c = E(() => ({ value: e.value, disabled: e.disabled })), d = A(1);
  o({ el: u, $el: u });
  let p = E(() => D(u));
  ae(() => s.registerOption({ id: i, element: p, propsRef: c })), Me(() => s.unregisterOption(i));
  let v = E(() => {
    var w;
    return ((w = s.firstOption.value) == null ? void 0 : w.id) === i;
  }), x = E(() => s.disabled.value || e.disabled), b = E(() => s.compare(we(s.value.value), we(e.value))), h = E(() => x.value ? -1 : b.value || !s.containsCheckedOption.value && v.value ? 0 : -1);
  function S() {
    var w;
    s.change(e.value) && (d.value |= 2, (w = D(u)) == null || w.focus());
  }
  function g() {
    d.value |= 2;
  }
  function C() {
    d.value &= -3;
  }
  return () => {
    let { value: w, disabled: $, ...k } = e, _ = { checked: b.value, disabled: x.value, active: !!(d.value & 2) }, M = { id: i, ref: u, role: "radio", "aria-checked": b.value ? "true" : "false", "aria-labelledby": a.value, "aria-describedby": l.value, "aria-disabled": x.value ? !0 : void 0, tabIndex: h.value, onClick: x.value ? void 0 : S, onFocus: x.value ? void 0 : g, onBlur: x.value ? void 0 : C };
    return le({ ourProps: M, theirProps: k, slot: _, attrs: t, slots: n, name: "RadioGroupOption" });
  };
} }), dd = Da, pd = ga, Na = Symbol("GroupContext"), fd = z({ name: "SwitchGroup", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: t, attrs: n }) {
  let o = A(null), r = Kr({ name: "SwitchLabel", props: { htmlFor: E(() => {
    var s;
    return (s = o.value) == null ? void 0 : s.id;
  }), onClick(s) {
    o.value && (s.currentTarget.tagName === "LABEL" && s.preventDefault(), o.value.click(), o.value.focus({ preventScroll: !0 }));
  } } }), i = So({ name: "SwitchDescription" });
  return xe(Na, { switchRef: o, labelledby: r, describedby: i }), () => le({ theirProps: e, ourProps: {}, slot: {}, slots: t, attrs: n, name: "SwitchGroup" });
} }), hd = z({ name: "Switch", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "button" }, modelValue: { type: Boolean, default: void 0 }, defaultChecked: { type: Boolean, optional: !0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, value: { type: String, optional: !0 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { emit: t, attrs: n, slots: o, expose: r }) {
  var i;
  let s = (i = e.id) != null ? i : `headlessui-switch-${be()}`, a = ge(Na, null), [l, u] = go(E(() => e.modelValue), (g) => t("update:modelValue", g), E(() => e.defaultChecked));
  function c() {
    u(!l.value);
  }
  let d = A(null), p = a === null ? d : a.switchRef, v = Rn(E(() => ({ as: e.as, type: n.type })), p);
  r({ el: p, $el: p });
  function x(g) {
    g.preventDefault(), c();
  }
  function b(g) {
    g.key === Q.Space ? (g.preventDefault(), c()) : g.key === Q.Enter && aa(g.currentTarget);
  }
  function h(g) {
    g.preventDefault();
  }
  let S = E(() => {
    var g, C;
    return (C = (g = D(p)) == null ? void 0 : g.closest) == null ? void 0 : C.call(g, "form");
  });
  return ae(() => {
    he([S], () => {
      if (!S.value || e.defaultChecked === void 0)
        return;
      function g() {
        u(e.defaultChecked);
      }
      return S.value.addEventListener("reset", g), () => {
        var C;
        (C = S.value) == null || C.removeEventListener("reset", g);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: g, value: C, form: w, ...$ } = e, k = { checked: l.value }, _ = { id: s, ref: p, role: "switch", type: v.value, tabIndex: 0, "aria-checked": l.value, "aria-labelledby": a == null ? void 0 : a.labelledby.value, "aria-describedby": a == null ? void 0 : a.describedby.value, onClick: x, onKeyup: b, onKeypress: h };
    return oe(K, [g != null && l.value != null ? oe(it, $o({ features: et.Hidden, as: "input", type: "checkbox", hidden: !0, readOnly: !0, checked: l.value, form: w, name: g, value: C })) : null, le({ ourProps: _, theirProps: { ...n, ...Rt($, ["modelValue", "defaultChecked"]) }, slot: k, attrs: n, slots: o, name: "Switch" })]);
  };
} }), vd = Da, md = ga;
function gd(e) {
  let t = { called: !1 };
  return (...n) => {
    if (!t.called)
      return t.called = !0, e(...n);
  };
}
function er(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function Vn(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
var yr = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(yr || {});
function bd(e, t) {
  let n = Ht();
  if (!e)
    return n.dispose;
  let { transitionDuration: o, transitionDelay: r } = getComputedStyle(e), [i, s] = [o, r].map((a) => {
    let [l = 0] = a.split(",").filter(Boolean).map((u) => u.includes("ms") ? parseFloat(u) : parseFloat(u) * 1e3).sort((u, c) => c - u);
    return l;
  });
  return i !== 0 ? n.setTimeout(() => t("finished"), i + s) : t("finished"), n.add(() => t("cancelled")), n.dispose;
}
function Fi(e, t, n, o, r, i) {
  let s = Ht(), a = i !== void 0 ? gd(i) : () => {
  };
  return Vn(e, ...r), er(e, ...t, ...n), s.nextFrame(() => {
    Vn(e, ...n), er(e, ...o), s.add(bd(e, (l) => (Vn(e, ...o, ...t), er(e, ...r), a(l))));
  }), s.add(() => Vn(e, ...t, ...n, ...o, ...r)), s.add(() => a("cancelled")), s.dispose;
}
function It(e = "") {
  return e.split(/\s+/).filter((t) => t.length > 1);
}
let Yr = Symbol("TransitionContext");
var yd = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(yd || {});
function wd() {
  return ge(Yr, null) !== null;
}
function xd() {
  let e = ge(Yr, null);
  if (e === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function $d() {
  let e = ge(Xr, null);
  if (e === null)
    throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let Xr = Symbol("NestingContext");
function Ao(e) {
  return "children" in e ? Ao(e.children) : e.value.filter(({ state: t }) => t === "visible").length > 0;
}
function ja(e) {
  let t = A([]), n = A(!1);
  ae(() => n.value = !0), Me(() => n.value = !1);
  function o(i, s = Ot.Hidden) {
    let a = t.value.findIndex(({ id: l }) => l === i);
    a !== -1 && (fe(s, { [Ot.Unmount]() {
      t.value.splice(a, 1);
    }, [Ot.Hidden]() {
      t.value[a].state = "hidden";
    } }), !Ao(t) && n.value && (e == null || e()));
  }
  function r(i) {
    let s = t.value.find(({ id: a }) => a === i);
    return s ? s.state !== "visible" && (s.state = "visible") : t.value.push({ id: i, state: "visible" }), () => o(i, Ot.Unmount);
  }
  return { children: t, register: r, unregister: o };
}
let Va = Ne.RenderStrategy, ao = z({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: n, slots: o, expose: r }) {
  let i = A(0);
  function s() {
    i.value |= me.Opening, t("beforeEnter");
  }
  function a() {
    i.value &= ~me.Opening, t("afterEnter");
  }
  function l() {
    i.value |= me.Closing, t("beforeLeave");
  }
  function u() {
    i.value &= ~me.Closing, t("afterLeave");
  }
  if (!wd() && bc())
    return () => oe(_o, { ...e, onBeforeEnter: s, onAfterEnter: a, onBeforeLeave: l, onAfterLeave: u }, o);
  let c = A(null), d = E(() => e.unmount ? Ot.Unmount : Ot.Hidden);
  r({ el: c, $el: c });
  let { show: p, appear: v } = xd(), { register: x, unregister: b } = $d(), h = A(p.value ? "visible" : "hidden"), S = { value: !0 }, g = be(), C = { value: !1 }, w = ja(() => {
    !C.value && h.value !== "hidden" && (h.value = "hidden", b(g), u());
  });
  ae(() => {
    let H = x(g);
    Me(H);
  }), $e(() => {
    if (d.value === Ot.Hidden && g) {
      if (p.value && h.value !== "visible") {
        h.value = "visible";
        return;
      }
      fe(h.value, { hidden: () => b(g), visible: () => x(g) });
    }
  });
  let $ = It(e.enter), k = It(e.enterFrom), _ = It(e.enterTo), M = It(e.entered), U = It(e.leave), L = It(e.leaveFrom), N = It(e.leaveTo);
  ae(() => {
    $e(() => {
      if (h.value === "visible") {
        let H = D(c);
        if (H instanceof Comment && H.data === "")
          throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function Z(H) {
    let J = S.value && !v.value, X = D(c);
    !X || !(X instanceof HTMLElement) || J || (C.value = !0, p.value && s(), p.value || l(), H(p.value ? Fi(X, $, k, _, M, (ie) => {
      C.value = !1, ie === yr.Finished && a();
    }) : Fi(X, U, L, N, M, (ie) => {
      C.value = !1, ie === yr.Finished && (Ao(w) || (h.value = "hidden", b(g), u()));
    })));
  }
  return ae(() => {
    he([p], (H, J, X) => {
      Z(X), S.value = !1;
    }, { immediate: !0 });
  }), xe(Xr, w), Mn(E(() => fe(h.value, { visible: me.Open, hidden: me.Closed }) | i.value)), () => {
    let { appear: H, show: J, enter: X, enterFrom: ie, enterTo: ye, entered: Se, leave: Oe, leaveFrom: qe, leaveTo: V, ...q } = e, ee = { ref: c }, ue = { ...q, ...v.value && p.value && _n.isServer ? { class: O([n.class, q.class, ...$, ...k]) } : {} };
    return le({ theirProps: ue, ourProps: ee, slot: {}, slots: o, attrs: n, features: Va, visible: h.value === "visible", name: "TransitionChild" });
  };
} }), Cd = ao, _o = z({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: n, slots: o }) {
  let r = Mt(), i = E(() => e.show === null && r !== null ? (r.value & me.Open) === me.Open : e.show);
  $e(() => {
    if (![!0, !1].includes(i.value))
      throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let s = A(i.value ? "visible" : "hidden"), a = ja(() => {
    s.value = "hidden";
  }), l = A(!0), u = { show: i, appear: E(() => e.appear || !l.value) };
  return ae(() => {
    $e(() => {
      l.value = !1, i.value ? s.value = "visible" : Ao(a) || (s.value = "hidden");
    });
  }), xe(Xr, a), xe(Yr, u), () => {
    let c = Rt(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), d = { unmount: e.unmount };
    return le({ ourProps: { ...d, as: "template" }, theirProps: {}, slot: {}, slots: { ...o, default: () => [oe(Cd, { onBeforeEnter: () => t("beforeEnter"), onAfterEnter: () => t("afterEnter"), onBeforeLeave: () => t("beforeLeave"), onAfterLeave: () => t("afterLeave"), ...n, ...d, ...c }, o.default)] }, attrs: {}, features: Va, visible: s.value === "visible", name: "Transition" });
  };
} });
const Sd = /* @__PURE__ */ m("span", {
  class: "min-w-screen hidden sm:inline-block sm:h-screen sm:align-middle",
  "aria-hidden": "true"
}, "​", -1), kd = {
  key: 1,
  class: "relative flex h-fit w-auto flex-row-reverse items-center gap-4 space-y-0.5 border-b p-5 text-gray-800"
}, Ed = { class: "flex w-full flex-col" }, Od = { class: "text-base font-semibold leading-normal" }, Ad = { class: "text-sm font-normal leading-normal" }, _d = { class: "w-full" }, Rd = {
  key: 1,
  class: "mb-1 space-y-1.5"
}, Md = {
  key: 0,
  class: "text-center text-sm font-normal leading-normal text-gray-600"
}, G2 = /* @__PURE__ */ z({
  __name: "Modal",
  props: {
    bgColor: { default: "white" },
    cancel: { default: null },
    closeButton: { type: Boolean, default: !1 },
    closeButtonStyle: { default: "" },
    closeIconIsCircle: { type: Boolean, default: !1 },
    hasShadow: { type: Boolean, default: !0 },
    headingSubtitle: { default: "" },
    headingTitle: { default: "" },
    icon: { type: [Function, Object], default: null },
    iconColor: { default: "blue" },
    innerPadding: { type: Boolean, default: !0 },
    isDisabled: { type: Boolean, default: !1 },
    isOpen: { type: Boolean },
    isProcessing: { type: Boolean, default: !1 },
    linkText: { default: "" },
    maxContentHeight: { type: Boolean, default: !1 },
    maxHeight: { default: null },
    minHeight: { default: "40dvh" },
    size: { default: "3xl" },
    text: { default: "" },
    textTitle: { default: "" }
  },
  emits: ["close", "click"],
  setup(e) {
    const t = e, n = E(() => {
      switch (t.size) {
        case "full":
          return "sm:max-w-full";
        case "6xl":
          return "sm:max-w-6xl";
        case "5xl":
          return "sm:max-w-5xl";
        case "4xl":
          return "sm:max-w-4xl";
        case "2xl":
          return "sm:max-w-2xl";
        case "xl":
          return "sm:max-w-xl";
        case "lg":
          return "sm:max-w-lg";
        case "md":
          return "sm:max-w-md";
        case "sm":
          return "sm:max-w-sm";
        case "xs":
          return "sm:max-w-xs";
        default:
          return "sm:max-w-3xl";
      }
    }), o = E(() => {
      switch (t.maxHeight) {
        case "80vh":
          return "sm:max-h-[80dvh]";
        case "70vh":
          return "sm:max-h-[70dvh]";
        case "60vh":
          return "sm:max-h-[60dvh]";
        case "50vh":
          return "sm:max-h-[50dvh]";
        case "40vh":
          return "sm:max-h-[40dvh]";
        default:
          return "sm:max-h-full";
      }
    });
    return (r, i) => (f(), j(jr, { to: "#app" }, [
      B(T(_o), {
        as: "template",
        show: r.isOpen
      }, {
        default: F(() => [
          B(T(xa), {
            as: "div",
            open: r.isOpen,
            class: "min-w-screen fixed inset-0 z-40 h-full w-screen sm:flex sm:items-center sm:justify-center sm:px-5 sm:py-12",
            onClose: i[5] || (i[5] = (s) => r.$emit("close"))
          }, {
            default: F(() => [
              B(T(ao), {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: F(() => [
                  B(T($a), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              Sd,
              B(T(ao), {
                as: "template",
                enter: "transform transition ease-out duration-300",
                "enter-from": "translate-x-3/4 sm:translate-x-0 sm:scale-95 sm:opacity-0",
                "enter-to": "translate-x-0 sm:scale-100 sm:opacity-100",
                leave: "transform transition ease-out duration-300",
                "leave-from": "translate-x-0 sm:scale-100 sm:opacity-100",
                "leave-to": "translate-x-full sm:translate-x-0 sm:scale-95 sm:opacity-0"
              }, {
                default: F(() => [
                  m("div", {
                    class: O([[
                      `${n.value} bg-${t.bgColor}`,
                      r.headingTitle && "",
                      o.value,
                      r.maxContentHeight ? "sm:h-full" : "sm:h-fit",
                      r.textTitle ? "w-full max-w-xl" : "w-full",
                      (r.cancel || r.linkText || r.$slots.linkBtn) && "justify-between"
                    ], "relative z-40 flex h-[calc(100dvh)] flex-col p-0 transition-all sm:justify-center sm:overflow-hidden sm:rounded-lg"])
                  }, [
                    r.headingTitle ? P("", !0) : (f(), y("header", {
                      key: 0,
                      class: O(["flex max-h-fit w-full items-center sm:flex-row", [r.$slots.customHeadingTitle ? "flex-row-reverse border-b" : "justify-start sm:justify-end"]])
                    }, [
                      G(r.$slots, "customHeadingTitle"),
                      r.closeButton ? (f(), y("button", {
                        key: 0,
                        id: "closeBtn",
                        type: "button",
                        class: O(["w-fit px-4 focus:outline-none", [r.closeButton && !r.$slots.customHeadingTitle && "pt-4", !r.closeButton && "hidden"]]),
                        style: De(r.closeButtonStyle),
                        onClick: i[0] || (i[0] = (s) => r.$emit("close"))
                      }, [
                        B(T(bt), {
                          class: O(["hidden h-5 w-5 text-gray-500 sm:block", r.closeIconIsCircle && "rounded-full bg-white p-2"]),
                          "aria-hidden": "true"
                        }, null, 8, ["class"]),
                        B(T(Ti), {
                          class: "block h-5 w-5 text-gray-500 sm:hidden",
                          "aria-hidden": "true"
                        })
                      ], 6)) : P("", !0)
                    ], 2)),
                    r.headingTitle ? (f(), y("header", kd, [
                      m("div", Ed, [
                        m("h3", Od, R(r.headingTitle), 1),
                        m("p", Ad, R(r.headingSubtitle), 1)
                      ]),
                      r.closeButton ? (f(), y("button", {
                        key: 0,
                        id: "headingTitleCloseBtn",
                        type: "button",
                        class: "block w-fit focus:outline-none sm:hidden",
                        onClick: i[1] || (i[1] = (s) => r.$emit("close"))
                      }, [
                        B(T(Ti), {
                          class: "block h-5 w-5 text-gray-500",
                          "aria-hidden": "true"
                        })
                      ])) : P("", !0),
                      r.closeButton ? (f(), y("button", {
                        key: 1,
                        type: "button",
                        class: "absolute right-4 top-0 hidden h-full w-5 focus:outline-none sm:block",
                        style: De(r.closeButtonStyle),
                        onClick: i[2] || (i[2] = (s) => r.$emit("close"))
                      }, [
                        B(T(bt), {
                          class: O(["h-5 w-5 text-gray-500", r.closeIconIsCircle && "rounded-full bg-white"]),
                          "aria-hidden": "true"
                        }, null, 8, ["class"])
                      ], 4)) : P("", !0)
                    ])) : P("", !0),
                    m("div", {
                      class: O(["flex w-full justify-center overflow-y-auto text-center sm:h-full", [
                        n.value,
                        {
                          "p-5": r.innerPadding,
                          [`min-h-[${r.minHeight}]`]: !r.textTitle && r.minHeight !== null
                        }
                      ]])
                    }, [
                      m("div", _d, [
                        r.icon ? (f(), y("div", {
                          key: 0,
                          class: O(["mx-auto mt-5 flex aspect-square h-11 w-11 items-center justify-center rounded-full p-2.5 sm:mb-6", `bg-${r.iconColor}-100`])
                        }, [
                          (f(), j(Le(r.icon), {
                            class: O(["h-6 w-6", `text-${r.iconColor}-400`])
                          }, null, 8, ["class"]))
                        ], 2)) : P("", !0),
                        r.textTitle ? (f(), y("div", Rd, [
                          B(T(Ca), {
                            as: "h3",
                            class: "text-center text-base font-semibold leading-normal text-gray-800"
                          }, {
                            default: F(() => [
                              ce(R(r.textTitle), 1)
                            ]),
                            _: 1
                          }),
                          r.text && !r.$slots.text ? (f(), y("p", Md, R(r.text), 1)) : P("", !0),
                          G(r.$slots, "text")
                        ])) : G(r.$slots, "default", { key: 2 })
                      ])
                    ], 2),
                    r.cancel || r.linkText ? (f(), y("div", {
                      key: 2,
                      class: O(["flex max-h-fit w-full flex-row space-x-3 place-self-end rounded-bl-md rounded-br-md bg-white p-5", [!r.textTitle && "sm:justify-end"]])
                    }, [
                      r.cancel ? (f(), j(rt, {
                        key: 0,
                        id: "cancelBtn",
                        class: O(["max-h-fit w-full min-w-max", !r.textTitle && "sm:w-auto"]),
                        outlined: !0,
                        onClick: i[3] || (i[3] = (s) => r.$emit("close"))
                      }, {
                        default: F(() => [
                          ce(R(r.cancel), 1)
                        ]),
                        _: 1
                      }, 8, ["class"])) : P("", !0),
                      r.linkText ? (f(), j(rt, {
                        key: 1,
                        id: "linkBtn",
                        class: O(["max-h-fit w-full min-w-max", !r.textTitle && "sm:w-auto"]),
                        processing: t.isProcessing,
                        "processing-label": r.linkText,
                        disabled: t.isDisabled,
                        onClick: i[4] || (i[4] = (s) => r.$emit("click"))
                      }, {
                        default: F(() => [
                          ce(R(r.linkText), 1)
                        ]),
                        _: 1
                      }, 8, ["class", "processing", "processing-label", "disabled"])) : P("", !0)
                    ], 2)) : P("", !0),
                    r.$slots.linkBtn ? G(r.$slots, "linkBtn", {
                      key: 3,
                      class: O(["flex max-h-fit w-full bg-white p-5", !r.textTitle && "sm:w-auto"])
                    }) : P("", !0)
                  ], 2)
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["open"])
        ]),
        _: 3
      }, 8, ["show"])
    ]));
  }
}), Hi = /* @__PURE__ */ z({
  __name: "Tag",
  props: {
    name: {},
    colors: {},
    icon: {},
    iconPosition: { default: "left" }
  },
  setup(e) {
    const t = e, n = E(() => {
      var o;
      return /^#([0-9a-f]{3}){1,2}$/i.test((o = t.colors) == null ? void 0 : o.color) ? `color: ${t.colors.color}; background-color: ${t.colors.color}1f` : null;
    });
    return (o, r) => {
      var i, s;
      return f(), y("span", {
        class: O(["flex w-fit items-center gap-x-1.5 rounded-md px-2 py-0.5 font-medium", [
          { "flex-row-reverse": o.iconPosition === "right" },
          ((i = o.colors) == null ? void 0 : i.color) ?? "text-gray-800",
          ((s = o.colors) == null ? void 0 : s.background) ?? "bg-gray-50"
        ]]),
        style: De(n.value)
      }, [
        (f(), j(Le(o.icon), { class: "aspect-square h-4" })),
        ce(" " + R(o.name), 1)
      ], 6);
    };
  }
}), Td = ["for"], Pd = {
  key: 0,
  class: "ml-1 text-red-600"
}, Id = { class: "relative" }, Ld = { class: "flex flex-row items-center justify-center" }, Dd = { class: "inline-flex gap-3 text-left" }, Bd = ["src"], zd = {
  key: 0,
  class: "flex p-3"
}, Nd = { class: "absolute right-3 flex h-8 w-10 items-center justify-center" }, jd = {
  key: 0,
  class: "mb-0 mt-2 flex flex-col py-1 pl-3 pr-9"
}, Vd = { class: "text-xs uppercase text-gray-400" }, Fd = {
  key: 0,
  class: "mt-3 text-xs text-gray-600"
}, Hd = { class: "flex" }, Ud = { class: "flex items-center gap-3" }, Wd = ["src"], qd = { class: "inline-flex w-full py-0.5 indent-5 text-sm font-normal text-gray-500" }, Zd = /* @__PURE__ */ z({
  inheritAttrs: !1,
  __name: "Dropdown",
  props: {
    displayedValueOfKey: { default: "text" },
    emptyListText: { default: "" },
    fixedWidth: { default: "" },
    fullWidth: { type: Boolean, default: !1 },
    imageUrl: { default: "" },
    isDisabled: { type: Boolean, default: !1 },
    label: { default: "" },
    labelPosition: { default: "center" },
    position: { default: "bottom" },
    searchBar: { type: Boolean, default: !1 },
    selectedValue: { default: 0 },
    theme: { default: null },
    topLabel: { default: "" },
    values: {}
  },
  emits: ["updateDropdown"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = A(""), i = E(() => {
      if (n.selectedValue === void 0)
        return n.label;
      if (typeof n.selectedValue == "object")
        return n.selectedValue[n.displayedValueOfKey];
      const g = n.values.find(
        (C) => C.id === n.selectedValue || C[n.displayedValueOfKey] === n.selectedValue
      );
      return g ? g[n.displayedValueOfKey] : n.label;
    }), s = E(() => r.value === "" ? n.values : n.values.filter((g) => g[n.displayedValueOfKey].toLowerCase().includes(r.value.toLowerCase()) || g.isCategoryTitle)), a = A(n.selectedValue ?? n.values[0]), l = E(() => n.values.filter((g) => g.id === n.selectedValue)[0]), u = (g) => {
      var C;
      return ((C = s.value[g + 1]) == null ? void 0 : C.isCategoryTitle) || !s.value[g + 1];
    }, c = (g) => {
      g.disabled || g.isCategoryTitle || o("updateDropdown", g.id);
    }, d = (g) => `width: ${(g.length + 7) * 8}px;`, p = (g, C) => g ? "bg-gray-100 text-gray-900" : (C == null ? void 0 : C.color) ?? "text-gray-900", v = (g) => {
      var C, w, $, k;
      return g.isCategoryTitle ? [] : g.badgeColor ? [
        ((C = l.value) == null ? void 0 : C.id) !== g.id && `hover:bg-${g.badgeColor}-50 bg-transparent`,
        ((w = l.value) == null ? void 0 : w.id) === g.id && `bg-${g.badgeColor}-50 font-semibold`,
        g.disabled && "bg-transparent !opacity-50"
      ] : [
        (($ = l.value) == null ? void 0 : $.id) !== g.id && "bg-transparent hover:bg-violet-50",
        ((k = l.value) == null ? void 0 : k.id) === g.id && "bg-violet-100 font-semibold text-violet-800",
        g.disabled && "bg-transparent !opacity-50"
      ];
    }, x = () => {
      r.value = "";
    }, b = E(() => n.theme === "light" ? "text-white" : "text-gray-800"), h = E(() => {
      const g = [];
      return n.theme ? (g.push("border-transparent font-serif", b.value), g) : (g.push(n.isDisabled ? "bg-gray-100 text-gray-400 border-gray-200" : "bg-white border-gray-300"), g.push(
        W({
          type: "ring",
          value: "800",
          prefix: "focus"
        }),
        W({
          type: "border",
          value: "800",
          prefix: "focus"
        }),
        "shadow-sm"
      ), g);
    }), S = E(() => {
      switch (n.labelPosition) {
        case "right":
          return "justify-end";
        case "left":
          return "justify-start";
        default:
          return "justify-between";
      }
    });
    return (g, C) => (f(), y("div", {
      class: O([g.fullWidth ? "w-full" : "", g.$attrs.class])
    }, [
      g.topLabel ? (f(), y("label", {
        key: 0,
        for: g.label,
        class: O(["mb-1 block w-full text-left text-sm font-medium", g.theme ? b.value : "text-gray-900"])
      }, [
        ce(R(g.topLabel), 1),
        g.$attrs.required ? (f(), y("sup", Pd, "*")) : P("", !0)
      ], 10, Td)) : P("", !0),
      B(T(Ec), {
        modelValue: a.value,
        "onUpdate:modelValue": C[1] || (C[1] = (w) => a.value = w),
        disabled: g.isDisabled
      }, {
        default: F(() => [
          m("div", Id, [
            B(T(Oc), {
              class: O([
                "!focus:border-violet-500 relative flex w-full items-center justify-between rounded-md rounded-r-md border text-left text-sm focus:outline-none focus:ring-1",
                g.fixedWidth ? g.fixedWidth : "w-full",
                h.value,
                l.value && l.value.badgeText ? "p-2" : "py-2.5 pl-3 pr-2"
              ]),
              style: De(!g.fixedWidth && d(g.label)),
              onClick: x
            }, {
              default: F(() => [
                m("div", {
                  class: O(["flex w-full items-center", S.value])
                }, [
                  m("div", Ld, [
                    l.value && l.value.badgeText ? (f(), j(Hi, {
                      key: 0,
                      colors: {
                        color: `text-${l.value.badgeColor}-600`,
                        background: `bg-${l.value.badgeColor}-50`
                      },
                      icon: l.value.badgeIcon,
                      name: l.value.badgeText,
                      class: "mr-2 flex h-fit py-1 pl-1 text-xs",
                      "icon-position": "left"
                    }, null, 8, ["colors", "icon", "name"])) : P("", !0),
                    m("div", Dd, [
                      g.imageUrl && !g.theme ? (f(), y("img", {
                        key: 0,
                        src: g.imageUrl,
                        class: "h-4 rounded-sm",
                        alt: ""
                      }, null, 8, Bd)) : P("", !0),
                      m("p", null, R(i.value), 1)
                    ])
                  ]),
                  g.theme ? (f(), j(T(Gs), {
                    key: 0,
                    class: O(`right-3 flex h-5 w-5 ${b.value}`),
                    "aria-hidden": "true"
                  }, null, 8, ["class"])) : (f(), j(T(Vr), {
                    key: 1,
                    class: "right-3 flex h-5 w-5 text-gray-400",
                    "aria-hidden": "true"
                  }))
                ], 2)
              ]),
              _: 1
            }, 8, ["class", "style"]),
            B(T(_o), {
              leave: "transition ease-in duration-100",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: F(() => [
                B(T(Ac), {
                  class: O(["absolute z-20 mt-1 max-h-96 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none", g.position === "top" && "bottom-12"])
                }, {
                  default: F(() => [
                    g.searchBar && g.values.length > 7 ? (f(), y("div", zd, [
                      ze(m("input", _t({
                        "onUpdate:modelValue": C[0] || (C[0] = (w) => r.value = w),
                        type: "text",
                        class: [
                          "h-8 w-full rounded-md border-gray-300 text-left text-xs placeholder:text-gray-500 focus:outline-none",
                          T(W)({
                            type: "border",
                            value: "800",
                            prefix: "focus"
                          }),
                          T(W)({
                            type: "ring",
                            value: "800",
                            prefix: "focus"
                          })
                        ]
                      }, { ...g.$attrs, class: void 0 }), null, 16), [
                        [rn, r.value]
                      ]),
                      m("div", Nd, [
                        B(T(Hu), { class: "h-5 w-5 text-gray-400" })
                      ])
                    ])) : P("", !0),
                    (f(!0), y(K, null, se(s.value, (w, $) => (f(), j(T(zi), {
                      key: w.id,
                      as: "template",
                      value: w,
                      disabled: w.disabled || !1,
                      class: O(v(w)),
                      onClick: (k) => c(w)
                    }, {
                      default: F(({ selected: k, active: _ }) => [
                        w.isCategoryTitle ? (f(), y("li", jd, [
                          m("span", Vd, R(w.text), 1),
                          u($) ? (f(), y("div", Fd, R(g.emptyListText), 1)) : P("", !0)
                        ])) : (f(), y("li", {
                          key: 1,
                          class: O(["relative cursor-pointer select-none pl-3 pr-9", [
                            w.badgeText ? "py-1.5" : "py-2",
                            w.disabled && "pointer-events-none opacity-75",
                            p(_, w)
                          ]])
                        }, [
                          m("div", Hd, [
                            w.icon ? (f(), j(Le(w.icon), {
                              key: 0,
                              class: O(["mr-2 h-5 w-5", (w == null ? void 0 : w.iconColor) ?? (w == null ? void 0 : w.color) ?? "text-gray-400"])
                            }, null, 8, ["class"])) : P("", !0),
                            w.badgeText ? (f(), j(Hi, {
                              key: 1,
                              colors: { color: `text-${w.badgeColor}-600`, background: `bg-${w.badgeColor}-50` },
                              icon: w.badgeIcon,
                              name: w.badgeText,
                              class: "mr-2 flex h-fit py-1 pl-1 text-xs",
                              "icon-position": "left"
                            }, null, 8, ["colors", "icon", "name"])) : P("", !0),
                            m("div", Ud, [
                              g.imageUrl ? (f(), y("img", {
                                key: 0,
                                src: w.imageUrl,
                                class: "h-4 rounded-sm",
                                alt: ""
                              }, null, 8, Wd)) : P("", !0),
                              m("span", {
                                class: O(["block", k && "font-semibold"])
                              }, R(w[g.displayedValueOfKey]), 3)
                            ])
                          ])
                        ], 2))
                      ]),
                      _: 2
                    }, 1032, ["value", "disabled", "class", "onClick"]))), 128)),
                    s.value.length < 1 ? (f(), j(T(zi), { key: 1 }, {
                      default: F(() => [
                        m("li", qd, R(g.emptyListText), 1)
                      ]),
                      _: 1
                    })) : P("", !0)
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ], 2));
  }
}), Gd = { class: "relative border-gray-900" }, Kd = { class: "flex items-center" }, Yd = { class: "flex gap-2" }, Xd = { class: "flex items-center" }, Qd = ["src"], Jd = { class: "pointer-events-none inset-y-0 right-0 flex items-center" }, ep = { class: "flex items-center" }, tp = ["src"], K2 = /* @__PURE__ */ z({
  __name: "CountryDropdown",
  props: {
    modelValue: {},
    countries: {},
    position: { default: "bottom" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = A(), i = A();
    return ae(async () => {
      var s;
      r.value = (s = n.countries) == null ? void 0 : s.find((a) => a.alpha2Code === n.modelValue), i.value = r.value;
    }), he(i, () => o("update:modelValue", i.value.alpha2Code)), (s, a) => (f(), y("div", Gd, [
      m("div", Kd, [
        B(T(ko), {
          modelValue: i.value,
          "onUpdate:modelValue": a[0] || (a[0] = (l) => i.value = l)
        }, {
          default: F(() => [
            B(T(Zr), { class: "h-full rounded-md border-transparent bg-transparent py-0 pr-1 text-xl text-gray-500 focus:border-transparent focus:ring-transparent" }, {
              default: F(() => {
                var l;
                return [
                  m("div", Yd, [
                    m("span", Xd, [
                      m("img", {
                        src: (l = i.value) == null ? void 0 : l.flag,
                        alt: "",
                        class: "h-4 w-6 flex-shrink-0"
                      }, null, 8, Qd)
                    ]),
                    m("span", Jd, [
                      B(T(Vr), {
                        class: "h-5 w-5 text-gray-500",
                        "aria-hidden": "true"
                      })
                    ])
                  ])
                ];
              }),
              _: 1
            }),
            B(Gt, {
              "leave-active-class": "transition ease-in duration-100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: F(() => [
                B(T(Eo), {
                  class: O(["absolute -left-4 z-10 max-h-72 w-72 overflow-auto rounded-md border bg-white py-2 text-base shadow-lg ring-0 focus:outline-none sm:text-sm", n.position === "bottom" ? "top-10" : "bottom-10"])
                }, {
                  default: F(() => [
                    (f(!0), y(K, null, se(n.countries, (l) => (f(), j(T(In), {
                      key: l.id,
                      value: l,
                      as: "template"
                    }, {
                      default: F(({ active: u, selected: c }) => [
                        m("li", {
                          class: O(["relative cursor-pointer select-none p-4", u || c ? "bg-gray-200" : "text-gray-900"])
                        }, [
                          m("div", ep, [
                            m("img", {
                              src: l.flag,
                              alt: "",
                              class: "h-4 w-6 flex-shrink-0"
                            }, null, 8, tp),
                            m("span", {
                              class: O([c ? "font-semibold" : "font-normal", "ml-3 block truncate"])
                            }, R(l.name) + " (+" + R(l.phonePrefix) + ") ", 3)
                          ])
                        ], 2)
                      ]),
                      _: 2
                    }, 1032, ["value"]))), 128))
                  ]),
                  _: 1
                }, 8, ["class"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]));
  }
});
function np({ variation: e, content: t }) {
  const n = E(() => e.value > 0 ? "Increased by" : e.value < 0 ? "Decreased by" : "No variation"), o = E(() => t.value), r = E(() => `${(e.value > 0 ? "+" : "") + e.value}%`), i = E(() => e.value > 0 ? "M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" : e.value < 0 ? "M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" : ""), s = E(() => e.value > 0 ? "green" : e.value < 0 ? "red" : "gray");
  return {
    labelSr: n,
    computedContent: o,
    variationFormatted: r,
    variationIcon: i,
    variationColor: s
  };
}
const op = z({
  name: "Card",
  props: {
    title: {
      type: String,
      required: !0
    },
    content: {
      type: [String, Number],
      default: null
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    variation: {
      type: Number,
      default: null
    }
  },
  setup(e) {
    const { labelSr: t, computedContent: n, variationFormatted: o, variationIcon: r, variationColor: i } = np(at(e));
    return {
      getColorClass: W,
      labelSr: t,
      computedContent: n,
      variationFormatted: o,
      variationIcon: r,
      variationColor: i
    };
  }
}), rp = { class: "px-4 py-5 sm:p-6" }, ip = { class: "truncate text-sm font-medium uppercase tracking-wider text-gray-500" }, sp = { key: 0 }, ap = ["d"], lp = {
  key: 0,
  class: "sr-only"
};
function up(e, t, n, o, r, i) {
  return f(), y("div", {
    class: O(["overflow-hidden rounded-lg bg-white shadow", { "cursor-pointer hover:bg-gray-50": e.clickable }])
  }, [
    m("div", rp, [
      m("dt", ip, R(e.title), 1),
      m("dd", {
        class: O(`mt-1 flex items-baseline justify-between text-3xl font-extrabold ${e.getColorClass({
          type: "text",
          value: "800"
        })}`)
      }, [
        e.computedContent ? (f(), y("div", sp, R(e.computedContent), 1)) : G(e.$slots, "default", { key: 1 }),
        e.variation != null ? (f(), y("div", {
          key: 2,
          class: O([
            "inline-flex items-baseline rounded-full px-2.5 py-0.5 text-sm font-medium md:mt-2 lg:mt-0",
            e.variation == 0 ? "bg-gray-100 text-gray-800" : e.variation > 0 ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"
          ])
        }, [
          (f(), y("svg", {
            class: O(["-ml-1 mr-0.5 h-5 flex-shrink-0 self-center", (e.variationIcon == "" ? "w-2" : "w-5") + " text-" + e.variationColor + "-500"]),
            fill: "currentColor",
            viewBox: "0 0 20 20",
            "aria-hidden": "true"
          }, [
            m("path", {
              "fill-rule": "evenodd",
              d: e.variationIcon,
              "clip-rule": "evenodd"
            }, null, 8, ap)
          ], 2)),
          e.labelSr ? (f(), y("span", lp, R(e.labelSr), 1)) : P("", !0),
          ce(" " + R(e.variationFormatted), 1)
        ], 2)) : P("", !0)
      ], 2),
      G(e.$slots, "bottom")
    ])
  ], 2);
}
const Y2 = /* @__PURE__ */ Ee(op, [["render", up]]), cp = /* @__PURE__ */ z({
  __name: "Container",
  props: {
    rounded: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    maxSize: { default: "full" },
    size: { default: "large" },
    width: { default: null },
    hasMargin: { type: Boolean, default: !0 },
    hasBorder: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = E(() => {
      const o = ["bg-white overflow-hidden"];
      switch (t.hasMargin && o.push("mb-12"), t.hasBorder && o.push("border"), t.rounded && o.push("rounded-lg"), t.shadow && o.push("shadow"), t.maxSize && o.push(`sm:max-w-${t.maxSize}`), t.size) {
        case "large":
          o.push("px-2 lg:px-12 py-6");
          break;
        case "xsmall":
          o.push("p-3");
          break;
        case "xxsmall":
          o.push("p-1");
          break;
        default:
          o.push("py-6 px-4 sm:p-6");
          break;
      }
      return t.width && o.push(t.width), o;
    });
    return (o, r) => (f(), y("div", {
      class: O(n.value)
    }, [
      G(o.$slots, "default")
    ], 2));
  }
}), dp = /* @__PURE__ */ z({
  __name: "Badge",
  props: {
    color: {},
    colorIntensity: { default: "200" },
    isCircle: { type: Boolean, default: !1 },
    size: { default: "sm" },
    isBold: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = E(() => {
      const o = ["rounded-full text-sm flex items-center justify-center gap-2 leading-tight"];
      return t.isBold && o.push("font-semibold"), t.color === "white" ? o.push("bg-white bg-opacity-50 text-white") : o.push(`bg-${t.color}-${t.colorIntensity} text-${t.color}-500`), t.isCircle ? o.push("h-7 aspect-square mr-2 rounded-full md:mr-3") : o.push(t.size === "md" ? "px-5 py-2.5" : "px-2 py-1.5"), o;
    });
    return (o, r) => (f(), y("span", {
      class: O(n.value)
    }, [
      G(o.$slots, "default")
    ], 2));
  }
}), X2 = /* @__PURE__ */ z({
  __name: "AdvancedCard",
  props: {
    number: {},
    backgroundColor: {},
    isOutlined: { type: Boolean }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    z({ name: "AdvancedCard" });
    const n = e, o = t, i = !!Kt()["right-button"], s = E(() => {
      const a = [];
      return i ? n.isOutlined ? a.push("justify-center") : a.push("justify-between") : a.push("text-white"), a;
    });
    return (a, l) => (f(), j(cp, {
      width: "w-full",
      size: "xxsmall",
      "has-margin": !1,
      "has-border": i && !n.isOutlined,
      shadow: !i
    }, {
      default: F(() => [
        m("div", {
          class: O(["flex w-full items-center", s.value])
        }, [
          n.number ? (f(), j(dp, {
            key: 0,
            color: "white",
            "is-circle": !0
          }, {
            default: F(() => [
              ce(R(n.number), 1)
            ]),
            _: 1
          })) : P("", !0),
          G(a.$slots, "default"),
          i ? (f(), j(rt, {
            key: 1,
            ghost: !0,
            onClick: l[0] || (l[0] = (u) => o("onClick"))
          }, {
            default: F(() => [
              G(a.$slots, "right-button")
            ]),
            _: 3
          })) : P("", !0)
        ], 2)
      ]),
      _: 3
    }, 8, ["has-border", "shadow"]));
  }
}), pp = {
  key: 0,
  class: "z-1 absolute left-0 top-0 flex h-full w-full items-center justify-center rounded-lg bg-black/50"
}, fp = { class: "line-clamp-3" }, hp = { class: "group mx-auto my-2 block aspect-[4/3] w-full max-w-[200px] overflow-hidden rounded-lg" }, vp = {
  key: 1,
  class: "mt-3 border-none text-center"
}, mp = ["src"], Q2 = /* @__PURE__ */ z({
  __name: "ProductCard",
  props: {
    isClickable: { type: Boolean, default: !0 },
    isDisabled: { type: Boolean, default: !1 },
    imgOverlayText: { default: "" },
    product: {},
    color: { default: "" },
    btnText: { default: null },
    btnImg: { default: "" },
    isSerif: { type: Boolean, default: !1 }
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    const n = e, o = t;
    return (r, i) => (f(), y("div", {
      class: O([n.isClickable && !n.isDisabled && "cursor-pointer", "relative h-full rounded-lg bg-gray-100 p-3"]),
      onClick: i[0] || (i[0] = (s) => !n.isDisabled && n.isClickable && o("onClick", n.product))
    }, [
      n.isDisabled ? (f(), y("div", pp, [
        m("div", {
          class: O(["px-2 text-center text-2xl font-black text-white", n.isSerif && "font-serif"])
        }, [
          G(r.$slots, "disabledContent")
        ], 2)
      ])) : P("", !0),
      m("h3", {
        class: O(["flex h-12 items-center justify-center text-center font-extrabold leading-5", n.isSerif && "font-serif"]),
        style: De(n.color && `color: ${r.$props.color}`)
      }, [
        m("span", fp, R(n.product.name), 1)
      ], 6),
      m("div", hp, [
        m("div", {
          style: De(`background-image: url(${n.product.pictureUrl})`),
          class: "h-full w-full bg-cover bg-center"
        }, [
          r.imgOverlayText ? (f(), y("div", {
            key: 0,
            class: O(["flex h-full w-full items-center justify-center bg-black/50 font-extrabold text-white", n.isSerif && "font-serif"])
          }, [
            m("span", null, R(n.imgOverlayText), 1)
          ], 2)) : P("", !0)
        ], 4)
      ]),
      n.btnText || n.btnImg ? (f(), y("div", vp, [
        B(rt, {
          class: O(["border-none focus:ring-transparent", !n.isClickable && "cursor-default focus:!ring-0 focus:!ring-transparent focus:!ring-offset-0"]),
          "rounded-size": "rounded-full"
        }, {
          default: F(() => [
            m("span", {
              class: O(["font-extrabold", n.isSerif && "font-serif"])
            }, R(n.btnText ?? n.product.points), 3),
            !n.btnText && n.btnImg ? (f(), y("img", {
              key: 0,
              src: n.btnImg,
              class: "ml-1 w-4"
            }, null, 8, mp)) : (f(), j(T(Ru), {
              key: 1,
              class: "my-auto ml-1 w-5"
            }))
          ]),
          _: 1
        }, 8, ["class"])
      ])) : P("", !0)
    ], 2));
  }
});
function Ro(e) {
  return hu() ? (Fs(e), !0) : !1;
}
function Mo(e) {
  return typeof e == "function" ? e() : T(e);
}
const To = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const gp = (e) => typeof e < "u", bp = Object.prototype.toString, yp = (e) => bp.call(e) === "[object Object]", Xn = () => {
}, wp = /* @__PURE__ */ xp();
function xp() {
  var e, t;
  return To && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(ad|hone|od)/.test(window.navigator.userAgent) || ((t = window == null ? void 0 : window.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function $p(e) {
  let t;
  function n() {
    return t || (t = e()), t;
  }
  return n.reset = async () => {
    const o = t;
    t = void 0, o && await o;
  }, n;
}
function Cp(e) {
  return e || vo();
}
function Sp(e, t = !0, n) {
  Cp() ? ae(e, n) : t ? e() : ke(e);
}
function kp(e, t, n = {}) {
  const {
    immediate: o = !0
  } = n, r = A(!1);
  let i = null;
  function s() {
    i && (clearTimeout(i), i = null);
  }
  function a() {
    r.value = !1, s();
  }
  function l(...u) {
    s(), r.value = !0, i = setTimeout(() => {
      r.value = !1, i = null, e(...u);
    }, Mo(t));
  }
  return o && (r.value = !0, To && l()), Ro(a), {
    isPending: fu(r),
    start: l,
    stop: a
  };
}
function mt(e) {
  var t;
  const n = Mo(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const Po = To ? window : void 0, Fa = To ? window.navigator : void 0;
function Nt(...e) {
  let t, n, o, r;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([n, o, r] = e, t = Po) : [t, n, o, r] = e, !t)
    return Xn;
  Array.isArray(n) || (n = [n]), Array.isArray(o) || (o = [o]);
  const i = [], s = () => {
    i.forEach((c) => c()), i.length = 0;
  }, a = (c, d, p, v) => (c.addEventListener(d, p, v), () => c.removeEventListener(d, p, v)), l = he(
    () => [mt(t), Mo(r)],
    ([c, d]) => {
      if (s(), !c)
        return;
      const p = yp(d) ? { ...d } : d;
      i.push(
        ...n.flatMap((v) => o.map((x) => a(c, v, x, p)))
      );
    },
    { immediate: !0, flush: "post" }
  ), u = () => {
    l(), s();
  };
  return Ro(u), u;
}
let Ui = !1;
function Ep(e, t, n = {}) {
  const { window: o = Po, ignore: r = [], capture: i = !0, detectIframe: s = !1 } = n;
  if (!o)
    return Xn;
  wp && !Ui && (Ui = !0, Array.from(o.document.body.children).forEach((p) => p.addEventListener("click", Xn)), o.document.documentElement.addEventListener("click", Xn));
  let a = !0;
  const l = (p) => r.some((v) => {
    if (typeof v == "string")
      return Array.from(o.document.querySelectorAll(v)).some((x) => x === p.target || p.composedPath().includes(x));
    {
      const x = mt(v);
      return x && (p.target === x || p.composedPath().includes(x));
    }
  }), c = [
    Nt(o, "click", (p) => {
      const v = mt(e);
      if (!(!v || v === p.target || p.composedPath().includes(v))) {
        if (p.detail === 0 && (a = !l(p)), !a) {
          a = !0;
          return;
        }
        t(p);
      }
    }, { passive: !0, capture: i }),
    Nt(o, "pointerdown", (p) => {
      const v = mt(e);
      a = !l(p) && !!(v && !p.composedPath().includes(v));
    }, { passive: !0 }),
    s && Nt(o, "blur", (p) => {
      setTimeout(() => {
        var v;
        const x = mt(e);
        ((v = o.document.activeElement) == null ? void 0 : v.tagName) === "IFRAME" && !(x != null && x.contains(o.document.activeElement)) && t(p);
      }, 0);
    })
  ].filter(Boolean);
  return () => c.forEach((p) => p());
}
function Op() {
  const e = A(!1);
  return vo() && ae(() => {
    e.value = !0;
  }), e;
}
function Io(e) {
  const t = Op();
  return E(() => (t.value, !!e()));
}
function Wi(e, t = {}) {
  const {
    controls: n = !1,
    navigator: o = Fa
  } = t, r = Io(() => o && "permissions" in o);
  let i;
  const s = typeof e == "string" ? { name: e } : e, a = A(), l = () => {
    i && (a.value = i.state);
  }, u = $p(async () => {
    if (r.value) {
      if (!i)
        try {
          i = await o.permissions.query(s), Nt(i, "change", l), l();
        } catch {
          a.value = "prompt";
        }
      return i;
    }
  });
  return u(), n ? {
    state: a,
    isSupported: r,
    query: u
  } : a;
}
function Ap(e = {}) {
  const {
    navigator: t = Fa,
    read: n = !1,
    source: o,
    copiedDuring: r = 1500,
    legacy: i = !1
  } = e, s = Io(() => t && "clipboard" in t), a = Wi("clipboard-read"), l = Wi("clipboard-write"), u = E(() => s.value || i), c = A(""), d = A(!1), p = kp(() => d.value = !1, r);
  function v() {
    s.value && a.value !== "denied" ? t.clipboard.readText().then((S) => {
      c.value = S;
    }) : c.value = h();
  }
  u.value && n && Nt(["copy", "cut"], v);
  async function x(S = Mo(o)) {
    u.value && S != null && (s.value && l.value !== "denied" ? await t.clipboard.writeText(S) : b(S), c.value = S, d.value = !0, p.start());
  }
  function b(S) {
    const g = document.createElement("textarea");
    g.value = S ?? "", g.style.position = "absolute", g.style.opacity = "0", document.body.appendChild(g), g.select(), document.execCommand("copy"), g.remove();
  }
  function h() {
    var S, g, C;
    return (C = (g = (S = document == null ? void 0 : document.getSelection) == null ? void 0 : S.call(document)) == null ? void 0 : g.toString()) != null ? C : "";
  }
  return {
    isSupported: u,
    text: c,
    copied: d,
    copy: x
  };
}
function _p(e) {
  return JSON.parse(JSON.stringify(e));
}
function Rp(e, t, n = {}) {
  const { window: o = Po, ...r } = n;
  let i;
  const s = Io(() => o && "MutationObserver" in o), a = () => {
    i && (i.disconnect(), i = void 0);
  }, l = he(
    () => mt(e),
    (d) => {
      a(), s.value && o && d && (i = new MutationObserver(t), i.observe(d, r));
    },
    { immediate: !0 }
  ), u = () => i == null ? void 0 : i.takeRecords(), c = () => {
    a(), l();
  };
  return Ro(c), {
    isSupported: s,
    stop: c,
    takeRecords: u
  };
}
function Mp(e, t, n = {}) {
  const { window: o = Po, ...r } = n;
  let i;
  const s = Io(() => o && "ResizeObserver" in o), a = () => {
    i && (i.disconnect(), i = void 0);
  }, l = E(() => Array.isArray(e) ? e.map((d) => mt(d)) : [mt(e)]), u = he(
    l,
    (d) => {
      if (a(), s.value && o) {
        i = new ResizeObserver(t);
        for (const p of d)
          p && i.observe(p, r);
      }
    },
    { immediate: !0, flush: "post", deep: !0 }
  ), c = () => {
    a(), u();
  };
  return Ro(c), {
    isSupported: s,
    stop: c
  };
}
function Tp(e, t = {}) {
  const {
    reset: n = !0,
    windowResize: o = !0,
    windowScroll: r = !0,
    immediate: i = !0
  } = t, s = A(0), a = A(0), l = A(0), u = A(0), c = A(0), d = A(0), p = A(0), v = A(0);
  function x() {
    const b = mt(e);
    if (!b) {
      n && (s.value = 0, a.value = 0, l.value = 0, u.value = 0, c.value = 0, d.value = 0, p.value = 0, v.value = 0);
      return;
    }
    const h = b.getBoundingClientRect();
    s.value = h.height, a.value = h.bottom, l.value = h.left, u.value = h.right, c.value = h.top, d.value = h.width, p.value = h.x, v.value = h.y;
  }
  return Mp(e, x), he(() => mt(e), (b) => !b && x()), Rp(e, x, {
    attributeFilter: ["style", "class"]
  }), r && Nt("scroll", x, { capture: !0, passive: !0 }), o && Nt("resize", x, { passive: !0 }), Sp(() => {
    i && x();
  }), {
    height: s,
    bottom: a,
    left: l,
    right: u,
    top: c,
    width: d,
    x: p,
    y: v,
    update: x
  };
}
function sn(e, t, n, o = {}) {
  var r, i, s;
  const {
    clone: a = !1,
    passive: l = !1,
    eventName: u,
    deep: c = !1,
    defaultValue: d,
    shouldEmit: p
  } = o, v = vo(), x = n || (v == null ? void 0 : v.emit) || ((r = v == null ? void 0 : v.$emit) == null ? void 0 : r.bind(v)) || ((s = (i = v == null ? void 0 : v.proxy) == null ? void 0 : i.$emit) == null ? void 0 : s.bind(v == null ? void 0 : v.proxy));
  let b = u;
  t || (t = "modelValue"), b = b || `update:${t.toString()}`;
  const h = (C) => a ? typeof a == "function" ? a(C) : _p(C) : C, S = () => gp(e[t]) ? h(e[t]) : d, g = (C) => {
    p ? p(C) && x(b, C) : x(b, C);
  };
  if (l) {
    const C = S(), w = A(C);
    let $ = !1;
    return he(
      () => e[t],
      (k) => {
        $ || ($ = !0, w.value = h(k), ke(() => $ = !1));
      }
    ), he(
      w,
      (k) => {
        !$ && (k !== e[t] || c) && g(k);
      },
      { deep: c }
    ), w;
  } else
    return E({
      get() {
        return S();
      },
      set(C) {
        g(C);
      }
    });
}
const Pp = { class: "flex flex-grow flex-col" }, J2 = /* @__PURE__ */ z({
  __name: "Switch",
  props: {
    modelValue: { type: Boolean },
    label: { default: "" },
    description: { default: "" },
    tooltip: { default: "" },
    id: {},
    isDisabled: { type: Boolean },
    isReversed: { type: Boolean, default: !1 },
    fontColorGradient: { default: "900" },
    fontColor: { default: "gray" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = Kt(), o = e, i = sn(o, "modelValue", t), s = E(() => {
      const l = i.value ? "bg-green-500" : "bg-red-300";
      return o.isDisabled ? "bg-gray-200" : `${l} cursor-pointer`;
    }), a = E(() => o.isDisabled ? "text-gray-400" : `text-${o.fontColor}-${o.fontColorGradient}`);
    return (l, u) => (f(), j(T(fd), {
      as: "div",
      class: O(["flex items-center justify-between", l.isReversed && "flex-row-reverse"])
    }, {
      default: F(() => [
        m("span", Pp, [
          l.label || n.label ? (f(), j(T(vd), {
            key: 0,
            as: "span",
            class: O(["text-sm font-medium", [l.isReversed ? "ml-4" : "mr-4", a.value]]),
            passive: ""
          }, {
            default: F(() => [
              ce(R(l.label) + " ", 1),
              n.label ? G(l.$slots, "label", { key: 0 }) : P("", !0)
            ]),
            _: 3
          }, 8, ["class"])) : P("", !0),
          B(T(md), {
            as: "span",
            class: "text-sm text-gray-500"
          }, {
            default: F(() => [
              ce(R(l.description), 1)
            ]),
            _: 1
          })
        ]),
        B(T(hd), {
          id: "switch",
          modelValue: T(i),
          "onUpdate:modelValue": u[0] || (u[0] = (c) => mo(i) ? i.value = c : null),
          disabled: l.isDisabled,
          class: O([
            s.value,
            "relative inline-flex h-6 w-11 flex-shrink-0 rounded-full border-2 border-solid border-transparent transition-colors duration-200 ease-in-out focus:ring-offset-0"
          ])
        }, {
          default: F(() => [
            m("span", {
              class: O([
                T(i) ? "translate-x-5" : "translate-x-0",
                "pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
              ])
            }, [
              m("span", {
                class: O([
                  T(i) ? "opacity-0 duration-100 ease-out" : "opacity-100 duration-200 ease-in",
                  "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                ]),
                "aria-hidden": "true"
              }, [
                B(T(bt), {
                  class: O(["h-3 w-3", l.isDisabled ? "text-gray-400" : "text-red-400"]),
                  "aria-hidden": "true"
                }, null, 8, ["class"])
              ], 2),
              m("span", {
                class: O([
                  T(i) ? "opacity-100 duration-200 ease-in" : "opacity-0 duration-100 ease-out",
                  "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"
                ]),
                "aria-hidden": "true"
              }, [
                B(T(Iu), {
                  class: O(["h-3 w-3", l.isDisabled ? "text-gray-400" : "text-green-500"]),
                  "aria-hidden": "true"
                }, null, 8, ["class"])
              ], 2)
            ], 2)
          ]),
          _: 1
        }, 8, ["modelValue", "disabled", "class"])
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
function Ip({ currentPage: e, lastPage: t }, {
  emit: n
}) {
  const o = E(() => {
    const l = e.value > 3 ? e.value - 2 : 2, u = e.value < t.value - 3 ? e.value + 3 : t.value;
    if (t.value > 10) {
      const c = [1];
      for (let d = l; d < u; d++)
        c.push(d);
      return c.push(t.value), c;
    } else
      return t.value;
  }), r = E(() => e.value + 1), i = E(() => e.value - 1);
  return {
    pagesDisplayed: A(6),
    changePage: (l) => {
      n("update:changePage", l);
    },
    displayPages: o,
    nextPage: r,
    previousPage: i
  };
}
const Lp = z({
  name: "Pagination",
  props: {
    // For Table Component, true is needed
    backgroundColor: {
      type: Boolean,
      default: !0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    lastPage: {
      type: Number,
      required: !0
    },
    total: {
      type: Number,
      required: !0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    previousLabel: {
      type: String,
      default: null
    },
    nextLabel: {
      type: String,
      default: null
    }
  },
  emits: {
    "update:changePage"(e) {
      return e;
    }
  },
  setup(e, t) {
    const { pagesDisplayed: n, displayPages: o, changePage: r, nextPage: i, previousPage: s } = Ip(at(e), t);
    return {
      getColorClass: W,
      pagesDisplayed: n,
      displayPages: o,
      changePage: r,
      nextPage: i,
      previousPage: s
    };
  }
}), Dp = { class: "-mt-2 md:-mt-px md:flex md:w-0 md:flex-1" }, Bp = /* @__PURE__ */ m("svg", {
  class: "mr-2 h-5 w-5 text-gray-400",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /* @__PURE__ */ m("path", {
    "fill-rule": "evenodd",
    d: "M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z",
    "clip-rule": "evenodd"
  })
], -1), zp = { class: "hidden md:inline" }, Np = { class: "inline md:hidden" }, jp = { class: "mt-2 items-center px-8 text-sm font-medium text-gray-400 lg:hidden" }, Vp = { class: "hidden md:-mt-px lg:flex" }, Fp = ["onClick"], Hp = { class: "-mt-2 md:-mt-px md:flex md:w-0 md:flex-1 md:justify-end" }, Up = { class: "hidden md:inline" }, Wp = { class: "inline md:hidden" }, qp = /* @__PURE__ */ m("svg", {
  class: "ml-2 h-5 w-5 text-gray-400",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "aria-hidden": "true"
}, [
  /* @__PURE__ */ m("path", {
    "fill-rule": "evenodd",
    d: "M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z",
    "clip-rule": "evenodd"
  })
], -1);
function Zp(e, t, n, o, r, i) {
  return f(), y("nav", {
    class: O(["xs:px-0 flex w-full items-center justify-between px-4 pb-2 sm:px-2", e.backgroundColor ? "border-gray-200 bg-gray-50" : ""])
  }, [
    m("div", Dp, [
      e.currentPage > 1 ? (f(), y("button", {
        key: 0,
        class: "inline-flex items-center border-t-2 border-transparent pr-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 focus:outline-none",
        onClick: t[0] || (t[0] = (s) => e.changePage(e.previousPage))
      }, [
        Bp,
        m("span", zp, R(e.previousLabel), 1),
        m("span", Np, R(e.previousPage), 1)
      ])) : P("", !0)
    ]),
    m("span", jp, R(e.currentPage) + " / " + R(e.lastPage), 1),
    m("div", Vp, [
      (f(!0), y(K, null, se(e.displayPages, (s) => (f(), y("button", {
        key: s,
        class: O(`${Number(s) === e.currentPage ? `${e.getColorClass({ type: "border", value: "800" })} ${e.getColorClass({ type: "text", value: "800" })}` : "border-transparent text-gray-500 hover:text-gray-700"} inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium hover:border-gray-300 hover:text-gray-700 focus:outline-none`),
        onClick: (a) => e.changePage(Number(s))
      }, R(s), 11, Fp))), 128))
    ]),
    m("div", Hp, [
      e.nextPage <= e.lastPage ? (f(), y("button", {
        key: 0,
        class: "inline-flex items-center border-t-2 border-transparent pl-1 pt-4 text-sm font-medium text-gray-500 hover:border-gray-300 hover:text-gray-700 focus:outline-none",
        onClick: t[1] || (t[1] = (s) => e.changePage(e.nextPage))
      }, [
        m("span", Up, R(e.nextLabel), 1),
        m("span", Wp, R(e.nextPage), 1),
        qp
      ])) : P("", !0)
    ])
  ], 2);
}
const qi = /* @__PURE__ */ Ee(Lp, [["render", Zp]]), Gp = { class: "flex animate-pulse flex-col" }, Kp = { key: 0 }, Yp = { class: "space-y-6" }, Xp = { class: "space-y-6" }, Qp = /* @__PURE__ */ m("div", { class: "block h-2 rounded bg-gray-300 sm:mt-px sm:pt-2" }, null, -1), Jp = /* @__PURE__ */ m("div", { class: "mt-1 h-2 rounded bg-gray-300 sm:col-span-2 sm:mt-0" }, [
  /* @__PURE__ */ m("div", { class: "block h-2 max-w-lg rounded bg-gray-300" })
], -1), ef = [
  Qp,
  Jp
], tf = { key: 1 }, nf = { class: "px-16 py-20" }, of = { class: "space-y-4" }, rf = /* @__PURE__ */ m("div", { class: "mb-12 flex items-center gap-4" }, [
  /* @__PURE__ */ m("div", { class: "h-40 w-32 rounded bg-gray-300" }),
  /* @__PURE__ */ m("div", { class: "h-12 w-full rounded bg-gray-300" })
], -1), sf = /* @__PURE__ */ m("div", { class: "mb-2" }, [
  /* @__PURE__ */ m("div", { class: "relative" }, [
    /* @__PURE__ */ m("div", { class: "h-3 w-32 rounded bg-gray-300" }),
    /* @__PURE__ */ m("div", { class: "my-1 h-3 rounded bg-gray-300" })
  ])
], -1), af = [
  sf
], lf = { key: 2 }, uf = { class: "flex items-center space-x-4" }, cf = { class: "flex items-center space-x-4" }, df = /* @__PURE__ */ m("span", { class: "h-2 w-12 rounded bg-gray-300" }, null, -1), pf = {
  key: 0,
  class: "h-5 w-5 flex-shrink-0 text-gray-300",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}, ff = /* @__PURE__ */ m("path", { d: "M5.555 17.776l8-16 .894.448-8 16-.894-.448z" }, null, -1), hf = [
  ff
], vf = /* @__PURE__ */ m("h1", { class: "mt-5 h-4 w-44 rounded bg-gray-300" }, null, -1), mf = { key: 3 }, gf = /* @__PURE__ */ m("div", {
  "data-placeholder": "",
  class: "relative mt-8 h-8 w-full overflow-hidden rounded bg-gray-200"
}, null, -1), bf = /* @__PURE__ */ m("div", {
  "data-placeholder": "",
  class: "relative mt-8 h-8 w-full overflow-hidden rounded bg-gray-200"
}, null, -1), yf = /* @__PURE__ */ m("div", {
  "data-placeholder": "",
  class: "relative mt-8 h-96 w-full overflow-hidden rounded bg-gray-200"
}, null, -1), wf = [
  gf,
  bf,
  yf
], xf = { key: 5 }, $f = /* @__PURE__ */ m("div", {
  "data-placeholder": "",
  class: "relative mb-2 mt-10 h-6 w-36 rounded bg-gray-200 md:w-56"
}, null, -1), Cf = /* @__PURE__ */ m("div", {
  "data-placeholder": "",
  class: "relative mb-2 h-4 w-48 rounded bg-gray-200 md:w-80"
}, null, -1), Sf = /* @__PURE__ */ m("div", {
  "data-placeholder": "",
  class: "relative mb-2 h-4 w-64 rounded bg-gray-200 md:w-96"
}, null, -1), kf = /* @__PURE__ */ m("div", {
  "data-placeholder": "",
  class: "relative mb-2 h-4 w-60 rounded bg-gray-200 md:w-64"
}, null, -1), Ef = [
  $f,
  Cf,
  Sf,
  kf
], Of = {
  key: 6,
  "data-placeholder": "",
  class: "relative inline-flex h-full min-h-5 items-center justify-center rounded-md bg-gray-200 text-sm font-medium shadow-sm"
}, Af = {
  key: 7,
  "data-placeholder": "",
  class: "relative h-10 w-44 rounded-md bg-gray-200 shadow"
}, _f = { key: 8 }, Rf = /* @__PURE__ */ m("div", {
  "data-placeholder": "",
  class: "relative flex h-32 w-52 items-center justify-center rounded bg-gray-200 shadow"
}, [
  /* @__PURE__ */ m("div", { class: "h-16 w-36 rounded bg-white" })
], -1), Mf = [
  Rf
], Tf = {
  key: 9,
  "data-placeholder": "",
  class: "relative flex h-full w-full items-center justify-center rounded bg-gray-200 shadow"
}, Pf = { key: 10 }, If = { class: "gap-6 lg:grid lg:grid-cols-6 lg:py-6" }, Lf = {
  key: 0,
  "data-placeholder": "",
  class: "relative h-4 w-32 rounded bg-gray-200"
}, Df = {
  key: 1,
  "data-placeholder": "",
  class: "relative h-4 w-12 rounded bg-gray-200"
}, Bf = /* @__PURE__ */ m("div", {
  "data-placeholder": "",
  class: "relative h-4 w-full rounded bg-gray-200"
}, null, -1), zf = /* @__PURE__ */ m("div", {
  "data-placeholder": "",
  class: "relative h-4 w-full rounded bg-gray-200"
}, null, -1), Nf = {
  key: 11,
  class: "p-4"
}, jf = { class: "space-y-3" }, Vf = /* @__PURE__ */ m("div", {
  "data-placeholder": "",
  class: "relative h-8 w-full rounded bg-gray-200"
}, null, -1), Ff = [
  Vf
], Hf = {
  key: 12,
  class: "p-4"
}, Uf = /* @__PURE__ */ m("div", { class: "py-2" }, [
  /* @__PURE__ */ m("span", { class: "block h-3 w-36 rounded bg-gray-300" })
], -1), Wf = [
  Uf
], qf = {
  key: 13,
  class: "p-4"
}, Zf = /* @__PURE__ */ vu('<div class="py-2"><div class="flex items-center"><span class="block h-12 w-12 rounded-full bg-gray-300"></span><div class="ml-4"><div class="flex-col space-y-2 pt-3"><div class="h-3 w-32 rounded bg-gray-300"></div><div class="h-1.5 w-32 rounded bg-gray-300"></div></div></div></div></div>', 1), Gf = [
  Zf
], Kf = {
  key: 14,
  class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
}, Yf = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }, Xf = { class: "overflow-hidden border-b border-gray-200 shadow sm:rounded-lg" }, Qf = { class: "min-w-full divide-y divide-gray-200" }, Jf = { class: "bg-gray-50" }, eh = /* @__PURE__ */ m("span", { class: "block h-2 w-full rounded bg-gray-300" }, null, -1), th = [
  eh
], nh = { class: "divide-y divide-gray-200 bg-white" }, oh = /* @__PURE__ */ m("td", { class: "px-6 py-4" }, [
  /* @__PURE__ */ m("div", { class: "flex items-center" }, [
    /* @__PURE__ */ m("span", { class: "block h-10 w-10 rounded-full bg-gray-300" }),
    /* @__PURE__ */ m("div", { class: "ml-4" }, [
      /* @__PURE__ */ m("div", { class: "flex items-center" }, [
        /* @__PURE__ */ m("div", { class: "h-3 w-32 rounded bg-gray-300" })
      ])
    ])
  ])
], -1), rh = /* @__PURE__ */ m("span", { class: "block h-3 w-36 rounded bg-gray-300" }, null, -1), ih = [
  rh
], wr = /* @__PURE__ */ z({
  __name: "Loader",
  props: {
    type: { default: null },
    sectionHeight: { default: "h-48" }
  },
  setup(e) {
    const t = e;
    return (n, o) => (f(), y("div", Gp, [
      t.type === "form" ? (f(), y("div", Kp, [
        m("div", Yp, [
          m("div", Xp, [
            (f(), y(K, null, se(4, (r) => m("div", {
              key: r,
              class: "pt-5 sm:grid sm:grid-cols-3 sm:items-start sm:gap-4"
            }, ef)), 64))
          ])
        ])
      ])) : t.type === "integration" ? (f(), y("div", tf, [
        m("div", nf, [
          m("div", of, [
            rf,
            (f(), y(K, null, se(6, (r) => m("div", {
              key: r,
              class: "sm:col-span-6 sm:grid"
            }, af)), 64))
          ])
        ])
      ])) : t.type === "breadcrumb" ? (f(), y("div", lf, [
        m("div", null, [
          m("ol", uf, [
            (f(), y(K, null, se(2, (r) => m("li", { key: r }, [
              m("div", cf, [
                df,
                r !== 2 ? (f(), y("svg", pf, hf)) : P("", !0)
              ])
            ])), 64))
          ]),
          vf
        ])
      ])) : t.type === "default" ? (f(), y("div", mf, wf)) : t.type === "section" ? (f(), y("div", {
        key: 4,
        class: O(["w-full bg-gray-200", t.sectionHeight])
      }, null, 2)) : t.type === "subheader" ? (f(), y("div", xf, Ef)) : t.type === "text" ? (f(), y("div", Of)) : t.type === "button" ? (f(), y("div", Af)) : t.type === "thumbnail" ? (f(), y("div", _f, Mf)) : t.type === "image" ? (f(), y("div", Tf, [
        B(T(Wu), { class: "w-1/2 min-w-5 max-w-xs text-white" })
      ])) : t.type === "cardImgRight" || t.type === "cardImgLeft" ? (f(), y("div", Pf, [
        m("ul", If, [
          (f(), y(K, null, se(4, (r) => m("li", {
            key: r,
            class: "rounded-md lg:col-span-3 lg:mx-0 lg:border lg:border-gray-100"
          }, [
            m("div", {
              class: O(["flex px-4 py-6 lg:py-4", n.type === "cardImgLeft" ? "flex-row-reverse" : "space-x-6"])
            }, [
              m("div", {
                class: O(["flex flex-auto flex-col", n.type === "cardImgRight" ? "justify-between" : "space-y-4"])
              }, [
                n.type === "cardImgRight" ? (f(), y("div", Lf)) : P("", !0),
                n.type === "cardImgRight" ? (f(), y("div", Df)) : P("", !0),
                Bf,
                zf
              ], 2),
              m("div", {
                "data-placeholder": "",
                class: O(["relative h-28 w-28 flex-none rounded-md bg-gray-200", n.type === "cardImgLeft" && "mr-6"])
              }, null, 2)
            ], 2)
          ])), 64))
        ])
      ])) : t.type === "list" ? (f(), y("div", Nf, [
        m("ul", jf, [
          (f(), y(K, null, se(4, (r) => m("li", {
            key: r,
            class: "rounded-md lg:col-span-3 lg:mx-0 lg:border lg:border-gray-100"
          }, Ff)), 64))
        ])
      ])) : t.type === "tableCell" ? (f(), y("div", Hf, Wf)) : t.type === "tableAvatarCell" ? (f(), y("div", qf, Gf)) : (f(), y("div", Kf, [
        m("div", Yf, [
          m("div", Xf, [
            m("table", Qf, [
              m("thead", Jf, [
                m("tr", null, [
                  (f(), y(K, null, se(6, (r) => m("th", {
                    key: r,
                    scope: "col",
                    class: "px-6 py-3"
                  }, th)), 64))
                ])
              ]),
              m("tbody", nh, [
                (f(), y(K, null, se(4, (r) => m("tr", { key: r }, [
                  oh,
                  (f(), y(K, null, se(5, (i) => m("td", {
                    key: i,
                    class: "px-6 py-4"
                  }, ih)), 64))
                ])), 64))
              ])
            ])
          ])
        ])
      ]))
    ]));
  }
}), Zi = (e) => (Number(e) % 10 + 1).toString().padStart(2, "0"), sh = (e, t) => {
  switch (e) {
    case "woman":
      return `/images/avatars/woman${Zi(t)}.jpg`;
    case "man":
      return `/images/avatars/man${Zi(t)}.jpg`;
    default:
      return "/images/avatars/default.jpg";
  }
};
function ah() {
  return {
    showTooltip: A(!1)
  };
}
function lh({ phone: e, gender: t }) {
  return {
    picture: E(() => sh(t, e))
  };
}
function uh({ colorHexa: e, color: t, backgroundColor: n }) {
  const o = E(() => {
    let i = "";
    return e == null && (i += `text-${t}-800`, n && (i += ` bg-${t}-100`)), i;
  }), r = E(() => {
    let i = "";
    return e != null && (i += `color: ${e};`, n && (i += `background-color: ${e}0f`)), i;
  });
  return {
    colorClass: o,
    colorStyle: r
  };
}
function ch({ sort: e, columns: t }, n) {
  const o = (v) => e !== null && v.sortable !== !1, r = (v) => {
    document.getElementsByTagName("main")[0].scrollTop = 0, n.emit("update:changePage", v);
  }, i = (v) => {
    o(v) && n.emit("update:changeSort", {
      sortBy: v.id,
      sortOrder: e.sortOrder === "DESC" ? "ASC" : "DESC"
    });
  }, s = (v) => {
    v.column.clickable && n.emit("cellClicked", v);
  }, a = (v) => {
    n.emit("rowClicked", v);
  }, l = (v) => {
    n.emit("link:clicked", v);
  }, u = (v) => ({
    customer: "pl-3 pr-12 py-4 whitespace-nowrap",
    label: "pr-6 py-4 whitespace-nowrap",
    datetime: "pl-4 pr-20 py-4 whitespace-nowrap text-sm font-medium text-gray-700 w-20",
    price: "px-4 py-4 whitespace-nowrap text-sm text-gray-500 font-medium",
    icon: "px-2 py-4 whitespace-nowrap"
  })[v] || "px-4 py-4 whitespace-nowrap text-sm text-gray-500", c = A(0), d = (v) => {
    c.value = v;
  }, p = E(() => Object.keys(t).length);
  return {
    isSortable: o,
    changePage: r,
    changeSort: i,
    cellClicked: s,
    rowClicked: a,
    linkClicked: l,
    getTdClassByType: u,
    getDropdownRowId: d,
    dropdownRowId: c,
    cols: p
  };
}
const dh = { class: "flex items-center" }, ph = { class: "hidden w-12 flex-shrink-0 sm:block" }, fh = { class: "relative inline-block" }, hh = ["src"], vh = { class: "ml-2 text-left sm:ml-3" }, mh = { class: "text-sm font-medium text-gray-600" }, gh = { class: "hidden text-sm capitalize text-gray-500 sm:block" }, bh = { class: "block w-44 truncate text-sm lowercase text-gray-500 sm:hidden" }, yh = /* @__PURE__ */ z({
  __name: "RowCustomer",
  props: {
    id: {},
    gender: {},
    name: { default: "" },
    phone: {},
    email: { default: "" },
    hasOptin: { type: Boolean },
    countryFlag: { default: null }
  },
  setup(e) {
    const t = e, { picture: n } = lh(t);
    return (o, r) => {
      const i = ne("router-link");
      return f(), y("div", null, [
        m("div", dh, [
          m("div", ph, [
            m("span", fh, [
              m("img", {
                class: "h-12 w-12 rounded-full",
                src: T(n),
                alt: ""
              }, null, 8, hh),
              m("span", {
                class: O(["absolute right-0 top-0 block h-2.5 w-2.5 rounded-full ring-2 ring-white", o.hasOptin ? "bg-green-400" : "bg-gray-300"])
              }, null, 2),
              o.countryFlag ? (f(), y("span", {
                key: 0,
                class: "absolute bottom-0 right-0 hidden h-3 w-3 rounded-full bg-cover bg-center ring-2 ring-white sm:block",
                style: De({ backgroundImage: `url('${o.countryFlag}')` })
              }, null, 4)) : P("", !0)
            ])
          ]),
          m("div", vh, [
            m("div", mh, [
              B(i, {
                class: O(`${T(W)({ type: "text", value: "800" })} ${T(W)({
                  type: "text",
                  value: "600",
                  prefix: "hover"
                })}`),
                to: {
                  name: "CustomerDetail",
                  params: {
                    customerId: o.id
                  }
                }
              }, {
                default: F(() => [
                  ce(R(o.phone), 1)
                ]),
                _: 1
              }, 8, ["class", "to"])
            ]),
            m("div", gh, R(o.name), 1),
            m("div", bh, R(o.email), 1)
          ])
        ])
      ]);
    };
  }
}), wh = { class: "text-sm text-gray-500" }, xh = {
  key: 0,
  class: "text-sm font-medium text-gray-600"
}, $h = /* @__PURE__ */ z({
  __name: "RowDatetime",
  props: {
    date: {},
    time: { default: "" }
  },
  setup(e) {
    return (t, n) => (f(), y("div", null, [
      m("div", wh, R(t.date), 1),
      t.time ? (f(), y("div", xh, R(t.time), 1)) : P("", !0)
    ]));
  }
}), Ch = { class: "flex items-center" }, Gi = /* @__PURE__ */ z({
  __name: "RowIcon",
  props: {
    color: {},
    colorIntensity: { default: 500 },
    icon: { default: null }
  },
  setup(e) {
    return (t, n) => (f(), y("p", Ch, [
      (f(), j(Le(t.icon), {
        class: O(["h-6 w-6", `text-${t.color}-${t.colorIntensity}`])
      }, null, 8, ["class"]))
    ]));
  }
}), Sh = ["d"], Ki = /* @__PURE__ */ z({
  __name: "RowLabel",
  props: {
    label: {},
    backgroundColor: { type: Boolean, default: !0 },
    color: { default: "gray" },
    colorHexa: { default: null },
    colorIntensity: { default: 500 },
    svg: { default: null }
  },
  setup(e) {
    const t = e, { colorClass: n, colorStyle: o } = uh(t);
    return (r, i) => (f(), y("span", {
      class: O(["inline-flex items-center rounded-full px-3 py-0.5 text-sm font-medium", T(n)]),
      style: De(T(o))
    }, [
      r.svg != null ? (f(), y("svg", {
        key: 0,
        class: O(["mr-1.5 h-5 w-5 flex-shrink-0", `text-${r.color}-600 mr-1.5 h-5 w-5 flex-shrink-0 text-${r.color}-${r.colorIntensity}`]),
        style: De(r.colorHexa != null ? `color: ${r.colorHexa};` : ""),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        fill: "currentColor",
        "aria-hidden": "true"
      }, [
        (f(!0), y(K, null, se(r.svg, (s) => (f(), y("path", {
          key: s,
          "fill-rule": "evenodd",
          d: s,
          "clip-rule": "evenodd"
        }, null, 8, Sh))), 128))
      ], 6)) : P("", !0),
      ce(" " + R(r.label), 1)
    ], 6));
  }
}), kh = { key: 0 }, Eh = { key: 1 }, Oh = /* @__PURE__ */ z({
  __name: "RowLabels",
  props: {
    labels: {},
    backgroundColor: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (t, n) => Array.isArray(t.labels) ? (f(), y("span", kh, [
      (f(!0), y(K, null, se(t.labels, (o) => (f(), y("span", {
        key: o.label
      }, [
        B(Ki, {
          color: o.color,
          "color-hexa": o.colorHexa,
          label: o.label,
          svg: o.svg,
          "background-color": t.backgroundColor
        }, null, 8, ["color", "color-hexa", "label", "svg", "background-color"])
      ]))), 128))
    ])) : (f(), y("span", Eh, [
      (f(), j(Ki, {
        key: t.labels.label,
        color: t.labels.color,
        "color-hexa": t.labels.colorHexa,
        label: t.labels.label,
        svg: t.labels.svg,
        "background-color": t.backgroundColor
      }, null, 8, ["color", "color-hexa", "label", "svg", "background-color"]))
    ]));
  }
}), Ah = { key: 0 }, _h = {
  key: 1,
  class: "inline-flex items-center rounded-md bg-green-100 px-2.5 py-0.5 text-sm font-medium text-green-800"
}, Rh = /* @__PURE__ */ m("svg", {
  class: "-ml-0.5 mr-1.5 h-2 w-2 text-green-400",
  fill: "currentColor",
  viewBox: "0 0 8 8"
}, [
  /* @__PURE__ */ m("circle", {
    cx: "4",
    cy: "4",
    r: "3"
  })
], -1), Mh = { class: "absolute right-0 top-3 flex items-center justify-center" }, Th = { class: "relative" }, Ph = { class: "absolute left-2 top-3 z-10 -mt-1 rounded-lg bg-gray-400 p-2 text-sm text-white shadow-lg" }, Ih = /* @__PURE__ */ z({
  __name: "RowStores",
  props: {
    stores: {},
    storesLabel: { default: null }
  },
  setup(e) {
    const { showTooltip: t } = ah();
    return (n, o) => n.stores.length === 1 ? (f(), y("span", Ah, R(n.stores[0].name), 1)) : (f(), y("span", _h, [
      Rh,
      m("div", {
        class: "relative cursor-pointer",
        onMouseover: o[0] || (o[0] = (r) => t.value = !0),
        onMouseout: o[1] || (o[1] = (r) => t.value = !1)
      }, [
        ce(R(n.stores.length) + " " + R(n.storesLabel) + " ", 1),
        ze(m("div", Mh, [
          m("div", Th, [
            m("div", Ph, [
              (f(!0), y(K, null, se(n.stores, (r) => (f(), y("p", {
                key: r.id
              }, R(r.name), 1))), 128))
            ])
          ])
        ], 512), [
          [At, T(t)]
        ])
      ], 32)
    ]));
  }
}), Lh = {
  key: 0,
  class: "bg-white px-4 py-4"
}, Dh = { class: "font-semibold text-gray-800" }, Bh = { class: "bg-gray-50" }, zh = ["onClick"], Nh = {
  key: 0,
  class: "bg-white"
}, jh = {
  key: 1,
  class: "divide-y divide-gray-200 bg-white"
}, Vh = ["onClick"], Fh = ["onClick"], Hh = { class: "text-md font-semibold text-gray-800" }, Uh = { class: "bg-gray-50" }, Wh = ["onClick"], qh = {
  key: 0,
  class: "bg-white"
}, Zh = {
  key: 1,
  class: "divide-y divide-gray-200 bg-white"
}, Gh = ["onClick"], Kh = ["onClick"], Yh = { key: 1 }, Xh = { key: 2 }, Qh = { key: 3 }, Jh = { key: 4 }, e0 = { key: 1 }, t0 = { key: 5 }, n0 = ["onClick"], o0 = { key: 6 }, r0 = { key: 7 }, i0 = { key: 0 }, s0 = { key: 8 }, a0 = { class: "mb-1 font-semibold text-black" }, l0 = { key: 10 }, u0 = { key: 2 }, c0 = ["colspan"], d0 = {
  key: 0,
  class: "w-full"
}, e7 = /* @__PURE__ */ z({
  __name: "Table",
  props: {
    cellClasses: { default: "" },
    columns: {},
    dropdown: { default: null },
    isLoading: { type: Boolean, default: !1 },
    loaderRowsNumber: { default: 8 },
    newDesign: { type: Boolean, default: !1 },
    pagination: { default: null },
    rowClasses: { default: "" },
    rows: {},
    rowStoresLabel: { default: null },
    sort: { default: null },
    tableTitle: { default: null },
    useHeaderKey: { type: Boolean, default: !1 }
  },
  emits: ["rowClicked", "cellClicked", "update:changePage", "update:changeSort", "link:clicked", "dropdown:clicked"],
  setup(e, { emit: t }) {
    const n = e, o = t, {
      changePage: r,
      changeSort: i,
      cols: s,
      dropdownRowId: a,
      getDropdownRowId: l,
      getTdClassByType: u,
      isSortable: c,
      linkClicked: d,
      cellClicked: p,
      rowClicked: v
    } = ch(n, { emit: o }), x = E(() => Object.keys(n.columns).length), b = E(() => Object.keys(n.columns));
    return (h, S) => (f(), y(K, null, [
      m("div", {
        class: O(h.newDesign && "w-full overflow-hidden rounded-xl border")
      }, [
        h.tableTitle ? (f(), y("div", Lh, [
          m("h2", Dh, R(h.tableTitle), 1)
        ])) : P("", !0),
        m("div", {
          class: O(h.newDesign && "overflow-auto")
        }, [
          m("table", {
            class: O(["min-w-full divide-y divide-gray-200", { "border-t": h.newDesign && h.tableTitle, "rounded-md": !h.newDesign }])
          }, [
            h.useHeaderKey ? (f(), y(K, { key: 0 }, [
              m("thead", Bh, [
                m("tr", null, [
                  (f(!0), y(K, null, se(b.value, (g) => {
                    var C, w, $;
                    return f(), y("th", {
                      key: h.columns[g].id,
                      scope: "col",
                      class: O(["w-1/6 p-4 text-left text-xs font-medium uppercase tracking-wider text-gray-600", [
                        {
                          "hidden sm:table-cell": (C = h.columns[g]) == null ? void 0 : C.hideOnMobile,
                          "sm:hidden": (w = h.columns[g]) == null ? void 0 : w.hideOnDesktop,
                          "cursor-pointer": T(c)(h.columns[g])
                        },
                        ($ = h.columns[g]) == null ? void 0 : $.headerClass
                      ]]),
                      onClick: (k) => T(i)(h.columns[g])
                    }, [
                      G(h.$slots, `th-${g}`, {
                        th: h.columns[g]
                      }, () => [
                        ce(R(h.columns[g].label) + " ", 1),
                        T(c)(h.columns[g]) && h.sort.sortBy === h.columns[g].id ? (f(), j(T(Pi), {
                          key: 0,
                          class: "ml-2 inline h-4 w-4"
                        })) : P("", !0)
                      ])
                    ], 10, zh);
                  }), 128))
                ])
              ]),
              h.isLoading ? (f(), y("tbody", Nh, [
                (f(!0), y(K, null, se(h.loaderRowsNumber, (g) => (f(), y("tr", { key: g }, [
                  h.$slots.loader ? P("", !0) : (f(!0), y(K, { key: 0 }, se(x.value, (C) => (f(), y("td", {
                    key: C,
                    ref_for: !0,
                    ref: "loader"
                  }, [
                    B(wr, {
                      type: "tableCell",
                      class: "min-w-full"
                    })
                  ]))), 128)),
                  G(h.$slots, "loader")
                ]))), 128))
              ])) : (f(), y("tbody", jh, [
                (f(!0), y(K, null, se(h.rows, (g) => (f(), y("tr", {
                  key: g.id,
                  class: O(h.rowClasses),
                  onClick: (C) => T(v)(g)
                }, [
                  (f(!0), y(K, null, se(b.value, (C) => {
                    var w, $, k;
                    return f(), y("td", {
                      key: `${C}-${g.id}`,
                      class: O([
                        {
                          "hidden sm:table-cell": (w = g.data[C]) == null ? void 0 : w.hideOnMobile,
                          "sm:hidden": ($ = g.data[C]) == null ? void 0 : $.hideOnDesktop
                        },
                        T(u)((k = g.data[C]) == null ? void 0 : k.type),
                        h.cellClasses
                      ]),
                      onClick: (_) => T(p)({ id: g.id, column: g.data[C] })
                    }, [
                      G(h.$slots, `td-${C}`, {
                        data: g.data
                      }, () => [
                        m("span", Hh, R(g.data[C]), 1)
                      ])
                    ], 10, Fh);
                  }), 128))
                ], 10, Vh))), 128))
              ]))
            ], 64)) : (f(), y(K, { key: 1 }, [
              m("thead", Uh, [
                m("tr", null, [
                  (f(!0), y(K, null, se(h.columns, (g) => (f(), y("th", {
                    key: g.id,
                    scope: "col",
                    class: O(["w-1/6 p-4 text-left text-xs font-medium uppercase tracking-wider text-gray-600", [
                      {
                        "hidden sm:table-cell": g == null ? void 0 : g.hideOnMobile,
                        "sm:hidden": g == null ? void 0 : g.hideOnDesktop,
                        "cursor-pointer": T(c)(g)
                      },
                      g == null ? void 0 : g.headerClass
                    ]]),
                    onClick: (C) => T(i)(g)
                  }, [
                    G(h.$slots, `th-${g.name}`, { th: g }, () => [
                      ce(R(g.label) + " ", 1),
                      T(c)(g) && h.sort.sortBy === g.id ? (f(), j(T(Pi), {
                        key: 0,
                        class: "ml-2 inline h-4 w-4"
                      })) : P("", !0)
                    ])
                  ], 10, Wh))), 128))
                ])
              ]),
              h.isLoading ? (f(), y("tbody", qh, [
                (f(!0), y(K, null, se(h.loaderRowsNumber, (g) => (f(), y("tr", { key: g }, [
                  h.$slots.loader ? P("", !0) : (f(!0), y(K, { key: 0 }, se(x.value, (C) => (f(), y("td", {
                    key: C,
                    ref_for: !0,
                    ref: "loader"
                  }, [
                    B(wr, {
                      type: "tableCell",
                      class: "min-w-full"
                    })
                  ]))), 128)),
                  G(h.$slots, "loader")
                ]))), 128))
              ])) : (f(), y("tbody", Zh, [
                (f(!0), y(K, null, se(h.rows, (g, C) => (f(), y("tr", {
                  key: g.id,
                  class: O(h.rowClasses),
                  onClick: (w) => T(v)({ id: g.id, row: g.data })
                }, [
                  (f(!0), y(K, null, se(g.data, (w, $) => {
                    var k, _, M, U, L, N, Z, H, J, X, ie, ye, Se, Oe;
                    return f(), y("td", {
                      key: $,
                      class: O([
                        {
                          "hidden sm:table-cell": (k = h.columns[$]) == null ? void 0 : k.hideOnMobile,
                          "sm:hidden": (_ = h.columns[$]) == null ? void 0 : _.hideOnDesktop
                        },
                        T(u)((M = h.columns[$]) == null ? void 0 : M.type),
                        h.cellClasses
                      ]),
                      onClick: (qe) => T(p)({ id: g.id, column: h.columns[$] })
                    }, [
                      ((U = h.columns[$]) == null ? void 0 : U.type) === "customer" ? (f(), j(yh, {
                        key: 0,
                        id: w.id,
                        "country-flag": w.countryFlag ?? null,
                        email: w.email,
                        gender: w.gender ?? "",
                        "has-optin": w.hasOptin,
                        name: w.name,
                        phone: w.phone
                      }, null, 8, ["id", "country-flag", "email", "gender", "has-optin", "name", "phone"])) : ((L = h.columns[$]) == null ? void 0 : L.type) === "datetime" ? (f(), y("span", Yh, [
                        B($h, {
                          date: w.date,
                          time: w.time
                        }, null, 8, ["date", "time"])
                      ])) : ((N = h.columns[$]) == null ? void 0 : N.type) === "label" ? (f(), y("span", Xh, [
                        B(Oh, {
                          labels: w,
                          "background-color": ((Z = h.columns[$]) == null ? void 0 : Z.backgroundColor) ?? !0
                        }, null, 8, ["labels", "background-color"])
                      ])) : ((H = h.columns[$]) == null ? void 0 : H.type) === "icon" ? (f(), y("span", Qh, [
                        B(Gi, {
                          color: w.color,
                          "color-intensity": w.colorIntensity,
                          icon: w.icon
                        }, null, 8, ["color", "color-intensity", "icon"])
                      ])) : ((J = h.columns[$]) == null ? void 0 : J.type) === "iconLink" ? (f(), y("span", Jh, [
                        w.icon ? (f(), j(Gi, {
                          key: 0,
                          color: w.color,
                          "color-intensity": w.colorIntensity,
                          icon: w.icon,
                          class: "cursor-pointer",
                          onClick: (qe) => T(d)(g.id)
                        }, null, 8, ["color", "color-intensity", "icon", "onClick"])) : (f(), y("span", e0, "-"))
                      ])) : ((X = h.columns[$]) == null ? void 0 : X.type) === "link" ? (f(), y("span", t0, [
                        m("button", {
                          type: "button",
                          class: O(`${T(W)({
                            type: "text",
                            value: "700",
                            prefix: "hover"
                          })} underline`),
                          onClick: (qe) => T(d)(g.id)
                        }, R(w), 11, n0)
                      ])) : ((ie = h.columns[$]) == null ? void 0 : ie.type) === "stores" ? (f(), y("span", o0, [
                        B(Ih, {
                          stores: w,
                          "stores-label": h.rowStoresLabel
                        }, null, 8, ["stores", "stores-label"])
                      ])) : ((ye = h.columns[$]) == null ? void 0 : ye.type) === "dropdown" ? (f(), y("span", r0, [
                        w.isDisabled ? (f(), y("span", i0, R(w.isDisabled), 1)) : (f(), j(Zd, {
                          key: 1,
                          label: h.dropdown.label,
                          "selected-value": w.role_template_id,
                          values: h.dropdown.values,
                          "zindex-value": h.rows.length ? h.rows.length - C : void 0,
                          onUpdateDropdown: T(l),
                          onClick: (qe) => h.$emit("dropdown:clicked", {
                            id: g.id,
                            dropdownRowId: T(a)
                          })
                        }, null, 8, ["label", "selected-value", "values", "zindex-value", "onUpdateDropdown", "onClick"]))
                      ])) : ((Se = h.columns[$]) == null ? void 0 : Se.type) === "doubleLine" ? (f(), y("span", s0, [
                        m("p", a0, R(w.title), 1),
                        m("p", null, R(w.description), 1)
                      ])) : ((Oe = h.columns[$]) == null ? void 0 : Oe.type) === "customCell" ? G(h.$slots, $, _t({
                        key: 9,
                        ref_for: !0
                      }, g)) : (f(), y("div", l0, R(w), 1))
                    ], 10, Kh);
                  }), 128))
                ], 10, Gh))), 128))
              ]))
            ], 64)),
            h.pagination != null && !h.newDesign ? (f(), y("tfoot", u0, [
              m("tr", null, [
                m("td", { colspan: T(s) }, [
                  B(qi, {
                    "current-page": h.pagination.currentPage,
                    "last-page": h.pagination.lastPage,
                    total: h.pagination.total,
                    "onUpdate:changePage": T(r)
                  }, null, 8, ["current-page", "last-page", "total", "onUpdate:changePage"])
                ], 8, c0)
              ])
            ])) : P("", !0)
          ], 2)
        ], 2)
      ], 2),
      h.pagination != null && h.newDesign ? (f(), y("div", d0, [
        B(qi, {
          "background-color": !1,
          "current-page": h.pagination.currentPage,
          "last-page": h.pagination.lastPage,
          total: h.pagination.total,
          "onUpdate:changePage": T(r)
        }, null, 8, ["current-page", "last-page", "total", "onUpdate:changePage"])
      ])) : P("", !0)
    ], 64));
  }
});
function p0(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
    })
  ]);
}
function f0(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
    })
  ]);
}
function h0(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function Ha(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m4.5 12.75 6 6 9-13.5"
    })
  ]);
}
function v0(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 19.5 8.25 12l7.5-7.5"
    })
  ]);
}
function m0(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
    })
  ]);
}
function Qr(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
    })
  ]);
}
function Ua(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    })
  ]);
}
function g0(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function Wa(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    })
  ]);
}
function b0(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 18 18 6M6 6l12 12"
    })
  ]);
}
function y0({
  emit: e
}) {
  const t = A(!1);
  return {
    confirmAndClose: () => {
      e("confirm"), t.value = !1;
    },
    open: t
  };
}
const w0 = z({
  name: "ConfirmButton",
  components: {
    Button: rt,
    Dialog: xa,
    DialogOverlay: $a,
    DialogTitle: Ca,
    TransitionChild: ao,
    TransitionRoot: _o,
    ExclamationTriangleIcon: m0
  },
  props: {
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    confirmButtonLabel: {
      type: String,
      default: null
    },
    processingButtonLabel: {
      type: String,
      default: null
    },
    cancelButtonLabel: {
      type: String,
      default: null
    },
    outlined: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    isFixed: {
      type: Boolean,
      default: !1
    },
    white: {
      type: Boolean,
      default: !0
    },
    isOpenable: {
      type: Boolean,
      default: !0
    },
    processing: {
      type: Boolean,
      default: null
    }
  },
  emits: {
    confirm() {
      return !0;
    }
  },
  setup(e, t) {
    const { open: n, confirmAndClose: o } = y0(t);
    return {
      open: n,
      confirmAndClose: o,
      getColorClass: W
    };
  }
}), x0 = { class: "flex min-h-screen items-end justify-center px-4 pb-20 pt-4 text-center sm:block sm:p-0" }, $0 = /* @__PURE__ */ m("span", {
  class: "hidden sm:inline-block sm:h-screen sm:align-middle",
  "aria-hidden": "true"
}, "​", -1), C0 = { class: "inline-block transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6 sm:align-middle" }, S0 = { class: "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-green-100" }, k0 = { class: "mt-3 text-center sm:mt-5" }, E0 = {
  key: 0,
  class: "mt-2"
}, O0 = { class: "text-sm text-gray-500" }, A0 = { class: "mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3" }, _0 = /* @__PURE__ */ m("svg", {
  class: "-ml-1 mr-3 h-5 w-5 animate-spin text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /* @__PURE__ */ m("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /* @__PURE__ */ m("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1);
function R0(e, t, n, o, r, i) {
  const s = ne("Button"), a = ne("DialogOverlay"), l = ne("TransitionChild"), u = ne("ExclamationTriangleIcon"), c = ne("DialogTitle"), d = ne("Dialog"), p = ne("TransitionRoot");
  return f(), y("span", null, [
    B(s, {
      class: "w-full",
      outlined: e.outlined,
      disabled: e.disabled,
      "is-fixed": e.isFixed,
      white: e.white,
      onClick: t[0] || (t[0] = (v) => e.open = e.isOpenable)
    }, {
      default: F(() => [
        G(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["outlined", "disabled", "is-fixed", "white"]),
    B(p, {
      as: "template",
      show: e.open
    }, {
      default: F(() => [
        B(d, {
          as: "div",
          static: "",
          class: "fixed inset-0 z-10 overflow-y-auto",
          open: e.open,
          onClose: t[3] || (t[3] = (v) => e.open = !1)
        }, {
          default: F(() => [
            m("div", x0, [
              B(l, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0",
                "enter-to": "opacity-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: F(() => [
                  B(a, { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
                ]),
                _: 1
              }),
              $0,
              B(l, {
                as: "template",
                enter: "ease-out duration-300",
                "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                leave: "ease-in duration-200",
                "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              }, {
                default: F(() => [
                  m("div", C0, [
                    m("div", null, [
                      m("div", S0, [
                        B(u, {
                          class: "h-6 w-6 text-green-600",
                          "aria-hidden": "true"
                        })
                      ]),
                      m("div", k0, [
                        B(c, {
                          as: "h3",
                          class: "text-lg font-medium leading-6 text-gray-900"
                        }, {
                          default: F(() => [
                            ce(R(e.title), 1)
                          ]),
                          _: 1
                        }),
                        e.text !== null ? (f(), y("div", E0, [
                          m("p", O0, R(e.text), 1)
                        ])) : P("", !0)
                      ])
                    ]),
                    m("div", A0, [
                      e.processing === null || e.processing === !1 ? (f(), y("button", {
                        key: 0,
                        type: "button",
                        class: O(`inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 shadow-sm ${e.getColorClass({ type: "bg", value: "800" })} text-base font-medium text-white ${e.getColorClass(
                          {
                            type: "bg",
                            value: "600",
                            prefix: "hover"
                          }
                        )} focus:outline-none focus:ring-2 focus:ring-offset-2 ${e.getColorClass({
                          type: "bg",
                          value: "800",
                          prefix: "focus"
                        })} sm:col-start-2 sm:text-sm`),
                        onClick: t[1] || (t[1] = (...v) => e.confirmAndClose && e.confirmAndClose(...v))
                      }, R(e.confirmButtonLabel), 3)) : (f(), y("button", {
                        key: 1,
                        type: "button",
                        disabled: "",
                        class: O(`inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 shadow-sm ${e.getColorClass(
                          {
                            type: "bg",
                            value: "800"
                          }
                        )} text-base font-medium text-white ${e.getColorClass({
                          type: "bg",
                          value: "600",
                          prefix: "hover"
                        })} focus:outline-none focus:ring-2 focus:ring-offset-2 ${e.getColorClass({
                          type: "ring",
                          value: "800",
                          prefix: "hover"
                        })} sm:col-start-2 sm:text-sm`)
                      }, [
                        _0,
                        ce(" " + R(e.processingButtonLabel), 1)
                      ], 2)),
                      m("button", {
                        type: "button",
                        class: O(`mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 ${e.getColorClass(
                          {
                            type: "ring",
                            value: "800",
                            prefix: "focus"
                          }
                        )} sm:col-start-1 sm:mt-0 sm:text-sm`),
                        onClick: t[2] || (t[2] = (v) => e.open = !1)
                      }, R(e.cancelButtonLabel), 3)
                    ])
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"])
  ]);
}
const t7 = /* @__PURE__ */ Ee(w0, [["render", R0]]);
function M0() {
  return qa().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function qa() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const T0 = typeof Proxy == "function", P0 = "devtools-plugin:setup", I0 = "plugin:settings:set";
let en, xr;
function L0() {
  var e;
  return en !== void 0 || (typeof window < "u" && window.performance ? (en = !0, xr = window.performance) : typeof global < "u" && (!((e = global.perf_hooks) === null || e === void 0) && e.performance) ? (en = !0, xr = global.perf_hooks.performance) : en = !1), en;
}
function D0() {
  return L0() ? xr.now() : Date.now();
}
class B0 {
  constructor(t, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = n;
    const o = {};
    if (t.settings)
      for (const s in t.settings) {
        const a = t.settings[s];
        o[s] = a.defaultValue;
      }
    const r = `__vue-devtools-plugin-settings__${t.id}`;
    let i = Object.assign({}, o);
    try {
      const s = localStorage.getItem(r), a = JSON.parse(s);
      Object.assign(i, a);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return i;
      },
      setSettings(s) {
        try {
          localStorage.setItem(r, JSON.stringify(s));
        } catch {
        }
        i = s;
      },
      now() {
        return D0();
      }
    }, n && n.on(I0, (s, a) => {
      s === this.plugin.id && this.fallbacks.setSettings(a);
    }), this.proxiedOn = new Proxy({}, {
      get: (s, a) => this.target ? this.target.on[a] : (...l) => {
        this.onQueue.push({
          method: a,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (s, a) => this.target ? this.target[a] : a === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(a) ? (...l) => (this.targetQueue.push({
        method: a,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[a](...l)) : (...l) => new Promise((u) => {
        this.targetQueue.push({
          method: a,
          args: l,
          resolve: u
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function z0(e, t) {
  const n = e, o = qa(), r = M0(), i = T0 && n.enableEarlyProxy;
  if (r && (o.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !i))
    r.emit(P0, e, t);
  else {
    const s = i ? new B0(n, r) : null;
    (o.__VUE_DEVTOOLS_PLUGINS__ = o.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: s
    }), s && t(s.proxiedTarget);
  }
}
/*!
 * vuex v4.0.2
 * (c) 2021 Evan You
 * @license MIT
 */
var N0 = "store";
function Xt(e, t) {
  Object.keys(e).forEach(function(n) {
    return t(e[n], n);
  });
}
function j0(e) {
  return e !== null && typeof e == "object";
}
function V0(e) {
  return e && typeof e.then == "function";
}
function st(e, t) {
  if (!e)
    throw new Error("[vuex] " + t);
}
function F0(e, t) {
  return function() {
    return e(t);
  };
}
function Za(e, t, n) {
  return t.indexOf(e) < 0 && (n && n.prepend ? t.unshift(e) : t.push(e)), function() {
    var o = t.indexOf(e);
    o > -1 && t.splice(o, 1);
  };
}
function Ga(e, t) {
  e._actions = /* @__PURE__ */ Object.create(null), e._mutations = /* @__PURE__ */ Object.create(null), e._wrappedGetters = /* @__PURE__ */ Object.create(null), e._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  var n = e.state;
  Lo(e, n, [], e._modules.root, !0), Jr(e, n, t);
}
function Jr(e, t, n) {
  var o = e._state;
  e.getters = {}, e._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var r = e._wrappedGetters, i = {};
  Xt(r, function(s, a) {
    i[a] = F0(s, e), Object.defineProperty(e.getters, a, {
      // TODO: use `computed` when it's possible. at the moment we can't due to
      // https://github.com/vuejs/vuex/pull/1883
      get: function() {
        return i[a]();
      },
      enumerable: !0
      // for local getters
    });
  }), e._state = Nr({
    data: t
  }), e.strict && Z0(e), o && n && e._withCommit(function() {
    o.data = null;
  });
}
function Lo(e, t, n, o, r) {
  var i = !n.length, s = e._modules.getNamespace(n);
  if (o.namespaced && (e._modulesNamespaceMap[s] && process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate namespace " + s + " for the namespaced module " + n.join("/")), e._modulesNamespaceMap[s] = o), !i && !r) {
    var a = ei(t, n.slice(0, -1)), l = n[n.length - 1];
    e._withCommit(function() {
      process.env.NODE_ENV !== "production" && l in a && console.warn(
        '[vuex] state field "' + l + '" was overridden by a module with the same name at "' + n.join(".") + '"'
      ), a[l] = o.state;
    });
  }
  var u = o.context = H0(e, s, n);
  o.forEachMutation(function(c, d) {
    var p = s + d;
    U0(e, p, c, u);
  }), o.forEachAction(function(c, d) {
    var p = c.root ? d : s + d, v = c.handler || c;
    W0(e, p, v, u);
  }), o.forEachGetter(function(c, d) {
    var p = s + d;
    q0(e, p, c, u);
  }), o.forEachChild(function(c, d) {
    Lo(e, t, n.concat(d), c, r);
  });
}
function H0(e, t, n) {
  var o = t === "", r = {
    dispatch: o ? e.dispatch : function(i, s, a) {
      var l = lo(i, s, a), u = l.payload, c = l.options, d = l.type;
      if ((!c || !c.root) && (d = t + d, process.env.NODE_ENV !== "production" && !e._actions[d])) {
        console.error("[vuex] unknown local action type: " + l.type + ", global type: " + d);
        return;
      }
      return e.dispatch(d, u);
    },
    commit: o ? e.commit : function(i, s, a) {
      var l = lo(i, s, a), u = l.payload, c = l.options, d = l.type;
      if ((!c || !c.root) && (d = t + d, process.env.NODE_ENV !== "production" && !e._mutations[d])) {
        console.error("[vuex] unknown local mutation type: " + l.type + ", global type: " + d);
        return;
      }
      e.commit(d, u, c);
    }
  };
  return Object.defineProperties(r, {
    getters: {
      get: o ? function() {
        return e.getters;
      } : function() {
        return Ka(e, t);
      }
    },
    state: {
      get: function() {
        return ei(e.state, n);
      }
    }
  }), r;
}
function Ka(e, t) {
  if (!e._makeLocalGettersCache[t]) {
    var n = {}, o = t.length;
    Object.keys(e.getters).forEach(function(r) {
      if (r.slice(0, o) === t) {
        var i = r.slice(o);
        Object.defineProperty(n, i, {
          get: function() {
            return e.getters[r];
          },
          enumerable: !0
        });
      }
    }), e._makeLocalGettersCache[t] = n;
  }
  return e._makeLocalGettersCache[t];
}
function U0(e, t, n, o) {
  var r = e._mutations[t] || (e._mutations[t] = []);
  r.push(function(s) {
    n.call(e, o.state, s);
  });
}
function W0(e, t, n, o) {
  var r = e._actions[t] || (e._actions[t] = []);
  r.push(function(s) {
    var a = n.call(e, {
      dispatch: o.dispatch,
      commit: o.commit,
      getters: o.getters,
      state: o.state,
      rootGetters: e.getters,
      rootState: e.state
    }, s);
    return V0(a) || (a = Promise.resolve(a)), e._devtoolHook ? a.catch(function(l) {
      throw e._devtoolHook.emit("vuex:error", l), l;
    }) : a;
  });
}
function q0(e, t, n, o) {
  if (e._wrappedGetters[t]) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate getter key: " + t);
    return;
  }
  e._wrappedGetters[t] = function(i) {
    return n(
      o.state,
      // local state
      o.getters,
      // local getters
      i.state,
      // root state
      i.getters
      // root getters
    );
  };
}
function Z0(e) {
  he(function() {
    return e._state.data;
  }, function() {
    process.env.NODE_ENV !== "production" && st(e._committing, "do not mutate vuex store state outside mutation handlers.");
  }, { deep: !0, flush: "sync" });
}
function ei(e, t) {
  return t.reduce(function(n, o) {
    return n[o];
  }, e);
}
function lo(e, t, n) {
  return j0(e) && e.type && (n = t, t = e, e = e.type), process.env.NODE_ENV !== "production" && st(typeof e == "string", "expects string as the type, but found " + typeof e + "."), { type: e, payload: t, options: n };
}
var G0 = "vuex bindings", Yi = "vuex:mutations", tr = "vuex:actions", tn = "vuex", K0 = 0;
function Y0(e, t) {
  z0(
    {
      id: "org.vuejs.vuex",
      app: e,
      label: "Vuex",
      homepage: "https://next.vuex.vuejs.org/",
      logo: "https://vuejs.org/images/icons/favicon-96x96.png",
      packageName: "vuex",
      componentStateTypes: [G0]
    },
    function(n) {
      n.addTimelineLayer({
        id: Yi,
        label: "Vuex Mutations",
        color: Xi
      }), n.addTimelineLayer({
        id: tr,
        label: "Vuex Actions",
        color: Xi
      }), n.addInspector({
        id: tn,
        label: "Vuex",
        icon: "storage",
        treeFilterPlaceholder: "Filter stores..."
      }), n.on.getInspectorTree(function(o) {
        if (o.app === e && o.inspectorId === tn)
          if (o.filter) {
            var r = [];
            Ja(r, t._modules.root, o.filter, ""), o.rootNodes = r;
          } else
            o.rootNodes = [
              Qa(t._modules.root, "")
            ];
      }), n.on.getInspectorState(function(o) {
        if (o.app === e && o.inspectorId === tn) {
          var r = o.nodeId;
          Ka(t, r), o.state = J0(
            tv(t._modules, r),
            r === "root" ? t.getters : t._makeLocalGettersCache,
            r
          );
        }
      }), n.on.editInspectorState(function(o) {
        if (o.app === e && o.inspectorId === tn) {
          var r = o.nodeId, i = o.path;
          r !== "root" && (i = r.split("/").filter(Boolean).concat(i)), t._withCommit(function() {
            o.set(t._state.data, i, o.state.value);
          });
        }
      }), t.subscribe(function(o, r) {
        var i = {};
        o.payload && (i.payload = o.payload), i.state = r, n.notifyComponentUpdate(), n.sendInspectorTree(tn), n.sendInspectorState(tn), n.addTimelineEvent({
          layerId: Yi,
          event: {
            time: Date.now(),
            title: o.type,
            data: i
          }
        });
      }), t.subscribeAction({
        before: function(o, r) {
          var i = {};
          o.payload && (i.payload = o.payload), o._id = K0++, o._time = Date.now(), i.state = r, n.addTimelineEvent({
            layerId: tr,
            event: {
              time: o._time,
              title: o.type,
              groupId: o._id,
              subtitle: "start",
              data: i
            }
          });
        },
        after: function(o, r) {
          var i = {}, s = Date.now() - o._time;
          i.duration = {
            _custom: {
              type: "duration",
              display: s + "ms",
              tooltip: "Action duration",
              value: s
            }
          }, o.payload && (i.payload = o.payload), i.state = r, n.addTimelineEvent({
            layerId: tr,
            event: {
              time: Date.now(),
              title: o.type,
              groupId: o._id,
              subtitle: "end",
              data: i
            }
          });
        }
      });
    }
  );
}
var Xi = 8702998, X0 = 6710886, Q0 = 16777215, Ya = {
  label: "namespaced",
  textColor: Q0,
  backgroundColor: X0
};
function Xa(e) {
  return e && e !== "root" ? e.split("/").slice(-2, -1)[0] : "Root";
}
function Qa(e, t) {
  return {
    id: t || "root",
    // all modules end with a `/`, we want the last segment only
    // cart/ -> cart
    // nested/cart/ -> cart
    label: Xa(t),
    tags: e.namespaced ? [Ya] : [],
    children: Object.keys(e._children).map(
      function(n) {
        return Qa(
          e._children[n],
          t + n + "/"
        );
      }
    )
  };
}
function Ja(e, t, n, o) {
  o.includes(n) && e.push({
    id: o || "root",
    label: o.endsWith("/") ? o.slice(0, o.length - 1) : o || "Root",
    tags: t.namespaced ? [Ya] : []
  }), Object.keys(t._children).forEach(function(r) {
    Ja(e, t._children[r], n, o + r + "/");
  });
}
function J0(e, t, n) {
  t = n === "root" ? t : t[n];
  var o = Object.keys(t), r = {
    state: Object.keys(e.state).map(function(s) {
      return {
        key: s,
        editable: !0,
        value: e.state[s]
      };
    })
  };
  if (o.length) {
    var i = ev(t);
    r.getters = Object.keys(i).map(function(s) {
      return {
        key: s.endsWith("/") ? Xa(s) : s,
        editable: !1,
        value: $r(function() {
          return i[s];
        })
      };
    });
  }
  return r;
}
function ev(e) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    var o = n.split("/");
    if (o.length > 1) {
      var r = t, i = o.pop();
      o.forEach(function(s) {
        r[s] || (r[s] = {
          _custom: {
            value: {},
            display: s,
            tooltip: "Module",
            abstract: !0
          }
        }), r = r[s]._custom.value;
      }), r[i] = $r(function() {
        return e[n];
      });
    } else
      t[n] = $r(function() {
        return e[n];
      });
  }), t;
}
function tv(e, t) {
  var n = t.split("/").filter(function(o) {
    return o;
  });
  return n.reduce(
    function(o, r, i) {
      var s = o[r];
      if (!s)
        throw new Error('Missing module "' + r + '" for path "' + t + '".');
      return i === n.length - 1 ? s : s._children;
    },
    t === "root" ? e : e.root._children
  );
}
function $r(e) {
  try {
    return e();
  } catch (t) {
    return t;
  }
}
var lt = function(t, n) {
  this.runtime = n, this._children = /* @__PURE__ */ Object.create(null), this._rawModule = t;
  var o = t.state;
  this.state = (typeof o == "function" ? o() : o) || {};
}, el = { namespaced: { configurable: !0 } };
el.namespaced.get = function() {
  return !!this._rawModule.namespaced;
};
lt.prototype.addChild = function(t, n) {
  this._children[t] = n;
};
lt.prototype.removeChild = function(t) {
  delete this._children[t];
};
lt.prototype.getChild = function(t) {
  return this._children[t];
};
lt.prototype.hasChild = function(t) {
  return t in this._children;
};
lt.prototype.update = function(t) {
  this._rawModule.namespaced = t.namespaced, t.actions && (this._rawModule.actions = t.actions), t.mutations && (this._rawModule.mutations = t.mutations), t.getters && (this._rawModule.getters = t.getters);
};
lt.prototype.forEachChild = function(t) {
  Xt(this._children, t);
};
lt.prototype.forEachGetter = function(t) {
  this._rawModule.getters && Xt(this._rawModule.getters, t);
};
lt.prototype.forEachAction = function(t) {
  this._rawModule.actions && Xt(this._rawModule.actions, t);
};
lt.prototype.forEachMutation = function(t) {
  this._rawModule.mutations && Xt(this._rawModule.mutations, t);
};
Object.defineProperties(lt.prototype, el);
var Qt = function(t) {
  this.register([], t, !1);
};
Qt.prototype.get = function(t) {
  return t.reduce(function(n, o) {
    return n.getChild(o);
  }, this.root);
};
Qt.prototype.getNamespace = function(t) {
  var n = this.root;
  return t.reduce(function(o, r) {
    return n = n.getChild(r), o + (n.namespaced ? r + "/" : "");
  }, "");
};
Qt.prototype.update = function(t) {
  tl([], this.root, t);
};
Qt.prototype.register = function(t, n, o) {
  var r = this;
  o === void 0 && (o = !0), process.env.NODE_ENV !== "production" && nl(t, n);
  var i = new lt(n, o);
  if (t.length === 0)
    this.root = i;
  else {
    var s = this.get(t.slice(0, -1));
    s.addChild(t[t.length - 1], i);
  }
  n.modules && Xt(n.modules, function(a, l) {
    r.register(t.concat(l), a, o);
  });
};
Qt.prototype.unregister = function(t) {
  var n = this.get(t.slice(0, -1)), o = t[t.length - 1], r = n.getChild(o);
  if (!r) {
    process.env.NODE_ENV !== "production" && console.warn(
      "[vuex] trying to unregister module '" + o + "', which is not registered"
    );
    return;
  }
  r.runtime && n.removeChild(o);
};
Qt.prototype.isRegistered = function(t) {
  var n = this.get(t.slice(0, -1)), o = t[t.length - 1];
  return n ? n.hasChild(o) : !1;
};
function tl(e, t, n) {
  if (process.env.NODE_ENV !== "production" && nl(e, n), t.update(n), n.modules)
    for (var o in n.modules) {
      if (!t.getChild(o)) {
        process.env.NODE_ENV !== "production" && console.warn(
          "[vuex] trying to add a new module '" + o + "' on hot reloading, manual reload is needed"
        );
        return;
      }
      tl(
        e.concat(o),
        t.getChild(o),
        n.modules[o]
      );
    }
}
var Qi = {
  assert: function(e) {
    return typeof e == "function";
  },
  expected: "function"
}, nv = {
  assert: function(e) {
    return typeof e == "function" || typeof e == "object" && typeof e.handler == "function";
  },
  expected: 'function or object with "handler" function'
}, Ji = {
  getters: Qi,
  mutations: Qi,
  actions: nv
};
function nl(e, t) {
  Object.keys(Ji).forEach(function(n) {
    if (t[n]) {
      var o = Ji[n];
      Xt(t[n], function(r, i) {
        st(
          o.assert(r),
          ov(e, n, i, r, o.expected)
        );
      });
    }
  });
}
function ov(e, t, n, o, r) {
  var i = t + " should be " + r + ' but "' + t + "." + n + '"';
  return e.length > 0 && (i += ' in module "' + e.join(".") + '"'), i += " is " + JSON.stringify(o) + ".", i;
}
function rv(e) {
  return new We(e);
}
var We = function e(t) {
  var n = this;
  t === void 0 && (t = {}), process.env.NODE_ENV !== "production" && (st(typeof Promise < "u", "vuex requires a Promise polyfill in this browser."), st(this instanceof e, "store must be called with the new operator."));
  var o = t.plugins;
  o === void 0 && (o = []);
  var r = t.strict;
  r === void 0 && (r = !1);
  var i = t.devtools;
  this._committing = !1, this._actions = /* @__PURE__ */ Object.create(null), this._actionSubscribers = [], this._mutations = /* @__PURE__ */ Object.create(null), this._wrappedGetters = /* @__PURE__ */ Object.create(null), this._modules = new Qt(t), this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null), this._subscribers = [], this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null), this._devtools = i;
  var s = this, a = this, l = a.dispatch, u = a.commit;
  this.dispatch = function(p, v) {
    return l.call(s, p, v);
  }, this.commit = function(p, v, x) {
    return u.call(s, p, v, x);
  }, this.strict = r;
  var c = this._modules.root.state;
  Lo(this, c, [], this._modules.root), Jr(this, c), o.forEach(function(d) {
    return d(n);
  });
}, ti = { state: { configurable: !0 } };
We.prototype.install = function(t, n) {
  t.provide(n || N0, this), t.config.globalProperties.$store = this;
  var o = this._devtools !== void 0 ? this._devtools : process.env.NODE_ENV !== "production" || !1;
  o && Y0(t, this);
};
ti.state.get = function() {
  return this._state.data;
};
ti.state.set = function(e) {
  process.env.NODE_ENV !== "production" && st(!1, "use store.replaceState() to explicit replace store state.");
};
We.prototype.commit = function(t, n, o) {
  var r = this, i = lo(t, n, o), s = i.type, a = i.payload, l = i.options, u = { type: s, payload: a }, c = this._mutations[s];
  if (!c) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown mutation type: " + s);
    return;
  }
  this._withCommit(function() {
    c.forEach(function(p) {
      p(a);
    });
  }), this._subscribers.slice().forEach(function(d) {
    return d(u, r.state);
  }), process.env.NODE_ENV !== "production" && l && l.silent && console.warn(
    "[vuex] mutation type: " + s + ". Silent option has been removed. Use the filter functionality in the vue-devtools"
  );
};
We.prototype.dispatch = function(t, n) {
  var o = this, r = lo(t, n), i = r.type, s = r.payload, a = { type: i, payload: s }, l = this._actions[i];
  if (!l) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown action type: " + i);
    return;
  }
  try {
    this._actionSubscribers.slice().filter(function(c) {
      return c.before;
    }).forEach(function(c) {
      return c.before(a, o.state);
    });
  } catch (c) {
    process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in before action subscribers: "), console.error(c));
  }
  var u = l.length > 1 ? Promise.all(l.map(function(c) {
    return c(s);
  })) : l[0](s);
  return new Promise(function(c, d) {
    u.then(function(p) {
      try {
        o._actionSubscribers.filter(function(v) {
          return v.after;
        }).forEach(function(v) {
          return v.after(a, o.state);
        });
      } catch (v) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in after action subscribers: "), console.error(v));
      }
      c(p);
    }, function(p) {
      try {
        o._actionSubscribers.filter(function(v) {
          return v.error;
        }).forEach(function(v) {
          return v.error(a, o.state, p);
        });
      } catch (v) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in error action subscribers: "), console.error(v));
      }
      d(p);
    });
  });
};
We.prototype.subscribe = function(t, n) {
  return Za(t, this._subscribers, n);
};
We.prototype.subscribeAction = function(t, n) {
  var o = typeof t == "function" ? { before: t } : t;
  return Za(o, this._actionSubscribers, n);
};
We.prototype.watch = function(t, n, o) {
  var r = this;
  return process.env.NODE_ENV !== "production" && st(typeof t == "function", "store.watch only accepts a function."), he(function() {
    return t(r.state, r.getters);
  }, n, Object.assign({}, o));
};
We.prototype.replaceState = function(t) {
  var n = this;
  this._withCommit(function() {
    n._state.data = t;
  });
};
We.prototype.registerModule = function(t, n, o) {
  o === void 0 && (o = {}), typeof t == "string" && (t = [t]), process.env.NODE_ENV !== "production" && (st(Array.isArray(t), "module path must be a string or an Array."), st(t.length > 0, "cannot register the root module by using registerModule.")), this._modules.register(t, n), Lo(this, this.state, t, this._modules.get(t), o.preserveState), Jr(this, this.state);
};
We.prototype.unregisterModule = function(t) {
  var n = this;
  typeof t == "string" && (t = [t]), process.env.NODE_ENV !== "production" && st(Array.isArray(t), "module path must be a string or an Array."), this._modules.unregister(t), this._withCommit(function() {
    var o = ei(n.state, t.slice(0, -1));
    delete o[t[t.length - 1]];
  }), Ga(this);
};
We.prototype.hasModule = function(t) {
  return typeof t == "string" && (t = [t]), process.env.NODE_ENV !== "production" && st(Array.isArray(t), "module path must be a string or an Array."), this._modules.isRegistered(t);
};
We.prototype.hotUpdate = function(t) {
  this._modules.update(t), Ga(this, !0);
};
We.prototype._withCommit = function(t) {
  var n = this._committing;
  this._committing = !0, t(), this._committing = n;
};
Object.defineProperties(We.prototype, ti);
const iv = {
  namespaced: !0,
  state: {
    notification: null,
    timeout: null
  },
  getters: {
    get: (e) => e.notification
  },
  actions: {
    setNotification({ commit: e }, t) {
      e("clear"), e("add", t), t.persist || e(
        "setTimeout",
        setTimeout(
          () => {
            e("clear");
          },
          t.timeout ? t.timeout : 2e3
        )
      );
    },
    success({ dispatch: e }, t) {
      const n = {
        ...t,
        type: "success"
      };
      e("setNotification", n);
    },
    error({ dispatch: e }, t) {
      const n = {
        ...t,
        type: "error"
      };
      e("setNotification", n);
    }
  },
  mutations: {
    add(e, t) {
      e.notification = t;
    },
    clear(e) {
      e.notification = null, e.timeout && clearTimeout(e.timeout);
    },
    setTimeout(e, t) {
      e.timeout = t;
    }
  }
}, gt = rv({
  modules: {
    notification: iv
  }
});
function ol(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: sv } = Object.prototype, { getPrototypeOf: ni } = Object, Do = ((e) => (t) => {
  const n = sv.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ut = (e) => (e = e.toLowerCase(), (t) => Do(t) === e), Bo = (e) => (t) => typeof t === e, { isArray: hn } = Array, kn = Bo("undefined");
function av(e) {
  return e !== null && !kn(e) && e.constructor !== null && !kn(e.constructor) && Ke(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const rl = ut("ArrayBuffer");
function lv(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && rl(e.buffer), t;
}
const uv = Bo("string"), Ke = Bo("function"), il = Bo("number"), zo = (e) => e !== null && typeof e == "object", cv = (e) => e === !0 || e === !1, Qn = (e) => {
  if (Do(e) !== "object")
    return !1;
  const t = ni(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, dv = ut("Date"), pv = ut("File"), fv = ut("Blob"), hv = ut("FileList"), vv = (e) => zo(e) && Ke(e.pipe), mv = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || Ke(e.append) && ((t = Do(e)) === "formdata" || // detect form-data instance
  t === "object" && Ke(e.toString) && e.toString() === "[object FormData]"));
}, gv = ut("URLSearchParams"), [bv, yv, wv, xv] = ["ReadableStream", "Request", "Response", "Headers"].map(ut), $v = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Ln(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, r;
  if (typeof e != "object" && (e = [e]), hn(e))
    for (o = 0, r = e.length; o < r; o++)
      t.call(null, e[o], o, e);
  else {
    const i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), s = i.length;
    let a;
    for (o = 0; o < s; o++)
      a = i[o], t.call(null, e[a], a, e);
  }
}
function sl(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let o = n.length, r;
  for (; o-- > 0; )
    if (r = n[o], t === r.toLowerCase())
      return r;
  return null;
}
const Bt = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), al = (e) => !kn(e) && e !== Bt;
function Cr() {
  const { caseless: e } = al(this) && this || {}, t = {}, n = (o, r) => {
    const i = e && sl(t, r) || r;
    Qn(t[i]) && Qn(o) ? t[i] = Cr(t[i], o) : Qn(o) ? t[i] = Cr({}, o) : hn(o) ? t[i] = o.slice() : t[i] = o;
  };
  for (let o = 0, r = arguments.length; o < r; o++)
    arguments[o] && Ln(arguments[o], n);
  return t;
}
const Cv = (e, t, n, { allOwnKeys: o } = {}) => (Ln(t, (r, i) => {
  n && Ke(r) ? e[i] = ol(r, n) : e[i] = r;
}, { allOwnKeys: o }), e), Sv = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), kv = (e, t, n, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, Ev = (e, t, n, o) => {
  let r, i, s;
  const a = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (r = Object.getOwnPropertyNames(e), i = r.length; i-- > 0; )
      s = r[i], (!o || o(s, e, t)) && !a[s] && (t[s] = e[s], a[s] = !0);
    e = n !== !1 && ni(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Ov = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const o = e.indexOf(t, n);
  return o !== -1 && o === n;
}, Av = (e) => {
  if (!e)
    return null;
  if (hn(e))
    return e;
  let t = e.length;
  if (!il(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, _v = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && ni(Uint8Array)), Rv = (e, t) => {
  const o = (e && e[Symbol.iterator]).call(e);
  let r;
  for (; (r = o.next()) && !r.done; ) {
    const i = r.value;
    t.call(e, i[0], i[1]);
  }
}, Mv = (e, t) => {
  let n;
  const o = [];
  for (; (n = e.exec(t)) !== null; )
    o.push(n);
  return o;
}, Tv = ut("HTMLFormElement"), Pv = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, o, r) {
    return o.toUpperCase() + r;
  }
), es = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Iv = ut("RegExp"), ll = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), o = {};
  Ln(n, (r, i) => {
    let s;
    (s = t(r, i, e)) !== !1 && (o[i] = s || r);
  }), Object.defineProperties(e, o);
}, Lv = (e) => {
  ll(e, (t, n) => {
    if (Ke(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const o = e[n];
    if (Ke(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Dv = (e, t) => {
  const n = {}, o = (r) => {
    r.forEach((i) => {
      n[i] = !0;
    });
  };
  return hn(e) ? o(e) : o(String(e).split(t)), n;
}, Bv = () => {
}, zv = (e, t) => e != null && Number.isFinite(e = +e) ? e : t, nr = "abcdefghijklmnopqrstuvwxyz", ts = "0123456789", ul = {
  DIGIT: ts,
  ALPHA: nr,
  ALPHA_DIGIT: nr + nr.toUpperCase() + ts
}, Nv = (e = 16, t = ul.ALPHA_DIGIT) => {
  let n = "";
  const { length: o } = t;
  for (; e--; )
    n += t[Math.random() * o | 0];
  return n;
};
function jv(e) {
  return !!(e && Ke(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const Vv = (e) => {
  const t = new Array(10), n = (o, r) => {
    if (zo(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (!("toJSON" in o)) {
        t[r] = o;
        const i = hn(o) ? [] : {};
        return Ln(o, (s, a) => {
          const l = n(s, r + 1);
          !kn(l) && (i[a] = l);
        }), t[r] = void 0, i;
      }
    }
    return o;
  };
  return n(e, 0);
}, Fv = ut("AsyncFunction"), Hv = (e) => e && (zo(e) || Ke(e)) && Ke(e.then) && Ke(e.catch), cl = ((e, t) => e ? setImmediate : t ? ((n, o) => (Bt.addEventListener("message", ({ source: r, data: i }) => {
  r === Bt && i === n && o.length && o.shift()();
}, !1), (r) => {
  o.push(r), Bt.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  Ke(Bt.postMessage)
), Uv = typeof queueMicrotask < "u" ? queueMicrotask.bind(Bt) : typeof process < "u" && process.nextTick || cl, I = {
  isArray: hn,
  isArrayBuffer: rl,
  isBuffer: av,
  isFormData: mv,
  isArrayBufferView: lv,
  isString: uv,
  isNumber: il,
  isBoolean: cv,
  isObject: zo,
  isPlainObject: Qn,
  isReadableStream: bv,
  isRequest: yv,
  isResponse: wv,
  isHeaders: xv,
  isUndefined: kn,
  isDate: dv,
  isFile: pv,
  isBlob: fv,
  isRegExp: Iv,
  isFunction: Ke,
  isStream: vv,
  isURLSearchParams: gv,
  isTypedArray: _v,
  isFileList: hv,
  forEach: Ln,
  merge: Cr,
  extend: Cv,
  trim: $v,
  stripBOM: Sv,
  inherits: kv,
  toFlatObject: Ev,
  kindOf: Do,
  kindOfTest: ut,
  endsWith: Ov,
  toArray: Av,
  forEachEntry: Rv,
  matchAll: Mv,
  isHTMLForm: Tv,
  hasOwnProperty: es,
  hasOwnProp: es,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ll,
  freezeMethods: Lv,
  toObjectSet: Dv,
  toCamelCase: Pv,
  noop: Bv,
  toFiniteNumber: zv,
  findKey: sl,
  global: Bt,
  isContextDefined: al,
  ALPHABET: ul,
  generateString: Nv,
  isSpecCompliantForm: jv,
  toJSONObject: Vv,
  isAsyncFn: Fv,
  isThenable: Hv,
  setImmediate: cl,
  asap: Uv
};
function re(e, t, n, o, r) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), o && (this.request = o), r && (this.response = r, this.status = r.status ? r.status : null);
}
I.inherits(re, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: I.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const dl = re.prototype, pl = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  pl[e] = { value: e };
});
Object.defineProperties(re, pl);
Object.defineProperty(dl, "isAxiosError", { value: !0 });
re.from = (e, t, n, o, r, i) => {
  const s = Object.create(dl);
  return I.toFlatObject(e, s, function(l) {
    return l !== Error.prototype;
  }, (a) => a !== "isAxiosError"), re.call(s, e.message, t, n, o, r), s.cause = e, s.name = e.name, i && Object.assign(s, i), s;
};
const Wv = null;
function Sr(e) {
  return I.isPlainObject(e) || I.isArray(e);
}
function fl(e) {
  return I.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function ns(e, t, n) {
  return e ? e.concat(t).map(function(r, i) {
    return r = fl(r), !n && i ? "[" + r + "]" : r;
  }).join(n ? "." : "") : t;
}
function qv(e) {
  return I.isArray(e) && !e.some(Sr);
}
const Zv = I.toFlatObject(I, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function No(e, t, n) {
  if (!I.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = I.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(b, h) {
    return !I.isUndefined(h[b]);
  });
  const o = n.metaTokens, r = n.visitor || c, i = n.dots, s = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && I.isSpecCompliantForm(t);
  if (!I.isFunction(r))
    throw new TypeError("visitor must be a function");
  function u(x) {
    if (x === null)
      return "";
    if (I.isDate(x))
      return x.toISOString();
    if (!l && I.isBlob(x))
      throw new re("Blob is not supported. Use a Buffer instead.");
    return I.isArrayBuffer(x) || I.isTypedArray(x) ? l && typeof Blob == "function" ? new Blob([x]) : Buffer.from(x) : x;
  }
  function c(x, b, h) {
    let S = x;
    if (x && !h && typeof x == "object") {
      if (I.endsWith(b, "{}"))
        b = o ? b : b.slice(0, -2), x = JSON.stringify(x);
      else if (I.isArray(x) && qv(x) || (I.isFileList(x) || I.endsWith(b, "[]")) && (S = I.toArray(x)))
        return b = fl(b), S.forEach(function(C, w) {
          !(I.isUndefined(C) || C === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? ns([b], w, i) : s === null ? b : b + "[]",
            u(C)
          );
        }), !1;
    }
    return Sr(x) ? !0 : (t.append(ns(h, b, i), u(x)), !1);
  }
  const d = [], p = Object.assign(Zv, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: Sr
  });
  function v(x, b) {
    if (!I.isUndefined(x)) {
      if (d.indexOf(x) !== -1)
        throw Error("Circular reference detected in " + b.join("."));
      d.push(x), I.forEach(x, function(S, g) {
        (!(I.isUndefined(S) || S === null) && r.call(
          t,
          S,
          I.isString(g) ? g.trim() : g,
          b,
          p
        )) === !0 && v(S, b ? b.concat(g) : [g]);
      }), d.pop();
    }
  }
  if (!I.isObject(e))
    throw new TypeError("data must be an object");
  return v(e), t;
}
function os(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(o) {
    return t[o];
  });
}
function oi(e, t) {
  this._pairs = [], e && No(e, this, t);
}
const hl = oi.prototype;
hl.append = function(t, n) {
  this._pairs.push([t, n]);
};
hl.toString = function(t) {
  const n = t ? function(o) {
    return t.call(this, o, os);
  } : os;
  return this._pairs.map(function(r) {
    return n(r[0]) + "=" + n(r[1]);
  }, "").join("&");
};
function Gv(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function vl(e, t, n) {
  if (!t)
    return e;
  const o = n && n.encode || Gv;
  I.isFunction(n) && (n = {
    serialize: n
  });
  const r = n && n.serialize;
  let i;
  if (r ? i = r(t, n) : i = I.isURLSearchParams(t) ? t.toString() : new oi(t, n).toString(o), i) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class Kv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    I.forEach(this.handlers, function(o) {
      o !== null && t(o);
    });
  }
}
const rs = Kv, ml = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Yv = typeof URLSearchParams < "u" ? URLSearchParams : oi, Xv = typeof FormData < "u" ? FormData : null, Qv = typeof Blob < "u" ? Blob : null, Jv = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Yv,
    FormData: Xv,
    Blob: Qv
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, ri = typeof window < "u" && typeof document < "u", kr = typeof navigator == "object" && navigator || void 0, em = ri && (!kr || ["ReactNative", "NativeScript", "NS"].indexOf(kr.product) < 0), tm = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), nm = ri && window.location.href || "http://localhost", om = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: ri,
  hasStandardBrowserEnv: em,
  hasStandardBrowserWebWorkerEnv: tm,
  navigator: kr,
  origin: nm
}, Symbol.toStringTag, { value: "Module" })), Be = {
  ...om,
  ...Jv
};
function rm(e, t) {
  return No(e, new Be.classes.URLSearchParams(), Object.assign({
    visitor: function(n, o, r, i) {
      return Be.isNode && I.isBuffer(n) ? (this.append(o, n.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function im(e) {
  return I.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function sm(e) {
  const t = {}, n = Object.keys(e);
  let o;
  const r = n.length;
  let i;
  for (o = 0; o < r; o++)
    i = n[o], t[i] = e[i];
  return t;
}
function gl(e) {
  function t(n, o, r, i) {
    let s = n[i++];
    if (s === "__proto__")
      return !0;
    const a = Number.isFinite(+s), l = i >= n.length;
    return s = !s && I.isArray(r) ? r.length : s, l ? (I.hasOwnProp(r, s) ? r[s] = [r[s], o] : r[s] = o, !a) : ((!r[s] || !I.isObject(r[s])) && (r[s] = []), t(n, o, r[s], i) && I.isArray(r[s]) && (r[s] = sm(r[s])), !a);
  }
  if (I.isFormData(e) && I.isFunction(e.entries)) {
    const n = {};
    return I.forEachEntry(e, (o, r) => {
      t(im(o), r, n, 0);
    }), n;
  }
  return null;
}
function am(e, t, n) {
  if (I.isString(e))
    try {
      return (t || JSON.parse)(e), I.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (n || JSON.stringify)(e);
}
const ii = {
  transitional: ml,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const o = n.getContentType() || "", r = o.indexOf("application/json") > -1, i = I.isObject(t);
    if (i && I.isHTMLForm(t) && (t = new FormData(t)), I.isFormData(t))
      return r ? JSON.stringify(gl(t)) : t;
    if (I.isArrayBuffer(t) || I.isBuffer(t) || I.isStream(t) || I.isFile(t) || I.isBlob(t) || I.isReadableStream(t))
      return t;
    if (I.isArrayBufferView(t))
      return t.buffer;
    if (I.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let a;
    if (i) {
      if (o.indexOf("application/x-www-form-urlencoded") > -1)
        return rm(t, this.formSerializer).toString();
      if ((a = I.isFileList(t)) || o.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return No(
          a ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || r ? (n.setContentType("application/json", !1), am(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || ii.transitional, o = n && n.forcedJSONParsing, r = this.responseType === "json";
    if (I.isResponse(t) || I.isReadableStream(t))
      return t;
    if (t && I.isString(t) && (o && !this.responseType || r)) {
      const s = !(n && n.silentJSONParsing) && r;
      try {
        return JSON.parse(t);
      } catch (a) {
        if (s)
          throw a.name === "SyntaxError" ? re.from(a, re.ERR_BAD_RESPONSE, this, null, this.response) : a;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Be.classes.FormData,
    Blob: Be.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
I.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  ii.headers[e] = {};
});
const si = ii, lm = I.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), um = (e) => {
  const t = {};
  let n, o, r;
  return e && e.split(`
`).forEach(function(s) {
    r = s.indexOf(":"), n = s.substring(0, r).trim().toLowerCase(), o = s.substring(r + 1).trim(), !(!n || t[n] && lm[n]) && (n === "set-cookie" ? t[n] ? t[n].push(o) : t[n] = [o] : t[n] = t[n] ? t[n] + ", " + o : o);
  }), t;
}, is = Symbol("internals");
function yn(e) {
  return e && String(e).trim().toLowerCase();
}
function Jn(e) {
  return e === !1 || e == null ? e : I.isArray(e) ? e.map(Jn) : String(e);
}
function cm(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = n.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const dm = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function or(e, t, n, o, r) {
  if (I.isFunction(o))
    return o.call(this, t, n);
  if (r && (t = n), !!I.isString(t)) {
    if (I.isString(o))
      return t.indexOf(o) !== -1;
    if (I.isRegExp(o))
      return o.test(t);
  }
}
function pm(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, o) => n.toUpperCase() + o);
}
function fm(e, t) {
  const n = I.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + n, {
      value: function(r, i, s) {
        return this[o].call(this, t, r, i, s);
      },
      configurable: !0
    });
  });
}
class jo {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, o) {
    const r = this;
    function i(a, l, u) {
      const c = yn(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const d = I.findKey(r, c);
      (!d || r[d] === void 0 || u === !0 || u === void 0 && r[d] !== !1) && (r[d || l] = Jn(a));
    }
    const s = (a, l) => I.forEach(a, (u, c) => i(u, c, l));
    if (I.isPlainObject(t) || t instanceof this.constructor)
      s(t, n);
    else if (I.isString(t) && (t = t.trim()) && !dm(t))
      s(um(t), n);
    else if (I.isHeaders(t))
      for (const [a, l] of t.entries())
        i(l, a, o);
    else
      t != null && i(n, t, o);
    return this;
  }
  get(t, n) {
    if (t = yn(t), t) {
      const o = I.findKey(this, t);
      if (o) {
        const r = this[o];
        if (!n)
          return r;
        if (n === !0)
          return cm(r);
        if (I.isFunction(n))
          return n.call(this, r, o);
        if (I.isRegExp(n))
          return n.exec(r);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = yn(t), t) {
      const o = I.findKey(this, t);
      return !!(o && this[o] !== void 0 && (!n || or(this, this[o], o, n)));
    }
    return !1;
  }
  delete(t, n) {
    const o = this;
    let r = !1;
    function i(s) {
      if (s = yn(s), s) {
        const a = I.findKey(o, s);
        a && (!n || or(o, o[a], a, n)) && (delete o[a], r = !0);
      }
    }
    return I.isArray(t) ? t.forEach(i) : i(t), r;
  }
  clear(t) {
    const n = Object.keys(this);
    let o = n.length, r = !1;
    for (; o--; ) {
      const i = n[o];
      (!t || or(this, this[i], i, t, !0)) && (delete this[i], r = !0);
    }
    return r;
  }
  normalize(t) {
    const n = this, o = {};
    return I.forEach(this, (r, i) => {
      const s = I.findKey(o, i);
      if (s) {
        n[s] = Jn(r), delete n[i];
        return;
      }
      const a = t ? pm(i) : String(i).trim();
      a !== i && delete n[i], n[a] = Jn(r), o[a] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return I.forEach(this, (o, r) => {
      o != null && o !== !1 && (n[r] = t && I.isArray(o) ? o.join(", ") : o);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const o = new this(t);
    return n.forEach((r) => o.set(r)), o;
  }
  static accessor(t) {
    const o = (this[is] = this[is] = {
      accessors: {}
    }).accessors, r = this.prototype;
    function i(s) {
      const a = yn(s);
      o[a] || (fm(r, s), o[a] = !0);
    }
    return I.isArray(t) ? t.forEach(i) : i(t), this;
  }
}
jo.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
I.reduceDescriptors(jo.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[n] = o;
    }
  };
});
I.freezeMethods(jo);
const ot = jo;
function rr(e, t) {
  const n = this || si, o = t || n, r = ot.from(o.headers);
  let i = o.data;
  return I.forEach(e, function(a) {
    i = a.call(n, i, r.normalize(), t ? t.status : void 0);
  }), r.normalize(), i;
}
function bl(e) {
  return !!(e && e.__CANCEL__);
}
function vn(e, t, n) {
  re.call(this, e ?? "canceled", re.ERR_CANCELED, t, n), this.name = "CanceledError";
}
I.inherits(vn, re, {
  __CANCEL__: !0
});
function yl(e, t, n) {
  const o = n.config.validateStatus;
  !n.status || !o || o(n.status) ? e(n) : t(new re(
    "Request failed with status code " + n.status,
    [re.ERR_BAD_REQUEST, re.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function hm(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function vm(e, t) {
  e = e || 10;
  const n = new Array(e), o = new Array(e);
  let r = 0, i = 0, s;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const u = Date.now(), c = o[i];
    s || (s = u), n[r] = l, o[r] = u;
    let d = i, p = 0;
    for (; d !== r; )
      p += n[d++], d = d % e;
    if (r = (r + 1) % e, r === i && (i = (i + 1) % e), u - s < t)
      return;
    const v = c && u - c;
    return v ? Math.round(p * 1e3 / v) : void 0;
  };
}
function mm(e, t) {
  let n = 0, o = 1e3 / t, r, i;
  const s = (u, c = Date.now()) => {
    n = c, r = null, i && (clearTimeout(i), i = null), e.apply(null, u);
  };
  return [(...u) => {
    const c = Date.now(), d = c - n;
    d >= o ? s(u, c) : (r = u, i || (i = setTimeout(() => {
      i = null, s(r);
    }, o - d)));
  }, () => r && s(r)];
}
const uo = (e, t, n = 3) => {
  let o = 0;
  const r = vm(50, 250);
  return mm((i) => {
    const s = i.loaded, a = i.lengthComputable ? i.total : void 0, l = s - o, u = r(l), c = s <= a;
    o = s;
    const d = {
      loaded: s,
      total: a,
      progress: a ? s / a : void 0,
      bytes: l,
      rate: u || void 0,
      estimated: u && a && c ? (a - s) / u : void 0,
      event: i,
      lengthComputable: a != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, ss = (e, t) => {
  const n = e != null;
  return [(o) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: o
  }), t[1]];
}, as = (e) => (...t) => I.asap(() => e(...t)), gm = Be.hasStandardBrowserEnv ? ((e, t) => (n) => (n = new URL(n, Be.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(Be.origin),
  Be.navigator && /(msie|trident)/i.test(Be.navigator.userAgent)
) : () => !0, bm = Be.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, o, r, i) {
      const s = [e + "=" + encodeURIComponent(t)];
      I.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()), I.isString(o) && s.push("path=" + o), I.isString(r) && s.push("domain=" + r), i === !0 && s.push("secure"), document.cookie = s.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function ym(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function wm(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function wl(e, t) {
  return e && !ym(t) ? wm(e, t) : t;
}
const ls = (e) => e instanceof ot ? { ...e } : e;
function Ut(e, t) {
  t = t || {};
  const n = {};
  function o(u, c, d, p) {
    return I.isPlainObject(u) && I.isPlainObject(c) ? I.merge.call({ caseless: p }, u, c) : I.isPlainObject(c) ? I.merge({}, c) : I.isArray(c) ? c.slice() : c;
  }
  function r(u, c, d, p) {
    if (I.isUndefined(c)) {
      if (!I.isUndefined(u))
        return o(void 0, u, d, p);
    } else
      return o(u, c, d, p);
  }
  function i(u, c) {
    if (!I.isUndefined(c))
      return o(void 0, c);
  }
  function s(u, c) {
    if (I.isUndefined(c)) {
      if (!I.isUndefined(u))
        return o(void 0, u);
    } else
      return o(void 0, c);
  }
  function a(u, c, d) {
    if (d in t)
      return o(u, c);
    if (d in e)
      return o(void 0, u);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: a,
    headers: (u, c, d) => r(ls(u), ls(c), d, !0)
  };
  return I.forEach(Object.keys(Object.assign({}, e, t)), function(c) {
    const d = l[c] || r, p = d(e[c], t[c], c);
    I.isUndefined(p) && d !== a || (n[c] = p);
  }), n;
}
const xl = (e) => {
  const t = Ut({}, e);
  let { data: n, withXSRFToken: o, xsrfHeaderName: r, xsrfCookieName: i, headers: s, auth: a } = t;
  t.headers = s = ot.from(s), t.url = vl(wl(t.baseURL, t.url), e.params, e.paramsSerializer), a && s.set(
    "Authorization",
    "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))
  );
  let l;
  if (I.isFormData(n)) {
    if (Be.hasStandardBrowserEnv || Be.hasStandardBrowserWebWorkerEnv)
      s.setContentType(void 0);
    else if ((l = s.getContentType()) !== !1) {
      const [u, ...c] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      s.setContentType([u || "multipart/form-data", ...c].join("; "));
    }
  }
  if (Be.hasStandardBrowserEnv && (o && I.isFunction(o) && (o = o(t)), o || o !== !1 && gm(t.url))) {
    const u = r && i && bm.read(i);
    u && s.set(r, u);
  }
  return t;
}, xm = typeof XMLHttpRequest < "u", $m = xm && function(e) {
  return new Promise(function(n, o) {
    const r = xl(e);
    let i = r.data;
    const s = ot.from(r.headers).normalize();
    let { responseType: a, onUploadProgress: l, onDownloadProgress: u } = r, c, d, p, v, x;
    function b() {
      v && v(), x && x(), r.cancelToken && r.cancelToken.unsubscribe(c), r.signal && r.signal.removeEventListener("abort", c);
    }
    let h = new XMLHttpRequest();
    h.open(r.method.toUpperCase(), r.url, !0), h.timeout = r.timeout;
    function S() {
      if (!h)
        return;
      const C = ot.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), $ = {
        data: !a || a === "text" || a === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: C,
        config: e,
        request: h
      };
      yl(function(_) {
        n(_), b();
      }, function(_) {
        o(_), b();
      }, $), h = null;
    }
    "onloadend" in h ? h.onloadend = S : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(S);
    }, h.onabort = function() {
      h && (o(new re("Request aborted", re.ECONNABORTED, e, h)), h = null);
    }, h.onerror = function() {
      o(new re("Network Error", re.ERR_NETWORK, e, h)), h = null;
    }, h.ontimeout = function() {
      let w = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const $ = r.transitional || ml;
      r.timeoutErrorMessage && (w = r.timeoutErrorMessage), o(new re(
        w,
        $.clarifyTimeoutError ? re.ETIMEDOUT : re.ECONNABORTED,
        e,
        h
      )), h = null;
    }, i === void 0 && s.setContentType(null), "setRequestHeader" in h && I.forEach(s.toJSON(), function(w, $) {
      h.setRequestHeader($, w);
    }), I.isUndefined(r.withCredentials) || (h.withCredentials = !!r.withCredentials), a && a !== "json" && (h.responseType = r.responseType), u && ([p, x] = uo(u, !0), h.addEventListener("progress", p)), l && h.upload && ([d, v] = uo(l), h.upload.addEventListener("progress", d), h.upload.addEventListener("loadend", v)), (r.cancelToken || r.signal) && (c = (C) => {
      h && (o(!C || C.type ? new vn(null, e, h) : C), h.abort(), h = null);
    }, r.cancelToken && r.cancelToken.subscribe(c), r.signal && (r.signal.aborted ? c() : r.signal.addEventListener("abort", c)));
    const g = hm(r.url);
    if (g && Be.protocols.indexOf(g) === -1) {
      o(new re("Unsupported protocol " + g + ":", re.ERR_BAD_REQUEST, e));
      return;
    }
    h.send(i || null);
  });
}, Cm = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let o = new AbortController(), r;
    const i = function(u) {
      if (!r) {
        r = !0, a();
        const c = u instanceof Error ? u : this.reason;
        o.abort(c instanceof re ? c : new vn(c instanceof Error ? c.message : c));
      }
    };
    let s = t && setTimeout(() => {
      s = null, i(new re(`timeout ${t} of ms exceeded`, re.ETIMEDOUT));
    }, t);
    const a = () => {
      e && (s && clearTimeout(s), s = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(i) : u.removeEventListener("abort", i);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", i));
    const { signal: l } = o;
    return l.unsubscribe = () => I.asap(a), l;
  }
}, Sm = Cm, km = function* (e, t) {
  let n = e.byteLength;
  if (!t || n < t) {
    yield e;
    return;
  }
  let o = 0, r;
  for (; o < n; )
    r = o + t, yield e.slice(o, r), o = r;
}, Em = async function* (e, t) {
  for await (const n of Om(e))
    yield* km(n, t);
}, Om = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: o } = await t.read();
      if (n)
        break;
      yield o;
    }
  } finally {
    await t.cancel();
  }
}, us = (e, t, n, o) => {
  const r = Em(e, t);
  let i = 0, s, a = (l) => {
    s || (s = !0, o && o(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: u, value: c } = await r.next();
        if (u) {
          a(), l.close();
          return;
        }
        let d = c.byteLength;
        if (n) {
          let p = i += d;
          n(p);
        }
        l.enqueue(new Uint8Array(c));
      } catch (u) {
        throw a(u), u;
      }
    },
    cancel(l) {
      return a(l), r.return();
    }
  }, {
    highWaterMark: 2
  });
}, Vo = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", $l = Vo && typeof ReadableStream == "function", Am = Vo && (typeof TextEncoder == "function" ? ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Cl = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, _m = $l && Cl(() => {
  let e = !1;
  const t = new Request(Be.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), cs = 64 * 1024, Er = $l && Cl(() => I.isReadableStream(new Response("").body)), co = {
  stream: Er && ((e) => e.body)
};
Vo && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !co[t] && (co[t] = I.isFunction(e[t]) ? (n) => n[t]() : (n, o) => {
      throw new re(`Response type '${t}' is not supported`, re.ERR_NOT_SUPPORT, o);
    });
  });
})(new Response());
const Rm = async (e) => {
  if (e == null)
    return 0;
  if (I.isBlob(e))
    return e.size;
  if (I.isSpecCompliantForm(e))
    return (await new Request(Be.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (I.isArrayBufferView(e) || I.isArrayBuffer(e))
    return e.byteLength;
  if (I.isURLSearchParams(e) && (e = e + ""), I.isString(e))
    return (await Am(e)).byteLength;
}, Mm = async (e, t) => {
  const n = I.toFiniteNumber(e.getContentLength());
  return n ?? Rm(t);
}, Tm = Vo && (async (e) => {
  let {
    url: t,
    method: n,
    data: o,
    signal: r,
    cancelToken: i,
    timeout: s,
    onDownloadProgress: a,
    onUploadProgress: l,
    responseType: u,
    headers: c,
    withCredentials: d = "same-origin",
    fetchOptions: p
  } = xl(e);
  u = u ? (u + "").toLowerCase() : "text";
  let v = Sm([r, i && i.toAbortSignal()], s), x;
  const b = v && v.unsubscribe && (() => {
    v.unsubscribe();
  });
  let h;
  try {
    if (l && _m && n !== "get" && n !== "head" && (h = await Mm(c, o)) !== 0) {
      let $ = new Request(t, {
        method: "POST",
        body: o,
        duplex: "half"
      }), k;
      if (I.isFormData(o) && (k = $.headers.get("content-type")) && c.setContentType(k), $.body) {
        const [_, M] = ss(
          h,
          uo(as(l))
        );
        o = us($.body, cs, _, M);
      }
    }
    I.isString(d) || (d = d ? "include" : "omit");
    const S = "credentials" in Request.prototype;
    x = new Request(t, {
      ...p,
      signal: v,
      method: n.toUpperCase(),
      headers: c.normalize().toJSON(),
      body: o,
      duplex: "half",
      credentials: S ? d : void 0
    });
    let g = await fetch(x);
    const C = Er && (u === "stream" || u === "response");
    if (Er && (a || C && b)) {
      const $ = {};
      ["status", "statusText", "headers"].forEach((U) => {
        $[U] = g[U];
      });
      const k = I.toFiniteNumber(g.headers.get("content-length")), [_, M] = a && ss(
        k,
        uo(as(a), !0)
      ) || [];
      g = new Response(
        us(g.body, cs, _, () => {
          M && M(), b && b();
        }),
        $
      );
    }
    u = u || "text";
    let w = await co[I.findKey(co, u) || "text"](g, e);
    return !C && b && b(), await new Promise(($, k) => {
      yl($, k, {
        data: w,
        headers: ot.from(g.headers),
        status: g.status,
        statusText: g.statusText,
        config: e,
        request: x
      });
    });
  } catch (S) {
    throw b && b(), S && S.name === "TypeError" && /fetch/i.test(S.message) ? Object.assign(
      new re("Network Error", re.ERR_NETWORK, e, x),
      {
        cause: S.cause || S
      }
    ) : re.from(S, S && S.code, e, x);
  }
}), Or = {
  http: Wv,
  xhr: $m,
  fetch: Tm
};
I.forEach(Or, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const ds = (e) => `- ${e}`, Pm = (e) => I.isFunction(e) || e === null || e === !1, Sl = {
  getAdapter: (e) => {
    e = I.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, o;
    const r = {};
    for (let i = 0; i < t; i++) {
      n = e[i];
      let s;
      if (o = n, !Pm(n) && (o = Or[(s = String(n)).toLowerCase()], o === void 0))
        throw new re(`Unknown adapter '${s}'`);
      if (o)
        break;
      r[s || "#" + i] = o;
    }
    if (!o) {
      const i = Object.entries(r).map(
        ([a, l]) => `adapter ${a} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = t ? i.length > 1 ? `since :
` + i.map(ds).join(`
`) : " " + ds(i[0]) : "as no adapter specified";
      throw new re(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: Or
};
function ir(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new vn(null, e);
}
function ps(e) {
  return ir(e), e.headers = ot.from(e.headers), e.data = rr.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Sl.getAdapter(e.adapter || si.adapter)(e).then(function(o) {
    return ir(e), o.data = rr.call(
      e,
      e.transformResponse,
      o
    ), o.headers = ot.from(o.headers), o;
  }, function(o) {
    return bl(o) || (ir(e), o && o.response && (o.response.data = rr.call(
      e,
      e.transformResponse,
      o.response
    ), o.response.headers = ot.from(o.response.headers))), Promise.reject(o);
  });
}
const kl = "1.7.9", Fo = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Fo[e] = function(o) {
    return typeof o === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const fs = {};
Fo.transitional = function(t, n, o) {
  function r(i, s) {
    return "[Axios v" + kl + "] Transitional option '" + i + "'" + s + (o ? ". " + o : "");
  }
  return (i, s, a) => {
    if (t === !1)
      throw new re(
        r(s, " has been removed" + (n ? " in " + n : "")),
        re.ERR_DEPRECATED
      );
    return n && !fs[s] && (fs[s] = !0, console.warn(
      r(
        s,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(i, s, a) : !0;
  };
};
Fo.spelling = function(t) {
  return (n, o) => (console.warn(`${o} is likely a misspelling of ${t}`), !0);
};
function Im(e, t, n) {
  if (typeof e != "object")
    throw new re("options must be an object", re.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let r = o.length;
  for (; r-- > 0; ) {
    const i = o[r], s = t[i];
    if (s) {
      const a = e[i], l = a === void 0 || s(a, i, e);
      if (l !== !0)
        throw new re("option " + i + " must be " + l, re.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new re("Unknown option " + i, re.ERR_BAD_OPTION);
  }
}
const eo = {
  assertOptions: Im,
  validators: Fo
}, pt = eo.validators;
class po {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new rs(),
      response: new rs()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (o) {
      if (o instanceof Error) {
        let r = {};
        Error.captureStackTrace ? Error.captureStackTrace(r) : r = new Error();
        const i = r.stack ? r.stack.replace(/^.+\n/, "") : "";
        try {
          o.stack ? i && !String(o.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (o.stack += `
` + i) : o.stack = i;
        } catch {
        }
      }
      throw o;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = Ut(this.defaults, n);
    const { transitional: o, paramsSerializer: r, headers: i } = n;
    o !== void 0 && eo.assertOptions(o, {
      silentJSONParsing: pt.transitional(pt.boolean),
      forcedJSONParsing: pt.transitional(pt.boolean),
      clarifyTimeoutError: pt.transitional(pt.boolean)
    }, !1), r != null && (I.isFunction(r) ? n.paramsSerializer = {
      serialize: r
    } : eo.assertOptions(r, {
      encode: pt.function,
      serialize: pt.function
    }, !0)), eo.assertOptions(n, {
      baseUrl: pt.spelling("baseURL"),
      withXsrfToken: pt.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let s = i && I.merge(
      i.common,
      i[n.method]
    );
    i && I.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (x) => {
        delete i[x];
      }
    ), n.headers = ot.concat(s, i);
    const a = [];
    let l = !0;
    this.interceptors.request.forEach(function(b) {
      typeof b.runWhen == "function" && b.runWhen(n) === !1 || (l = l && b.synchronous, a.unshift(b.fulfilled, b.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(b) {
      u.push(b.fulfilled, b.rejected);
    });
    let c, d = 0, p;
    if (!l) {
      const x = [ps.bind(this), void 0];
      for (x.unshift.apply(x, a), x.push.apply(x, u), p = x.length, c = Promise.resolve(n); d < p; )
        c = c.then(x[d++], x[d++]);
      return c;
    }
    p = a.length;
    let v = n;
    for (d = 0; d < p; ) {
      const x = a[d++], b = a[d++];
      try {
        v = x(v);
      } catch (h) {
        b.call(this, h);
        break;
      }
    }
    try {
      c = ps.call(this, v);
    } catch (x) {
      return Promise.reject(x);
    }
    for (d = 0, p = u.length; d < p; )
      c = c.then(u[d++], u[d++]);
    return c;
  }
  getUri(t) {
    t = Ut(this.defaults, t);
    const n = wl(t.baseURL, t.url);
    return vl(n, t.params, t.paramsSerializer);
  }
}
I.forEach(["delete", "get", "head", "options"], function(t) {
  po.prototype[t] = function(n, o) {
    return this.request(Ut(o || {}, {
      method: t,
      url: n,
      data: (o || {}).data
    }));
  };
});
I.forEach(["post", "put", "patch"], function(t) {
  function n(o) {
    return function(i, s, a) {
      return this.request(Ut(a || {}, {
        method: t,
        headers: o ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: s
      }));
    };
  }
  po.prototype[t] = n(), po.prototype[t + "Form"] = n(!0);
});
const to = po;
class ai {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(i) {
      n = i;
    });
    const o = this;
    this.promise.then((r) => {
      if (!o._listeners)
        return;
      let i = o._listeners.length;
      for (; i-- > 0; )
        o._listeners[i](r);
      o._listeners = null;
    }), this.promise.then = (r) => {
      let i;
      const s = new Promise((a) => {
        o.subscribe(a), i = a;
      }).then(r);
      return s.cancel = function() {
        o.unsubscribe(i);
      }, s;
    }, t(function(i, s, a) {
      o.reason || (o.reason = new vn(i, s, a), n(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (o) => {
      t.abort(o);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new ai(function(r) {
        t = r;
      }),
      cancel: t
    };
  }
}
const Lm = ai;
function Dm(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Bm(e) {
  return I.isObject(e) && e.isAxiosError === !0;
}
const Ar = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Ar).forEach(([e, t]) => {
  Ar[t] = e;
});
const zm = Ar;
function El(e) {
  const t = new to(e), n = ol(to.prototype.request, t);
  return I.extend(n, to.prototype, t, { allOwnKeys: !0 }), I.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(r) {
    return El(Ut(e, r));
  }, n;
}
const _e = El(si);
_e.Axios = to;
_e.CanceledError = vn;
_e.CancelToken = Lm;
_e.isCancel = bl;
_e.VERSION = kl;
_e.toFormData = No;
_e.AxiosError = re;
_e.Cancel = _e.CanceledError;
_e.all = function(t) {
  return Promise.all(t);
};
_e.spread = Dm;
_e.isAxiosError = Bm;
_e.mergeConfig = Ut;
_e.AxiosHeaders = ot;
_e.formToJSON = (e) => gl(I.isHTMLForm(e) ? new FormData(e) : e);
_e.getAdapter = Sl.getAdapter;
_e.HttpStatusCode = zm;
_e.default = _e;
const hs = _e;
function Nm({
  isBatch: e,
  downloadErrorMessage: t,
  downloadSuccessMessage: n,
  params: o,
  path: r,
  filename: i,
  batchSuccessMessage: s,
  headers: a
}, {
  emit: l
}) {
  const u = A(!1), c = () => {
    if (e.value)
      p();
    else {
      if (u.value)
        return;
      u.value = !0, d();
    }
  }, d = () => {
    hs.get(r.value, {
      responseType: "blob",
      params: o.value,
      headers: a.value
    }).then((v) => {
      const x = window.URL.createObjectURL(new Blob([v.data])), b = document.createElement("a");
      b.href = x, b.setAttribute("download", i.value), document.body.appendChild(b), b.click(), gt.dispatch("notification/success", {
        text: n.value,
        timeout: 2e3
      }), u.value = !1;
    }).catch(() => {
      gt.dispatch("notification/error", {
        text: t.value,
        persist: !0
      }), u.value = !1;
    });
  }, p = () => {
    hs.get(r.value, {
      params: o.value,
      headers: a.value
    }).then(() => {
      gt.dispatch("notification/success", {
        text: s.value,
        timeout: 2e3
      }), l("batchCompleted");
    }).catch(() => {
      gt.dispatch("notification/error", {
        text: t.value,
        persist: !0
      });
    });
  };
  return {
    inProgress: u,
    downloadCsv: c
  };
}
const jm = z({
  name: "DownloadCsvButton",
  components: {
    ArrowDownTrayIcon: p0,
    Button: rt
  },
  props: {
    isBatch: {
      type: Boolean,
      default: !1
    },
    filename: {
      type: String,
      default: null
    },
    downloadErrorMessage: {
      type: String,
      default: null
    },
    downloadSuccessMessage: {
      type: String,
      default: null
    },
    batchSuccessMessage: {
      type: String,
      default: null
    },
    path: {
      type: String,
      required: !0
    },
    params: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Object,
      default: null
    },
    headers: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      type: Object,
      default: null
    }
  },
  emits: {
    batchCompleted() {
      return !0;
    }
  },
  setup(e, t) {
    const { inProgress: n, downloadCsv: o } = Nm(at(e), t);
    return {
      inProgress: n,
      downloadCsv: o
    };
  }
});
function Vm(e, t, n, o, r, i) {
  const s = ne("ArrowDownTrayIcon"), a = ne("Button");
  return f(), j(a, {
    processing: e.inProgress,
    onClick: e.downloadCsv
  }, {
    default: F(() => [
      B(s, { class: "mr-2 h-4 w-4" }),
      G(e.$slots, "default")
    ]),
    _: 3
  }, 8, ["processing", "onClick"]);
}
const n7 = /* @__PURE__ */ Ee(jm, [["render", Vm]]);
function Fm({
  width: e,
  bgColor: t,
  textColor: n
}) {
  const o = A(!1), r = E(() => {
    const i = [], s = "p-2 -mt-1 text-sm rounded-lg shadow-lg";
    return o.value ? i.push("block") : i.push("hidden"), i.push(s, e.value, t.value, n.value), i;
  });
  return {
    show: o,
    tooltipClasses: r
  };
}
function Hm({
  width: e,
  positionY: t,
  positionX: n,
  iconPositionX: o,
  iconPositionY: r
}) {
  const i = A(!1), s = E(() => {
    const l = [], u = "absolute z-10 p-2 lowercase bg-gray-400 -mt-1 text-sm text-white rounded-lg shadow-lg";
    return l.push(u, e.value, t.value, n.value), l;
  }), a = E(() => {
    const l = [], u = "absolute flex items-center justify-center";
    return l.push(u, o.value, r.value), l;
  });
  return {
    show: i,
    tooltipClasses: s,
    iconClasses: a
  };
}
const Um = z({
  name: "Tooltip",
  components: {
    InformationCircleIcon: Qr
  },
  props: {
    text: {
      type: String,
      default: null
    },
    width: {
      type: String,
      default: "w-56"
    },
    positionY: {
      type: String,
      default: "top-0"
    },
    positionX: {
      type: String,
      default: "left-2"
    },
    iconPositionX: {
      type: String,
      default: "top-3"
    },
    iconPositionY: {
      type: String,
      default: "right-0"
    }
  },
  setup(e) {
    const { show: t, tooltipClasses: n, iconClasses: o } = Hm(at(e));
    return {
      show: t,
      tooltipClasses: n,
      iconClasses: o
    };
  }
}), Wm = {
  key: 0,
  class: "relative"
}, qm = { key: 0 };
function Zm(e, t, n, o, r, i) {
  const s = ne("InformationCircleIcon");
  return f(), y("div", {
    class: O(e.iconClasses)
  }, [
    m("div", null, [
      m("div", {
        class: "cursor-pointer",
        onMouseover: t[0] || (t[0] = (a) => e.show = !0),
        onMouseleave: t[1] || (t[1] = (a) => e.show = !1)
      }, [
        B(s, {
          class: "block h-4 w-4",
          "aria-hidden": "true"
        })
      ], 32),
      e.show ? (f(), y("div", Wm, [
        m("div", {
          class: O(e.tooltipClasses)
        }, [
          e.text ? (f(), y("span", qm, R(e.text), 1)) : G(e.$slots, "default", { key: 1 })
        ], 2)
      ])) : P("", !0)
    ])
  ], 2);
}
const o7 = /* @__PURE__ */ Ee(Um, [["render", Zm]]);
var Fe = "top", tt = "bottom", nt = "right", He = "left", li = "auto", Dn = [Fe, tt, nt, He], an = "start", En = "end", Gm = "clippingParents", Ol = "viewport", wn = "popper", Km = "reference", vs = /* @__PURE__ */ Dn.reduce(function(e, t) {
  return e.concat([t + "-" + an, t + "-" + En]);
}, []), Al = /* @__PURE__ */ [].concat(Dn, [li]).reduce(function(e, t) {
  return e.concat([t, t + "-" + an, t + "-" + En]);
}, []), Ym = "beforeRead", Xm = "read", Qm = "afterRead", Jm = "beforeMain", eg = "main", tg = "afterMain", ng = "beforeWrite", og = "write", rg = "afterWrite", ig = [Ym, Xm, Qm, Jm, eg, tg, ng, og, rg];
function wt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Ye(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Wt(e) {
  var t = Ye(e).Element;
  return e instanceof t || e instanceof Element;
}
function Qe(e) {
  var t = Ye(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function ui(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = Ye(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function sg(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var o = t.styles[n] || {}, r = t.attributes[n] || {}, i = t.elements[n];
    !Qe(i) || !wt(i) || (Object.assign(i.style, o), Object.keys(r).forEach(function(s) {
      var a = r[s];
      a === !1 ? i.removeAttribute(s) : i.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function ag(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(o) {
      var r = t.elements[o], i = t.attributes[o] || {}, s = Object.keys(t.styles.hasOwnProperty(o) ? t.styles[o] : n[o]), a = s.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !Qe(r) || !wt(r) || (Object.assign(r.style, a), Object.keys(i).forEach(function(l) {
        r.removeAttribute(l);
      }));
    });
  };
}
const lg = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: sg,
  effect: ag,
  requires: ["computeStyles"]
};
function yt(e) {
  return e.split("-")[0];
}
var jt = Math.max, fo = Math.min, ln = Math.round;
function _r() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function _l() {
  return !/^((?!chrome|android).)*safari/i.test(_r());
}
function un(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var o = e.getBoundingClientRect(), r = 1, i = 1;
  t && Qe(e) && (r = e.offsetWidth > 0 && ln(o.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && ln(o.height) / e.offsetHeight || 1);
  var s = Wt(e) ? Ye(e) : window, a = s.visualViewport, l = !_l() && n, u = (o.left + (l && a ? a.offsetLeft : 0)) / r, c = (o.top + (l && a ? a.offsetTop : 0)) / i, d = o.width / r, p = o.height / i;
  return {
    width: d,
    height: p,
    top: c,
    right: u + d,
    bottom: c + p,
    left: u,
    x: u,
    y: c
  };
}
function ci(e) {
  var t = un(e), n = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - o) <= 1 && (o = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: o
  };
}
function Rl(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && ui(n)) {
    var o = t;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function kt(e) {
  return Ye(e).getComputedStyle(e);
}
function ug(e) {
  return ["table", "td", "th"].indexOf(wt(e)) >= 0;
}
function Tt(e) {
  return ((Wt(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ho(e) {
  return wt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ui(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Tt(e)
  );
}
function ms(e) {
  return !Qe(e) || // https://github.com/popperjs/popper-core/issues/837
  kt(e).position === "fixed" ? null : e.offsetParent;
}
function cg(e) {
  var t = /firefox/i.test(_r()), n = /Trident/i.test(_r());
  if (n && Qe(e)) {
    var o = kt(e);
    if (o.position === "fixed")
      return null;
  }
  var r = Ho(e);
  for (ui(r) && (r = r.host); Qe(r) && ["html", "body"].indexOf(wt(r)) < 0; ) {
    var i = kt(r);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Bn(e) {
  for (var t = Ye(e), n = ms(e); n && ug(n) && kt(n).position === "static"; )
    n = ms(n);
  return n && (wt(n) === "html" || wt(n) === "body" && kt(n).position === "static") ? t : n || cg(e) || t;
}
function di(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function xn(e, t, n) {
  return jt(e, fo(t, n));
}
function dg(e, t, n) {
  var o = xn(e, t, n);
  return o > n ? n : o;
}
function Ml() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Tl(e) {
  return Object.assign({}, Ml(), e);
}
function Pl(e, t) {
  return t.reduce(function(n, o) {
    return n[o] = e, n;
  }, {});
}
var pg = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Tl(typeof t != "number" ? t : Pl(t, Dn));
};
function fg(e) {
  var t, n = e.state, o = e.name, r = e.options, i = n.elements.arrow, s = n.modifiersData.popperOffsets, a = yt(n.placement), l = di(a), u = [He, nt].indexOf(a) >= 0, c = u ? "height" : "width";
  if (!(!i || !s)) {
    var d = pg(r.padding, n), p = ci(i), v = l === "y" ? Fe : He, x = l === "y" ? tt : nt, b = n.rects.reference[c] + n.rects.reference[l] - s[l] - n.rects.popper[c], h = s[l] - n.rects.reference[l], S = Bn(i), g = S ? l === "y" ? S.clientHeight || 0 : S.clientWidth || 0 : 0, C = b / 2 - h / 2, w = d[v], $ = g - p[c] - d[x], k = g / 2 - p[c] / 2 + C, _ = xn(w, k, $), M = l;
    n.modifiersData[o] = (t = {}, t[M] = _, t.centerOffset = _ - k, t);
  }
}
function hg(e) {
  var t = e.state, n = e.options, o = n.element, r = o === void 0 ? "[data-popper-arrow]" : o;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || Rl(t.elements.popper, r) && (t.elements.arrow = r));
}
const vg = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: fg,
  effect: hg,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function cn(e) {
  return e.split("-")[1];
}
var mg = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function gg(e, t) {
  var n = e.x, o = e.y, r = t.devicePixelRatio || 1;
  return {
    x: ln(n * r) / r || 0,
    y: ln(o * r) / r || 0
  };
}
function gs(e) {
  var t, n = e.popper, o = e.popperRect, r = e.placement, i = e.variation, s = e.offsets, a = e.position, l = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, d = e.isFixed, p = s.x, v = p === void 0 ? 0 : p, x = s.y, b = x === void 0 ? 0 : x, h = typeof c == "function" ? c({
    x: v,
    y: b
  }) : {
    x: v,
    y: b
  };
  v = h.x, b = h.y;
  var S = s.hasOwnProperty("x"), g = s.hasOwnProperty("y"), C = He, w = Fe, $ = window;
  if (u) {
    var k = Bn(n), _ = "clientHeight", M = "clientWidth";
    if (k === Ye(n) && (k = Tt(n), kt(k).position !== "static" && a === "absolute" && (_ = "scrollHeight", M = "scrollWidth")), k = k, r === Fe || (r === He || r === nt) && i === En) {
      w = tt;
      var U = d && k === $ && $.visualViewport ? $.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        k[_]
      );
      b -= U - o.height, b *= l ? 1 : -1;
    }
    if (r === He || (r === Fe || r === tt) && i === En) {
      C = nt;
      var L = d && k === $ && $.visualViewport ? $.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        k[M]
      );
      v -= L - o.width, v *= l ? 1 : -1;
    }
  }
  var N = Object.assign({
    position: a
  }, u && mg), Z = c === !0 ? gg({
    x: v,
    y: b
  }, Ye(n)) : {
    x: v,
    y: b
  };
  if (v = Z.x, b = Z.y, l) {
    var H;
    return Object.assign({}, N, (H = {}, H[w] = g ? "0" : "", H[C] = S ? "0" : "", H.transform = ($.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + b + "px)" : "translate3d(" + v + "px, " + b + "px, 0)", H));
  }
  return Object.assign({}, N, (t = {}, t[w] = g ? b + "px" : "", t[C] = S ? v + "px" : "", t.transform = "", t));
}
function bg(e) {
  var t = e.state, n = e.options, o = n.gpuAcceleration, r = o === void 0 ? !0 : o, i = n.adaptive, s = i === void 0 ? !0 : i, a = n.roundOffsets, l = a === void 0 ? !0 : a, u = {
    placement: yt(t.placement),
    variation: cn(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, gs(Object.assign({}, u, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, gs(Object.assign({}, u, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const yg = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: bg,
  data: {}
};
var Fn = {
  passive: !0
};
function wg(e) {
  var t = e.state, n = e.instance, o = e.options, r = o.scroll, i = r === void 0 ? !0 : r, s = o.resize, a = s === void 0 ? !0 : s, l = Ye(t.elements.popper), u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && u.forEach(function(c) {
    c.addEventListener("scroll", n.update, Fn);
  }), a && l.addEventListener("resize", n.update, Fn), function() {
    i && u.forEach(function(c) {
      c.removeEventListener("scroll", n.update, Fn);
    }), a && l.removeEventListener("resize", n.update, Fn);
  };
}
const xg = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: wg,
  data: {}
};
var $g = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function no(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return $g[t];
  });
}
var Cg = {
  start: "end",
  end: "start"
};
function bs(e) {
  return e.replace(/start|end/g, function(t) {
    return Cg[t];
  });
}
function pi(e) {
  var t = Ye(e), n = t.pageXOffset, o = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: o
  };
}
function fi(e) {
  return un(Tt(e)).left + pi(e).scrollLeft;
}
function Sg(e, t) {
  var n = Ye(e), o = Tt(e), r = n.visualViewport, i = o.clientWidth, s = o.clientHeight, a = 0, l = 0;
  if (r) {
    i = r.width, s = r.height;
    var u = _l();
    (u || !u && t === "fixed") && (a = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a + fi(e),
    y: l
  };
}
function kg(e) {
  var t, n = Tt(e), o = pi(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, i = jt(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), s = jt(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), a = -o.scrollLeft + fi(e), l = -o.scrollTop;
  return kt(r || n).direction === "rtl" && (a += jt(n.clientWidth, r ? r.clientWidth : 0) - i), {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function hi(e) {
  var t = kt(e), n = t.overflow, o = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + o);
}
function Il(e) {
  return ["html", "body", "#document"].indexOf(wt(e)) >= 0 ? e.ownerDocument.body : Qe(e) && hi(e) ? e : Il(Ho(e));
}
function $n(e, t) {
  var n;
  t === void 0 && (t = []);
  var o = Il(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = Ye(o), s = r ? [i].concat(i.visualViewport || [], hi(o) ? o : []) : o, a = t.concat(s);
  return r ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat($n(Ho(s)))
  );
}
function Rr(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Eg(e, t) {
  var n = un(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function ys(e, t, n) {
  return t === Ol ? Rr(Sg(e, n)) : Wt(t) ? Eg(t, n) : Rr(kg(Tt(e)));
}
function Og(e) {
  var t = $n(Ho(e)), n = ["absolute", "fixed"].indexOf(kt(e).position) >= 0, o = n && Qe(e) ? Bn(e) : e;
  return Wt(o) ? t.filter(function(r) {
    return Wt(r) && Rl(r, o) && wt(r) !== "body";
  }) : [];
}
function Ag(e, t, n, o) {
  var r = t === "clippingParents" ? Og(e) : [].concat(t), i = [].concat(r, [n]), s = i[0], a = i.reduce(function(l, u) {
    var c = ys(e, u, o);
    return l.top = jt(c.top, l.top), l.right = fo(c.right, l.right), l.bottom = fo(c.bottom, l.bottom), l.left = jt(c.left, l.left), l;
  }, ys(e, s, o));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Ll(e) {
  var t = e.reference, n = e.element, o = e.placement, r = o ? yt(o) : null, i = o ? cn(o) : null, s = t.x + t.width / 2 - n.width / 2, a = t.y + t.height / 2 - n.height / 2, l;
  switch (r) {
    case Fe:
      l = {
        x: s,
        y: t.y - n.height
      };
      break;
    case tt:
      l = {
        x: s,
        y: t.y + t.height
      };
      break;
    case nt:
      l = {
        x: t.x + t.width,
        y: a
      };
      break;
    case He:
      l = {
        x: t.x - n.width,
        y: a
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var u = r ? di(r) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (i) {
      case an:
        l[u] = l[u] - (t[c] / 2 - n[c] / 2);
        break;
      case En:
        l[u] = l[u] + (t[c] / 2 - n[c] / 2);
        break;
    }
  }
  return l;
}
function On(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = o === void 0 ? e.placement : o, i = n.strategy, s = i === void 0 ? e.strategy : i, a = n.boundary, l = a === void 0 ? Gm : a, u = n.rootBoundary, c = u === void 0 ? Ol : u, d = n.elementContext, p = d === void 0 ? wn : d, v = n.altBoundary, x = v === void 0 ? !1 : v, b = n.padding, h = b === void 0 ? 0 : b, S = Tl(typeof h != "number" ? h : Pl(h, Dn)), g = p === wn ? Km : wn, C = e.rects.popper, w = e.elements[x ? g : p], $ = Ag(Wt(w) ? w : w.contextElement || Tt(e.elements.popper), l, c, s), k = un(e.elements.reference), _ = Ll({
    reference: k,
    element: C,
    strategy: "absolute",
    placement: r
  }), M = Rr(Object.assign({}, C, _)), U = p === wn ? M : k, L = {
    top: $.top - U.top + S.top,
    bottom: U.bottom - $.bottom + S.bottom,
    left: $.left - U.left + S.left,
    right: U.right - $.right + S.right
  }, N = e.modifiersData.offset;
  if (p === wn && N) {
    var Z = N[r];
    Object.keys(L).forEach(function(H) {
      var J = [nt, tt].indexOf(H) >= 0 ? 1 : -1, X = [Fe, tt].indexOf(H) >= 0 ? "y" : "x";
      L[H] += Z[X] * J;
    });
  }
  return L;
}
function _g(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = n.boundary, i = n.rootBoundary, s = n.padding, a = n.flipVariations, l = n.allowedAutoPlacements, u = l === void 0 ? Al : l, c = cn(o), d = c ? a ? vs : vs.filter(function(x) {
    return cn(x) === c;
  }) : Dn, p = d.filter(function(x) {
    return u.indexOf(x) >= 0;
  });
  p.length === 0 && (p = d);
  var v = p.reduce(function(x, b) {
    return x[b] = On(e, {
      placement: b,
      boundary: r,
      rootBoundary: i,
      padding: s
    })[yt(b)], x;
  }, {});
  return Object.keys(v).sort(function(x, b) {
    return v[x] - v[b];
  });
}
function Rg(e) {
  if (yt(e) === li)
    return [];
  var t = no(e);
  return [bs(e), t, bs(t)];
}
function Mg(e) {
  var t = e.state, n = e.options, o = e.name;
  if (!t.modifiersData[o]._skip) {
    for (var r = n.mainAxis, i = r === void 0 ? !0 : r, s = n.altAxis, a = s === void 0 ? !0 : s, l = n.fallbackPlacements, u = n.padding, c = n.boundary, d = n.rootBoundary, p = n.altBoundary, v = n.flipVariations, x = v === void 0 ? !0 : v, b = n.allowedAutoPlacements, h = t.options.placement, S = yt(h), g = S === h, C = l || (g || !x ? [no(h)] : Rg(h)), w = [h].concat(C).reduce(function(ue, te) {
      return ue.concat(yt(te) === li ? _g(t, {
        placement: te,
        boundary: c,
        rootBoundary: d,
        padding: u,
        flipVariations: x,
        allowedAutoPlacements: b
      }) : te);
    }, []), $ = t.rects.reference, k = t.rects.popper, _ = /* @__PURE__ */ new Map(), M = !0, U = w[0], L = 0; L < w.length; L++) {
      var N = w[L], Z = yt(N), H = cn(N) === an, J = [Fe, tt].indexOf(Z) >= 0, X = J ? "width" : "height", ie = On(t, {
        placement: N,
        boundary: c,
        rootBoundary: d,
        altBoundary: p,
        padding: u
      }), ye = J ? H ? nt : He : H ? tt : Fe;
      $[X] > k[X] && (ye = no(ye));
      var Se = no(ye), Oe = [];
      if (i && Oe.push(ie[Z] <= 0), a && Oe.push(ie[ye] <= 0, ie[Se] <= 0), Oe.every(function(ue) {
        return ue;
      })) {
        U = N, M = !1;
        break;
      }
      _.set(N, Oe);
    }
    if (M)
      for (var qe = x ? 3 : 1, V = function(te) {
        var Ce = w.find(function(je) {
          var dt = _.get(je);
          if (dt)
            return dt.slice(0, te).every(function(mn) {
              return mn;
            });
        });
        if (Ce)
          return U = Ce, "break";
      }, q = qe; q > 0; q--) {
        var ee = V(q);
        if (ee === "break")
          break;
      }
    t.placement !== U && (t.modifiersData[o]._skip = !0, t.placement = U, t.reset = !0);
  }
}
const Tg = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Mg,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function ws(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function xs(e) {
  return [Fe, nt, tt, He].some(function(t) {
    return e[t] >= 0;
  });
}
function Pg(e) {
  var t = e.state, n = e.name, o = t.rects.reference, r = t.rects.popper, i = t.modifiersData.preventOverflow, s = On(t, {
    elementContext: "reference"
  }), a = On(t, {
    altBoundary: !0
  }), l = ws(s, o), u = ws(a, r, i), c = xs(l), d = xs(u);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const Ig = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Pg
};
function Lg(e, t, n) {
  var o = yt(e), r = [He, Fe].indexOf(o) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, s = i[0], a = i[1];
  return s = s || 0, a = (a || 0) * r, [He, nt].indexOf(o) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function Dg(e) {
  var t = e.state, n = e.options, o = e.name, r = n.offset, i = r === void 0 ? [0, 0] : r, s = Al.reduce(function(c, d) {
    return c[d] = Lg(d, t.rects, i), c;
  }, {}), a = s[t.placement], l = a.x, u = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[o] = s;
}
const Bg = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Dg
};
function zg(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Ll({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const Ng = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: zg,
  data: {}
};
function jg(e) {
  return e === "x" ? "y" : "x";
}
function Vg(e) {
  var t = e.state, n = e.options, o = e.name, r = n.mainAxis, i = r === void 0 ? !0 : r, s = n.altAxis, a = s === void 0 ? !1 : s, l = n.boundary, u = n.rootBoundary, c = n.altBoundary, d = n.padding, p = n.tether, v = p === void 0 ? !0 : p, x = n.tetherOffset, b = x === void 0 ? 0 : x, h = On(t, {
    boundary: l,
    rootBoundary: u,
    padding: d,
    altBoundary: c
  }), S = yt(t.placement), g = cn(t.placement), C = !g, w = di(S), $ = jg(w), k = t.modifiersData.popperOffsets, _ = t.rects.reference, M = t.rects.popper, U = typeof b == "function" ? b(Object.assign({}, t.rects, {
    placement: t.placement
  })) : b, L = typeof U == "number" ? {
    mainAxis: U,
    altAxis: U
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, U), N = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, Z = {
    x: 0,
    y: 0
  };
  if (k) {
    if (i) {
      var H, J = w === "y" ? Fe : He, X = w === "y" ? tt : nt, ie = w === "y" ? "height" : "width", ye = k[w], Se = ye + h[J], Oe = ye - h[X], qe = v ? -M[ie] / 2 : 0, V = g === an ? _[ie] : M[ie], q = g === an ? -M[ie] : -_[ie], ee = t.elements.arrow, ue = v && ee ? ci(ee) : {
        width: 0,
        height: 0
      }, te = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Ml(), Ce = te[J], je = te[X], dt = xn(0, _[ie], ue[ie]), mn = C ? _[ie] / 2 - qe - dt - Ce - L.mainAxis : V - dt - Ce - L.mainAxis, au = C ? -_[ie] / 2 + qe + dt + je + L.mainAxis : q + dt + je + L.mainAxis, Go = t.elements.arrow && Bn(t.elements.arrow), lu = Go ? w === "y" ? Go.clientTop || 0 : Go.clientLeft || 0 : 0, $i = (H = N == null ? void 0 : N[w]) != null ? H : 0, uu = ye + mn - $i - lu, cu = ye + au - $i, Ci = xn(v ? fo(Se, uu) : Se, ye, v ? jt(Oe, cu) : Oe);
      k[w] = Ci, Z[w] = Ci - ye;
    }
    if (a) {
      var Si, du = w === "x" ? Fe : He, pu = w === "x" ? tt : nt, Pt = k[$], zn = $ === "y" ? "height" : "width", ki = Pt + h[du], Ei = Pt - h[pu], Ko = [Fe, He].indexOf(S) !== -1, Oi = (Si = N == null ? void 0 : N[$]) != null ? Si : 0, Ai = Ko ? ki : Pt - _[zn] - M[zn] - Oi + L.altAxis, _i = Ko ? Pt + _[zn] + M[zn] - Oi - L.altAxis : Ei, Ri = v && Ko ? dg(Ai, Pt, _i) : xn(v ? Ai : ki, Pt, v ? _i : Ei);
      k[$] = Ri, Z[$] = Ri - Pt;
    }
    t.modifiersData[o] = Z;
  }
}
const Fg = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Vg,
  requiresIfExists: ["offset"]
};
function Hg(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Ug(e) {
  return e === Ye(e) || !Qe(e) ? pi(e) : Hg(e);
}
function Wg(e) {
  var t = e.getBoundingClientRect(), n = ln(t.width) / e.offsetWidth || 1, o = ln(t.height) / e.offsetHeight || 1;
  return n !== 1 || o !== 1;
}
function qg(e, t, n) {
  n === void 0 && (n = !1);
  var o = Qe(t), r = Qe(t) && Wg(t), i = Tt(t), s = un(e, r, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (o || !o && !n) && ((wt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  hi(i)) && (a = Ug(t)), Qe(t) ? (l = un(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = fi(i))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function Zg(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function r(i) {
    n.add(i.name);
    var s = [].concat(i.requires || [], i.requiresIfExists || []);
    s.forEach(function(a) {
      if (!n.has(a)) {
        var l = t.get(a);
        l && r(l);
      }
    }), o.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || r(i);
  }), o;
}
function Gg(e) {
  var t = Zg(e);
  return ig.reduce(function(n, o) {
    return n.concat(t.filter(function(r) {
      return r.phase === o;
    }));
  }, []);
}
function Kg(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function Yg(e) {
  var t = e.reduce(function(n, o) {
    var r = n[o.name];
    return n[o.name] = r ? Object.assign({}, r, o, {
      options: Object.assign({}, r.options, o.options),
      data: Object.assign({}, r.data, o.data)
    }) : o, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var $s = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Cs() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function Xg(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, o = n === void 0 ? [] : n, r = t.defaultOptions, i = r === void 0 ? $s : r;
  return function(a, l, u) {
    u === void 0 && (u = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, $s, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], p = !1, v = {
      state: c,
      setOptions: function(S) {
        var g = typeof S == "function" ? S(c.options) : S;
        b(), c.options = Object.assign({}, i, c.options, g), c.scrollParents = {
          reference: Wt(a) ? $n(a) : a.contextElement ? $n(a.contextElement) : [],
          popper: $n(l)
        };
        var C = Gg(Yg([].concat(o, c.options.modifiers)));
        return c.orderedModifiers = C.filter(function(w) {
          return w.enabled;
        }), x(), v.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!p) {
          var S = c.elements, g = S.reference, C = S.popper;
          if (Cs(g, C)) {
            c.rects = {
              reference: qg(g, Bn(C), c.options.strategy === "fixed"),
              popper: ci(C)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(L) {
              return c.modifiersData[L.name] = Object.assign({}, L.data);
            });
            for (var w = 0; w < c.orderedModifiers.length; w++) {
              if (c.reset === !0) {
                c.reset = !1, w = -1;
                continue;
              }
              var $ = c.orderedModifiers[w], k = $.fn, _ = $.options, M = _ === void 0 ? {} : _, U = $.name;
              typeof k == "function" && (c = k({
                state: c,
                options: M,
                name: U,
                instance: v
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Kg(function() {
        return new Promise(function(h) {
          v.forceUpdate(), h(c);
        });
      }),
      destroy: function() {
        b(), p = !0;
      }
    };
    if (!Cs(a, l))
      return v;
    v.setOptions(u).then(function(h) {
      !p && u.onFirstUpdate && u.onFirstUpdate(h);
    });
    function x() {
      c.orderedModifiers.forEach(function(h) {
        var S = h.name, g = h.options, C = g === void 0 ? {} : g, w = h.effect;
        if (typeof w == "function") {
          var $ = w({
            state: c,
            name: S,
            instance: v,
            options: C
          }), k = function() {
          };
          d.push($ || k);
        }
      });
    }
    function b() {
      d.forEach(function(h) {
        return h();
      }), d = [];
    }
    return v;
  };
}
var Qg = [xg, Ng, yg, lg, Bg, Tg, Fg, vg, Ig], Jg = /* @__PURE__ */ Xg({
  defaultModifiers: Qg
});
const e1 = z({
  name: "PopperTooltip",
  props: {
    text: {
      type: String,
      default: null
    },
    tooltipPosition: {
      type: String,
      default: "right"
    },
    width: {
      type: String,
      default: "w-56"
    },
    bgColor: {
      type: String,
      default: "bg-gray-600"
    },
    textColor: {
      type: String,
      default: "text-white"
    }
  },
  emits: ["opened", "closed"],
  setup(e) {
    const { show: t, tooltipClasses: n } = Fm(at(e));
    return {
      show: t,
      tooltipClasses: n
    };
  },
  methods: {
    toggleTooltip(e = !1) {
      e ? (this.show = !0, Jg(this.$refs.contentRef, this.$refs.tooltipRef, {
        placement: this.tooltipPosition,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 8]
            }
          }
        ]
      })) : this.show = !1, this.$emit(this.show ? "opened" : "closed");
    }
  }
}), t1 = { class: "flex flex-wrap" }, n1 = { class: "w-full text-center" }, o1 = { key: 0 };
function r1(e, t, n, o, r, i) {
  return f(), y("div", t1, [
    m("div", n1, [
      m("div", {
        ref: "contentRef",
        onMouseenter: t[0] || (t[0] = (s) => e.toggleTooltip(!0)),
        onMouseleave: t[1] || (t[1] = (s) => e.toggleTooltip())
      }, [
        G(e.$slots, "default")
      ], 544),
      m("div", {
        ref: "tooltipRef",
        class: O(e.tooltipClasses)
      }, [
        e.text ? (f(), y("span", o1, R(e.text), 1)) : G(e.$slots, "tooltip-content", { key: 1 })
      ], 2)
    ])
  ]);
}
const Dl = /* @__PURE__ */ Ee(e1, [["render", r1]]), i1 = z({
  components: {
    PlusCircleIcon: g0,
    MagnifyingGlassIcon: Ua,
    Button: rt
  },
  props: {
    search: {
      type: Boolean,
      default: !1
    },
    button: {
      type: Boolean,
      default: !0
    },
    inputPlaceholder: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    btnLabel: {
      type: String,
      default: null
    }
  },
  emits: ["clicked", "search"],
  setup() {
    return {
      handleInputValue: Vt
    };
  }
}), s1 = { class: "mb-6 flex items-center justify-between" }, a1 = { class: "!m-0 text-lg font-bold leading-6 text-gray-900" }, l1 = { class: "flex-end relative flex h-full" }, u1 = {
  key: 0,
  class: "mr-4 w-80"
}, c1 = { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, d1 = ["placeholder"];
function p1(e, t, n, o, r, i) {
  const s = ne("MagnifyingGlassIcon"), a = ne("PlusCircleIcon"), l = ne("Button");
  return f(), y("div", s1, [
    m("h3", a1, R(e.title), 1),
    m("div", l1, [
      e.search ? (f(), y("div", u1, [
        m("div", c1, [
          B(s, {
            class: "h-5 w-5 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        m("input", {
          id: "search",
          name: "search",
          class: "focus:ring-mainColor focus:border-mainColor block h-full w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-3 text-sm placeholder-gray-500 focus:text-gray-900 focus:placeholder-gray-400 focus:outline-none focus:ring-1 sm:text-sm",
          placeholder: e.inputPlaceholder,
          type: "search",
          onInput: t[0] || (t[0] = (u) => e.$emit("search", e.handleInputValue(u)))
        }, null, 40, d1)
      ])) : P("", !0),
      e.button ? (f(), j(l, {
        key: 1,
        onClick: t[1] || (t[1] = (u) => e.$emit("clicked"))
      }, {
        default: F(() => [
          B(a, {
            class: "-ml-1 mr-2 h-5 w-5",
            "aria-hidden": "true"
          }),
          ce(" " + R(e.btnLabel), 1)
        ]),
        _: 1
      })) : P("", !0)
    ])
  ]);
}
const r7 = /* @__PURE__ */ Ee(i1, [["render", p1]]);
function f1({ tabs: e, crumbsTitle: t }) {
  return {
    crumbs: E(() => {
      const o = [];
      return e.value.forEach((r) => {
        o.push({
          name: r.name,
          href: r.href
        });
      }), t.value && o.push({
        name: t.value
      }), o;
    })
  };
}
const h1 = z({
  name: "Breadcrumb",
  components: {
    HomeIcon: Vu
  },
  props: {
    title: {
      type: String,
      default: null
    },
    homeLink: {
      type: String,
      default: "/"
    },
    tabs: {
      type: Array,
      required: !0
    },
    crumbsTitle: {
      type: String,
      default: null
    }
  },
  setup(e) {
    const { crumbs: t } = f1(at(e));
    return {
      crumbs: t
    };
  }
}), v1 = { class: "mx-auto max-w-7xl" }, m1 = {
  key: 0,
  class: "flex",
  "aria-label": "Breadcrumb"
}, g1 = { class: "flex list-none items-center space-x-4" }, b1 = ["href"], y1 = /* @__PURE__ */ m("span", { class: "sr-only" }, "Home", -1), w1 = { class: "flex items-center" }, x1 = /* @__PURE__ */ m("svg", {
  class: "h-5 w-5 flex-shrink-0 text-gray-300",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20",
  "aria-hidden": "true"
}, [
  /* @__PURE__ */ m("path", { d: "M5.555 17.776l8-16 .894.448-8 16-.894-.448z" })
], -1), $1 = ["href"], C1 = {
  key: 1,
  class: "ml-4 text-sm font-medium hover:text-gray-700"
};
function S1(e, t, n, o, r, i) {
  const s = ne("HomeIcon");
  return f(), y("div", null, [
    m("div", v1, [
      e.crumbs ? (f(), y("nav", m1, [
        m("ul", g1, [
          m("li", null, [
            m("div", null, [
              m("a", {
                href: e.homeLink,
                class: "text-gray-400 hover:text-gray-500"
              }, [
                B(s, { class: "h-5 w-5" }),
                y1
              ], 8, b1)
            ])
          ]),
          (f(!0), y(K, null, se(e.crumbs, (a, l) => (f(), y("li", { key: l }, [
            m("div", w1, [
              x1,
              a.href ? (f(), y("a", {
                key: 0,
                href: a.href,
                class: "ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              }, R(a.name), 9, $1)) : (f(), y("span", C1, R(a.name), 1))
            ])
          ]))), 128))
        ])
      ])) : P("", !0)
    ])
  ]);
}
const i7 = /* @__PURE__ */ Ee(h1, [["render", S1]]);
function k1({ tabs: e, tabClasses: t }, {
  emit: n
}) {
  return {
    tabClass: (i, s) => {
      const a = [];
      return s ? a.push("border-transparent !text-gray-400 cursor-default") : i ? a.push(
        `font-bold ${W({ type: "border", value: "800" })} ${W({ type: "text", value: "800" })}`
      ) : a.push("border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"), t.value && a.push(t.value), a;
    },
    handleNav: (i) => {
      if (!i.disabled) {
        const s = e.value.filter((a) => a.current === !0);
        s[0].current = !1, i.current = !0, n("tabClicked", i);
      }
    }
  };
}
const E1 = z({
  name: "Tab",
  components: {
    ArrowLongRightIcon: Zs,
    CalculatorIcon: Pu,
    CogIcon: Bu,
    EnvelopeIcon: zu,
    AdjustmentsVerticalIcon: _u,
    GiftIcon: ju,
    EyeIcon: Ks,
    PlusIcon: Zu,
    ClipboardIcon: Du,
    XMarkIcon: bt,
    ArrowTopRightOnSquareIcon: Mu,
    BoltIcon: Tu,
    InformationCircleIcon: Fu,
    XCircleIcon: Ku
  },
  props: {
    tabs: {
      type: Array,
      required: !0
    },
    tabClasses: {
      type: String,
      default: ""
    }
  },
  emits: {
    tabClicked(e) {
      return e;
    }
  },
  setup(e, t) {
    const { handleNav: n, tabClass: o } = k1(at(e), t);
    return {
      getColorClass: W,
      tabClass: o,
      handleInputValue: Vt,
      tabClicked: (i) => {
        const s = Vt(i), a = e.tabs.find((l) => l.name === s);
        t.emit("tabClicked", a);
      },
      handleNav: n
    };
  }
}), O1 = { class: "no-scrollbar block overflow-auto" }, A1 = {
  class: "flex space-x-6 sm:space-x-8",
  "aria-label": "Tabs"
}, _1 = ["href", "disabled", "onClick"];
function R1(e, t, n, o, r, i) {
  return f(), y("div", O1, [
    m("nav", A1, [
      (f(!0), y(K, null, se(e.tabs, (s) => (f(), y("a", {
        key: s.name,
        href: s.href,
        class: O(["whitespace-nowrap border-b-2 px-1 py-2 text-sm font-medium text-gray-700 sm:py-4", e.tabClass(s.current, s.disabled)]),
        disabled: s.disabled,
        onClick: (a) => e.handleNav(s)
      }, [
        (f(), j(Le(s.icon), {
          class: O(["inline", [
            "-ml-0.5 mr-2 inline h-5 w-5",
            s.current ? `${e.getColorClass({ type: "text", value: "800" })}` : "text-gray-700 group-hover:text-gray-800"
          ]])
        }, null, 8, ["class"])),
        m("span", null, R(s.name), 1)
      ], 10, _1))), 128))
    ])
  ]);
}
const s7 = /* @__PURE__ */ Ee(E1, [["render", R1]]), M1 = z({
  name: "Headline",
  props: {
    title: {
      type: String,
      required: !0
    },
    subtitle: {
      type: String,
      default: null
    },
    hasIconLeft: {
      type: Boolean,
      default: !0
    },
    hasIconRight: {
      type: Boolean,
      default: !1
    }
  },
  setup() {
    return {
      getColorClass: W
    };
  }
}), T1 = { class: "flex flex-col" }, P1 = { class: "flex items-center justify-center sm:justify-start" }, I1 = { class: "text-lg font-semibold text-gray-700" }, L1 = {
  key: 1,
  class: "ml-2"
}, D1 = {
  key: 0,
  class: "mt-1 text-center text-sm font-light text-gray-400 sm:text-left"
};
function B1(e, t, n, o, r, i) {
  return f(), y("div", T1, [
    m("div", P1, [
      e.hasIconLeft ? (f(), y("span", {
        key: 0,
        class: O(`mr-2 h-6 w-6 p-1 text-white ${e.getColorClass({
          type: "bg",
          value: "800"
        })} rounded`)
      }, [
        G(e.$slots, "icon-left")
      ], 2)) : P("", !0),
      m("h3", I1, R(e.title), 1),
      e.hasIconRight ? (f(), y("span", L1, [
        G(e.$slots, "icon-right")
      ])) : P("", !0)
    ]),
    e.subtitle ? (f(), y("p", D1, R(e.subtitle), 1)) : P("", !0)
  ]);
}
const a7 = /* @__PURE__ */ Ee(M1, [["render", B1]]);
function z1() {
  return {
    getRank: (t) => {
      const n = "🥉", o = t < 2 ? "🥇" : "🥈";
      return t > 2 ? n : o;
    }
  };
}
const N1 = z({
  name: "Album",
  components: {
    ArrowLongRightIcon: Zs,
    PlusCircleIcon: qu
  },
  props: {
    title: {
      type: String,
      required: !0
    },
    subtitle: {
      type: String,
      default: ""
    },
    leftLegend: {
      type: String,
      default: ""
    },
    leftValue: {
      type: [Number, String],
      default: ""
    },
    rightLegend: {
      type: String,
      default: ""
    },
    rightValue: {
      type: [Number, String],
      default: ""
    },
    ranking: {
      type: Array,
      default: () => []
    },
    link: {
      type: String,
      default: ""
    },
    noData: {
      type: Boolean,
      default: !1
    },
    background: {
      type: String,
      default: ""
    },
    backgroundPattern: {
      type: String,
      default: ""
    },
    backgroundIcon: {
      type: String,
      default: ""
    },
    truncate: {
      type: Boolean,
      default: !1
    },
    backgroundGradient: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  setup(e, t) {
    const { getRank: n } = z1(), o = !!t.slots["custom-subtitle"];
    return {
      getRank: n,
      hasCustomSubtitle: o,
      getColorClass: W
    };
  }
}), j1 = {
  key: 0,
  class: "flex h-56 flex-col justify-between rounded-md bg-white shadow"
}, V1 = ["src"], F1 = ["src"], H1 = { class: "px-3 py-3 md:h-24 md:px-6" }, U1 = { class: "font-semibold xl:text-lg" }, W1 = {
  key: 0,
  class: "mb-4 h-14 text-gray-800"
}, q1 = { class: "flex items-center justify-end text-gray-500" }, Z1 = { class: "p-3 pb-0 text-gray-700 md:p-6 md:pb-0" }, G1 = { class: "font-semibold xl:text-lg" }, K1 = { key: 1 }, Y1 = {
  key: 0,
  class: "flex flex-col justify-center md:h-28"
}, X1 = { class: "flex items-center md:w-3/4" }, Q1 = { class: "mr-2 w-4" }, J1 = { class: "... overflow-hidden truncate whitespace-nowrap text-sm xl:text-base" }, eb = { class: "text-sm uppercase text-gray-600" }, tb = {
  key: 0,
  class: "border-l border-gray-300"
}, nb = { class: "text-sm uppercase text-gray-600" }, ob = { class: "flex items-center justify-end text-gray-500" };
function rb(e, t, n, o, r, i) {
  const s = ne("PlusCircleIcon"), a = ne("ArrowLongRightIcon");
  return e.noData ? (f(), y("div", j1, [
    m("div", {
      class: O(["flex justify-between rounded-t-md object-cover", e.backgroundGradient]),
      style: De(e.background && `background-image: url(${e.background})`)
    }, [
      m("img", {
        class: "h-auto w-1/2 object-cover",
        src: e.backgroundPattern
      }, null, 8, V1),
      m("img", {
        class: "my-2 mr-4 h-20 w-auto",
        src: e.backgroundIcon
      }, null, 8, F1)
    ], 6),
    m("div", H1, [
      m("h4", U1, R(e.title), 1),
      e.subtitle ? (f(), y("p", W1, R(e.subtitle), 1)) : P("", !0)
    ]),
    m("div", {
      class: O(`${e.getColorClass({ type: "bg", value: "50" })} cursor-pointer rounded-b-md px-2 shadow`),
      onClick: t[1] || (t[1] = (l) => e.$emit("click"))
    }, [
      m("div", q1, [
        m("span", {
          class: "mr-2 origin-left transform cursor-pointer border-b border-transparent text-xs leading-8 transition hover:-translate-x-1 hover:scale-105 hover:border-gray-500",
          onClick: t[0] || (t[0] = (l) => e.$emit("click"))
        }, R(e.link), 1),
        B(s, { class: "h-4 w-4 leading-8" })
      ])
    ], 2)
  ])) : (f(), y("div", {
    key: 1,
    class: O(["flex flex-col justify-between rounded-md bg-white shadow", e.ranking.length > 0 ? "h-70 md:h-56" : "h-56"])
  }, [
    m("div", Z1, [
      m("h4", G1, R(e.title), 1),
      e.subtitle ? (f(), y("p", {
        key: 0,
        class: O(["text-gray-800 underline", e.truncate ? "... max-w-xs overflow-hidden truncate whitespace-nowrap" : ""])
      }, R(e.subtitle), 3)) : P("", !0),
      e.hasCustomSubtitle ? (f(), y("span", K1, [
        G(e.$slots, "custom-subtitle")
      ])) : P("", !0)
    ]),
    e.ranking.length > 0 ? (f(), y("div", Y1, [
      (f(!0), y(K, null, se(e.ranking, (l, u) => (f(), y("div", {
        key: u,
        class: O(["mx-2 flex flex-col items-center justify-between p-1 md:mx-6 md:flex-row", u !== e.ranking.length - 1 ? "border-b border-gray-200" : ""])
      }, [
        m("div", X1, [
          m("p", Q1, R(e.getRank(l.rank)), 1),
          m("p", J1, R(l.name), 1)
        ]),
        m("span", {
          class: O(`text-lg ${e.getColorClass({ type: "text", value: "800" })} font-bold`)
        }, R(l.count), 3)
      ], 2))), 128))
    ])) : (f(), y("div", {
      key: 1,
      class: O(["flex px-3 text-center md:px-5", [e.rightLegend ? "justify-around" : "justify-center", e.subtitle ? "" : "mt-6"]])
    }, [
      m("div", null, [
        m("p", eb, R(e.leftLegend), 1),
        m("span", {
          class: O(`${e.getColorClass({ type: "text", value: "800" })} text-4xl font-bold`)
        }, R(e.leftValue), 3)
      ]),
      e.rightLegend ? (f(), y("div", tb)) : P("", !0),
      m("div", null, [
        m("p", nb, R(e.rightLegend), 1),
        m("span", {
          class: O(`${e.getColorClass({ type: "text", value: "800" })} text-4xl font-bold`)
        }, R(e.rightValue), 3)
      ])
    ], 2)),
    m("div", {
      class: O(`${e.getColorClass({ type: "bg", value: "50" })} cursor-pointer rounded-b-md px-2`),
      onClick: t[3] || (t[3] = (l) => e.$emit("click"))
    }, [
      m("div", ob, [
        m("span", {
          class: "mr-2 origin-left transform cursor-pointer border-b border-transparent text-xs leading-8 transition hover:-translate-x-1 hover:scale-105 hover:border-gray-500",
          onClick: t[2] || (t[2] = (l) => e.$emit("click"))
        }, R(e.link), 1),
        B(a, { class: "h-4 w-4 leading-8" })
      ])
    ], 2)
  ], 2));
}
const l7 = /* @__PURE__ */ Ee(N1, [["render", rb]]), ib = z({
  components: {
    Popover: Gr,
    PopoverButton: Ta,
    PopoverPanel: Pa
  },
  props: {
    title: {
      type: String,
      default: null
    },
    panelClasses: {
      type: String,
      default: ""
    }
  },
  setup(e, t) {
    const n = !!t.slots.content, o = !!t.slots.submitButton;
    return {
      getColorClass: W,
      hasCustomContent: n,
      hasSubmitButton: o
    };
  }
}), sb = {
  key: 1,
  class: "min-w-md overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5"
}, ab = { class: "bg-red-500 px-6 py-3 text-center" }, lb = { class: "flex items-center justify-center text-white" }, ub = { class: "font-medium" }, cb = { class: "bg-white px-6 py-3 text-center" };
function db(e, t, n, o, r, i) {
  const s = ne("PopoverButton"), a = ne("PopoverPanel"), l = ne("Popover", !0);
  return f(), j(l, { class: "relative" }, {
    default: F(() => [
      B(s, { class: "flex" }, {
        default: F(() => [
          G(e.$slots, "button")
        ]),
        _: 3
      }),
      B(Gt, {
        "enter-active-class": "transition duration-200 ease-out",
        "enter-from-class": "translate-y-1 opacity-0",
        "enter-to-class": "translate-y-0 opacity-100",
        "leave-active-class": "transition duration-150 ease-in",
        "leave-from-class": "translate-y-0 opacity-100",
        "leave-to-class": "translate-y-1 opacity-0"
      }, {
        default: F(() => [
          B(a, {
            class: O(["absolute -left-36 z-50 mt-2 w-80", e.panelClasses])
          }, {
            default: F(() => [
              m("div", null, [
                e.hasCustomContent ? G(e.$slots, "content", { key: 0 }) : (f(), y("div", sb, [
                  m("div", ab, [
                    m("div", lb, [
                      G(e.$slots, "button"),
                      m("h2", ub, R(e.title), 1)
                    ])
                  ]),
                  m("div", cb, [
                    G(e.$slots, "default")
                  ])
                ]))
              ]),
              e.hasSubmitButton ? (f(), j(s, {
                key: 0,
                class: O(`flex w-full justify-center p-2 font-medium ${e.getColorClass({ type: "text", value: "800" })} ${e.getColorClass(
                  {
                    type: "text",
                    value: "600",
                    prefix: "hover"
                  }
                )} rounded-md bg-white`)
              }, {
                default: F(() => [
                  G(e.$slots, "submitButton")
                ]),
                _: 3
              }, 8, ["class"])) : P("", !0)
            ]),
            _: 3
          }, 8, ["class"])
        ]),
        _: 3
      })
    ]),
    _: 3
  });
}
const u7 = /* @__PURE__ */ Ee(ib, [["render", db]]), pb = { class: "h-2.5 w-full rounded-full bg-gray-200 dark:bg-gray-700" }, fb = { class: "flex" }, hb = { class: "-ml-3 mt-1 text-base font-medium" }, c7 = /* @__PURE__ */ z({
  __name: "ProgressBar",
  props: {
    percent: {},
    variant: { default: null }
  },
  setup(e) {
    return (t, n) => (f(), y("div", pb, [
      m("div", {
        class: O(`${T(W)({
          type: "bg",
          value: "500",
          variant: t.variant
        })} h-2.5 rounded-full`),
        style: De(`width: ${t.percent}%`)
      }, null, 6),
      m("div", fb, [
        m("div", {
          style: De(`width: ${t.percent - 3}%`)
        }, null, 4),
        m("div", hb, R(t.percent) + " %", 1)
      ])
    ]));
  }
});
function vb() {
  const e = A(gt.getters["notification/get"]);
  return {
    closeNotificationModal: () => {
      e.value = null;
    },
    subscribe: () => {
      gt.subscribe((r) => {
        (r.type === "notification/add" || r.type === "notification/clear") && (e.value = gt.getters["notification/get"]);
      });
    },
    notification: e,
    create: (r, i) => {
      gt.dispatch(`notification/${r}`, i);
    }
  };
}
const mb = z({
  name: "Notification",
  components: {
    CheckCircleIcon: h0,
    XMarkIcon: bt,
    XCircleIcon: Wa
  },
  setup() {
    const { subscribe: e, closeNotificationModal: t, notification: n } = vb();
    return e(), {
      getColorClass: W,
      closeNotificationModal: t,
      notification: n
    };
  }
}), gb = {
  key: 0,
  class: "pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5"
}, bb = { class: "p-4" }, yb = { class: "flex items-center" }, wb = { class: "flex-shrink-0" }, xb = { class: "ml-3 w-0 flex-1" }, $b = { class: "text-sm text-gray-500" }, Cb = { class: "ml-4 flex flex-shrink-0" }, Sb = /* @__PURE__ */ m("span", { class: "sr-only" }, "Close", -1);
function kb(e, t, n, o, r, i) {
  const s = ne("CheckCircleIcon"), a = ne("XCircleIcon"), l = ne("XMarkIcon");
  return f(), j(jr, { to: "body" }, [
    e.notification !== null ? (f(), y("div", {
      key: 0,
      "aria-live": "assertive",
      class: O(["pointer-events-none fixed inset-0 z-50 flex justify-center px-4 py-6 sm:justify-end sm:p-6", e.notification.isBottom === !1 ? "items-start" : "items-end sm:items-start"])
    }, [
      B(Gt, {
        "enter-active-class": "transform ease-out duration-300 transition",
        "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
        "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
        "leave-active-class": "transition ease-in duration-100",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: F(() => [
          e.notification !== null ? (f(), y("div", gb, [
            m("div", bb, [
              m("div", yb, [
                m("div", wb, [
                  e.notification.type === "success" ? (f(), j(s, {
                    key: 0,
                    class: "h-6 w-6 text-green-400",
                    "aria-hidden": "true"
                  })) : P("", !0),
                  e.notification.type === "error" ? (f(), j(a, {
                    key: 1,
                    class: "h-6 w-6 text-red-400",
                    "aria-hidden": "true"
                  })) : P("", !0)
                ]),
                m("div", xb, [
                  m("p", $b, R(e.notification.text), 1)
                ]),
                m("div", Cb, [
                  m("button", {
                    class: O(`inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 ${e.getColorClass({ type: "ring", value: "800", prefix: "focus" })}`),
                    onClick: t[0] || (t[0] = (...u) => e.closeNotificationModal && e.closeNotificationModal(...u))
                  }, [
                    Sb,
                    B(l, {
                      class: "h-5 w-5",
                      "aria-hidden": "true"
                    })
                  ], 2)
                ])
              ])
            ])
          ])) : P("", !0)
        ]),
        _: 1
      })
    ], 2)) : P("", !0)
  ]);
}
const Eb = /* @__PURE__ */ Ee(mb, [["render", kb]]), Ob = { class: "text-sm md:text-base" }, Ab = {
  key: 0,
  class: "flex items-center"
}, d7 = /* @__PURE__ */ z({
  __name: "Tip",
  props: {
    color: { default: "green" },
    title: { default: "" },
    subtitle: { default: "" },
    description: { default: "" },
    showCloseIcon: { type: Boolean, default: !0 },
    showIconBackground: { type: Boolean, default: !0 },
    containerClass: { default: "" },
    textClass: { default: "" },
    size: { default: "medium" }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = Kt().icon, s = E(() => ({
      lighterBg: `bg-${n.color}-100`,
      lightBg: `bg-${n.color}-100`,
      bg: `bg-${n.color}-200`,
      border: `border-${n.color}-400`,
      text: `text-${n.color}-400`,
      subtitle: `text-${n.color}-600`,
      title: `text-${n.color}-700`
    }));
    return (a, l) => (f(), y("div", Ob, [
      m("div", {
        class: O([
          "relative rounded-l border-l-4",
          s.value.lighterBg,
          s.value.border,
          a.containerClass,
          {
            "p-2": a.size === "small",
            "p-4": a.size === "medium"
          }
        ])
      }, [
        a.showCloseIcon ? (f(), j(T(bt), {
          key: 0,
          class: "absolute right-4 top-4 h-6 w-6 cursor-pointer hover:text-gray-700",
          "aria-hidden": "true",
          onClick: l[0] || (l[0] = (u) => o("close"))
        })) : P("", !0),
        m("div", {
          class: O([
            "flex flex-col md:flex-row",
            {
              "md:gap-2": a.size === "small",
              "md:gap-4": a.size === "medium"
            }
          ])
        }, [
          T(i) ? (f(), y("div", Ab, [
            m("div", {
              class: O(["flex h-8 w-8 items-center justify-center rounded-full p-1", s.value.lightBg])
            }, [
              m("span", {
                class: O(["h-8 w-8 rounded-full", s.value.subtitle, a.showIconBackground ? s.value.bg : ""])
              }, [
                G(a.$slots, "icon")
              ], 2)
            ], 2)
          ])) : P("", !0),
          m("div", {
            class: O(["flex w-full flex-col items-start justify-center", a.textClass])
          }, [
            a.title ? (f(), y("p", {
              key: 0,
              class: O(["text-lg font-bold", s.value.title])
            }, R(a.title), 3)) : P("", !0),
            a.subtitle ? (f(), y("p", {
              key: 1,
              class: O(s.value.subtitle)
            }, R(a.subtitle), 3)) : P("", !0),
            a.description ? (f(), y("p", {
              key: 2,
              class: O(["pb-2 text-gray-400", s.value.text])
            }, R(a.description), 3)) : P("", !0),
            G(a.$slots, "default")
          ], 2)
        ], 2)
      ], 2)
    ]));
  }
}), _b = ["disabled"], Rb = {
  key: 0,
  class: "flex h-full cursor-pointer items-center justify-center focus:outline-none"
}, Mb = ["src"], Tb = {
  key: 0,
  class: "absolute right-4 top-4 block aspect-square h-5 rounded-full border border-gray-200"
}, Pb = {
  key: 1,
  class: "flex h-full items-center space-x-3"
}, Ib = ["src"], Lb = { class: "flex h-full flex-col" }, Db = {
  key: 0,
  class: "absolute right-4 block aspect-square h-5 rounded-full border border-gray-200"
}, Bb = { class: "space-y-1.5" }, p7 = /* @__PURE__ */ z({
  __name: "RadioGroup",
  props: {
    radioValues: {},
    modelValue: {},
    isOnlyImage: { type: Boolean, default: !1 },
    showUnselectedRadioBox: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = E({
      get() {
        return n.modelValue;
      },
      set(i) {
        o("update:modelValue", i);
      }
    });
    return (i, s) => (f(), j(T(ld), {
      modelValue: r.value,
      "onUpdate:modelValue": s[0] || (s[0] = (a) => r.value = a),
      "radio-values": []
    }, {
      default: F(() => [
        (f(!0), y(K, null, se(n.radioValues, (a, l) => (f(), j(T(cd), {
          key: a.id,
          as: "template",
          value: a
        }, {
          default: F(({ active: u, checked: c }) => [
            m("div", {
              class: O(["relative border-2 !p-4", [
                u && T(W)({ type: "border", value: "800" }) + T(W)({ type: "ring", value: "800", prefix: "focus" }),
                !c && "border-gray-100",
                "relative flex flex-col items-stretch rounded-lg border bg-white p-4",
                !a.disabled && `cursor-pointer ${T(W)({
                  type: "border",
                  value: "800",
                  prefix: "hover"
                })} focus:outline-none`,
                c ? T(W)({ type: "border", value: "800" }) : "border-gray-100",
                a.disabled && "opacity-60 hover:cursor-default hover:bg-none"
              ]]),
              disabled: a.disabled
            }, [
              i.isOnlyImage ? (f(), y("div", Rb, [
                (f(), j(Le(a.icon), {
                  class: O([a.color ?? "text-black", "h-10 w-10"])
                }, null, 8, ["class"])),
                a.img ? (f(), y("img", {
                  key: 0,
                  src: a.img,
                  alt: "",
                  class: "h-20 w-1/2 max-w-none object-contain"
                }, null, 8, Mb)) : P("", !0),
                m("div", {
                  class: O([T(W)({ type: "text", value: "800" })])
                }, [
                  !c && i.showUnselectedRadioBox ? (f(), y("span", Tb)) : P("", !0),
                  c ? (f(), j(T(Ii), {
                    key: 1,
                    class: O(["absolute right-3.5 top-3.5 aspect-square h-6", [T(W)({ type: "text", value: "800" })]])
                  }, null, 8, ["class"])) : P("", !0)
                ], 2)
              ])) : (f(), y("div", Pb, [
                (f(), j(Le(a.icon), {
                  class: O([a.color ?? "text-black", "aspect-square h-9 min-w-fit"])
                }, null, 8, ["class"])),
                a.img ? (f(), y("img", {
                  key: 0,
                  src: a.img,
                  alt: "",
                  class: "h-9 w-9 max-w-none object-cover"
                }, null, 8, Ib)) : P("", !0),
                m("div", Lb, [
                  !c && i.showUnselectedRadioBox ? (f(), y("span", Db)) : P("", !0),
                  c ? (f(), j(T(Ii), {
                    key: 1,
                    class: O(["absolute right-3.5 top-3.5 aspect-square h-6", [T(W)({ type: "text", value: "800" })]])
                  }, null, 8, ["class"])) : P("", !0),
                  m("div", {
                    class: O([T(W)({ type: "text", value: "800" })])
                  }, [
                    m("div", Bb, [
                      a.title ? (f(), j(T(dd), {
                        key: 0,
                        as: "span",
                        class: "block text-sm font-medium text-gray-900"
                      }, {
                        default: F(() => [
                          ce(R(a.title), 1)
                        ]),
                        _: 2
                      }, 1024)) : P("", !0),
                      a.description ? (f(), j(T(pd), {
                        key: 1,
                        as: "span",
                        class: "flex items-center text-xs text-gray-500"
                      }, {
                        default: F(() => [
                          ce(R(a.description), 1)
                        ]),
                        _: 2
                      }, 1024)) : P("", !0)
                    ]),
                    G(i.$slots, l)
                  ], 2)
                ])
              ]))
            ], 10, _b)
          ]),
          _: 2
        }, 1032, ["value"]))), 128))
      ]),
      _: 3
    }, 8, ["modelValue"]));
  }
}), zb = { class: "my-6 grid w-max grid-cols-1 items-center rounded-md border-2 border-zinc-100 bg-white p-1" }, Nb = { class: "relative" }, jb = { class: "relative z-10 flex gap-1" }, Vb = { class: "absolute top-0 aspect-square w-12 cursor-pointer rounded-md" }, f7 = /* @__PURE__ */ z({
  __name: "Selector",
  props: {
    selectedItem: {}
  },
  setup(e) {
    const t = e;
    return (n, o) => (f(), y("div", zb, [
      m("div", Nb, [
        m("div", jb, [
          G(n.$slots, "default")
        ]),
        m("div", Vb, [
          m("span", {
            class: "transition-medium hidden h-full w-full rounded-md bg-zinc-100 transition-transform ease-out sm:block",
            style: De({ transform: `translateX(calc(100% * ${t.selectedItem} + 4px * ${t.selectedItem}))` })
          }, null, 4)
        ])
      ])
    ]));
  }
}), h7 = /* @__PURE__ */ z({
  __name: "SelectorItem",
  props: {
    value: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = e;
    return (n, o) => (f(), y("div", {
      class: O([t.value !== t.modelValue ? "hover:bg-zinc-50" : "bg-zinc-100 sm:bg-transparent", "p-1/2 flex aspect-square w-12 cursor-pointer flex-col items-center justify-center rounded-md"]),
      onClick: o[0] || (o[0] = (r) => n.$emit("update:modelValue", t.value))
    }, [
      G(n.$slots, "default")
    ], 2));
  }
}), Fb = /* @__PURE__ */ m("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1), Hb = /* @__PURE__ */ m("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1), Ub = [
  Fb,
  Hb
], v7 = /* @__PURE__ */ z({
  __name: "Spinner",
  props: {
    width: { default: "h-4" },
    height: { default: "w-4" }
  },
  setup(e) {
    const t = e;
    return (n, o) => (f(), y("svg", {
      class: O(["m-auto animate-spin text-gray-600", [t.width, t.height]]),
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24"
    }, Ub, 2));
  }
}), Wb = {
  key: 1,
  class: "flex flex-col"
}, qb = { class: "flex items-center gap-2" }, Zb = { class: "font-medium text-gray-800" }, Gb = {
  key: 0,
  id: "disclosureSubtitle",
  class: "text-sm font-normal text-gray-600"
}, Kb = /* @__PURE__ */ z({
  __name: "Disclosure",
  props: {
    icon: { type: [Function, Object], default: null },
    iconColor: { default: "" },
    id: { default: null },
    isDefaultOpen: { type: Boolean, default: !1 },
    hasBorder: { type: Boolean, default: !0 },
    hasShadow: { type: Boolean, default: !0 },
    hasThemeColor: { type: Boolean, default: !1 },
    subtitle: { default: "" },
    title: { default: "" },
    titlePaddings: { default: "px-2 py-4 md:px-8" },
    titleBgColor: { default: "" }
  },
  setup(e) {
    const t = e, o = !!Kt().title, r = ge("openedId", A(null)), i = ge("isGroup", A(!1)), s = ge("setOpenedId", () => {
    }), a = A(!1);
    $e(() => {
      a.value = (r == null ? void 0 : r.value) === t.id;
    });
    const l = (b) => {
      const h = [];
      return t.hasBorder && h.push("border"), t.hasShadow && b && h.push("shadow-sm"), b ? (t.hasThemeColor ? h.push("border", W({ type: "bg", value: "50" }), W({ type: "border", value: "200" })) : h.push("bg-white"), h) : (h.push("shadow-none bg-white"), h);
    }, u = (b) => {
      const h = [t.titlePaddings];
      return b && t.hasBorder && h.push("border-b"), t.titleBgColor && (h.push(t.titleBgColor), h.push(b ? "rounded-t-md" : "rounded-md")), h;
    }, c = (b) => {
      if (b) {
        s(null), a.value = !1;
        return;
      }
      a.value = !a.value, s(t.id);
    }, d = A(null), p = (b) => {
      const h = b;
      h.style.height = "0", h.offsetHeight, h.style.height = `${h.scrollHeight}px`;
    }, v = (b) => {
      const h = b;
      h.style.height = `${h.scrollHeight}px`, h.offsetHeight, h.style.height = "0";
    }, x = (b) => {
      const h = b;
      h.style.height = "auto";
    };
    return (b, h) => (f(), j(T(Yc), {
      key: t.isDefaultOpen.toString(),
      "default-open": t.isDefaultOpen
    }, {
      default: F(({ open: S }) => [
        m("div", {
          class: O(["rounded-md", l(T(i) ? a.value : S)])
        }, [
          B(T(Xc), {
            as: "div",
            class: O(["cursor-pointer items-center text-sm font-medium text-gray-700 focus:outline-none", t.hasBorder && "focus-visible:ring focus-visible:ring-opacity-75"]),
            onClick: (g) => c(T(i) ? a.value : S)
          }, {
            default: F(() => [
              m("div", {
                class: O(["flex w-full items-center justify-between", u(T(i) ? a.value : S)])
              }, [
                o ? G(b.$slots, "title", { key: 0 }, void 0, !0) : (f(), y("div", Wb, [
                  m("div", qb, [
                    t.icon ? (f(), y("span", {
                      key: 0,
                      class: "text-md mr-2 rounded-full px-1 py-1",
                      style: De(`color: ${t.iconColor}; background-color: ${t.iconColor}4f;`)
                    }, [
                      (f(), j(Le(t.icon), {
                        class: "h-6 w-6",
                        "aria-hidden": "true"
                      }))
                    ], 4)) : P("", !0),
                    m("h2", Zb, R(t.title), 1)
                  ]),
                  t.subtitle ? (f(), y("p", Gb, R(t.subtitle), 1)) : P("", !0)
                ])),
                B(T(Lu), {
                  class: O([(T(i) ? S : a.value) && "rotate-180", "h-5 w-5 duration-200"])
                }, null, 8, ["class"])
              ], 2)
            ]),
            _: 2
          }, 1032, ["class", "onClick"]),
          B(Gt, {
            onEnter: p,
            onLeave: v,
            onAfterEnter: x
          }, {
            default: F(() => [
              ze(m("div", {
                ref_key: "content",
                ref: d
              }, [
                G(b.$slots, "default", {}, void 0, !0)
              ], 512), [
                [At, T(i) ? a.value : S]
              ])
            ]),
            _: 2
          }, 1024)
        ], 2)
      ]),
      _: 3
    }, 8, ["default-open"]));
  }
});
const m7 = /* @__PURE__ */ Ee(Kb, [["__scopeId", "data-v-227182a5"]]), Yb = { class: "px-3 py-3 md:h-24 md:px-6" }, Xb = {
  key: 1,
  class: "mb-4 text-sm text-gray-800"
}, g7 = /* @__PURE__ */ z({
  __name: "Title",
  props: {
    title: { default: "" },
    subtitle: { default: "" },
    fontSize: { default: "lg" },
    fontWeight: { default: "semibold" }
  },
  setup(e) {
    return (t, n) => (f(), y("div", Yb, [
      t.title ? (f(), y("h3", {
        key: 0,
        class: O(`text-${t.fontSize} font-${t.fontWeight} `)
      }, R(t.title), 3)) : P("", !0),
      t.subtitle ? (f(), y("p", Xb, R(t.subtitle), 1)) : P("", !0),
      G(t.$slots, "default")
    ]));
  }
}), Qb = ["value"], Jb = /* @__PURE__ */ z({
  __name: "SingleNumberInput",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = t, o = (r) => {
      const i = r.target, s = i == null ? void 0 : i.value;
      if (!/[0-9]/.test(s)) {
        i.value = "";
        return;
      }
      if (s.length > 1) {
        i.value = s.slice(0, 1);
        return;
      }
      n("update:modelValue", i == null ? void 0 : i.value);
    };
    return (r, i) => (f(), y("input", {
      value: r.modelValue,
      type: "text",
      pattern: "[0-9]*",
      min: "0",
      max: "9",
      maxlength: "6",
      inputmode: "numeric",
      autocomplete: "one-time-code",
      required: "",
      class: O(["focus:border-ring-500 block h-12 w-12 appearance-none rounded-xl border-transparent bg-gray-100 text-center text-2xl shadow-sm", `${T(W)({ type: "ring", value: "800", prefix: "focus" })}`]),
      onInput: o
    }, null, 42, Qb));
  }
}), ey = { class: "flex gap-x-2 font-semibold" }, b7 = /* @__PURE__ */ z({
  __name: "CodeValidator",
  props: {
    modelValue: {},
    confirmationLength: { default: 6 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, o = A(0), r = A([]), s = sn(n, "modelValue", t), a = () => {
      o.value = -1;
    }, l = (g) => {
      o.value = g;
    }, u = (g) => {
      o.value = Math.max(Math.min(n.confirmationLength - 1, g), 0);
    }, c = () => {
      u(o.value + 1);
    }, d = () => {
      u(o.value - 1);
    }, p = (g) => {
      switch (g.key) {
        case "Backspace":
          g.preventDefault(), x(""), d();
          break;
        case "Delete":
          g.preventDefault(), x("");
          break;
        case "ArrowLeft":
          g.preventDefault(), d();
          break;
        case "ArrowRight":
          g.preventDefault(), c();
          break;
      }
    }, v = (g) => {
      var U;
      const C = ((U = g == null ? void 0 : g.clipboardData) == null ? void 0 : U.getData("text/plain").slice(0, n.confirmationLength - o.value).split("")) || [];
      if (!C.join("").match(/^\d+$/))
        return;
      const _ = s.value.slice(0, o.value).concat(C).slice(0, n.confirmationLength);
      s.value = _;
      const M = _.length;
      u(M);
    }, x = (g) => {
      r.value = Object.assign([], s.value);
      const C = o.value;
      s.value[C] = g;
    }, b = (g) => {
      if (/Android/i.test(navigator.userAgent)) {
        let w = g.data.toString().split("");
        for (const $ of w)
          x($), c();
      } else {
        const C = g.target, w = C == null ? void 0 : C.value;
        x(w), c();
      }
    }, h = A([]);
    he(
      () => o.value,
      (g, C) => {
        if (g !== C && o.value > -1) {
          const w = h.value[o.value].$el;
          ke(() => {
            w.focus === "function" && w.focus(), w.select();
          });
        }
      }
    );
    const S = (g) => {
      g && h.value.push(g);
    };
    return (g, C) => (f(), y("div", ey, [
      (f(!0), y(K, null, se(g.confirmationLength, (w) => (f(), j(Jb, {
        key: w,
        ref_for: !0,
        ref: S,
        modelValue: T(s)[w - 1],
        "onUpdate:modelValue": ($) => T(s)[w - 1] = $,
        focus: o.value === w - 1,
        onKeydown: p,
        onPaste: ft(v, ["prevent"]),
        onInput: b,
        onFocus: ($) => l(w - 1),
        onBlur: a
      }, null, 8, ["modelValue", "onUpdate:modelValue", "focus", "onFocus"]))), 128))
    ]));
  }
});
/*!
 * qrcode.vue v3.4.1
 * A Vue.js component to generate QRCode.
 * © 2017-2023 @scopewu(https://github.com/scopewu)
 * MIT License.
 */
var ho = function() {
  return ho = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, ho.apply(this, arguments);
};
var qt;
(function(e) {
  var t = (
    /** @class */
    function() {
      function s(a, l, u, c) {
        if (this.version = a, this.errorCorrectionLevel = l, this.modules = [], this.isFunction = [], a < s.MIN_VERSION || a > s.MAX_VERSION)
          throw new RangeError("Version value out of range");
        if (c < -1 || c > 7)
          throw new RangeError("Mask value out of range");
        this.size = a * 4 + 17;
        for (var d = [], p = 0; p < this.size; p++)
          d.push(!1);
        for (var p = 0; p < this.size; p++)
          this.modules.push(d.slice()), this.isFunction.push(d.slice());
        this.drawFunctionPatterns();
        var v = this.addEccAndInterleave(u);
        if (this.drawCodewords(v), c == -1)
          for (var x = 1e9, p = 0; p < 8; p++) {
            this.applyMask(p), this.drawFormatBits(p);
            var b = this.getPenaltyScore();
            b < x && (c = p, x = b), this.applyMask(p);
          }
        r(0 <= c && c <= 7), this.mask = c, this.applyMask(c), this.drawFormatBits(c), this.isFunction = [];
      }
      return s.encodeText = function(a, l) {
        var u = e.QrSegment.makeSegments(a);
        return s.encodeSegments(u, l);
      }, s.encodeBinary = function(a, l) {
        var u = e.QrSegment.makeBytes(a);
        return s.encodeSegments([u], l);
      }, s.encodeSegments = function(a, l, u, c, d, p) {
        if (u === void 0 && (u = 1), c === void 0 && (c = 40), d === void 0 && (d = -1), p === void 0 && (p = !0), !(s.MIN_VERSION <= u && u <= c && c <= s.MAX_VERSION) || d < -1 || d > 7)
          throw new RangeError("Invalid value");
        var v, x;
        for (v = u; ; v++) {
          var b = s.getNumDataCodewords(v, l) * 8, h = i.getTotalBits(a, v);
          if (h <= b) {
            x = h;
            break;
          }
          if (v >= c)
            throw new RangeError("Data too long");
        }
        for (var S = 0, g = [s.Ecc.MEDIUM, s.Ecc.QUARTILE, s.Ecc.HIGH]; S < g.length; S++) {
          var C = g[S];
          p && x <= s.getNumDataCodewords(v, C) * 8 && (l = C);
        }
        for (var w = [], $ = 0, k = a; $ < k.length; $++) {
          var _ = k[$];
          n(_.mode.modeBits, 4, w), n(_.numChars, _.mode.numCharCountBits(v), w);
          for (var M = 0, U = _.getData(); M < U.length; M++) {
            var L = U[M];
            w.push(L);
          }
        }
        r(w.length == x);
        var N = s.getNumDataCodewords(v, l) * 8;
        r(w.length <= N), n(0, Math.min(4, N - w.length), w), n(0, (8 - w.length % 8) % 8, w), r(w.length % 8 == 0);
        for (var Z = 236; w.length < N; Z ^= 253)
          n(Z, 8, w);
        for (var H = []; H.length * 8 < w.length; )
          H.push(0);
        return w.forEach(function(J, X) {
          return H[X >>> 3] |= J << 7 - (X & 7);
        }), new s(v, l, H, d);
      }, s.prototype.getModule = function(a, l) {
        return 0 <= a && a < this.size && 0 <= l && l < this.size && this.modules[l][a];
      }, s.prototype.getModules = function() {
        return this.modules;
      }, s.prototype.drawFunctionPatterns = function() {
        for (var a = 0; a < this.size; a++)
          this.setFunctionModule(6, a, a % 2 == 0), this.setFunctionModule(a, 6, a % 2 == 0);
        this.drawFinderPattern(3, 3), this.drawFinderPattern(this.size - 4, 3), this.drawFinderPattern(3, this.size - 4);
        for (var l = this.getAlignmentPatternPositions(), u = l.length, a = 0; a < u; a++)
          for (var c = 0; c < u; c++)
            a == 0 && c == 0 || a == 0 && c == u - 1 || a == u - 1 && c == 0 || this.drawAlignmentPattern(l[a], l[c]);
        this.drawFormatBits(0), this.drawVersion();
      }, s.prototype.drawFormatBits = function(a) {
        for (var l = this.errorCorrectionLevel.formatBits << 3 | a, u = l, c = 0; c < 10; c++)
          u = u << 1 ^ (u >>> 9) * 1335;
        var d = (l << 10 | u) ^ 21522;
        r(d >>> 15 == 0);
        for (var c = 0; c <= 5; c++)
          this.setFunctionModule(8, c, o(d, c));
        this.setFunctionModule(8, 7, o(d, 6)), this.setFunctionModule(8, 8, o(d, 7)), this.setFunctionModule(7, 8, o(d, 8));
        for (var c = 9; c < 15; c++)
          this.setFunctionModule(14 - c, 8, o(d, c));
        for (var c = 0; c < 8; c++)
          this.setFunctionModule(this.size - 1 - c, 8, o(d, c));
        for (var c = 8; c < 15; c++)
          this.setFunctionModule(8, this.size - 15 + c, o(d, c));
        this.setFunctionModule(8, this.size - 8, !0);
      }, s.prototype.drawVersion = function() {
        if (!(this.version < 7)) {
          for (var a = this.version, l = 0; l < 12; l++)
            a = a << 1 ^ (a >>> 11) * 7973;
          var u = this.version << 12 | a;
          r(u >>> 18 == 0);
          for (var l = 0; l < 18; l++) {
            var c = o(u, l), d = this.size - 11 + l % 3, p = Math.floor(l / 3);
            this.setFunctionModule(d, p, c), this.setFunctionModule(p, d, c);
          }
        }
      }, s.prototype.drawFinderPattern = function(a, l) {
        for (var u = -4; u <= 4; u++)
          for (var c = -4; c <= 4; c++) {
            var d = Math.max(Math.abs(c), Math.abs(u)), p = a + c, v = l + u;
            0 <= p && p < this.size && 0 <= v && v < this.size && this.setFunctionModule(p, v, d != 2 && d != 4);
          }
      }, s.prototype.drawAlignmentPattern = function(a, l) {
        for (var u = -2; u <= 2; u++)
          for (var c = -2; c <= 2; c++)
            this.setFunctionModule(a + c, l + u, Math.max(Math.abs(c), Math.abs(u)) != 1);
      }, s.prototype.setFunctionModule = function(a, l, u) {
        this.modules[l][a] = u, this.isFunction[l][a] = !0;
      }, s.prototype.addEccAndInterleave = function(a) {
        var l = this.version, u = this.errorCorrectionLevel;
        if (a.length != s.getNumDataCodewords(l, u))
          throw new RangeError("Invalid argument");
        for (var c = s.NUM_ERROR_CORRECTION_BLOCKS[u.ordinal][l], d = s.ECC_CODEWORDS_PER_BLOCK[u.ordinal][l], p = Math.floor(s.getNumRawDataModules(l) / 8), v = c - p % c, x = Math.floor(p / c), b = [], h = s.reedSolomonComputeDivisor(d), S = 0, g = 0; S < c; S++) {
          var C = a.slice(g, g + x - d + (S < v ? 0 : 1));
          g += C.length;
          var w = s.reedSolomonComputeRemainder(C, h);
          S < v && C.push(0), b.push(C.concat(w));
        }
        for (var $ = [], k = function(_) {
          b.forEach(function(M, U) {
            (_ != x - d || U >= v) && $.push(M[_]);
          });
        }, S = 0; S < b[0].length; S++)
          k(S);
        return r($.length == p), $;
      }, s.prototype.drawCodewords = function(a) {
        if (a.length != Math.floor(s.getNumRawDataModules(this.version) / 8))
          throw new RangeError("Invalid argument");
        for (var l = 0, u = this.size - 1; u >= 1; u -= 2) {
          u == 6 && (u = 5);
          for (var c = 0; c < this.size; c++)
            for (var d = 0; d < 2; d++) {
              var p = u - d, v = (u + 1 & 2) == 0, x = v ? this.size - 1 - c : c;
              !this.isFunction[x][p] && l < a.length * 8 && (this.modules[x][p] = o(a[l >>> 3], 7 - (l & 7)), l++);
            }
        }
        r(l == a.length * 8);
      }, s.prototype.applyMask = function(a) {
        if (a < 0 || a > 7)
          throw new RangeError("Mask value out of range");
        for (var l = 0; l < this.size; l++)
          for (var u = 0; u < this.size; u++) {
            var c = void 0;
            switch (a) {
              case 0:
                c = (u + l) % 2 == 0;
                break;
              case 1:
                c = l % 2 == 0;
                break;
              case 2:
                c = u % 3 == 0;
                break;
              case 3:
                c = (u + l) % 3 == 0;
                break;
              case 4:
                c = (Math.floor(u / 3) + Math.floor(l / 2)) % 2 == 0;
                break;
              case 5:
                c = u * l % 2 + u * l % 3 == 0;
                break;
              case 6:
                c = (u * l % 2 + u * l % 3) % 2 == 0;
                break;
              case 7:
                c = ((u + l) % 2 + u * l % 3) % 2 == 0;
                break;
              default:
                throw new Error("Unreachable");
            }
            !this.isFunction[l][u] && c && (this.modules[l][u] = !this.modules[l][u]);
          }
      }, s.prototype.getPenaltyScore = function() {
        for (var a = 0, l = 0; l < this.size; l++) {
          for (var u = !1, c = 0, d = [0, 0, 0, 0, 0, 0, 0], p = 0; p < this.size; p++)
            this.modules[l][p] == u ? (c++, c == 5 ? a += s.PENALTY_N1 : c > 5 && a++) : (this.finderPenaltyAddHistory(c, d), u || (a += this.finderPenaltyCountPatterns(d) * s.PENALTY_N3), u = this.modules[l][p], c = 1);
          a += this.finderPenaltyTerminateAndCount(u, c, d) * s.PENALTY_N3;
        }
        for (var p = 0; p < this.size; p++) {
          for (var u = !1, v = 0, d = [0, 0, 0, 0, 0, 0, 0], l = 0; l < this.size; l++)
            this.modules[l][p] == u ? (v++, v == 5 ? a += s.PENALTY_N1 : v > 5 && a++) : (this.finderPenaltyAddHistory(v, d), u || (a += this.finderPenaltyCountPatterns(d) * s.PENALTY_N3), u = this.modules[l][p], v = 1);
          a += this.finderPenaltyTerminateAndCount(u, v, d) * s.PENALTY_N3;
        }
        for (var l = 0; l < this.size - 1; l++)
          for (var p = 0; p < this.size - 1; p++) {
            var x = this.modules[l][p];
            x == this.modules[l][p + 1] && x == this.modules[l + 1][p] && x == this.modules[l + 1][p + 1] && (a += s.PENALTY_N2);
          }
        for (var b = 0, h = 0, S = this.modules; h < S.length; h++) {
          var g = S[h];
          b = g.reduce(function($, k) {
            return $ + (k ? 1 : 0);
          }, b);
        }
        var C = this.size * this.size, w = Math.ceil(Math.abs(b * 20 - C * 10) / C) - 1;
        return r(0 <= w && w <= 9), a += w * s.PENALTY_N4, r(0 <= a && a <= 2568888), a;
      }, s.prototype.getAlignmentPatternPositions = function() {
        if (this.version == 1)
          return [];
        for (var a = Math.floor(this.version / 7) + 2, l = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (a * 2 - 2)) * 2, u = [6], c = this.size - 7; u.length < a; c -= l)
          u.splice(1, 0, c);
        return u;
      }, s.getNumRawDataModules = function(a) {
        if (a < s.MIN_VERSION || a > s.MAX_VERSION)
          throw new RangeError("Version number out of range");
        var l = (16 * a + 128) * a + 64;
        if (a >= 2) {
          var u = Math.floor(a / 7) + 2;
          l -= (25 * u - 10) * u - 55, a >= 7 && (l -= 36);
        }
        return r(208 <= l && l <= 29648), l;
      }, s.getNumDataCodewords = function(a, l) {
        return Math.floor(s.getNumRawDataModules(a) / 8) - s.ECC_CODEWORDS_PER_BLOCK[l.ordinal][a] * s.NUM_ERROR_CORRECTION_BLOCKS[l.ordinal][a];
      }, s.reedSolomonComputeDivisor = function(a) {
        if (a < 1 || a > 255)
          throw new RangeError("Degree out of range");
        for (var l = [], u = 0; u < a - 1; u++)
          l.push(0);
        l.push(1);
        for (var c = 1, u = 0; u < a; u++) {
          for (var d = 0; d < l.length; d++)
            l[d] = s.reedSolomonMultiply(l[d], c), d + 1 < l.length && (l[d] ^= l[d + 1]);
          c = s.reedSolomonMultiply(c, 2);
        }
        return l;
      }, s.reedSolomonComputeRemainder = function(a, l) {
        for (var u = l.map(function(x) {
          return 0;
        }), c = function(x) {
          var b = x ^ u.shift();
          u.push(0), l.forEach(function(h, S) {
            return u[S] ^= s.reedSolomonMultiply(h, b);
          });
        }, d = 0, p = a; d < p.length; d++) {
          var v = p[d];
          c(v);
        }
        return u;
      }, s.reedSolomonMultiply = function(a, l) {
        if (a >>> 8 || l >>> 8)
          throw new RangeError("Byte out of range");
        for (var u = 0, c = 7; c >= 0; c--)
          u = u << 1 ^ (u >>> 7) * 285, u ^= (l >>> c & 1) * a;
        return r(u >>> 8 == 0), u;
      }, s.prototype.finderPenaltyCountPatterns = function(a) {
        var l = a[1];
        r(l <= this.size * 3);
        var u = l > 0 && a[2] == l && a[3] == l * 3 && a[4] == l && a[5] == l;
        return (u && a[0] >= l * 4 && a[6] >= l ? 1 : 0) + (u && a[6] >= l * 4 && a[0] >= l ? 1 : 0);
      }, s.prototype.finderPenaltyTerminateAndCount = function(a, l, u) {
        return a && (this.finderPenaltyAddHistory(l, u), l = 0), l += this.size, this.finderPenaltyAddHistory(l, u), this.finderPenaltyCountPatterns(u);
      }, s.prototype.finderPenaltyAddHistory = function(a, l) {
        l[0] == 0 && (a += this.size), l.pop(), l.unshift(a);
      }, s.MIN_VERSION = 1, s.MAX_VERSION = 40, s.PENALTY_N1 = 3, s.PENALTY_N2 = 3, s.PENALTY_N3 = 40, s.PENALTY_N4 = 10, s.ECC_CODEWORDS_PER_BLOCK = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
        [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
        [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
        [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]
        // High
      ], s.NUM_ERROR_CORRECTION_BLOCKS = [
        // Version: (note that index 0 is for padding, and is set to an illegal value)
        //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
        [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
        [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
        [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
        [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]
        // High
      ], s;
    }()
  );
  e.QrCode = t;
  function n(s, a, l) {
    if (a < 0 || a > 31 || s >>> a)
      throw new RangeError("Value out of range");
    for (var u = a - 1; u >= 0; u--)
      l.push(s >>> u & 1);
  }
  function o(s, a) {
    return (s >>> a & 1) != 0;
  }
  function r(s) {
    if (!s)
      throw new Error("Assertion error");
  }
  var i = (
    /** @class */
    function() {
      function s(a, l, u) {
        if (this.mode = a, this.numChars = l, this.bitData = u, l < 0)
          throw new RangeError("Invalid argument");
        this.bitData = u.slice();
      }
      return s.makeBytes = function(a) {
        for (var l = [], u = 0, c = a; u < c.length; u++) {
          var d = c[u];
          n(d, 8, l);
        }
        return new s(s.Mode.BYTE, a.length, l);
      }, s.makeNumeric = function(a) {
        if (!s.isNumeric(a))
          throw new RangeError("String contains non-numeric characters");
        for (var l = [], u = 0; u < a.length; ) {
          var c = Math.min(a.length - u, 3);
          n(parseInt(a.substring(u, u + c), 10), c * 3 + 1, l), u += c;
        }
        return new s(s.Mode.NUMERIC, a.length, l);
      }, s.makeAlphanumeric = function(a) {
        if (!s.isAlphanumeric(a))
          throw new RangeError("String contains unencodable characters in alphanumeric mode");
        var l = [], u;
        for (u = 0; u + 2 <= a.length; u += 2) {
          var c = s.ALPHANUMERIC_CHARSET.indexOf(a.charAt(u)) * 45;
          c += s.ALPHANUMERIC_CHARSET.indexOf(a.charAt(u + 1)), n(c, 11, l);
        }
        return u < a.length && n(s.ALPHANUMERIC_CHARSET.indexOf(a.charAt(u)), 6, l), new s(s.Mode.ALPHANUMERIC, a.length, l);
      }, s.makeSegments = function(a) {
        return a == "" ? [] : s.isNumeric(a) ? [s.makeNumeric(a)] : s.isAlphanumeric(a) ? [s.makeAlphanumeric(a)] : [s.makeBytes(s.toUtf8ByteArray(a))];
      }, s.makeEci = function(a) {
        var l = [];
        if (a < 0)
          throw new RangeError("ECI assignment value out of range");
        if (a < 128)
          n(a, 8, l);
        else if (a < 16384)
          n(2, 2, l), n(a, 14, l);
        else if (a < 1e6)
          n(6, 3, l), n(a, 21, l);
        else
          throw new RangeError("ECI assignment value out of range");
        return new s(s.Mode.ECI, 0, l);
      }, s.isNumeric = function(a) {
        return s.NUMERIC_REGEX.test(a);
      }, s.isAlphanumeric = function(a) {
        return s.ALPHANUMERIC_REGEX.test(a);
      }, s.prototype.getData = function() {
        return this.bitData.slice();
      }, s.getTotalBits = function(a, l) {
        for (var u = 0, c = 0, d = a; c < d.length; c++) {
          var p = d[c], v = p.mode.numCharCountBits(l);
          if (p.numChars >= 1 << v)
            return 1 / 0;
          u += 4 + v + p.bitData.length;
        }
        return u;
      }, s.toUtf8ByteArray = function(a) {
        a = encodeURI(a);
        for (var l = [], u = 0; u < a.length; u++)
          a.charAt(u) != "%" ? l.push(a.charCodeAt(u)) : (l.push(parseInt(a.substring(u + 1, u + 3), 16)), u += 2);
        return l;
      }, s.NUMERIC_REGEX = /^[0-9]*$/, s.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/, s.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:", s;
    }()
  );
  e.QrSegment = i;
})(qt || (qt = {}));
(function(e) {
  (function(t) {
    var n = (
      /** @class */
      function() {
        function o(r, i) {
          this.ordinal = r, this.formatBits = i;
        }
        return o.LOW = new o(0, 1), o.MEDIUM = new o(1, 0), o.QUARTILE = new o(2, 3), o.HIGH = new o(3, 2), o;
      }()
    );
    t.Ecc = n;
  })(e.QrCode || (e.QrCode = {}));
})(qt || (qt = {}));
(function(e) {
  (function(t) {
    var n = (
      /** @class */
      function() {
        function o(r, i) {
          this.modeBits = r, this.numBitsCharCount = i;
        }
        return o.prototype.numCharCountBits = function(r) {
          return this.numBitsCharCount[Math.floor((r + 7) / 17)];
        }, o.NUMERIC = new o(1, [10, 12, 14]), o.ALPHANUMERIC = new o(2, [9, 11, 13]), o.BYTE = new o(4, [8, 16, 16]), o.KANJI = new o(8, [8, 10, 12]), o.ECI = new o(7, [0, 0, 0]), o;
      }()
    );
    t.Mode = n;
  })(e.QrSegment || (e.QrSegment = {}));
})(qt || (qt = {}));
var on = qt, Bl = "H", vi = {
  L: on.QrCode.Ecc.LOW,
  M: on.QrCode.Ecc.MEDIUM,
  Q: on.QrCode.Ecc.QUARTILE,
  H: on.QrCode.Ecc.HIGH
}, ty = function() {
  try {
    new Path2D().addPath(new Path2D());
  } catch {
    return !1;
  }
  return !0;
}();
function zl(e) {
  return e in vi;
}
function Nl(e, t) {
  t === void 0 && (t = 0);
  var n = [];
  return e.forEach(function(o, r) {
    var i = null;
    o.forEach(function(s, a) {
      if (!s && i !== null) {
        n.push("M".concat(i + t, " ").concat(r + t, "h").concat(a - i, "v1H").concat(i + t, "z")), i = null;
        return;
      }
      if (a === o.length - 1) {
        if (!s)
          return;
        i === null ? n.push("M".concat(a + t, ",").concat(r + t, " h1v1H").concat(a + t, "z")) : n.push("M".concat(i + t, ",").concat(r + t, " h").concat(a + 1 - i, "v1H").concat(i + t, "z"));
        return;
      }
      s && i === null && (i = a);
    });
  }), n.join("");
}
var mi = {
  value: {
    type: String,
    required: !0,
    default: ""
  },
  size: {
    type: Number,
    default: 100
  },
  level: {
    type: String,
    default: Bl,
    validator: function(e) {
      return zl(e);
    }
  },
  background: {
    type: String,
    default: "#fff"
  },
  foreground: {
    type: String,
    default: "#000"
  },
  margin: {
    type: Number,
    required: !1,
    default: 0
  }
}, ny = ho(ho({}, mi), { renderAs: {
  type: String,
  required: !1,
  default: "canvas",
  validator: function(e) {
    return ["canvas", "svg"].indexOf(e) > -1;
  }
} }), oy = z({
  name: "QRCodeSvg",
  props: mi,
  setup: function(e) {
    var t = A(0), n = A(""), o = function() {
      var r = e.value, i = e.level, s = e.margin, a = on.QrCode.encodeText(r, vi[i]).getModules();
      t.value = a.length + s * 2, n.value = Nl(a, s);
    };
    return o(), Us(o), function() {
      return oe("svg", {
        width: e.size,
        height: e.size,
        "shape-rendering": "crispEdges",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 ".concat(t.value, " ").concat(t.value)
      }, [
        oe("path", {
          fill: e.background,
          d: "M0,0 h".concat(t.value, "v").concat(t.value, "H0z")
        }),
        oe("path", { fill: e.foreground, d: n.value })
      ]);
    };
  }
}), ry = z({
  name: "QRCodeCanvas",
  props: mi,
  setup: function(e) {
    var t = A(null), n = function() {
      var o = e.value, r = e.level, i = e.size, s = e.margin, a = e.background, l = e.foreground, u = t.value;
      if (u) {
        var c = u.getContext("2d");
        if (c) {
          var d = on.QrCode.encodeText(o, vi[r]).getModules(), p = d.length + s * 2, v = window.devicePixelRatio || 1, x = i / p * v;
          u.height = u.width = i * v, c.scale(x, x), c.fillStyle = a, c.fillRect(0, 0, p, p), c.fillStyle = l, ty ? c.fill(new Path2D(Nl(d, s))) : d.forEach(function(b, h) {
            b.forEach(function(S, g) {
              S && c.fillRect(g + s, h + s, 1, 1);
            });
          });
        }
      }
    };
    return ae(n), Us(n), function() {
      return oe("canvas", {
        ref: t,
        style: { width: "".concat(e.size, "px"), height: "".concat(e.size, "px") }
      });
    };
  }
}), iy = z({
  name: "Qrcode",
  render: function() {
    var e = this.$props, t = e.renderAs, n = e.value, o = e.size, r = e.margin, i = e.level, s = e.background, a = e.foreground, l = o >>> 0, u = r >>> 0, c = zl(i) ? i : Bl;
    return oe(t === "svg" ? oy : ry, { value: n, size: l, margin: u, level: c, background: s, foreground: a });
  },
  props: ny
});
const sy = { class: "relative inline-block" }, ay = ["src"], y7 = /* @__PURE__ */ z({
  __name: "QrCode",
  props: {
    link: {},
    imgUrl: { default: "" },
    size: { default: 100 },
    imgSize: { default: "size-10" },
    imgPadding: { default: "p-1" },
    imgBgColor: { default: "#ffffff" },
    imgBorderColor: { default: "#ffffff" },
    imgBorderSize: { default: "border-4" }
  },
  setup(e) {
    const t = e;
    return (n, o) => (f(), y("figure", sy, [
      B(iy, {
        value: t.link,
        size: Number(t.size),
        foreground: "#222222",
        level: "H"
      }, null, 8, ["value", "size"]),
      n.imgUrl ? (f(), y("img", {
        key: 0,
        class: O(["absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 overflow-hidden rounded border-solid border-transparent object-contain shadow-sm", [t.imgSize, t.imgPadding, t.imgBorderSize]]),
        style: De(`background-color: ${t.imgBgColor}; border-color: ${t.imgBorderColor};`),
        src: t.imgUrl,
        alt: "Qr code"
      }, null, 14, ay)) : P("", !0)
    ]));
  }
}), w7 = /* @__PURE__ */ z({
  __name: "BackLink",
  props: {
    padding: { default: "p-1.5" },
    iconColor: { default: "text-gray-800" },
    iconSize: { default: "size-5" },
    backgroundColor: { default: "bg-gray-100" }
  },
  emits: ["onBack"],
  setup(e, { emit: t }) {
    const n = e, r = Kt().customIcon, i = t;
    return (s, a) => (f(), y("div", {
      class: O(["inline-block cursor-pointer rounded-full", n.padding, n.backgroundColor]),
      onClick: a[0] || (a[0] = (l) => i("onBack"))
    }, [
      m("div", {
        class: O([n.iconColor, n.iconSize])
      }, [
        T(r) ? G(s.$slots, "customIcon", { key: 0 }) : (f(), j(T(v0), { key: 1 }))
      ], 2)
    ], 2));
  }
}), ly = {
  key: 0,
  class: "flex gap-2"
}, x7 = /* @__PURE__ */ z({
  __name: "CopyBox",
  props: {
    buttonText: { default: null },
    classes: { default: null },
    icon: { type: [Function, Object], default: Gu },
    outlined: { type: Boolean, default: !1 },
    source: {},
    variant: { default: "gray" },
    variantShade: { default: "800" }
  },
  emits: ["copied"],
  setup(e, { emit: t }) {
    const { copy: n } = Ap(), o = e, r = E(() => o.outlined && o.classes ? `border bg-none ${o.classes}` : `${W({ type: "bg", value: "200", variant: o.variant })} ${o.classes}`), i = t;
    function s() {
      try {
        n(o.source), i("copied");
      } catch (a) {
        throw new Error(a);
      }
    }
    return (a, l) => (f(), y("div", {
      class: O(["flex w-full items-center justify-between gap-2 rounded-xl p-3", r.value])
    }, [
      m("p", null, R(a.source), 1),
      B(rt, {
        outlined: a.outlined,
        variant: a.variant,
        "variant-shade": a.variantShade,
        class: "rounded-xl",
        icon: !a.buttonText && a.icon,
        onClick: s
      }, {
        default: F(() => [
          a.buttonText ? (f(), y("div", ly, [
            (f(), j(Le(a.icon), { class: "h-5 w-5" })),
            m("span", null, R(a.buttonText), 1)
          ])) : P("", !0)
        ]),
        _: 1
      }, 8, ["outlined", "variant", "variant-shade", "icon"])
    ], 2));
  }
}), uy = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyMCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQzNzEgOS44OTMyVjUuNTQ0NkMxNi40MzcxIDEuNjU0NDEgMTMuNTU2MyAwLjMzNTY5MyAxMC4wMTQgMC4zMzU2OTNDNi40NzMwMSAwLjMzNTY5MyAzLjU5Mzc5IDEuNjU0MTQgMy41OTM3OSA1LjU0NDZWMTAuMTEyM0MwLjcyMTgxMyAxMS4wNTIgMC42OTA0MyAxMy40ODMyIDAuNjkwNDMgMTcuMjIzMkMwLjY5MDQzIDIyLjExNjEgMC43Mzg0NDMgMjQuMzM1NyA3LjE0MTE4IDI0LjMzNTdIMTMuNDQ5OEMxOS44NTI1IDI0LjMzNTcgMTkuMzI5NCAyMi4xMTYxIDE5LjMyOTQgMTcuMjIzMkMxOS4zMjkyIDEzLjE0MzQgMjAuMDI4MiAxMC42MTk4IDE2LjQzNzEgOS44OTMyWk0xMS4yODM1IDE5LjQ0Mkg4Ljc0NzA5TDkuNTc1NjYgMTcuMTQyN0M5LjAwODA4IDE2Ljk3MzggOC41OTUgMTYuNDkzOSA4LjU5NSAxNS45MjI4QzguNTk1IDE1LjIxMDQgOS4yMzEyNSAxNC42MzM0IDEwLjAxNSAxNC42MzM0QzEwLjc5OTYgMTQuNjMzNCAxMS40MzQgMTUuMjEwNCAxMS40MzQgMTUuOTIyOEMxMS40MzQgMTYuNDk0MiAxMS4wMjIgMTYuOTc0IDEwLjQ1NDcgMTcuMTQyN0wxMS4yODM1IDE5LjQ0MlpNMTMuODQyNyA5LjY3ODM0QzEzLjcxMzQgOS42NzYyIDEzLjU4NTIgOS42NzMyNSAxMy40NDk4IDkuNjczMjVINy4xNDA5MUM2LjgwNDgxIDkuNjczMjUgNi40OTAxOCA5LjY4MTgzIDYuMTg4MTQgOS42OTY4NVY1LjU0NDg3QzYuMTg4MTQgMi45NTUwNyA3LjkwNTExIDIuNzA4MjggMTAuMDE0IDIuNzA4MjhDMTIuMTI1IDIuNzA4MjggMTMuODQyMiAyLjk1NTA3IDEzLjg0MjIgNS41NDQ4N1Y5LjY3ODM0SDEzLjg0MjdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K", cy = { class: "relative h-[106px] w-full overflow-hidden" }, dy = ["src", "alt"], py = {
  key: 1,
  class: "block h-full w-full bg-gray-200"
}, fy = {
  key: 2,
  class: "absolute left-0 top-0 z-10 h-full w-full rounded-t-lg bg-black/60"
}, hy = {
  key: 0,
  class: "flex h-full flex-col items-center justify-center font-bold text-white"
}, vy = /* @__PURE__ */ m("img", {
  class: "mb-2 block h-5 w-auto",
  src: uy,
  "aria-hidden": "true"
}, null, -1), my = { class: "text-center" }, gy = {
  key: 3,
  class: "absolute right-2 top-2 rounded-full border border-gray-200 bg-gray-100 px-1.5 py-1 text-sm font-bold text-gray-800"
}, by = { class: "px-3 pb-3" }, yy = {
  key: 0,
  class: "flex h-12 items-center justify-center text-center text-sm font-bold"
}, wy = {
  key: 1,
  class: "mt-1 text-center"
}, xy = { class: "font-bold" }, $7 = /* @__PURE__ */ z({
  __name: "Reward",
  props: {
    badgeText: { default: "" },
    buttonBgColor: { default: "" },
    buttonText: { default: "" },
    buttonTextColor: { default: "" },
    img: { default: "" },
    isClickable: { type: Boolean, default: !0 },
    isProcessing: { type: Boolean, default: !1 },
    overlayText: { default: "" },
    title: {}
  },
  emits: ["onClick"],
  setup(e, { emit: t }) {
    const n = e, o = t;
    return (r, i) => (f(), y("div", {
      class: O(["min-h-auto w-full rounded-lg bg-white shadow-lg", r.isClickable ? "cursor-pointer" : "pointer-events-none"]),
      onClick: i[0] || (i[0] = (s) => o("onClick"))
    }, [
      m("div", cy, [
        r.img ? (f(), y("img", {
          key: 0,
          src: r.img,
          alt: r.title,
          class: "h-[106px] w-full rounded-t-lg object-cover"
        }, null, 8, dy)) : (f(), y("div", py)),
        r.overlayText ? (f(), y("div", fy, [
          r.overlayText ? (f(), y("div", hy, [
            vy,
            m("p", my, R(r.overlayText), 1)
          ])) : P("", !0)
        ])) : P("", !0),
        r.badgeText ? (f(), y("div", gy, R(r.badgeText), 1)) : P("", !0)
      ]),
      m("div", by, [
        r.title ? (f(), y("h3", yy, R(r.title), 1)) : P("", !0),
        r.buttonText ? (f(), y("div", wy, [
          B(rt, {
            class: O(["border-none !py-1 text-secondary shadow focus:ring-transparent", [
              !r.isClickable && "cursor-default focus:!ring-0 focus:!ring-transparent focus:!ring-offset-0",
              r.overlayText && "bg-primaryHover",
              !r.buttonBgColor && "!bg-primaryHover"
            ]]),
            style: De(`color: ${r.buttonTextColor}!important; background-color: ${r.buttonBgColor}!important;`),
            "rounded-size": "rounded-full",
            processing: r.isProcessing
          }, {
            default: F(() => [
              m("span", xy, R(n.buttonText), 1)
            ]),
            _: 1
          }, 8, ["class", "style", "processing"])
        ])) : P("", !0)
      ])
    ], 2));
  }
}), C7 = /* @__PURE__ */ z({
  __name: "DisclosureGroup",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = A(n.modelValue), i = (s) => {
      r.value = s, o("update:modelValue", r.value);
    };
    return xe("openedId", r), xe("isGroup", !0), xe("setOpenedId", i), (s, a) => (f(), y("div", null, [
      G(s.$slots, "default")
    ]));
  }
}), S7 = /* @__PURE__ */ z({
  __name: "Chip",
  props: {
    text: {},
    removable: { type: Boolean, default: !1 },
    color: { default: "gray" },
    icon: { type: [Function, Object, null], default: null }
  },
  emits: ["remove"],
  setup(e, { emit: t }) {
    const n = e, o = t;
    return (r, i) => (f(), y("div", {
      class: O(["inline-flex h-7 items-center justify-center gap-1.5 rounded-md border px-2 py-1", [
        n.color !== "gray" ? `border-${n.color}-50 bg-${n.color}-50` : "border-gray-300 bg-gray-100",
        !n.removable && "hover:cursor-default"
      ]])
    }, [
      n.icon ? (f(), j(Le(n.icon), {
        key: 0,
        class: O(["h-4 w-4", `text-${n.color}-600`])
      }, null, 8, ["class"])) : P("", !0),
      m("div", {
        class: O(["text-xs leading-tight", [
          n.color !== "gray" ? `text-${n.color}-600 font-semibold` : "text-gray-800",
          { "!font-medium": n.icon }
        ]])
      }, R(n.text), 3),
      n.removable ? (f(), y("button", {
        key: 1,
        class: "relative flex h-5 w-5 items-center justify-center",
        onClick: i[0] || (i[0] = (s) => o("remove"))
      }, [
        B(T(bt), {
          class: O(["h-4 w-4", n.color !== "gray" ? `text-${n.color}-400` : "text-gray-300"])
        }, null, 8, ["class"])
      ])) : P("", !0)
    ], 2));
  }
});
function jl(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M3.38 3.012a.75.75 0 1 0-1.408-.516A15.97 15.97 0 0 0 1 8c0 1.932.343 3.786.972 5.503a.75.75 0 0 0 1.408-.516A14.47 14.47 0 0 1 2.5 8c0-1.754.311-3.434.88-4.988ZM12.62 3.012a.75.75 0 1 1 1.408-.516A15.97 15.97 0 0 1 15 8a15.97 15.97 0 0 1-.972 5.503.75.75 0 0 1-1.408-.516c.569-1.554.88-3.233.88-4.987s-.311-3.434-.88-4.988ZM6.523 4.785a.75.75 0 0 1 .898.38l.758 1.515.812-.902a2.376 2.376 0 0 1 2.486-.674.75.75 0 1 1-.454 1.429.876.876 0 0 0-.918.249L8.9 8.122l.734 1.468.388-.124a.75.75 0 0 1 .457 1.428l-1 .32a.75.75 0 0 1-.899-.379L7.821 9.32l-.811.901a2.374 2.374 0 0 1-2.489.673.75.75 0 0 1 .458-1.428.874.874 0 0 0 .916-.248L7.1 7.878 6.366 6.41l-.389.124a.75.75 0 1 1-.454-1.43l1-.318Z" })
  ]);
}
const Ss = [
  "text",
  "number",
  "email",
  "password",
  "search",
  "url",
  "tel",
  "date",
  "time",
  "range",
  "passwordToggle"
];
function $y({ type: e }) {
  const t = (o) => e.value === "passwordToggle" ? o ? "text" : "password" : Ss.includes(e.value) ? e.value : Ss[0], n = E(() => {
    const o = ["absolute inset-y-0 pr-3 flex items-center"];
    return o.push(e.value === "number" ? "right-5" : "right-0"), o.push(e.value === "passwordToggle" ? "cursor-pointer" : "pointer-events-none"), o;
  });
  return {
    getComputedType: t,
    addOnClasses: n
  };
}
const Cy = {
  key: 0,
  class: "mb-1.5 flex w-full text-left text-sm font-normal text-gray-800"
}, Sy = ["for"], ky = {
  key: 0,
  class: "ml-1 text-red-600"
}, Ey = { class: "relative flex w-full" }, Oy = {
  key: 0,
  class: "inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3"
}, Ay = ["id", "type", "value"], _y = {
  key: 0,
  class: "text-gray-500 sm:text-sm"
}, Ry = {
  key: 2,
  class: "inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3"
}, My = {
  key: 1,
  class: "mt-1.5 text-sm font-normal"
}, Ty = ["href", "target"], Py = /* @__PURE__ */ z({
  inheritAttrs: !1,
  __name: "Input",
  props: {
    addOn: { default: null },
    bgColor: { default: null },
    errorClasses: { default: null },
    errors: { default: () => [] },
    fullWidth: { type: Boolean, default: !1 },
    id: {},
    label: { default: null },
    modelValue: { type: [String, Number, Boolean], default: void 0 },
    pattern: { default: "" },
    textColor: { default: null },
    tip: { default: null },
    toolTip: { default: null },
    type: { default: "text" }
  },
  emits: ["update:modelValue", "onFocus", "onBlur"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = A(!1), { getComputedType: i, addOnClasses: s } = $y(at(n)), a = Kt(), l = Ws(), u = A(!!a["icon-left"]), c = A(!!a["icon-right"]), d = E(() => {
      const b = [], h = u.value && c.value;
      return u.value || c.value ? (b.push("flex-1"), h || b.push(u.value ? "rounded-r-md" : "rounded-l-md")) : b.push("rounded-md"), b.join(" ");
    }), p = E(() => n.pattern === "b2c"), v = E(() => {
      var g;
      const b = ["block w-full sm:text-sm shadow-sm"];
      let h = [];
      p.value ? h = [
        "py-4",
        "rounded-xl",
        "focus:text-gray-800",
        "focus:ring-0",
        "border-transparent",
        "focus:border-transparent",
        "focus:ring-transparent",
        "caret-indigo-300",
        "bg-gray-50",
        "focus:bg-gray-100"
      ] : l.disabled ? h = ["border", "border-solid", "border-gray-200", "bg-gray-100", "text-gray-400"] : h = [
        "bg-white",
        "border",
        "border-solid",
        "border-gray-300",
        "text-gray-800",
        "bg-gray-50",
        "focus:border-violet-800",
        `${W({ type: "ring", value: "800", prefix: "focus" })}`,
        `${W({ type: "border", value: "800", prefix: "focus" })}`
      ];
      const S = ((g = n.errors) == null ? void 0 : g.length) > 0 ? ["border-red-300", "text-red-900", "placeholder-red-300"] : [];
      return n.bgColor && (h = h.filter((C) => !C.startsWith("bg-")), h.push(n.bgColor)), n.textColor ? (h = h.filter((C) => !C.startsWith("text-")), h.push(n.textColor)) : h.push("placeholder-gray-400"), [...b, ...h, ...S, d.value].join(" ");
    }), x = (b) => {
      let h = Vt(b);
      ["numeric", "decimal"].includes(n.type) && (h = Number(h)), o("update:modelValue", h);
    };
    return (b, h) => {
      var S, g, C;
      return f(), y("div", {
        class: O([b.fullWidth ? "w-full" : "", b.$attrs.class])
      }, [
        b.label || b.toolTip ? (f(), y("div", Cy, [
          b.label ? (f(), y("label", {
            key: 0,
            for: b.id
          }, [
            ce(R(b.label), 1),
            b.$attrs.required ? (f(), y("sup", ky, "*")) : P("", !0)
          ], 8, Sy)) : P("", !0),
          b.toolTip ? (f(), j(Dl, {
            key: 1,
            "tooltip-position": "top-start",
            "custom-styles": "bg-gray-600",
            text: b.toolTip
          }, {
            default: F(() => [
              B(T(Qr), { class: "ml-2 h-5 w-5 transform cursor-pointer text-gray-600" })
            ]),
            _: 1
          }, 8, ["text"])) : P("", !0)
        ])) : P("", !0),
        m("div", Ey, [
          u.value ? (f(), y("span", Oy, [
            G(b.$slots, "icon-left")
          ])) : P("", !0),
          m("input", _t({
            id: b.id,
            type: T(i)(r.value),
            value: b.modelValue,
            class: v.value
          }, { ...b.$attrs, class: void 0 }, {
            onInput: x,
            onFocus: h[0] || (h[0] = (w) => o("onFocus")),
            onBlur: h[1] || (h[1] = (w) => o("onBlur"))
          }), null, 16, Ay),
          b.addOn || b.type === "passwordToggle" ? (f(), y("div", {
            key: 1,
            class: O(T(s)),
            onClick: h[2] || (h[2] = (w) => r.value = !r.value)
          }, [
            b.addOn ? (f(), y("span", _y, R(b.addOn), 1)) : (f(), y(K, { key: 1 }, [
              r.value ? (f(), j(T(Nu), {
                key: 0,
                class: "aspect-square w-5 text-gray-600"
              })) : (f(), j(T(Ks), {
                key: 1,
                class: "aspect-square w-5 text-gray-600"
              }))
            ], 64))
          ], 2)) : P("", !0),
          c.value ? (f(), y("span", Ry, [
            G(b.$slots, "icon-right")
          ])) : P("", !0)
        ]),
        b.tip ? (f(), y("div", My, [
          m("a", {
            class: O(b.tip.link ? "cursor-pointer text-blue-600 hover:text-blue-700 hover:underline" : "text-gray-500"),
            href: (S = b.tip.link) == null ? void 0 : S.value,
            target: (g = b.tip.link) != null && g.isOpenedInNewTab ? "_blank" : "_self"
          }, R(b.tip.text), 11, Ty)
        ])) : P("", !0),
        ((C = b.errors) == null ? void 0 : C.length) > 0 ? (f(), y("p", {
          key: 2,
          id: "headline-error",
          class: O(["mt-2 text-sm text-red-600", b.errorClasses])
        }, R(b.errors[0]), 3)) : P("", !0)
      ], 2);
    };
  }
}), Iy = { class: "flex flex-col p-3" }, Ly = { class: "mt-2 flex flex-row" }, Dy = { class: "text-gray-800" }, Vl = /* @__PURE__ */ z({
  __name: "CustomVarInput",
  props: {
    modelValue: {},
    i18nStrings: {},
    isEditing: { type: Boolean }
  },
  emits: ["update:modelValue", "save", "back"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = sn(n, "modelValue", o), i = E(() => {
      var s, a;
      return n.isEditing ? (s = n.i18nStrings.customValue) == null ? void 0 : s.update : (a = n.i18nStrings.customValue) == null ? void 0 : a.create;
    });
    return (s, a) => {
      var l;
      return f(), y("div", Iy, [
        B(Py, {
          id: "customValue",
          modelValue: T(r),
          "onUpdate:modelValue": a[0] || (a[0] = (u) => mo(r) ? r.value = u : null),
          placeholder: (l = s.i18nStrings.customValue) == null ? void 0 : l.placeholder
        }, null, 8, ["modelValue", "placeholder"]),
        m("div", Ly, [
          B(rt, {
            outlined: "",
            class: "mr-2 flex-1 !border-gray-300 hover:!border-violet-600 hover:!bg-white",
            onClick: a[1] || (a[1] = (u) => o("back"))
          }, {
            default: F(() => {
              var u;
              return [
                m("span", Dy, R((u = s.i18nStrings.customValue) == null ? void 0 : u.back), 1)
              ];
            }),
            _: 1
          }),
          B(rt, {
            class: "flex-1",
            disabled: T(r).length === 0,
            onClick: a[2] || (a[2] = (u) => o("save"))
          }, {
            default: F(() => [
              ce(R(i.value), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]);
    };
  }
});
function By(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M5.223 2.25c-.497 0-.974.198-1.325.55l-1.3 1.298A3.75 3.75 0 0 0 7.5 9.75c.627.47 1.406.75 2.25.75.844 0 1.624-.28 2.25-.75.626.47 1.406.75 2.25.75.844 0 1.623-.28 2.25-.75a3.75 3.75 0 0 0 4.902-5.652l-1.3-1.299a1.875 1.875 0 0 0-1.325-.549H5.223Z" }),
    m("path", {
      "fill-rule": "evenodd",
      d: "M3 20.25v-8.755c1.42.674 3.08.673 4.5 0A5.234 5.234 0 0 0 9.75 12c.804 0 1.568-.182 2.25-.506a5.234 5.234 0 0 0 2.25.506c.804 0 1.567-.182 2.25-.506 1.42.674 3.08.675 4.5.001v8.755h.75a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1 0-1.5H3Zm3-6a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1-.75-.75v-3Zm8.25-.75a.75.75 0 0 0-.75.75v5.25c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-5.25a.75.75 0 0 0-.75-.75h-3Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function zy(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M9.375 3a1.875 1.875 0 0 0 0 3.75h1.875v4.5H3.375A1.875 1.875 0 0 1 1.5 9.375v-.75c0-1.036.84-1.875 1.875-1.875h3.193A3.375 3.375 0 0 1 12 2.753a3.375 3.375 0 0 1 5.432 3.997h3.943c1.035 0 1.875.84 1.875 1.875v.75c0 1.036-.84 1.875-1.875 1.875H12.75v-4.5h1.875a1.875 1.875 0 1 0-1.875-1.875V6.75h-1.5V4.875C11.25 3.839 10.41 3 9.375 3ZM11.25 12.75H3v6.75a2.25 2.25 0 0 0 2.25 2.25h6v-9ZM12.75 12.75v9h6.75a2.25 2.25 0 0 0 2.25-2.25v-6.75h-9Z" })
  ]);
}
function Ny(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", { d: "M21.721 12.752a9.711 9.711 0 0 0-.945-5.003 12.754 12.754 0 0 1-4.339 2.708 18.991 18.991 0 0 1-.214 4.772 17.165 17.165 0 0 0 5.498-2.477ZM14.634 15.55a17.324 17.324 0 0 0 .332-4.647c-.952.227-1.945.347-2.966.347-1.021 0-2.014-.12-2.966-.347a17.515 17.515 0 0 0 .332 4.647 17.385 17.385 0 0 0 5.268 0ZM9.772 17.119a18.963 18.963 0 0 0 4.456 0A17.182 17.182 0 0 1 12 21.724a17.18 17.18 0 0 1-2.228-4.605ZM7.777 15.23a18.87 18.87 0 0 1-.214-4.774 12.753 12.753 0 0 1-4.34-2.708 9.711 9.711 0 0 0-.944 5.004 17.165 17.165 0 0 0 5.498 2.477ZM21.356 14.752a9.765 9.765 0 0 1-7.478 6.817 18.64 18.64 0 0 0 1.988-4.718 18.627 18.627 0 0 0 5.49-2.098ZM2.644 14.752c1.682.971 3.53 1.688 5.49 2.099a18.64 18.64 0 0 0 1.988 4.718 9.765 9.765 0 0 1-7.478-6.816ZM13.878 2.43a9.755 9.755 0 0 1 6.116 3.986 11.267 11.267 0 0 1-3.746 2.504 18.63 18.63 0 0 0-2.37-6.49ZM12 2.276a17.152 17.152 0 0 1 2.805 7.121c-.897.23-1.837.353-2.805.353-.968 0-1.908-.122-2.805-.353A17.151 17.151 0 0 1 12 2.276ZM10.122 2.43a18.629 18.629 0 0 0-2.37 6.49 11.266 11.266 0 0 1-3.746-2.504 9.754 9.754 0 0 1 6.116-3.985Z" })
  ]);
}
function jy(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M19.902 4.098a3.75 3.75 0 0 0-5.304 0l-4.5 4.5a3.75 3.75 0 0 0 1.035 6.037.75.75 0 0 1-.646 1.353 5.25 5.25 0 0 1-1.449-8.45l4.5-4.5a5.25 5.25 0 1 1 7.424 7.424l-1.757 1.757a.75.75 0 1 1-1.06-1.06l1.757-1.757a3.75 3.75 0 0 0 0-5.304Zm-7.389 4.267a.75.75 0 0 1 1-.353 5.25 5.25 0 0 1 1.449 8.45l-4.5 4.5a5.25 5.25 0 1 1-7.424-7.424l1.757-1.757a.75.75 0 1 1 1.06 1.06l-1.757 1.757a3.75 3.75 0 1 0 5.304 5.304l4.5-4.5a3.75 3.75 0 0 0-1.035-6.037.75.75 0 0 1-.354-1Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Vy(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M3 4.875C3 3.839 3.84 3 4.875 3h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 0 1 3 9.375v-4.5ZM4.875 4.5a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5Zm7.875.375c0-1.036.84-1.875 1.875-1.875h4.5C20.16 3 21 3.84 21 4.875v4.5c0 1.036-.84 1.875-1.875 1.875h-4.5a1.875 1.875 0 0 1-1.875-1.875v-4.5Zm1.875-.375a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5ZM6 6.75A.75.75 0 0 1 6.75 6h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75A.75.75 0 0 1 6 7.5v-.75Zm9.75 0A.75.75 0 0 1 16.5 6h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75ZM3 14.625c0-1.036.84-1.875 1.875-1.875h4.5c1.036 0 1.875.84 1.875 1.875v4.5c0 1.035-.84 1.875-1.875 1.875h-4.5A1.875 1.875 0 0 1 3 19.125v-4.5Zm1.875-.375a.375.375 0 0 0-.375.375v4.5c0 .207.168.375.375.375h4.5a.375.375 0 0 0 .375-.375v-4.5a.375.375 0 0 0-.375-.375h-4.5Zm7.875-.75a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm6 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75ZM6 16.5a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm9.75 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm-3 3a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Zm6 0a.75.75 0 0 1 .75-.75h.75a.75.75 0 0 1 .75.75v.75a.75.75 0 0 1-.75.75h-.75a.75.75 0 0 1-.75-.75v-.75Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Fy(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M12 1.5c-1.921 0-3.816.111-5.68.327-1.497.174-2.57 1.46-2.57 2.93V21.75a.75.75 0 0 0 1.029.696l3.471-1.388 3.472 1.388a.75.75 0 0 0 .556 0l3.472-1.388 3.471 1.388a.75.75 0 0 0 1.029-.696V4.757c0-1.47-1.073-2.756-2.57-2.93A49.255 49.255 0 0 0 12 1.5Zm3.53 7.28a.75.75 0 0 0-1.06-1.06l-6 6a.75.75 0 1 0 1.06 1.06l6-6ZM8.625 9a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Zm5.625 3.375a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Hy(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.006 5.404.434c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.434 2.082-5.005Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function Uy(e, t) {
  return f(), y("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    m("path", {
      "fill-rule": "evenodd",
      d: "M19.253 2.292a.75.75 0 0 1 .955.461A28.123 28.123 0 0 1 21.75 12c0 3.266-.547 6.388-1.542 9.247a.75.75 0 1 1-1.416-.494c.94-2.7 1.458-5.654 1.458-8.753s-.519-6.054-1.458-8.754a.75.75 0 0 1 .461-.954Zm-14.227.013a.75.75 0 0 1 .414.976A23.183 23.183 0 0 0 3.75 12c0 3.085.6 6.027 1.69 8.718a.75.75 0 0 1-1.39.563c-1.161-2.867-1.8-6-1.8-9.281 0-3.28.639-6.414 1.8-9.281a.75.75 0 0 1 .976-.414Zm4.275 5.052a1.5 1.5 0 0 1 2.21.803l.716 2.148L13.6 8.246a2.438 2.438 0 0 1 2.978-.892l.213.09a.75.75 0 1 1-.584 1.381l-.214-.09a.937.937 0 0 0-1.145.343l-2.021 3.033 1.084 3.255 1.445-.89a.75.75 0 1 1 .786 1.278l-1.444.889a1.5 1.5 0 0 1-2.21-.803l-.716-2.148-1.374 2.062a2.437 2.437 0 0 1-2.978.892l-.213-.09a.75.75 0 0 1 .584-1.381l.214.09a.938.938 0 0 0 1.145-.344l2.021-3.032-1.084-3.255-1.445.89a.75.75 0 1 1-.786-1.278l1.444-.89Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const Wy = /* @__PURE__ */ z({
  __name: "VarIcons",
  props: {
    iconName: { default: "variable" }
  },
  setup(e) {
    const t = {
      "building-storefront": By,
      gift: zy,
      "globe-alt": Ny,
      "qr-code": Vy,
      link: jy,
      "receipt-percent": Fy,
      star: Hy,
      variable: Uy
    };
    return (n, o) => (f(), j(Le(t[n.iconName]), { class: "h-5 w-5" }));
  }
}), qy = { class: "ml-2 block cursor-pointer truncate text-base font-medium leading-5" }, Zy = { class: "mt-1 text-sm text-gray-800" }, Gy = { class: "text-gray-400" }, Fl = /* @__PURE__ */ z({
  __name: "VarListItem",
  props: {
    customVar: {},
    i18nStrings: {},
    isSelected: { type: Boolean }
  },
  setup(e) {
    return (t, n) => (f(), y("div", {
      class: O(["cursor-pointer px-4 py-3", {
        "bg-slate-100": !t.customVar.disabled && t.isSelected,
        "hover:bg-slate-50": !t.customVar.disabled && !t.isSelected
      }])
    }, [
      m("div", {
        class: O(["flex flex-col", { "opacity-50": t.customVar.disabled }])
      }, [
        m("div", {
          class: O(["flex flex-row items-center", t.customVar.disabled ? "text-gray-600" : "text-blue-600"])
        }, [
          B(Wy, {
            "icon-name": t.customVar.icon
          }, null, 8, ["icon-name"]),
          m("label", qy, R(t.customVar.label), 1)
        ], 2),
        m("p", Zy, [
          ce(R(t.customVar.description) + " ", 1),
          m("i", Gy, "(" + R(t.customVar.length) + " " + R(t.i18nStrings.characters) + ")", 1)
        ])
      ], 2)
    ], 2));
  }
}), Hn = (e, t, n) => e.reduce((r, i) => {
  if (!i.isVar && i.textValue)
    return r + i.textValue;
  if (i.isVar && i.textValue) {
    const s = gi(i.textValue, n);
    if (t && (s != null && s.example)) {
      const { value: a } = Uo(i.textValue, n);
      return s.hasCustomValue && a ? `${r}${a}` : `${r}${s.example}`;
    }
    return `${r}{{ ${i.textValue} }}`;
  }
  return r;
}, ""), oo = (e) => {
  if (!e)
    return [{ textValue: " ", isVar: !1 }];
  const t = [];
  let n = { textValue: "", isVar: !1 };
  for (let o = 0; o < e.length; o++) {
    const r = e[o], i = e[o + 1];
    r === "{" && i === "{" ? (n.textValue && t.push(n), n = { textValue: "", isVar: !0 }, o++) : r === "}" && i === "}" ? (n.textValue && t.push({ ...n, textValue: n.textValue.trim() }), n = { textValue: "", isVar: !1 }, o++) : n.textValue += r;
  }
  return n.textValue && t.push(n), t;
}, Uo = (e, t) => {
  const n = e.match(/(.*?)\((.*?)\)/);
  if (n) {
    const o = n[1], r = n[2], i = gi(o, t);
    if (i)
      return { value: r, varCode: o, customVar: i };
  }
  return {
    value: null,
    varCode: null,
    customVar: null
  };
}, Ky = (e) => e.replaceAll("  {{", " {{").replaceAll("}}  ", "}} "), Yy = (e) => e.replaceAll("{{", "{{ ").replaceAll("}}", " }}").replaceAll("{{  ", "{{ ").replaceAll("  }}", " }}"), ks = (e, t = !1) => {
  var n;
  if (t) {
    const o = ["\\", "[", "]", "{", "}", "~", "^", "|", "€"];
    return (n = e == null ? void 0 : e.split("")) == null ? void 0 : n.reduce((r, i) => o.includes(i) ? r + 2 : r + 1, 0);
  }
  return e.length;
}, Lt = ({
  textModelValue: e,
  varList: t,
  sanitizeForGsm: n = !1
}) => oo(e).reduce((r, i) => {
  if (i.isVar === !1)
    return r + ks(i == null ? void 0 : i.textValue, n);
  if (i.isVar === !0) {
    const s = t.find((u) => u.code === (i == null ? void 0 : i.textValue));
    if (s)
      return r + s.length;
    const { value: a, customVar: l } = Uo(i.textValue, t);
    return a && (l != null && l.hasCustomValue) ? r + l.length : r + ks(`{{ ${i == null ? void 0 : i.textValue} }}`, n);
  }
}, 0), Mr = (e, t) => gi(e, t) !== void 0, gi = (e, t) => t == null ? void 0 : t.find((n) => n.code === e || n.hasCustomValue && Xy(e, n.code)), Es = (e) => /[^\p{L}\p{N}\p{P}\p{Z}\p{M}^$€<>=+¨~−\n]/gu.test(e), Xy = (e, t) => {
  var n;
  return ((n = e.match(`${t}((.*))`)) == null ? void 0 : n.length) >= 1;
}, Qy = {
  key: 0,
  class: "mt-2 flex cursor-pointer flex-row items-center text-sm font-medium text-blue-600 hover:underline"
}, Os = /* @__PURE__ */ z({
  __name: "DropdownVars",
  props: {
    customVars: {},
    label: {},
    i18nStrings: {},
    textareaPosition: {},
    type: { default: "insert" }
  },
  emits: ["varClicked"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = A(!1), i = A(!1), s = A(""), a = A(null), l = (b, h) => {
      b != null && b.hasCustomValue ? (h.preventDefault(), h.stopPropagation(), i.value = !0, a.value = b) : (b == null ? void 0 : b.disabled) !== !0 && (o("varClicked", b.code), v());
    }, u = A(0), c = A(null), d = (b) => {
      r.value = !0, n.type === "update" && x();
      const h = b.target.getBoundingClientRect().left - n.textareaPosition.left;
      let S = b.target.getBoundingClientRect().width;
      ke(() => {
        if (c.value.$el) {
          const g = c.value.$el.getBoundingClientRect().width;
          n.type === "update" && (S += 10), h + g > n.textareaPosition.width ? u.value = S - g : u.value = 0;
        }
      });
    }, p = () => {
      var b;
      o("varClicked", `${(b = a.value) == null ? void 0 : b.code}(${s.value})`), v();
    };
    Ep(c, () => {
      v();
    });
    const v = () => {
      r.value = !1, i.value = !1, a.value = null, s.value = "";
    }, x = () => {
      const { value: b, customVar: h } = Uo(n.label, n.customVars);
      b && h && (s.value = b, i.value = !0, a.value = h);
    };
    return (b, h) => (f(), j(T(ko), null, {
      default: F(() => [
        B(T(Zr), {
          as: "span",
          class: "border-transparent bg-transparent py-0 focus:border-transparent focus:ring-transparent",
          onClick: d
        }, {
          default: F(() => [
            b.type === "insert" ? (f(), y("div", Qy, [
              B(T(jl), { class: "mr-1 h-4 w-4" }),
              ce(R(b.label), 1)
            ])) : P("", !0),
            b.type === "update" ? (f(), y("span", {
              key: 1,
              spellcheck: "false",
              class: O(T(Mr)(b.label, b.customVars) ? "text-blue-500" : "text-amber-500")
            }, R(b.label), 3)) : P("", !0)
          ]),
          _: 1
        }),
        B(Gt, {
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: F(() => [
            r.value ? (f(), j(T(Eo), {
              key: 0,
              ref_key: "dropdownMenu",
              ref: c,
              static: "",
              class: O(["absolute z-10 max-h-72 w-72 overflow-auto rounded-md border bg-white text-base shadow-lg ring-0 focus:outline-none sm:text-sm", b.type === "update" ? "top-6" : "top-8"]),
              style: De({ left: `${u.value}px` })
            }, {
              default: F(() => [
                i.value ? (f(), j(Vl, {
                  key: 0,
                  modelValue: s.value,
                  "onUpdate:modelValue": h[0] || (h[0] = (S) => s.value = S),
                  "i18n-strings": b.i18nStrings,
                  "is-editing": b.type === "update",
                  onSave: p,
                  onBack: h[1] || (h[1] = (S) => i.value = !1)
                }, null, 8, ["modelValue", "i18n-strings", "is-editing"])) : (f(!0), y(K, { key: 1 }, se(b.customVars, (S) => (f(), j(T(In), {
                  key: S.code,
                  value: S,
                  as: "template",
                  disabled: S.disabled,
                  onClick: (g) => l(S, g)
                }, {
                  default: F(() => [
                    B(Fl, {
                      "custom-var": S,
                      "i18n-strings": b.i18nStrings,
                      "is-selected": !S.disabled && b.type === "update" && b.label === S.code
                    }, null, 8, ["custom-var", "i18n-strings", "is-selected"])
                  ]),
                  _: 2
                }, 1032, ["value", "disabled", "onClick"]))), 128))
              ]),
              _: 1
            }, 8, ["class", "style"])) : P("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), Jy = { class: "sm:col-span-6" }, ew = ["for"], tw = ["id", "name"], nw = ["data-index"], ow = /* @__PURE__ */ m("span", { style: { "line-height": "0", "font-size": "0" } }, "{", -1), rw = /* @__PURE__ */ m("span", { style: { "line-height": "0", "font-size": "0" } }, "{ ", -1), iw = ["onClick"], sw = /* @__PURE__ */ m("span", { style: { "line-height": "0", "font-size": "0" } }, " }", -1), aw = /* @__PURE__ */ m("span", { style: { "line-height": "0", "font-size": "0" } }, "}", -1), lw = ["textContent"], uw = ["data-cy"], cw = { class: "max-h-72 w-full overflow-auto rounded-md border-[1px] ring-gray-200 sm:text-sm" }, dw = { class: "flex flex-row items-center" }, pw = { class: "mt-2 flex-grow text-xs text-gray-600" }, fw = {
  key: 1,
  class: "font-medium text-red-600"
}, hw = {
  key: 0,
  class: "relative"
}, vw = { key: 1 }, k7 = /* @__PURE__ */ z({
  __name: "TextareaWithVars",
  props: {
    modelValue: {},
    i18nStrings: {},
    label: {},
    customVars: {},
    maxLength: { default: null },
    varListPosition: { default: "dropdown" },
    isDisabled: { type: Boolean },
    messageContentRef: { default: null },
    dataCy: { default: null },
    sanitizeForGsm: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:exampleValue", "update:messageLength", "update:messageContentRef", "hasError"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = sn(n, "modelValue", o), i = sn(n, "messageContentRef", o), s = A([]), a = A(!1), l = A(!1), u = A(null), c = A(null), d = A(null), p = A(!1);
    ae(() => {
      n.sanitizeForGsm && (p.value = Es(r.value)), s.value = oo(r.value), i.value = c.value, o(
        "hasError",
        Lt({
          textModelValue: r.value,
          varList: n.customVars,
          sanitizeForGsm: n.sanitizeForGsm
        }) > n.maxLength || p.value
      ), o("update:exampleValue", Hn(s.value, !0, n.customVars)), o(
        "update:messageLength",
        Lt({
          textModelValue: r.value,
          varList: n.customVars,
          sanitizeForGsm: n.sanitizeForGsm
        })
      );
    }), he(r, () => {
      s.value = oo(r.value), i.value = c.value, o("update:exampleValue", Hn(s.value, !0, n.customVars)), o(
        "update:messageLength",
        Lt({
          textModelValue: r.value,
          varList: n.customVars,
          sanitizeForGsm: n.sanitizeForGsm
        })
      ), n.sanitizeForGsm && (p.value = Es(r.value)), o(
        "hasError",
        Lt({
          textModelValue: r.value,
          varList: n.customVars,
          sanitizeForGsm: n.sanitizeForGsm
        }) > n.maxLength || p.value
      );
    });
    const { width: v, left: x } = Tp(d), b = E(() => v.value), h = E(() => x.value), S = (V, q) => {
      const ee = n.customVars.find((ue) => ue.code === V);
      if (s.value[q] && (ee == null ? void 0 : ee.disabled) !== !0) {
        if (ee != null && ee.hasCustomValue && H.value === !1) {
          X.value = ee, H.value = !0;
          return;
        }
        s.value[q] = {
          isVar: !0,
          textValue: V
        };
        const ue = Hn(s.value);
        C(ue), Oe();
      }
    }, g = (V) => {
      const q = n.customVars.find((ee) => ee.code === V);
      if ((q == null ? void 0 : q.disabled) !== !0) {
        if (q != null && q.hasCustomValue) {
          X.value = q, H.value = !0;
          return;
        }
        const ee = u.value ?? r.value.length, ue = `${r.value.slice(
          0,
          ee
        )} {{ ${V} }} ${r.value.slice(ee)}`;
        u.value = ee + 7 + V.length, C(Ky(ue)), Oe();
      }
    }, C = (V) => {
      s.value = oo(V), o("update:modelValue", V), o("update:exampleValue", Hn(s.value, !0, n.customVars));
    }, w = () => {
      a.value = !1, C(Yy(r.value));
    }, $ = (V = !1) => {
      if (V === !1) {
        let q = u.value ?? r.value.length;
        a.value = !0, ke(() => {
          c.value.focus(), c.value.setSelectionRange(q, q), l.value = !1;
        });
      }
    }, k = (V) => {
      u.value = V.target.selectionStart;
    }, _ = (V) => {
      n.isDisabled || (u.value = M(V), $());
    }, M = (V) => {
      let ee = window.getSelection().getRangeAt(0).startOffset;
      const te = V.target.closest("span[data-index]");
      if (te) {
        const Ce = parseInt(te.getAttribute("data-index") || "0", 10);
        if (Ce > 0)
          for (let je = 0; je < Ce; je++) {
            const dt = s.value[je], mn = dt.isVar ? 6 : 0;
            ee += dt.textValue.length + mn;
          }
      } else
        ee = r.value.length;
      return ee;
    }, U = E(() => (V, q) => {
      const ee = n.isDisabled ? "cursor-default" : "cursor-pointer", ue = N.value === V, te = Mr(q.textValue, n.customVars), Ce = n.isDisabled ? [] : ["hover:bg-slate-200", "hover:border-slate-300"], je = n.isDisabled ? [] : ["hover:bg-amber-200", "hover:border-amber-300"];
      return ue && te ? [ee, "bg-slate-200", "border-slate-300"] : ue && !te ? [ee, "bg-amber-200", "border-amber-300"] : te ? [ee, "border-slate-200", "bg-slate-100", ...Ce] : [ee, "border-amber-200", "bg-amber-100", ...je];
    }), L = A(!1), N = A(null), Z = A(null), H = A(!1), J = A(""), X = A(null), ie = (V, q) => {
      const { value: ee, customVar: ue } = Uo(V, n.customVars);
      N.value === q && L.value === !0 ? Oe() : ue && N.value !== q ? (H.value = !0, N.value = q, Z.value = ue.code, X.value = ue, J.value = ee, L.value = !0) : (Se(), N.value = q, Z.value = V, L.value === !1 && (L.value = !0));
    }, ye = () => {
      Se(), L.value === !0 && (Z.value !== null || N.value !== null) ? (Z.value = null, N.value = null) : L.value === !0 && !(Z.value !== null || N.value !== null) ? Oe() : L.value === !1 && (L.value = !0);
    }, Se = () => {
      H.value = !1, X.value = null, J.value = "";
    }, Oe = () => {
      Z.value = null, N.value = null, L.value = !1, Se();
    }, qe = () => {
      var V, q;
      N.value !== null ? S(`${(V = X.value) == null ? void 0 : V.code}(${J.value})`, N.value) : g(`${(q = X.value) == null ? void 0 : q.code}(${J.value})`), Se();
    };
    return (V, q) => {
      var ee, ue;
      return f(), y("div", Jy, [
        m("label", {
          for: V.label,
          class: "block text-sm font-medium text-gray-800"
        }, R((ee = V.i18nStrings) == null ? void 0 : ee.textareaLabel), 9, ew),
        a.value === !1 ? (f(), y("div", {
          key: 0,
          id: V.label,
          ref_key: "editableDiv",
          ref: d,
          name: V.label,
          class: O([
            "mt-2 min-h-[78px] w-full whitespace-pre-wrap rounded-md border border-gray-200 px-3 py-2 outline-none ring-gray-200 sm:text-sm",
            {
              "cursor-default bg-gray-50 text-gray-400": V.isDisabled,
              "bg-white text-gray-800": !V.isDisabled,
              "border-red-300": p.value || T(Lt)({
                textModelValue: T(r),
                varList: V.customVars,
                sanitizeForGsm: V.sanitizeForGsm
              }) > V.maxLength
            }
          ]),
          tabindex: "0",
          onMousedown: q[1] || (q[1] = (te) => l.value = !0),
          onMouseup: q[2] || (q[2] = (te) => _(te)),
          onFocusin: q[3] || (q[3] = (te) => $(l.value))
        }, [
          (f(!0), y(K, null, se(s.value, (te, Ce) => (f(), y("span", {
            key: "text-block-" + Ce,
            "data-index": Ce
          }, [
            te.isVar ? (f(), y("span", {
              key: 0,
              class: O(["relative inline-block rounded-md border px-1 leading-[18px]", U.value(Ce, te)]),
              onMouseup: q[0] || (q[0] = (je) => je.stopPropagation())
            }, [
              ow,
              rw,
              V.varListPosition === "dropdown" ? (f(), j(Os, {
                key: 0,
                type: "update",
                label: te.textValue,
                "custom-vars": V.customVars,
                "i18n-strings": V.i18nStrings,
                "textarea-position": { width: b.value, left: h.value },
                onVarClicked: (je) => S(je, Ce)
              }, null, 8, ["label", "custom-vars", "i18n-strings", "textarea-position", "onVarClicked"])) : P("", !0),
              V.varListPosition === "below" ? (f(), y("span", {
                key: 1,
                spellcheck: "false",
                class: O(T(Mr)(te.textValue, V.customVars) ? "text-blue-500" : "text-amber-500"),
                onClick: (je) => ie(te.textValue, Ce)
              }, R(te.textValue), 11, iw)) : P("", !0),
              sw,
              aw
            ], 34)) : (f(), y("span", {
              key: 1,
              class: "inline whitespace-pre-wrap !outline-none",
              textContent: R(te.textValue)
            }, null, 8, lw))
          ], 8, nw))), 128))
        ], 42, tw)) : P("", !0),
        ze(m("textarea", {
          ref_key: "textareaRef",
          ref: c,
          "onUpdate:modelValue": q[4] || (q[4] = (te) => mo(r) ? r.value = te : null),
          "data-cy": V.dataCy,
          class: "!outline-2px !border-1px mt-2 block min-h-[78px] w-full resize-none whitespace-pre-wrap rounded-md border-[1px] !border-transparent px-3 py-2 !outline-offset-0 !outline-violet-800 ring-gray-200 sm:text-sm",
          onBlur: q[5] || (q[5] = (te) => k(te)),
          onFocusout: w
        }, null, 40, uw), [
          [At, a.value === !0],
          [rn, T(r)]
        ]),
        ze(m("div", {
          class: O([
            "w-full overflow-hidden transition-[margin-top] transition-[max-height] duration-300 ease-in-out",
            L.value ? "mt-2 max-h-72" : "mt-0 max-h-0"
          ])
        }, [
          m("div", cw, [
            H.value ? (f(), j(Vl, {
              key: 0,
              modelValue: J.value,
              "onUpdate:modelValue": q[6] || (q[6] = (te) => J.value = te),
              "i18n-strings": V.i18nStrings,
              "is-editing": N.value !== null,
              onSave: qe,
              onBack: q[7] || (q[7] = (te) => H.value = !1)
            }, null, 8, ["modelValue", "i18n-strings", "is-editing"])) : (f(!0), y(K, { key: 1 }, se(V.customVars, (te) => (f(), j(Fl, {
              key: te.code,
              "custom-var": te,
              "i18n-strings": V.i18nStrings,
              "is-selected": Z.value === te.code,
              onClick: (Ce) => N.value !== null ? S(te.code, N.value) : g(te.code)
            }, null, 8, ["custom-var", "i18n-strings", "is-selected", "onClick"]))), 128))
          ])
        ], 2), [
          [At, V.varListPosition === "below" && !V.isDisabled]
        ]),
        m("div", dw, [
          m("p", pw, [
            V.maxLength !== null ? (f(), y("span", {
              key: 0,
              class: O({
                "font-medium text-red-600": T(Lt)({
                  textModelValue: T(r),
                  varList: V.customVars,
                  sanitizeForGsm: V.sanitizeForGsm
                }) > V.maxLength
              })
            }, R(T(Lt)({
              textModelValue: T(r),
              varList: V.customVars,
              sanitizeForGsm: V.sanitizeForGsm
            })) + "/" + R(V.maxLength) + " " + R(V.i18nStrings.characters), 3)) : P("", !0),
            p.value ? (f(), y("span", fw, " - " + R(V.i18nStrings.errorEmojiInMessage), 1)) : P("", !0)
          ]),
          V.varListPosition === "dropdown" && !V.isDisabled ? (f(), y("div", hw, [
            ((ue = V.customVars) == null ? void 0 : ue.length) > 0 ? (f(), j(Os, {
              key: 0,
              label: V.i18nStrings.insertVar,
              "custom-vars": V.customVars,
              "i18n-strings": V.i18nStrings,
              "textarea-position": { width: b.value, left: h.value },
              onVarClicked: g
            }, null, 8, ["label", "custom-vars", "i18n-strings", "textarea-position"])) : P("", !0)
          ])) : P("", !0),
          V.varListPosition === "below" && !V.isDisabled ? (f(), y("div", vw, [
            m("a", {
              class: "mt-2 flex cursor-pointer flex-row items-center text-sm font-medium text-blue-600 hover:underline",
              onClick: ye
            }, [
              B(T(jl), { class: "mr-1 h-4 w-4" }),
              ce(R(V.i18nStrings.insertVar), 1)
            ])
          ])) : P("", !0)
        ])
      ]);
    };
  }
});
var mw = Object.defineProperty, gw = (e, t, n) => t in e ? mw(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Cn = (e, t, n) => gw(e, typeof t != "symbol" ? t + "" : t, n);
const As = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, _s = (e, t, n) => e.replaceAll(t, "").replace(n, ".").replace("..", ".").replace(/[^.\d]/g, ""), Rs = (e, t, n) => {
  var o;
  return new Intl.NumberFormat(((o = n.number) == null ? void 0 : o.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, bw = (e, t = !0, n) => {
  var o, r, i, s;
  const a = ((o = n.number) == null ? void 0 : o.unsigned) !== !0 && e.startsWith("-") ? "-" : "", l = ((r = n.number) == null ? void 0 : r.fraction) ?? 0;
  let u = Rs(0, l, n);
  const c = u.formatToParts(1000.12), d = ((i = c.find((h) => h.type === "group")) == null ? void 0 : i.value) ?? " ", p = ((s = c.find((h) => h.type === "decimal")) == null ? void 0 : s.value) ?? ".", v = _s(e, d, p);
  if (Number.isNaN(parseFloat(v)))
    return a;
  const x = v.split(".");
  if (x[1] != null && x[1].length >= 1) {
    const h = x[1].length <= l ? x[1].length : l;
    u = Rs(h, l, n);
  }
  let b = u.format(parseFloat(v));
  return t ? l > 0 && v.endsWith(".") && !v.slice(0, -1).includes(".") && (b += p) : b = _s(b, d, p), a + b;
};
let yw = class {
  constructor(t = {}) {
    Cn(this, "opts", {}), Cn(this, "memo", /* @__PURE__ */ new Map());
    const n = { ...t };
    if (n.tokens != null) {
      n.tokens = n.tokensReplace ? { ...n.tokens } : { ...As, ...n.tokens };
      for (const o of Object.values(n.tokens))
        typeof o.pattern == "string" && (o.pattern = new RegExp(o.pattern));
    } else
      n.tokens = As;
    Array.isArray(n.mask) && (n.mask.length > 1 ? n.mask = [...n.mask].sort((o, r) => o.length - r.length) : n.mask = n.mask[0] ?? ""), n.mask === "" && (n.mask = null), this.opts = n;
  }
  masked(t) {
    return this.process(String(t), this.findMask(String(t)));
  }
  unmasked(t) {
    return this.process(String(t), this.findMask(String(t)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const n = this.findMask(String(t));
    if (this.opts.mask == null || n == null)
      return !1;
    const o = this.process(String(t), n).length;
    return typeof this.opts.mask == "string" ? o >= this.opts.mask.length : o >= n.length;
  }
  findMask(t) {
    const n = this.opts.mask;
    if (n == null)
      return null;
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return n(t);
    const o = this.process(t, n.slice(-1).pop() ?? "", !1);
    return n.find((r) => this.process(t, r, !1).length >= o.length) ?? "";
  }
  escapeMask(t) {
    const n = [], o = [];
    return t.split("").forEach((r, i) => {
      r === "!" && t[i - 1] !== "!" ? o.push(i - o.length) : n.push(r);
    }), { mask: n.join(""), escaped: o };
  }
  process(t, n, o = !0) {
    if (this.opts.number != null)
      return bw(t, o, this.opts);
    if (n == null)
      return t;
    const r = `v=${t},mr=${n},m=${o ? 1 : 0}`;
    if (this.memo.has(r))
      return this.memo.get(r);
    const { mask: i, escaped: s } = this.escapeMask(n), a = [], l = this.opts.tokens != null ? this.opts.tokens : {}, u = this.isReversed() ? -1 : 1, c = this.isReversed() ? "unshift" : "push", d = this.isReversed() ? 0 : i.length - 1, p = this.isReversed() ? () => h > -1 && S > -1 : () => h < i.length && S < t.length, v = (C) => !this.isReversed() && C <= d || this.isReversed() && C >= d;
    let x, b = -1, h = this.isReversed() ? i.length - 1 : 0, S = this.isReversed() ? t.length - 1 : 0, g = !1;
    for (; p(); ) {
      const C = i.charAt(h), w = l[C], $ = (w == null ? void 0 : w.transform) != null ? w.transform(t.charAt(S)) : t.charAt(S);
      if (!s.includes(h) && w != null ? ($.match(w.pattern) != null ? (a[c]($), w.repeated ? (b === -1 ? b = h : h === d && h !== b && (h = b - u), d === b && (h -= u)) : w.multiple && (g = !0, h -= u), h += u) : w.multiple ? g && (h += u, S -= u, g = !1) : $ === x ? x = void 0 : w.optional && (h += u, S -= u), S += u) : (o && !this.isEager() && a[c](C), $ === C && !this.isEager() ? S += u : x = C, this.isEager() || (h += u)), this.isEager())
        for (; v(h) && (l[i.charAt(h)] == null || s.includes(h)); ) {
          if (o) {
            if (a[c](i.charAt(h)), t.charAt(S) === i.charAt(h)) {
              h += u, S += u;
              continue;
            }
          } else
            i.charAt(h) === t.charAt(S) && (S += u);
          h += u;
        }
    }
    return this.memo.set(r, a.join("")), this.memo.get(r);
  }
};
const Hl = (e) => JSON.parse(e.replaceAll("'", '"')), ww = (e, t = {}) => {
  const n = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (n.mask = xw(e.dataset.maska)), e.dataset.maskaEager != null && (n.eager = Un(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (n.reversed = Un(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (n.tokensReplace = Un(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (n.tokens = $w(e.dataset.maskaTokens));
  const o = {};
  return e.dataset.maskaNumberLocale != null && (o.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (o.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (o.unsigned = Un(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(o).length > 0) && (n.number = o), n;
}, Un = (e) => e !== "" ? !!JSON.parse(e) : !0, xw = (e) => e.startsWith("[") && e.endsWith("]") ? Hl(e) : e, $w = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return Hl(e);
  const t = {};
  return e.split("|").forEach((n) => {
    const o = n.split(":");
    t[o[0]] = {
      pattern: new RegExp(o[1]),
      optional: o[2] === "optional",
      multiple: o[2] === "multiple",
      repeated: o[2] === "repeated"
    };
  }), t;
};
let Cw = class {
  constructor(t, n = {}) {
    Cn(this, "items", /* @__PURE__ */ new Map()), Cn(this, "eventAbortController"), Cn(this, "onInput", (o) => {
      if (o instanceof CustomEvent && o.type === "input" && !o.isTrusted && !o.bubbles)
        return;
      const r = o.target, i = this.items.get(r), s = "inputType" in o && o.inputType.startsWith("delete"), a = i.isEager(), l = s && a && i.unmasked(r.value) === "" ? "" : r.value;
      this.fixCursor(r, s, () => this.setValue(r, l));
    }), this.options = n, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    t.value !== "" && t.value !== this.processInput(t).masked && this.setValue(t, t.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(t) {
    const n = this.getOptions(this.options);
    for (const o of t) {
      if (!this.items.has(o)) {
        const { signal: i } = this.eventAbortController;
        o.addEventListener("input", this.onInput, { capture: !0, signal: i });
      }
      const r = new yw(ww(o, n));
      this.items.set(o, r), queueMicrotask(() => this.updateValue(o)), o.selectionStart === null && r.isEager() && console.warn("Maska: input of `%s` type is not supported", o.type);
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: n, preProcess: o, postProcess: r, ...i } = t;
    return i;
  }
  fixCursor(t, n, o) {
    const r = t.selectionStart, i = t.value;
    if (o(), r === null || r === i.length && !n)
      return;
    const s = t.value, a = i.slice(0, r), l = s.slice(0, r), u = this.processInput(t, a).unmasked, c = this.processInput(t, l).unmasked;
    let d = r;
    a !== l && (d += n ? s.length - i.length : u.length - c.length), t.setSelectionRange(d, d);
  }
  setValue(t, n) {
    const o = this.processInput(t, n);
    t.value = o.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((r) => r(o)) : this.options.onMaska(o)), t.dispatchEvent(new CustomEvent("maska", { detail: o })), t.dispatchEvent(new CustomEvent("input", { detail: o.masked }));
  }
  processInput(t, n) {
    const o = this.items.get(t);
    let r = n ?? t.value;
    this.options.preProcess != null && (r = this.options.preProcess(r));
    let i = o.masked(r);
    return this.options.postProcess != null && (i = this.options.postProcess(i)), {
      masked: i,
      unmasked: o.unmasked(r),
      completed: o.completed(r)
    };
  }
};
const sr = /* @__PURE__ */ new WeakMap(), Sw = (e, t) => {
  if (e.arg == null || e.instance == null)
    return;
  const n = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : n && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, kw = (e, t) => {
  var n;
  const o = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (o == null || (o == null ? void 0 : o.type) === "file")
    return;
  let r = {};
  if (t.value != null && (r = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const i = (s) => {
      const a = t.modifiers.unmasked ? s.unmasked : t.modifiers.completed ? s.completed : s.masked;
      Sw(t, a);
    };
    r.onMaska = r.onMaska == null ? i : Array.isArray(r.onMaska) ? [...r.onMaska, i] : [r.onMaska, i];
  }
  sr.has(o) ? (n = sr.get(o)) == null || n.update(r) : sr.set(o, new Cw(o, r));
}, Ew = {
  key: 0,
  class: "mb-1.5 flex w-full text-left text-sm font-normal text-gray-800"
}, Ow = ["for"], Aw = {
  key: 0,
  class: "ml-1 text-red-600"
}, _w = { class: "relative flex w-full" }, Rw = {
  key: 0,
  class: "inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-50 px-3"
}, Mw = ["value"], Tw = {
  key: 1,
  class: "inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 px-3"
}, Pw = {
  key: 1,
  class: "mt-1.5 text-sm font-normal"
}, Iw = ["href", "target"], A7 = /* @__PURE__ */ z({
  inheritAttrs: !1,
  __name: "MaskInput",
  props: {
    id: {},
    bgColor: { default: null },
    errors: { default: () => [] },
    label: { default: null },
    modelValue: { default: void 0 },
    pattern: { default: "" },
    mask: {},
    textColor: { default: null },
    tip: { default: null },
    toolTip: { default: null },
    errorClasses: { default: null }
  },
  emits: ["update:modelValue", "onFocus", "onBlur"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = Kt(), i = Ws(), s = A(!!r["icon-left"]), a = A(!!r["icon-right"]), l = E(() => {
      const p = [], v = s.value && a.value;
      return s.value || a.value ? (p.push("flex-1"), v || p.push(s.value ? "rounded-r-md" : "rounded-l-md")) : p.push("rounded-md"), p.join(" ");
    }), u = E(() => n.pattern === "b2c"), c = E(() => {
      var b;
      const p = ["block w-full sm:text-sm shadow-sm"];
      let v = [];
      u.value ? v = [
        "py-4",
        "rounded-xl",
        "focus:text-gray-800",
        "focus:ring-0",
        "border-transparent",
        "focus:border-transparent",
        "focus:ring-transparent",
        "caret-indigo-300",
        "bg-gray-50",
        "focus:bg-gray-100"
      ] : i.disabled ? v = ["border", "border-solid", "border-gray-200", "bg-gray-100", "text-gray-400"] : v = [
        "bg-white",
        "border",
        "border-solid",
        "border-gray-300",
        "text-gray-800",
        "bg-gray-50",
        "focus:border-violet-800",
        `${W({ type: "ring", value: "800", prefix: "focus" })}`,
        `${W({ type: "border", value: "800", prefix: "focus" })}`
      ];
      const x = ((b = n.errors) == null ? void 0 : b.length) > 0 ? ["border-red-300", "text-red-900", "placeholder-red-300"] : [];
      return n.bgColor && (v = v.filter((h) => !h.startsWith("bg-")), v.push(n.bgColor)), n.textColor ? (v = v.filter((h) => !h.startsWith("text-")), v.push(n.textColor)) : v.push("placeholder-gray-400"), [...p, ...v, ...x, l.value].join(" ");
    }), d = (p) => {
      let v = Vt(p);
      ["numeric", "decimal"].includes(i.type) && (v = Number(v)), o("update:modelValue", v);
    };
    return (p, v) => {
      var x, b, h;
      return f(), y("div", null, [
        p.label || p.toolTip ? (f(), y("div", Ew, [
          p.label ? (f(), y("label", {
            key: 0,
            for: p.id
          }, [
            ce(R(p.label), 1),
            p.$attrs.required ? (f(), y("sup", Aw, "*")) : P("", !0)
          ], 8, Ow)) : P("", !0),
          p.toolTip ? (f(), j(Dl, {
            key: 1,
            "tooltip-position": "top-start",
            "custom-styles": "bg-gray-600",
            text: p.toolTip
          }, {
            default: F(() => [
              B(T(Qr), { class: "ml-2 h-5 w-5 transform cursor-pointer text-gray-600" })
            ]),
            _: 1
          }, 8, ["text"])) : P("", !0)
        ])) : P("", !0),
        m("div", _w, [
          s.value ? (f(), y("span", Rw, [
            G(p.$slots, "icon-left")
          ])) : P("", !0),
          ze(m("input", _t({
            type: "text",
            value: p.modelValue,
            class: c.value
          }, p.$attrs, {
            onInput: d,
            onFocus: v[0] || (v[0] = (S) => o("onFocus")),
            onBlur: v[1] || (v[1] = (S) => o("onBlur"))
          }), null, 16, Mw), [
            [T(kw), p.mask]
          ]),
          a.value ? (f(), y("span", Tw, [
            G(p.$slots, "icon-right")
          ])) : P("", !0)
        ]),
        p.tip ? (f(), y("div", Pw, [
          m("a", {
            class: O(p.tip.link ? "cursor-pointer text-blue-600 hover:text-blue-700 hover:underline" : "text-gray-500"),
            href: (x = p.tip.link) == null ? void 0 : x.value,
            target: (b = p.tip.link) != null && b.isOpenedInNewTab ? "_blank" : "_self"
          }, R(p.tip.text), 11, Iw)
        ])) : P("", !0),
        ((h = p.errors) == null ? void 0 : h.length) > 0 ? (f(), y("p", {
          key: 2,
          id: "headline-error",
          class: O(["mt-2 text-sm text-red-600", p.errorClasses])
        }, R(p.errors[0]), 3)) : P("", !0)
      ]);
    };
  }
}), Lw = z({
  name: "Checkbox",
  props: {
    checked: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    description: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      required: !0
    },
    isRounded: {
      type: Boolean,
      default: !1
    },
    isButton: {
      type: Boolean,
      default: !1
    },
    value: {
      type: [String, Number, Boolean, Object],
      required: !0
    },
    modelValue: {
      type: [String, Number, Boolean, Array, Object],
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup() {
    return {
      getColorClass: W,
      handleCheckboxValue: qs
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    inputClasses() {
      const e = ["h-4 w-4 border-gray-300"];
      return e.push(W({ type: "ring", value: "800", prefix: "focus" })), e.push(
        this.disabled ? "bg-gray-100 text-gray-400" : W({
          type: "text",
          value: "800"
        })
      ), e.push(this.isRounded ? "rounded-full" : "rounded"), e;
    },
    buttonClasses() {
      const e = [
        "items-center rounded-md border border-gray-300 shadow-sm p-2 cursor-pointer transition text-center text-gray-700",
        W({
          type: "border",
          value: "800",
          prefix: "hover"
        }),
        W({
          type: "bg",
          value: "50",
          prefix: "hover"
        })
      ];
      return this.modelValue.includes(this.value) && e.push(
        W({
          type: "border",
          value: "800"
        }),
        W({
          type: "bg",
          value: "50"
        })
      ), e;
    }
  }
}), Dw = { class: "flex h-5 items-center" }, Bw = ["id", "value", "name", "disabled"], zw = { class: "ml-3 text-sm" }, Nw = ["for"];
function jw(e, t, n, o, r, i) {
  return f(), y("label", {
    class: O(["flex", e.isButton ? e.buttonClasses : "items-start"])
  }, [
    m("div", Dw, [
      ze(m("input", {
        id: e.id,
        "onUpdate:modelValue": t[0] || (t[0] = (s) => e.model = s),
        type: "checkbox",
        class: O([e.inputClasses, !e.disabled && "cursor-pointer"]),
        value: e.value,
        name: e.name,
        disabled: e.disabled
      }, null, 10, Bw), [
        [mu, e.model]
      ])
    ]),
    m("div", zw, [
      m("div", {
        for: e.id,
        class: O(e.disabled ? "text-gray-500" : "cursor-pointer text-gray-700")
      }, [
        ce(R(e.label) + " ", 1),
        G(e.$slots, "default")
      ], 10, Nw),
      e.description !== null ? (f(), y("p", {
        key: 0,
        class: O(e.disabled ? "text-gray-300" : "text-gray-500")
      }, R(e.description), 3)) : P("", !0)
    ])
  ], 2);
}
const _7 = /* @__PURE__ */ Ee(Lw, [["render", jw]]);
function Vw() {
  return {
    getColorIfHexa: (t, n) => /^#[0-9A-F]{6}$/i.test(n) ? n : t
  };
}
const Fw = z({
  name: "ColorPicker",
  props: {
    label: {
      type: String,
      default: null
    },
    tip: {
      type: String,
      default: null
    },
    id: {
      type: String,
      required: !0
    },
    modelValue: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e) {
    const { getColorIfHexa: t } = Vw();
    return {
      onChange: (o) => {
        o.target.value = e.modelValue;
      },
      getColorClass: W,
      getColorIfHexa: t,
      handleInputValue: Vt
    };
  }
});
const Hw = {
  key: 0,
  class: "mb-3"
}, Uw = ["for"], Ww = {
  key: 0,
  class: "mt-2 text-xs font-normal text-gray-500"
}, qw = { class: "grid auto-cols-max grid-flow-col rounded-md" }, Zw = ["id", "disabled", "value"], Gw = ["value", "disabled"];
function Kw(e, t, n, o, r, i) {
  return f(), y("div", null, [
    e.label ? (f(), y("div", Hw, [
      m("label", {
        for: e.id,
        class: "block w-full text-left text-sm font-medium text-gray-900"
      }, R(e.label), 9, Uw),
      e.tip ? (f(), y("div", Ww, R(e.tip), 1)) : P("", !0)
    ])) : P("", !0),
    m("div", qw, [
      m("input", {
        id: e.id,
        disabled: e.disabled,
        value: e.modelValue,
        type: "color",
        class: "w-50 mr-2 block h-full min-w-0 flex-1 cursor-pointer rounded-md border-gray-300 bg-transparent sm:text-sm",
        onInput: t[0] || (t[0] = (s) => e.$emit("update:modelValue", e.getColorIfHexa(e.modelValue, e.handleInputValue(s))))
      }, null, 40, Zw),
      m("input", {
        value: e.modelValue,
        disabled: e.disabled,
        type: "text",
        maxlength: "7",
        class: O(` ${e.getColorClass({ type: "ring", value: "800", prefix: "focus" })} ${e.getColorClass({
          type: "border",
          value: "800",
          prefix: "focus"
        })} w-24 min-w-0 rounded-md border-gray-300 sm:text-sm`),
        onInput: t[1] || (t[1] = (s) => e.$emit("update:modelValue", e.getColorIfHexa(e.modelValue, e.handleInputValue(s)))),
        onChange: t[2] || (t[2] = (...s) => e.onChange && e.onChange(...s))
      }, null, 42, Gw)
    ])
  ]);
}
const R7 = /* @__PURE__ */ Ee(Fw, [["render", Kw], ["__scopeId", "data-v-fe5cf982"]]), Yw = z({
  name: "Radio",
  props: {
    checked: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    description: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    value: {
      type: [String, Number, Boolean, Object],
      required: !0
    },
    modelValue: {
      type: [String, Number, Boolean, Array, Object],
      default: ""
    }
  },
  emits: ["update:modelValue"],
  setup() {
    return {
      getColorClass: W,
      handleCheckboxValue: qs
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}), Xw = { class: "flex items-start" }, Qw = { class: "flex h-5 items-center" }, Jw = ["id", "name", "checked", "value", "disabled"], e5 = {
  key: 0,
  class: "ml-3 text-sm"
}, t5 = ["for"];
function n5(e, t, n, o, r, i) {
  return f(), y("div", Xw, [
    m("div", Qw, [
      ze(m("input", {
        id: e.id,
        "onUpdate:modelValue": t[0] || (t[0] = (s) => e.model = s),
        type: "radio",
        name: e.name,
        checked: e.value === e.modelValue,
        class: O(` ${e.getColorClass({ type: "ring", value: "800", prefix: "focus" })} h-4 w-4 ${e.getColorClass({ type: "text", value: "800" })} cursor-pointer border-gray-300`),
        value: e.value,
        disabled: e.disabled,
        onInput: t[1] || (t[1] = (s) => e.$emit("update:modelValue", e.handleCheckboxValue(s)))
      }, null, 42, Jw), [
        [gu, e.model]
      ])
    ]),
    e.label ? (f(), y("div", e5, [
      m("label", {
        for: e.id,
        class: O(["cursor-pointer", e.disabled ? "text-gray-500" : "text-gray-700"])
      }, [
        ce(R(e.label) + " ", 1),
        G(e.$slots, "default")
      ], 10, t5),
      e.description !== null ? (f(), y("p", {
        key: 0,
        class: O(e.disabled ? "text-gray-300" : "text-gray-500")
      }, R(e.description), 3)) : P("", !0)
    ])) : P("", !0)
  ]);
}
const M7 = /* @__PURE__ */ Ee(Yw, [["render", n5]]);
function Ms(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function de(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ms(Object(n), !0).forEach(function(o) {
      Xe(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ms(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function Xe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function o5(e, t) {
  if (e == null)
    return {};
  var n, o, r = function(s, a) {
    if (s == null)
      return {};
    var l, u, c = {}, d = Object.keys(s);
    for (u = 0; u < d.length; u++)
      l = d[u], a.indexOf(l) >= 0 || (c[l] = s[l]);
    return c;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      n = i[o], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
  }
  return r;
}
function Zt(e) {
  return function(t) {
    if (Array.isArray(t))
      return ar(t);
  }(e) || function(t) {
    if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null)
      return Array.from(t);
  }(e) || function(t, n) {
    if (t) {
      if (typeof t == "string")
        return ar(t, n);
      var o = Object.prototype.toString.call(t).slice(8, -1);
      if (o === "Object" && t.constructor && (o = t.constructor.name), o === "Map" || o === "Set")
        return Array.from(t);
      if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o))
        return ar(t, n);
    }
  }(e) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function ar(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, o = new Array(t); n < t; n++)
    o[n] = e[n];
  return o;
}
var Ts, r5, Wn, Re = (Ts = function(e) {
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = [], r = 0; r < arguments.length; r++) {
        var i = arguments[r];
        if (i) {
          var s = typeof i;
          if (s === "string" || s === "number")
            o.push(i);
          else if (Array.isArray(i)) {
            if (i.length) {
              var a = n.apply(null, i);
              a && o.push(a);
            }
          } else if (s === "object")
            if (i.toString === Object.prototype.toString)
              for (var l in i)
                t.call(i, l) && i[l] && o.push(l);
            else
              o.push(i.toString());
        }
      }
      return o.join(" ");
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
}, Ts(Wn = { path: r5, exports: {}, require: function(e, t) {
  return function() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
  }(t == null && Wn.path);
} }, Wn.exports), Wn.exports), ct = function(e) {
  return function(t, n) {
    if (!t)
      return e;
    var o;
    typeof t == "string" ? o = t : n = t;
    var r = e;
    return o && (r += "__" + o), r + (n ? Object.keys(n).reduce(function(i, s) {
      var a = n[s];
      return a && (i += " " + (typeof a == "boolean" ? r + "--" + s : r + "--" + s + "_" + a)), i;
    }, "") : "");
  };
};
function Tr(e, t, n) {
  var o, r, i, s, a;
  function l() {
    var c = Date.now() - s;
    c < t && c >= 0 ? o = setTimeout(l, t - c) : (o = null, n || (a = e.apply(i, r), i = r = null));
  }
  t == null && (t = 100);
  var u = function() {
    i = this, r = arguments, s = Date.now();
    var c = n && !o;
    return o || (o = setTimeout(l, t)), c && (a = e.apply(i, r), i = r = null), a;
  };
  return u.clear = function() {
    o && (clearTimeout(o), o = null);
  }, u.flush = function() {
    o && (a = e.apply(i, r), i = r = null, clearTimeout(o), o = null);
  }, u;
}
Tr.debounce = Tr;
var Pr = Tr, Y = function() {
  return Y = Object.assign || function(e) {
    for (var t, n = 1, o = arguments.length; n < o; n++)
      for (var r in t = arguments[n])
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    return e;
  }, Y.apply(this, arguments);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function Ul(e, t) {
  var n, o;
  return e && t ? (n = "" + e + t[0].toUpperCase() + t.slice(1), o = e + "-" + t) : (n = e || t, o = e || t), { name: n, classname: o };
}
function Wl(e) {
  return /^blob:/.test(e);
}
function Ps(e) {
  return Wl(e) || function(t) {
    return /^data:/.test(t);
  }(e);
}
function nn(e) {
  return !!(e && e.constructor && e.call && e.apply);
}
function Te(e) {
  return e === void 0;
}
function ro(e) {
  return typeof e == "object" && e !== null;
}
function Ir(e, t, n) {
  var o = {};
  return ro(e) ? (Object.keys(t).forEach(function(r) {
    Te(e[r]) ? o[r] = t[r] : ro(t[r]) ? ro(e[r]) ? o[r] = Ir(e[r], t[r], n[r]) : o[r] = e[r] ? t[r] : n[r] : t[r] === !0 || t[r] === !1 ? o[r] = !!e[r] : o[r] = e[r];
  }), o) : e ? t : n;
}
function qn(e) {
  var t = Number(e);
  return Number.isNaN(t) ? e : t;
}
function Is(e) {
  return typeof (e == "number" || function(t) {
    return typeof t == "object" && t !== null;
  }(e) && toString.call(e) == "[object Number]") && !ql(e);
}
function ql(e) {
  return e != e;
}
function Zl(e, t) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
var Sn = function(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = {}), this.type = "manipulateImage", this.move = e, this.scale = t;
}, i5 = function(e, t) {
  t === void 0 && (t = {}), this.type = "resize", this.directions = e, this.params = t;
}, bi = function(e) {
  this.type = "move", this.directions = e;
}, s5 = function() {
  function e(t, n, o, r, i) {
    this.type = "drag", this.nativeEvent = t, this.position = o, this.previousPosition = r, this.element = n, this.anchor = i;
  }
  return e.prototype.shift = function() {
    var t = this, n = t.element, o = t.anchor, r = t.position;
    if (n) {
      var i = n.getBoundingClientRect(), s = i.left, a = i.top;
      return { left: r.left - s - o.left, top: r.top - a - o.top };
    }
    return { left: 0, top: 0 };
  }, e;
}(), yi = { name: "DraggableElement", props: { classname: { type: String } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  if (!this.$refs.draggable)
    throw new Error('You should add ref "draggable" to your root element to use draggable mixin');
  this.touches = [], this.hovered = !1;
}, methods: { onMouseOver: function() {
  this.hovered || (this.hovered = !0, this.$emit("enter"));
}, onMouseLeave: function() {
  this.hovered && !this.touches.length && (this.hovered = !1, this.$emit("leave"));
}, onTouchStart: function(e) {
  e.cancelable && !this.disabled && e.touches.length === 1 && (this.touches = Zt(e.touches), this.hovered || (this.$emit("enter"), this.hovered = !0), e.touches.length && this.initAnchor(this.touches.reduce(function(t, n) {
    return { clientX: t.clientX + n.clientX / e.touches.length, clientY: t.clientY + n.clientY / e.touches.length };
  }, { clientX: 0, clientY: 0 })), e.preventDefault && e.preventDefault(), e.stopPropagation());
}, onTouchEnd: function() {
  this.processEnd();
}, onTouchMove: function(e) {
  this.touches.length && (this.processMove(e, e.touches), e.preventDefault && e.preventDefault(), e.stopPropagation && e.stopPropagation());
}, onMouseDown: function(e) {
  if (!this.disabled) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.initAnchor(t), e.stopPropagation();
  }
}, onMouseMove: function(e) {
  this.touches.length && (this.processMove(e, [{ fake: !0, clientX: e.clientX, clientY: e.clientY }]), e.preventDefault && e.preventDefault());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(e) {
  var t = this.$refs.draggable.getBoundingClientRect(), n = t.left, o = t.right, r = t.bottom, i = t.top;
  this.anchor = { left: e.clientX - n, top: e.clientY - i, bottom: r - e.clientY, right: o - e.clientX };
}, processMove: function(e, t) {
  var n = Zt(t);
  if (this.touches.length) {
    if (this.touches.length === 1 && n.length === 1) {
      var o = this.$refs.draggable;
      this.$emit("drag", new s5(e, o, { left: n[0].clientX, top: n[0].clientY }, { left: this.touches[0].clientX, top: this.touches[0].clientY }, this.anchor));
    }
    this.touches = n;
  }
}, processEnd: function() {
  this.touches.length && this.$emit("drag-end"), this.hovered && (this.$emit("leave"), this.hovered = !1), this.touches = [];
} }, emits: ["drag", "drag-end", "leave", "enter"] };
yi.render = function(e, t, n, o, r, i) {
  return f(), j("div", { ref: "draggable", class: n.classname, onTouchstart: t[1] || (t[1] = function() {
    return i.onTouchStart && i.onTouchStart.apply(i, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return i.onMouseDown && i.onMouseDown.apply(i, arguments);
  }), onMouseover: t[3] || (t[3] = function() {
    return i.onMouseOver && i.onMouseOver.apply(i, arguments);
  }), onMouseleave: t[4] || (t[4] = function() {
    return i.onMouseLeave && i.onMouseLeave.apply(i, arguments);
  }) }, [G(e.$slots, "default")], 34);
};
var lr = ct("vue-handler-wrapper"), Gl = { name: "HandlerWrapper", components: { DraggableElement: yi }, props: { horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, computed: { classes: function() {
  var e;
  if (this.horizontalPosition || this.verticalPosition) {
    var t, n = Ul(this.horizontalPosition, this.verticalPosition);
    e = lr((Xe(t = {}, n.classname, !0), Xe(t, "disabled", this.disabled), t));
  } else
    e = lr({ disabled: this.disabled });
  return { root: e, draggable: lr("draggable") };
} }, emits: ["leave", "enter", "drag", "drag-end"] };
Gl.render = function(e, t, n, o, r, i) {
  var s = ne("DraggableElement");
  return f(), j("div", { class: i.classes.root }, [B(s, { class: i.classes.draggable, onDrag: t[1] || (t[1] = function(a) {
    return e.$emit("drag", a);
  }), onDragEnd: t[2] || (t[2] = function(a) {
    return e.$emit("drag-end");
  }), onLeave: t[3] || (t[3] = function(a) {
    return e.$emit("leave");
  }), onEnter: t[4] || (t[4] = function(a) {
    return e.$emit("enter");
  }) }, { default: F(function() {
    return [G(e.$slots, "default")];
  }), _: 3 }, 8, ["class"])], 2);
};
var a5 = ct("vue-line-wrapper"), Kl = { name: "LineWrapper", components: { DraggableElement: yi }, props: { position: { type: String, required: !0 }, disabled: { type: Boolean, default: !1 } }, computed: { classname: function() {
  var e;
  return a5((Xe(e = {}, this.position, !0), Xe(e, "disabled", this.disabled), e));
} }, emits: ["leave", "enter", "drag", "drag-end"] };
Kl.render = function(e, t, n, o, r, i) {
  var s = ne("DraggableElement");
  return f(), j(s, { class: i.classname, onDrag: t[1] || (t[1] = function(a) {
    return e.$emit("drag", a);
  }), onDragEnd: t[2] || (t[2] = function(a) {
    return e.$emit("drag-end");
  }), onLeave: t[3] || (t[3] = function(a) {
    return e.$emit("leave");
  }), onEnter: t[4] || (t[4] = function(a) {
    return e.$emit("enter");
  }) }, { default: F(function() {
    return [G(e.$slots, "default")];
  }), _: 3 }, 8, ["class"]);
};
var vt = ["left", "right", "top", "bottom"], l5 = ["left", "right"], u5 = ["top", "bottom"], c5 = ["left", "top"], d5 = ["fill-area", "fit-area", "stencil", "none"], Ls = { left: 0, top: 0, width: 0, height: 0 };
function Ds(e, t, n) {
  return !(n = n || ["width", "height", "left", "top"]).some(function(o) {
    return e[o] !== t[o];
  });
}
function xt(e) {
  return { left: e.left, top: e.top, right: e.left + e.width, bottom: e.top + e.height };
}
function dn(e, t) {
  return { left: e.left - t.left, top: e.top - t.top };
}
function Pe(e) {
  return { left: e.left + e.width / 2, top: e.top + e.height / 2 };
}
function An(e, t) {
  var n = { left: 0, top: 0, right: 0, bottom: 0 };
  return vt.forEach(function(o) {
    var r = t[o], i = xt(e)[o];
    n[o] = r !== void 0 && i !== void 0 ? o === "left" || o === "top" ? Math.max(0, r - i) : Math.max(0, i - r) : 0;
  }), n;
}
function ht(e, t) {
  return { left: e.left - t.left, top: e.top - t.top, width: e.width + t.left + t.right, height: e.height + t.top + t.bottom };
}
function Wo(e) {
  return { left: -e.left, top: -e.top };
}
function Ue(e, t) {
  return Y(Y({}, e), { left: e.left + t.left, top: e.top + t.top });
}
function Je(e, t, n, o) {
  if (t !== 1) {
    if (n) {
      var r = Pe(e);
      return { width: e.width * t, height: e.height * t, left: e.left + e.width * (1 - t) / 2 + (n.left - r.left) * (o || 1 - t), top: e.top + e.height * (1 - t) / 2 + (n.top - r.top) * (o || 1 - t) };
    }
    return { width: e.width * t, height: e.height * t, left: e.left + e.width * (1 - t) / 2, top: e.top + e.height * (1 - t) / 2 };
  }
  return e;
}
function pe(e) {
  return e.width / e.height;
}
function pn(e, t) {
  return Math.min(t.right !== void 0 && t.left !== void 0 ? (t.right - t.left) / e.width : 1 / 0, t.bottom !== void 0 && t.top !== void 0 ? (t.bottom - t.top) / e.height : 1 / 0);
}
function fn(e, t) {
  var n = { left: 0, top: 0 }, o = An(e, t);
  return o.left && o.left > 0 ? n.left = o.left : o.right && o.right > 0 && (n.left = -o.right), o.top && o.top > 0 ? n.top = o.top : o.bottom && o.bottom > 0 && (n.top = -o.bottom), n;
}
function ur(e, t) {
  var n;
  return t.minimum && e < t.minimum ? n = t.minimum : t.maximum && e > t.maximum && (n = t.maximum), n;
}
function Yl(e, t) {
  var n = pe(e), o = pe(t);
  return t.width < 1 / 0 && t.height < 1 / 0 ? n > o ? { width: t.width, height: t.width / n } : { width: t.height * n, height: t.height } : t.width < 1 / 0 ? { width: t.width, height: t.width / n } : t.height < 1 / 0 ? { width: t.height * n, height: t.height } : e;
}
function Xl(e, t) {
  var n = t * Math.PI / 180;
  return { width: Math.abs(e.width * Math.cos(n)) + Math.abs(e.height * Math.sin(n)), height: Math.abs(e.width * Math.sin(n)) + Math.abs(e.height * Math.cos(n)) };
}
function Et(e, t) {
  var n = t * Math.PI / 180;
  return { left: e.left * Math.cos(n) - e.top * Math.sin(n), top: e.left * Math.sin(n) + e.top * Math.cos(n) };
}
function qo(e, t) {
  var n = An(Ie(e, t), t);
  return n.left + n.right + n.top + n.bottom ? n.left + n.right > n.top + n.bottom ? Math.min((e.width + n.left + n.right) / e.width, pn(e, t)) : Math.min((e.height + n.top + n.bottom) / e.height, pn(e, t)) : 1;
}
function Ie(e, t, n) {
  n === void 0 && (n = !1);
  var o = fn(e, t);
  return Ue(e, n ? Wo(o) : o);
}
function Lr(e) {
  return { width: e.right !== void 0 && e.left !== void 0 ? e.right - e.left : 1 / 0, height: e.bottom !== void 0 && e.top !== void 0 ? e.bottom - e.top : 1 / 0 };
}
function p5(e, t) {
  return Y(Y({}, e), { minWidth: Math.min(t.width, e.minWidth), minHeight: Math.min(t.height, e.minHeight), maxWidth: Math.min(t.width, e.maxWidth), maxHeight: Math.min(t.height, e.maxHeight) });
}
function Ql(e, t, n) {
  n === void 0 && (n = !0);
  var o = {};
  return vt.forEach(function(r) {
    var i = e[r], s = t[r];
    i !== void 0 && s !== void 0 ? o[r] = r === "left" || r === "top" ? n ? Math.max(i, s) : Math.min(i, s) : n ? Math.min(i, s) : Math.max(i, s) : s !== void 0 ? o[r] = s : i !== void 0 && (o[r] = i);
  }), o;
}
function Zo(e, t) {
  return Ql(e, t, !0);
}
function Bs(e) {
  var t = e.size, n = e.aspectRatio, o = e.ignoreMinimum, r = e.sizeRestrictions;
  return !!((t.correctRatio || pe(t) >= n.minimum && pe(t) <= n.maximum) && t.height <= r.maxHeight && t.width <= r.maxWidth && t.width && t.height && (o || t.height >= r.minHeight && t.width >= r.minWidth));
}
function zs(e, t) {
  return Math.pow(e.width - t.width, 2) + Math.pow(e.height - t.height, 2);
}
function St(e) {
  var t = e.width, n = e.height, o = e.sizeRestrictions, r = { minimum: e.aspectRatio && e.aspectRatio.minimum || 0, maximum: e.aspectRatio && e.aspectRatio.maximum || 1 / 0 }, i = { width: Math.max(o.minWidth, Math.min(o.maxWidth, t)), height: Math.max(o.minHeight, Math.min(o.maxHeight, n)) };
  function s(u, c) {
    return c === void 0 && (c = !1), u.reduce(function(d, p) {
      return Bs({ size: p, aspectRatio: r, sizeRestrictions: o, ignoreMinimum: c }) && (!d || zs(p, { width: t, height: n }) < zs(d, { width: t, height: n })) ? p : d;
    }, null);
  }
  var a = [];
  r && [r.minimum, r.maximum].forEach(function(u) {
    u && a.push({ width: i.width, height: i.width / u, correctRatio: !0 }, { width: i.height * u, height: i.height, correctRatio: !0 });
  }), Bs({ size: i, aspectRatio: r, sizeRestrictions: o }) && a.push(i);
  var l = s(a) || s(a, !0);
  return l && { width: l.width, height: l.height };
}
function Dr(e) {
  var t = e.event, n = e.coordinates, o = e.positionRestrictions, r = o === void 0 ? {} : o, i = Ue(n, t.directions);
  return Ue(i, fn(i, r));
}
function f5(e) {
  var t = e.coordinates, n = e.transform, o = e.imageSize, r = e.sizeRestrictions, i = e.positionRestrictions, s = e.aspectRatio, a = e.visibleArea, l = function(c, d) {
    return Dr({ coordinates: c, positionRestrictions: i, event: new bi({ left: d.left - c.left, top: d.top - c.top }) });
  }, u = Y({}, t);
  return (Array.isArray(n) ? n : [n]).forEach(function(c) {
    var d = {};
    Te((d = typeof c == "function" ? c({ coordinates: u, imageSize: o, visibleArea: a }) : c).width) && Te(d.height) || (u = function(p, v) {
      var x = Y(Y(Y({}, p), St({ width: v.width, height: v.height, sizeRestrictions: r, aspectRatio: s })), { left: 0, top: 0 });
      return l(x, { left: p.left, top: p.top });
    }(u, Y(Y({}, u), d))), Te(d.left) && Te(d.top) || (u = l(u, Y(Y({}, u), d)));
  }), u;
}
function h5(e) {
  e.event;
  var t = e.getAreaRestrictions, n = e.boundaries, o = e.coordinates, r = e.visibleArea;
  e.aspectRatio;
  var i = e.stencilSize, s = e.sizeRestrictions, a = e.positionRestrictions;
  e.stencilReference;
  var l, u, c, d = Y({}, o), p = Y({}, r), v = Y({}, i);
  l = pe(v), u = pe(d), c === void 0 && (c = 1e-3), (l === 0 || u === 0 ? Math.abs(u - l) < c : Math.abs(u / l) < 1 + c && Math.abs(u / l) > 1 - c) || (d = Y(Y({}, d), St({ sizeRestrictions: s, width: d.width, height: d.height, aspectRatio: { minimum: pe(v), maximum: pe(v) } })));
  var x = qo(p = Je(p, d.width * n.width / (p.width * v.width)), t({ visibleArea: p, type: "resize" }));
  return x !== 1 && (p = Je(p, x), d = Je(d, x)), p = Ie(p = Ue(p, dn(Pe(d), Pe(p))), t({ visibleArea: p, type: "move" })), { coordinates: d = Ie(d, Zo(xt(p), a)), visibleArea: p };
}
function v5(e) {
  var t = e.event, n = e.getAreaRestrictions, o = e.boundaries, r = e.coordinates, i = e.visibleArea;
  e.aspectRatio, e.stencilSize, e.sizeRestrictions;
  var s = e.positionRestrictions;
  e.stencilReference;
  var a = Y({}, r), l = Y({}, i);
  if (r && i && t.type !== "manipulateImage") {
    var u = { width: 0, height: 0 };
    l.width, o.width, pe(o) > pe(a) ? (u.height = 0.8 * o.height, u.width = u.height * pe(a)) : (u.width = 0.8 * o.width, u.height = u.width * pe(a));
    var c = qo(l = Je(l, a.width * o.width / (l.width * u.width)), n({ visibleArea: l, type: "resize" }));
    l = Je(l, c), c !== 1 && (u.height /= c, u.width /= c), l = Ie(l = Ue(l, dn(Pe(a), Pe(l))), n({ visibleArea: l, type: "move" })), a = Ie(a, Zo(xt(l), s));
  }
  return { coordinates: a, visibleArea: l };
}
function m5(e) {
  var t = e.event, n = e.coordinates, o = e.visibleArea, r = e.getAreaRestrictions, i = Y({}, o), s = Y({}, n);
  if (t.type === "setCoordinates") {
    var a = Math.max(0, s.width - i.width), l = Math.max(0, s.height - i.height);
    a > l ? i = Je(i, Math.min(s.width / i.width, pn(i, r({ visibleArea: i, type: "resize" })))) : l > a && (i = Je(i, Math.min(s.height / i.height, pn(i, r({ visibleArea: i, type: "resize" }))))), i = Ie(i = Ue(i, Wo(fn(s, xt(i)))), r({ visibleArea: i, type: "move" }));
  }
  return { visibleArea: i, coordinates: s };
}
function g5(e) {
  var t = e.imageSize, n = e.visibleArea, o = e.coordinates, r = n || t;
  return { left: (n ? n.left : 0) + r.width / 2 - o.width / 2, top: (n ? n.top : 0) + r.height / 2 - o.height / 2 };
}
function b5(e) {
  var t = e.imageSize, n = e.visibleArea, o = e.aspectRatio, r = e.sizeRestrictions, i = n || t, s = Math.min(o.maximum || 1 / 0, Math.max(o.minimum || 0, pe(i))), a = i.width < i.height ? { width: 0.8 * i.width, height: 0.8 * i.width / s } : { height: 0.8 * i.height, width: 0.8 * i.height * s };
  return St(Y(Y({}, a), { aspectRatio: o, sizeRestrictions: r }));
}
function y5(e) {
  var t, n, o = e.imageSize, r = e.visibleArea, i = e.boundaries, s = e.aspectRatio, a = e.sizeRestrictions, l = e.stencilSize, u = r || o;
  return pe(u) > pe(i) ? n = (t = l.height * u.height / i.height) * pe(l) : t = (n = l.width * u.width / i.width) / pe(l), St({ width: n, height: t, aspectRatio: s, sizeRestrictions: a });
}
function w5(e) {
  var t = e.getAreaRestrictions, n = e.coordinates, o = e.imageSize, r = pe(e.boundaries);
  if (n) {
    var i = { height: Math.max(n.height, o.height), width: Math.max(n.width, o.width) }, s = Yl({ width: pe(i) > r ? i.width : i.height * r, height: pe(i) > r ? i.width / r : i.height }, Lr(t())), a = { left: n.left + n.width / 2 - s.width / 2, top: n.top + n.height / 2 - s.height / 2, width: s.width, height: s.height }, l = An(n, xt(Y({ left: 0, top: 0 }, o))), u = {};
    return !l.left && !l.right && a.width <= o.width && (u.left = 0, u.right = o.width), !l.top && !l.bottom && a.height <= o.height && (u.top = 0, u.bottom = o.height), Ie(a, u);
  }
  var c = pe(o);
  return s = { height: c > r ? o.height : o.width / r, width: c > r ? o.height * r : o.width }, { left: o.width / 2 - s.width / 2, top: o.height / 2 - s.height / 2, width: s.width, height: s.height };
}
function Zn(e, t) {
  return Ql(e, xt(t));
}
function x5(e) {
  var t = e.event, n = e.coordinates, o = e.visibleArea, r = e.sizeRestrictions, i = e.getAreaRestrictions, s = e.positionRestrictions, a = e.adjustStencil, l = t.scale, u = t.move, c = Y({}, o), d = Y({}, n), p = 1, v = 1, x = l.factor && Math.abs(l.factor - 1) > 1e-3;
  c = Ue(c, { left: u.left || 0, top: u.top || 0 });
  var b = { stencil: { minimum: Math.max(r.minWidth ? r.minWidth / d.width : 0, r.minHeight ? r.minHeight / d.height : 0), maximum: Math.min(r.maxWidth ? r.maxWidth / d.width : 1 / 0, r.maxHeight ? r.maxHeight / d.height : 1 / 0, pn(d, s)) }, area: { maximum: pn(c, i({ visibleArea: c, type: "resize" })) } };
  l.factor && x && (l.factor < 1 ? (v = Math.max(l.factor, b.stencil.minimum)) > 1 && (v = 1) : l.factor > 1 && (v = Math.min(l.factor, Math.min(b.area.maximum, b.stencil.maximum))) < 1 && (v = 1)), v && (c = Je(c, v, l.center));
  var h = n.left - o.left, S = o.width + o.left - (n.width + n.left), g = n.top - o.top, C = o.height + o.top - (n.height + n.top);
  return c = Ie(c = Ue(c, fn(c, { left: s.left !== void 0 ? s.left - h * v : void 0, top: s.top !== void 0 ? s.top - g * v : void 0, bottom: s.bottom !== void 0 ? s.bottom + C * v : void 0, right: s.right !== void 0 ? s.right + S * v : void 0 })), i({ visibleArea: c, type: "move" })), d.width = d.width * v, d.height = d.height * v, d.left = c.left + h * v, d.top = c.top + g * v, d = Ie(d, Zo(xt(c), s)), l.factor && x && a && (l.factor > 1 ? p = Math.min(b.area.maximum, l.factor) / v : l.factor < 1 && (p = Math.max(d.height / c.height, d.width / c.width, l.factor / v)), p !== 1 && (c = Ue(c = Ie(c = Je(c, p, l.factor > 1 ? l.center : Pe(d)), i({ visibleArea: c, type: "move" })), Wo(fn(d, xt(c)))))), { coordinates: d, visibleArea: c };
}
function $5(e) {
  var t = e.aspectRatio, n = e.getAreaRestrictions, o = e.coordinates, r = e.visibleArea, i = e.sizeRestrictions, s = e.positionRestrictions, a = e.imageSize, l = e.previousImageSize, u = e.angle, c = Y({}, o), d = Y({}, r), p = Et(Pe(Y({ left: 0, top: 0 }, l)), u);
  return (c = Y(Y({}, St({ sizeRestrictions: i, aspectRatio: t, width: c.width, height: c.height })), Et(Pe(c), u))).left -= p.left - a.width / 2 + c.width / 2, c.top -= p.top - a.height / 2 + c.height / 2, d = Je(d, qo(d, n({ visibleArea: d, type: "resize" }))), { coordinates: c = Ie(c, s), visibleArea: d = Ie(d = Ue(d, dn(Pe(c), Pe(o))), n({ visibleArea: d, type: "move" })) };
}
function C5(e) {
  var t = e.flip, n = e.previousFlip, o = e.rotate;
  e.aspectRatio;
  var r = e.getAreaRestrictions, i = e.coordinates, s = e.visibleArea, a = e.imageSize, l = Y({}, i), u = Y({}, s), c = n.horizontal !== t.horizontal, d = n.vertical !== t.vertical;
  if (c || d) {
    var p = Et({ left: a.width / 2, top: a.height / 2 }, -o), v = Et(Pe(l), -o), x = Et({ left: c ? p.left - (v.left - p.left) : v.left, top: d ? p.top - (v.top - p.top) : v.top }, o);
    l = Ue(l, dn(x, Pe(l))), v = Et(Pe(u), -o), u = Ie(u = Ue(u, dn(x = Et({ left: c ? p.left - (v.left - p.left) : v.left, top: d ? p.top - (v.top - p.top) : v.top }, o), Pe(u))), r({ visibleArea: u, type: "move" }));
  }
  return { coordinates: l, visibleArea: u };
}
function Ns(e) {
  var t = e.directions, n = e.coordinates, o = e.positionRestrictions, r = o === void 0 ? {} : o, i = e.sizeRestrictions, s = e.preserveRatio, a = e.compensate, l = Y({}, t), u = ht(n, l).width, c = ht(n, l).height;
  u < 0 && (l.left < 0 && l.right < 0 ? (l.left = -(n.width - i.minWidth) / (l.left / l.right), l.right = -(n.width - i.minWidth) / (l.right / l.left)) : l.left < 0 ? l.left = -(n.width - i.minWidth) : l.right < 0 && (l.right = -(n.width - i.minWidth))), c < 0 && (l.top < 0 && l.bottom < 0 ? (l.top = -(n.height - i.minHeight) / (l.top / l.bottom), l.bottom = -(n.height - i.minHeight) / (l.bottom / l.top)) : l.top < 0 ? l.top = -(n.height - i.minHeight) : l.bottom < 0 && (l.bottom = -(n.height - i.minHeight)));
  var d = An(ht(n, l), r);
  a && (d.left && d.left > 0 && d.right === 0 ? (l.right += d.left, l.left -= d.left) : d.right && d.right > 0 && d.left === 0 && (l.left += d.right, l.right -= d.right), d.top && d.top > 0 && d.bottom === 0 ? (l.bottom += d.top, l.top -= d.top) : d.bottom && d.bottom > 0 && d.top === 0 && (l.top += d.bottom, l.bottom -= d.bottom), d = An(ht(n, l), r));
  var p = { width: 1 / 0, height: 1 / 0, left: 1 / 0, right: 1 / 0, top: 1 / 0, bottom: 1 / 0 };
  if (vt.forEach(function(b) {
    var h = d[b];
    h && l[b] && (p[b] = Math.max(0, 1 - h / l[b]));
  }), s) {
    var v = Math.min.apply(null, vt.map(function(b) {
      return p[b];
    }));
    v !== 1 / 0 && vt.forEach(function(b) {
      l[b] *= v;
    });
  } else
    vt.forEach(function(b) {
      p[b] !== 1 / 0 && (l[b] *= p[b]);
    });
  if (u = ht(n, l).width, c = ht(n, l).height, l.right + l.left && (u > i.maxWidth ? p.width = (i.maxWidth - n.width) / (l.right + l.left) : u < i.minWidth && (p.width = (i.minWidth - n.width) / (l.right + l.left))), l.bottom + l.top && (c > i.maxHeight ? p.height = (i.maxHeight - n.height) / (l.bottom + l.top) : c < i.minHeight && (p.height = (i.minHeight - n.height) / (l.bottom + l.top))), s) {
    var x = Math.min(p.width, p.height);
    x !== 1 / 0 && vt.forEach(function(b) {
      l[b] *= x;
    });
  } else
    p.width !== 1 / 0 && l5.forEach(function(b) {
      l[b] *= p.width;
    }), p.height !== 1 / 0 && u5.forEach(function(b) {
      l[b] *= p.height;
    });
  return l;
}
function Gn(e, t, n) {
  return t == 0 && n == 0 ? e / 2 : t == 0 ? 0 : n == 0 ? e : e * Math.abs(t / (t + n));
}
var S5 = ct("vue-simple-handler"), k5 = ct("vue-simple-handler-wrapper"), wi = { name: "SimpleHandler", components: { HandlerWrapper: Gl }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, horizontalPosition: { type: String }, verticalPosition: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  var e, t = (Xe(e = {}, this.horizontalPosition, !!this.horizontalPosition), Xe(e, this.verticalPosition, !!this.verticalPosition), Xe(e, "".concat(this.horizontalPosition, "-").concat(this.verticalPosition), !!(this.verticalPosition && this.horizontalPosition)), Xe(e, "hover", this.hover), e);
  return { default: Re(S5(t), this.defaultClass, this.hover && this.hoverClass), wrapper: Re(k5(t), this.wrapperClass) };
} }, methods: { onDrag: function(e) {
  this.$emit("drag", e);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
wi.render = function(e, t, n, o, r, i) {
  var s = ne("HandlerWrapper");
  return f(), j(s, { class: i.classes.wrapper, "vertical-position": n.verticalPosition, "horizontal-position": n.horizontalPosition, disabled: n.disabled, onDrag: i.onDrag, onDragEnd: i.onDragEnd, onEnter: i.onEnter, onLeave: i.onLeave }, { default: F(function() {
    return [B("div", { class: i.classes.default }, null, 2)];
  }), _: 1 }, 8, ["class", "vertical-position", "horizontal-position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var E5 = ct("vue-simple-line"), O5 = ct("vue-simple-line-wrapper"), xi = { name: "SimpleLine", components: { LineWrapper: Kl }, props: { defaultClass: { type: String }, hoverClass: { type: String }, wrapperClass: { type: String }, position: { type: String }, disabled: { type: Boolean, default: !1 } }, data: function() {
  return { hover: !1 };
}, computed: { classes: function() {
  return { root: Re(E5(Xe({}, this.position, !0)), this.defaultClass, this.hover && this.hoverClass), wrapper: Re(O5(Xe({}, this.position, !0)), this.wrapperClass) };
} }, methods: { onDrag: function(e) {
  this.$emit("drag", e);
}, onEnter: function() {
  this.hover = !0;
}, onLeave: function() {
  this.hover = !1;
}, onDragEnd: function() {
  this.$emit("drag-end");
} }, emits: ["drag", "drag-end"] };
xi.render = function(e, t, n, o, r, i) {
  var s = ne("LineWrapper");
  return f(), j(s, { class: i.classes.wrapper, position: n.position, disabled: n.disabled, onDrag: i.onDrag, onDragEnd: i.onDragEnd, onEnter: i.onEnter, onLeave: i.onLeave }, { default: F(function() {
    return [B("div", { class: i.classes.root }, null, 2)];
  }), _: 1 }, 8, ["class", "position", "disabled", "onDrag", "onDragEnd", "onEnter", "onLeave"]);
};
var cr = ct("vue-bounding-box"), A5 = ["east", "west", null], _5 = ["south", "north", null], Jl = { name: "BoundingBox", props: { width: { type: Number }, height: { type: Number }, transitions: { type: Object }, handlers: { type: Object, default: function() {
  return { eastNorth: !0, north: !0, westNorth: !0, west: !0, westSouth: !0, south: !0, eastSouth: !0, east: !0 };
} }, handlersComponent: { type: [Object, String], default: function() {
  return wi;
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} }, lines: { type: Object, default: function() {
  return { west: !0, north: !0, east: !0, south: !0 };
} }, linesComponent: { type: [Object, String], default: function() {
  return xi;
} }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, resizable: { type: Boolean, default: !0 } }, data: function() {
  var e = [];
  return A5.forEach(function(t) {
    _5.forEach(function(n) {
      if (t !== n) {
        var o = Ul(t, n), r = o.name, i = o.classname;
        e.push({ name: r, classname: i, verticalDirection: n, horizontalDirection: t });
      }
    });
  }), { points: e };
}, computed: { style: function() {
  var e = {};
  return this.width && this.height && (e.width = "".concat(this.width, "px"), e.height = "".concat(this.height, "px"), this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction))), e;
}, classes: function() {
  var e = this.handlersClasses, t = this.handlersWrappersClasses, n = this.linesClasses, o = this.linesWrappersClasses;
  return { root: cr(), handlers: e, handlersWrappers: t, lines: n, linesWrappers: o };
}, lineNodes: function() {
  var e = this, t = [];
  return this.points.forEach(function(n) {
    n.horizontalDirection && n.verticalDirection || !e.lines[n.name] || t.push({ name: n.name, component: e.linesComponent, class: Re(e.classes.lines.default, e.classes.lines[n.name], !e.resizable && e.classes.lines.disabled), wrapperClass: Re(e.classes.linesWrappers.default, e.classes.linesWrappers[n.name], !e.resizable && e.classes.linesWrappers.disabled), hoverClass: e.classes.lines.hover, verticalDirection: n.verticalDirection, horizontalDirection: n.horizontalDirection, disabled: !e.resizable });
  }), t;
}, handlerNodes: function() {
  var e = this, t = [], n = this.width, o = this.height;
  return this.points.forEach(function(r) {
    if (e.handlers[r.name]) {
      var i = { name: r.name, component: e.handlersComponent, class: Re(e.classes.handlers.default, e.classes.handlers[r.name]), wrapperClass: Re(e.classes.handlersWrappers.default, e.classes.handlersWrappers[r.name]), hoverClass: e.classes.handlers.hover, verticalDirection: r.verticalDirection, horizontalDirection: r.horizontalDirection, disabled: !e.resizable };
      if (n && o) {
        var s = r.horizontalDirection, a = r.verticalDirection, l = s === "east" ? n : s === "west" ? 0 : n / 2, u = a === "south" ? o : a === "north" ? 0 : o / 2;
        i.wrapperClass = cr("handler"), i.wrapperStyle = { transform: "translate(".concat(l, "px, ").concat(u, "px)") }, e.transitions && e.transitions.enabled && (i.wrapperStyle.transition = "".concat(e.transitions.time, "ms ").concat(e.transitions.timingFunction));
      } else
        i.wrapperClass = cr("handler", Xe({}, r.classname, !0));
      t.push(i);
    }
  }), t;
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [];
}, methods: { onEnd: function() {
  this.$emit("resize-end");
}, onHandlerDrag: function(e, t, n) {
  var o, r = e.shift(), i = r.left, s = r.top, a = { left: 0, right: 0, top: 0, bottom: 0 };
  t === "west" ? a.left -= i : t === "east" && (a.right += i), n === "north" ? a.top -= s : n === "south" && (a.bottom += s), !n && t ? o = "width" : n && !t && (o = "height"), this.resizable && this.$emit("resize", new i5(a, { allowedDirections: { left: t === "west" || !t, right: t === "east" || !t, bottom: n === "south" || !n, top: n === "north" || !n }, preserveAspectRatio: e.nativeEvent && e.nativeEvent.shiftKey, respectDirection: o }));
} }, emits: ["resize", "resize-end"] };
Jl.render = function(e, t, n, o, r, i) {
  return f(), j("div", { ref: "box", class: i.classes.root, style: i.style }, [G(e.$slots, "default"), B("div", null, [(f(!0), j(K, null, se(i.lineNodes, function(s) {
    return f(), j(Le(s.component), { key: s.name, "default-class": s.class, "hover-class": s.hoverClass, "wrapper-class": s.wrapperClass, position: s.name, disabled: s.disabled, onDrag: function(a) {
      return i.onHandlerDrag(a, s.horizontalDirection, s.verticalDirection);
    }, onDragEnd: t[1] || (t[1] = function(a) {
      return i.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "position", "disabled", "onDrag"]);
  }), 128))]), (f(!0), j(K, null, se(i.handlerNodes, function(s) {
    return f(), j("div", { key: s.name, style: s.wrapperStyle, class: s.wrapperClass }, [(f(), j(Le(s.component), { "default-class": s.class, "hover-class": s.hoverClass, "wrapper-class": s.wrapperClass, "horizontal-position": s.horizontalDirection, "vertical-position": s.verticalDirection, disabled: s.disabled, onDrag: function(a) {
      return i.onHandlerDrag(a, s.horizontalDirection, s.verticalDirection);
    }, onDragEnd: t[2] || (t[2] = function(a) {
      return i.onEnd();
    }) }, null, 8, ["default-class", "hover-class", "wrapper-class", "horizontal-position", "vertical-position", "disabled", "onDrag"]))], 6);
  }), 128))], 6);
};
var R5 = ct("vue-draggable-area"), eu = { name: "DraggableArea", props: { movable: { type: Boolean, default: !0 }, activationDistance: { type: Number, default: 20 } }, computed: { classnames: function() {
  return { default: R5() };
} }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, mounted: function() {
  this.touches = [], this.touchStarted = !1;
}, methods: { onTouchStart: function(e) {
  if (e.cancelable) {
    var t = this.movable && e.touches.length === 1;
    t && (this.touches = Zt(e.touches)), (this.touchStarted || t) && (e.preventDefault(), e.stopPropagation());
  }
}, onTouchEnd: function() {
  this.touchStarted = !1, this.processEnd();
}, onTouchMove: function(e) {
  this.touches.length >= 1 && (this.touchStarted ? (this.processMove(e, e.touches), e.preventDefault(), e.stopPropagation()) : Zl({ x: this.touches[0].clientX, y: this.touches[0].clientY }, { x: e.touches[0].clientX, y: e.touches[0].clientY }) > this.activationDistance && (this.initAnchor({ clientX: e.touches[0].clientX, clientY: e.touches[0].clientY }), this.touchStarted = !0));
}, onMouseDown: function(e) {
  if (this.movable && e.button === 0) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.initAnchor(t), e.stopPropagation();
  }
}, onMouseMove: function(e) {
  this.touches.length && (this.processMove(e, [{ fake: !0, clientX: e.clientX, clientY: e.clientY }]), e.preventDefault && e.cancelable && e.preventDefault(), e.stopPropagation());
}, onMouseUp: function() {
  this.processEnd();
}, initAnchor: function(e) {
  var t = this.$refs.container.getBoundingClientRect(), n = t.left, o = t.top;
  this.anchor = { x: e.clientX - n, y: e.clientY - o };
}, processMove: function(e, t) {
  var n = Zt(t);
  if (this.touches.length) {
    var o = this.$refs.container.getBoundingClientRect(), r = o.left, i = o.top;
    this.touches.length === 1 && n.length === 1 && this.$emit("move", new bi({ left: n[0].clientX - (r + this.anchor.x), top: n[0].clientY - (i + this.anchor.y) }));
  }
}, processEnd: function() {
  this.touches.length && this.$emit("move-end"), this.touches = [];
} }, emits: ["move", "move-end"] };
eu.render = function(e, t, n, o, r, i) {
  return f(), j("div", { ref: "container", onTouchstart: t[1] || (t[1] = function() {
    return i.onTouchStart && i.onTouchStart.apply(i, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return i.onMouseDown && i.onMouseDown.apply(i, arguments);
  }) }, [G(e.$slots, "default")], 544);
};
function dr(e) {
  var t, n;
  return { rotate: e.rotate || 0, flip: { horizontal: ((t = e == null ? void 0 : e.flip) === null || t === void 0 ? void 0 : t.horizontal) || !1, vertical: ((n = e == null ? void 0 : e.flip) === null || n === void 0 ? void 0 : n.vertical) || !1 } };
}
function M5(e) {
  return new Promise(function(t, n) {
    try {
      if (e)
        if (/^data:/i.test(e))
          t(function(l) {
            l = l.replace(/^data:([^;]+);base64,/gim, "");
            for (var u = atob(l), c = u.length, d = new ArrayBuffer(c), p = new Uint8Array(d), v = 0; v < c; v++)
              p[v] = u.charCodeAt(v);
            return d;
          }(e));
        else if (/^blob:/i.test(e)) {
          var o = new FileReader();
          o.onload = function(l) {
            t(l.target.result);
          }, i = e, s = function(l) {
            o.readAsArrayBuffer(l);
          }, (a = new XMLHttpRequest()).open("GET", i, !0), a.responseType = "blob", a.onload = function() {
            this.status != 200 && this.status !== 0 || s(this.response);
          }, a.send();
        } else {
          var r = new XMLHttpRequest();
          r.onreadystatechange = function() {
            r.readyState === 4 && (r.status === 200 || r.status === 0 ? t(r.response) : n("Warning: could not load an image to parse its orientation"), r = null);
          }, r.onprogress = function() {
            r.getResponseHeader("content-type") !== "image/jpeg" && r.abort();
          }, r.withCredentials = !1, r.open("GET", e, !0), r.responseType = "arraybuffer", r.send(null);
        }
      else
        n("Error: the image is empty");
    } catch (l) {
      n(l);
    }
    var i, s, a;
  });
}
function tu(e) {
  var t = e.rotate, n = e.flip, o = e.scaleX, r = e.scaleY, i = "";
  return i += " rotate(" + t + "deg) ", i += " scaleX(" + o * (n.horizontal ? -1 : 1) + ") ", i += " scaleY(" + r * (n.vertical ? -1 : 1) + ") ";
}
function T5(e) {
  try {
    var t, n = new DataView(e), o = void 0, r = void 0, i = void 0, s = void 0;
    if (n.getUint8(0) === 255 && n.getUint8(1) === 216)
      for (var a = n.byteLength, l = 2; l + 1 < a; ) {
        if (n.getUint8(l) === 255 && n.getUint8(l + 1) === 225) {
          i = l;
          break;
        }
        l++;
      }
    if (i && (o = i + 10, function(v, x, b) {
      var h, S = "";
      for (h = x, b += x; h < b; h++)
        S += String.fromCharCode(v.getUint8(h));
      return S;
    }(n, i + 4, 4) === "Exif")) {
      var u = n.getUint16(o);
      if (((r = u === 18761) || u === 19789) && n.getUint16(o + 2, r) === 42) {
        var c = n.getUint32(o + 4, r);
        c >= 8 && (s = o + c);
      }
    }
    if (s) {
      for (var d = n.getUint16(s, r), p = 0; p < d; p++)
        if (l = s + 12 * p + 2, n.getUint16(l, r) === 274) {
          l += 8, t = n.getUint16(l, r), n.setUint16(l, 1, r);
          break;
        }
    }
    return t;
  } catch {
    return null;
  }
}
function js(e, t) {
  var n = t.getBoundingClientRect(), o = n.left, r = n.top, i = { left: 0, top: 0 }, s = 0;
  return e.forEach(function(a) {
    i.left += (a.clientX - o) / e.length, i.top += (a.clientY - r) / e.length;
  }), e.forEach(function(a) {
    s += Zl({ x: i.left, y: i.top }, { x: a.clientX - o, y: a.clientY - r });
  }), { centerMass: i, spread: s, count: e.length };
}
var nu = { props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 }, eventsFilter: { type: Function, required: !1 } }, beforeMount: function() {
  window.addEventListener("mouseup", this.onMouseUp, { passive: !1 }), window.addEventListener("mousemove", this.onMouseMove, { passive: !1 }), window.addEventListener("touchmove", this.onTouchMove, { passive: !1 }), window.addEventListener("touchend", this.onTouchEnd, { passive: !1 });
}, beforeUnmount: function() {
  window.removeEventListener("mouseup", this.onMouseUp), window.removeEventListener("mousemove", this.onMouseMove), window.removeEventListener("touchmove", this.onTouchMove), window.removeEventListener("touchend", this.onTouchEnd);
}, created: function() {
  this.transforming = !1, this.debouncedProcessEnd = Pr(this.processEnd), this.touches = [];
}, methods: { processMove: function(e, t) {
  if (this.touches.length) {
    if (this.touches.length === 1 && t.length === 1)
      this.$emit("move", new Sn({ left: this.touches[0].clientX - t[0].clientX, top: this.touches[0].clientY - t[0].clientY }));
    else if (this.touches.length > 1 && this.touchResize) {
      var n = js(t, this.$refs.container), o = this.oldGeometricProperties;
      o.count === n.count && o.count > 1 && this.$emit("resize", new Sn({ left: o.centerMass.left - n.centerMass.left, top: o.centerMass.top - n.centerMass.top }, { factor: o.spread / n.spread, center: n.centerMass })), this.oldGeometricProperties = n;
    }
    this.touches = t;
  }
}, processEnd: function() {
  this.transforming && (this.transforming = !1, this.$emit("transform-end"));
}, processStart: function() {
  this.transforming = !0, this.debouncedProcessEnd.clear();
}, processEvent: function(e) {
  return this.eventsFilter ? this.eventsFilter(e, this.transforming) !== !1 : (e.preventDefault(), e.stopPropagation(), !0);
}, onTouchStart: function(e) {
  if (e.cancelable && (this.touchMove || this.touchResize && e.touches.length > 1) && this.processEvent(e)) {
    var t = this.$refs.container, n = t.getBoundingClientRect(), o = n.left, r = n.top, i = n.bottom, s = n.right;
    this.touches = Zt(e.touches).filter(function(a) {
      return a.clientX > o && a.clientX < s && a.clientY > r && a.clientY < i;
    }), this.oldGeometricProperties = js(this.touches, t);
  }
}, onTouchEnd: function(e) {
  e.touches.length === 0 && (this.touches = [], this.processEnd());
}, onTouchMove: function(e) {
  var t = this;
  if (this.touches.length) {
    var n = Zt(e.touches).filter(function(o) {
      return !o.identifier || t.touches.find(function(r) {
        return r.identifier === o.identifier;
      });
    });
    this.processEvent(e) && (this.processMove(e, n), this.processStart());
  }
}, onMouseDown: function(e) {
  if (this.mouseMove && "buttons" in e && e.buttons === 1 && this.processEvent(e)) {
    var t = { fake: !0, clientX: e.clientX, clientY: e.clientY };
    this.touches = [t], this.processStart();
  }
}, onMouseMove: function(e) {
  this.touches.length && this.processEvent(e) && this.processMove(e, [{ clientX: e.clientX, clientY: e.clientY }]);
}, onMouseUp: function() {
  this.touches = [], this.processEnd();
}, onWheel: function(e) {
  if (this.wheelResize && this.processEvent(e)) {
    var t = this.$refs.container.getBoundingClientRect(), n = t.left, o = t.top, r = 1 + this.wheelResize.ratio * (s = e.deltaY || e.detail || e.wheelDelta, (a = +s) == 0 || ql(a) ? a : a > 0 ? 1 : -1), i = { left: e.clientX - n, top: e.clientY - o };
    this.$emit("resize", new Sn({}, { factor: r, center: i })), this.touches.length || this.debouncedProcessEnd();
  }
  var s, a;
} }, emits: ["resize", "move", "transform-end"] };
nu.render = function(e, t, n, o, r, i) {
  return f(), j("div", { ref: "container", onTouchstart: t[1] || (t[1] = function() {
    return i.onTouchStart && i.onTouchStart.apply(i, arguments);
  }), onMousedown: t[2] || (t[2] = function() {
    return i.onMouseDown && i.onMouseDown.apply(i, arguments);
  }), onWheel: t[3] || (t[3] = function() {
    return i.onWheel && i.onWheel.apply(i, arguments);
  }) }, [G(e.$slots, "default")], 544);
};
var Br = { components: { TransformableImage: nu }, props: { touchMove: { type: Boolean, required: !0 }, mouseMove: { type: Boolean, required: !0 }, touchResize: { type: Boolean, required: !0 }, wheelResize: { type: [Boolean, Object], required: !0 } }, emits: ["resize", "move"] };
Br.render = function(e, t, n, o, r, i) {
  var s = ne("transformable-image");
  return f(), j(s, { "touch-move": n.touchMove, "touch-resize": n.touchResize, "mouse-move": n.mouseMove, "wheel-resize": n.wheelResize, onMove: t[1] || (t[1] = function(a) {
    return e.$emit("move", a);
  }), onResize: t[2] || (t[2] = function(a) {
    return e.$emit("resize", a);
  }) }, { default: F(function() {
    return [G(e.$slots, "default")];
  }), _: 3 }, 8, ["touch-move", "touch-resize", "mouse-move", "wheel-resize"]);
};
var Kn = ct("vue-preview"), ou = { props: { coordinates: { type: Object }, transitions: { type: Object }, image: { type: Object, default: function() {
  return {};
} }, imageClass: { type: String }, width: { type: Number }, height: { type: Number }, fill: { type: Boolean } }, data: function() {
  return { calculatedImageSize: { width: 0, height: 0 }, calculatedSize: { width: 0, height: 0 } };
}, computed: { classes: function() {
  return { root: Kn({ fill: this.fill }), wrapper: Kn("wrapper"), imageWrapper: Kn("image-wrapper"), image: Re(Kn("image"), this.imageClass) };
}, style: function() {
  if (this.fill)
    return {};
  var e = {};
  return this.width && (e.width = "".concat(this.size.width, "px")), this.height && (e.height = "".concat(this.size.height, "px")), this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), e;
}, wrapperStyle: function() {
  var e = { width: "".concat(this.size.width, "px"), height: "".concat(this.size.height, "px"), left: "calc(50% - ".concat(this.size.width / 2, "px)"), top: "calc(50% - ".concat(this.size.height / 2, "px)") };
  return this.transitions && this.transitions.enabled && (e.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), e;
}, imageStyle: function() {
  if (this.coordinates && this.image) {
    var e = this.coordinates.width / this.size.width, t = de(de({ rotate: 0, flip: { horizontal: !1, vertical: !1 } }, this.image.transforms), {}, { scaleX: 1 / e, scaleY: 1 / e }), n = this.imageSize.width, o = this.imageSize.height, r = Xl({ width: n, height: o }, t.rotate), i = { width: "".concat(n, "px"), height: "".concat(o, "px"), left: "0px", top: "0px" }, s = { rotate: { left: (n - r.width) * t.scaleX / 2, top: (o - r.height) * t.scaleY / 2 }, scale: { left: (1 - t.scaleX) * n / 2, top: (1 - t.scaleY) * o / 2 } };
    return i.transform = `translate(
				`.concat(-this.coordinates.left / e - s.rotate.left - s.scale.left, "px,").concat(-this.coordinates.top / e - s.rotate.top - s.scale.top, "px) ") + tu(t), this.transitions && this.transitions.enabled && (i.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), i;
  }
  return {};
}, size: function() {
  return { width: this.width || this.calculatedSize.width, height: this.height || this.calculatedSize.height };
}, imageSize: function() {
  return { width: this.image.width || this.calculatedImageSize.width, height: this.image.height || this.calculatedImageSize.height };
} }, watch: { image: function(e) {
  (e.width || e.height) && this.onChangeImage();
} }, mounted: function() {
  var e = this;
  this.onChangeImage(), this.$refs.image.addEventListener("load", function() {
    e.refreshImage();
  }), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh);
}, methods: { refreshImage: function() {
  var e = this.$refs.image;
  this.calculatedImageSize.height = e.naturalHeight, this.calculatedImageSize.width = e.naturalWidth;
}, refresh: function() {
  var e = this.$refs.root;
  this.width || (this.calculatedSize.width = e.clientWidth), this.height || (this.calculatedSize.height = e.clientHeight);
}, onChangeImage: function() {
  var e = this.$refs.image;
  e && e.complete && this.refreshImage(), this.refresh();
} } };
ou.render = function(e, t, n, o, r, i) {
  return f(), j("div", { ref: "root", class: i.classes.root, style: i.style }, [B("div", { ref: "wrapper", class: i.classes.wrapper, style: i.wrapperStyle }, [ze(B("img", { ref: "image", src: n.image && n.image.src, class: i.classes.image, style: i.imageStyle }, null, 14, ["src"]), [[At, n.image && n.image.src]])], 6)], 6);
};
var ru = { components: { Preview: ou }, inheritAttrs: !1 };
ru.render = function(e, t, n, o, r, i) {
  var s = ne("preview");
  return f(), j(s, _t(e.$attrs, { fill: !0 }), null, 16);
};
var pr = ct("vue-rectangle-stencil"), iu = { name: "RectangleStencil", components: { StencilPreview: ru, BoundingBox: Jl, DraggableArea: eu }, props: { image: { type: Object }, coordinates: { type: Object }, stencilCoordinates: { type: Object }, handlers: { type: Object }, handlersComponent: { type: [Object, String], default: function() {
  return wi;
} }, lines: { type: Object }, linesComponent: { type: [Object, String], default: function() {
  return xi;
} }, aspectRatio: { type: [Number, String] }, minAspectRatio: { type: [Number, String] }, maxAspectRatio: { type: [Number, String] }, movable: { type: Boolean, default: !0 }, resizable: { type: Boolean, default: !0 }, transitions: { type: Object }, movingClass: { type: String }, resizingClass: { type: String }, previewClass: { type: String }, boundingBoxClass: { type: String }, linesClasses: { type: Object, default: function() {
  return {};
} }, linesWrappersClasses: { type: Object, default: function() {
  return {};
} }, handlersClasses: { type: Object, default: function() {
  return {};
} }, handlersWrappersClasses: { type: Object, default: function() {
  return {};
} } }, data: function() {
  return { moving: !1, resizing: !1 };
}, computed: { classes: function() {
  return { stencil: Re(pr({ movable: this.movable, moving: this.moving, resizing: this.resizing }), this.moving && this.movingClass, this.resizing && this.resizingClass), preview: Re(pr("preview"), this.previewClass), boundingBox: Re(pr("bounding-box"), this.boundingBoxClass) };
}, style: function() {
  var e = this.stencilCoordinates, t = e.height, n = e.width, o = e.left, r = e.top, i = { width: "".concat(n, "px"), height: "".concat(t, "px"), transform: "translate(".concat(o, "px, ").concat(r, "px)") };
  return this.transitions && this.transitions.enabled && (i.transition = "".concat(this.transitions.time, "ms ").concat(this.transitions.timingFunction)), i;
} }, methods: { onMove: function(e) {
  this.$emit("move", e), this.moving = !0;
}, onMoveEnd: function() {
  this.$emit("move-end"), this.moving = !1;
}, onResize: function(e) {
  this.$emit("resize", e), this.resizing = !0;
}, onResizeEnd: function() {
  this.$emit("resize-end"), this.resizing = !1;
}, aspectRatios: function() {
  return { minimum: this.aspectRatio || this.minAspectRatio, maximum: this.aspectRatio || this.maxAspectRatio };
} }, emits: ["resize", "resize-end", "move", "move-end"] };
iu.render = function(e, t, n, o, r, i) {
  var s = ne("stencil-preview"), a = ne("draggable-area"), l = ne("bounding-box");
  return f(), j("div", { class: i.classes.stencil, style: i.style }, [B(l, { width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, transitions: n.transitions, class: i.classes.boundingBox, handlers: n.handlers, "handlers-component": n.handlersComponent, "handlers-classes": n.handlersClasses, "handlers-wrappers-classes": n.handlersWrappersClasses, lines: n.lines, "lines-component": n.linesComponent, "lines-classes": n.linesClasses, "lines-wrappers-classes": n.linesWrappersClasses, resizable: n.resizable, onResize: i.onResize, onResizeEnd: i.onResizeEnd }, { default: F(function() {
    return [B(a, { movable: n.movable, onMove: i.onMove, onMoveEnd: i.onMoveEnd }, { default: F(function() {
      return [B(s, { image: n.image, coordinates: n.coordinates, width: n.stencilCoordinates.width, height: n.stencilCoordinates.height, class: i.classes.preview, transitions: n.transitions }, null, 8, ["image", "coordinates", "width", "height", "class", "transitions"])];
    }), _: 1 }, 8, ["movable", "onMove", "onMoveEnd"])];
  }), _: 1 }, 8, ["width", "height", "transitions", "class", "handlers", "handlers-component", "handlers-classes", "handlers-wrappers-classes", "lines", "lines-component", "lines-classes", "lines-wrappers-classes", "resizable", "onResize", "onResizeEnd"])], 6);
};
var P5 = ["transitions"], $t = ct("vue-advanced-cropper"), su = { name: "Cropper", components: { BackgroundWrapper: Br }, props: { src: { type: String, default: null }, stencilComponent: { type: [Object, String], default: function() {
  return iu;
} }, backgroundWrapperComponent: { type: [Object, String], default: function() {
  return Br;
} }, stencilProps: { type: Object, default: function() {
  return {};
} }, autoZoom: { type: Boolean, default: !1 }, imageClass: { type: String }, boundariesClass: { type: String }, backgroundClass: { type: String }, foregroundClass: { type: String }, minWidth: { type: [Number, String] }, minHeight: { type: [Number, String] }, maxWidth: { type: [Number, String] }, maxHeight: { type: [Number, String] }, debounce: { type: [Boolean, Number], default: 500 }, transitions: { type: Boolean, default: !0 }, checkOrientation: { type: Boolean, default: !0 }, canvas: { type: [Object, Boolean], default: !0 }, crossOrigin: { type: [Boolean, String], default: void 0 }, transitionTime: { type: Number, default: 300 }, imageRestriction: { type: String, default: "fit-area", validator: function(e) {
  return d5.indexOf(e) !== -1;
} }, roundResult: { type: Boolean, default: !0 }, defaultSize: { type: [Function, Object] }, defaultPosition: { type: [Function, Object] }, defaultVisibleArea: { type: [Function, Object] }, defaultTransforms: { type: [Function, Object] }, defaultBoundaries: { type: [Function, String], validator: function(e) {
  return !(typeof e == "string" && e !== "fill" && e !== "fit");
} }, priority: { type: String, default: "coordinates" }, stencilSize: { type: [Object, Function] }, resizeImage: { type: [Boolean, Object], default: !0 }, moveImage: { type: [Boolean, Object], default: !0 }, autoZoomAlgorithm: { type: Function }, resizeAlgorithm: { type: Function, default: function(e) {
  var t = e.event, n = e.coordinates, o = e.aspectRatio, r = e.positionRestrictions, i = e.sizeRestrictions, s = Y(Y({}, n), { right: n.left + n.width, bottom: n.top + n.height }), a = t.params || {}, l = Y({}, t.directions), u = a.allowedDirections || { left: !0, right: !0, bottom: !0, top: !0 };
  i.widthFrozen && (l.left = 0, l.right = 0), i.heightFrozen && (l.top = 0, l.bottom = 0), vt.forEach(function(w) {
    u[w] || (l[w] = 0);
  });
  var c = ht(s, l = Ns({ coordinates: s, directions: l, sizeRestrictions: i, positionRestrictions: r })).width, d = ht(s, l).height, p = a.preserveRatio ? pe(s) : ur(c / d, o);
  if (p) {
    var v = a.respectDirection;
    if (v || (v = s.width >= s.height || p === 1 ? "width" : "height"), v === "width") {
      var x = c / p - s.height;
      if (u.top && u.bottom) {
        var b = l.top, h = l.bottom;
        l.bottom = Gn(x, h, b), l.top = Gn(x, b, h);
      } else
        u.bottom ? l.bottom = x : u.top ? l.top = x : u.right ? l.right = 0 : u.left && (l.left = 0);
    } else if (v === "height") {
      var S = s.width - d * p;
      if (u.left && u.right) {
        var g = l.left, C = l.right;
        l.left = -Gn(S, g, C), l.right = -Gn(S, C, g);
      } else
        u.left ? l.left = -S : u.right ? l.right = -S : u.top ? l.top = 0 : u.bottom && (l.bottom = 0);
    }
    l = Ns({ directions: l, coordinates: s, sizeRestrictions: i, positionRestrictions: r, preserveRatio: !0, compensate: a.compensate });
  }
  return c = ht(s, l).width, d = ht(s, l).height, (p = a.preserveRatio ? pe(s) : ur(c / d, o)) && Math.abs(p - c / d) > 1e-3 && vt.forEach(function(w) {
    u[w] || (l[w] = 0);
  }), Dr({ event: new bi({ left: -l.left, top: -l.top }), coordinates: { width: n.width + l.right + l.left, height: n.height + l.top + l.bottom, left: n.left, top: n.top }, positionRestrictions: r });
} }, moveAlgorithm: { type: Function, default: Dr }, initStretcher: { type: Function, default: function(e) {
  var t = e.stretcher, n = e.imageSize, o = pe(n);
  t.style.width = n.width + "px", t.style.height = t.clientWidth / o + "px", t.style.width = t.clientWidth + "px";
} }, fitCoordinates: { type: Function, default: function(e) {
  var t = e.visibleArea, n = e.coordinates, o = e.aspectRatio, r = e.sizeRestrictions, i = e.positionRestrictions, s = Y(Y({}, n), St({ width: n.width, height: n.height, aspectRatio: o, sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minHeight: Math.min(t.height, r.minHeight), minWidth: Math.min(t.width, r.minWidth) } }));
  return s = Ie(s = Ue(s, dn(Pe(n), Pe(s))), Zo(xt(t), i));
} }, fitVisibleArea: { type: Function, default: function(e) {
  var t = e.visibleArea, n = e.boundaries, o = e.getAreaRestrictions, r = e.coordinates, i = Y({}, t);
  i.height = i.width / pe(n), i.top += (t.height - i.height) / 2, (r.height - i.height > 0 || r.width - i.width > 0) && (i = Je(i, Math.max(r.height / i.height, r.width / i.width)));
  var s = Wo(fn(r, xt(i = Je(i, qo(i, o({ visibleArea: i, type: "resize" }))))));
  return i.width < r.width && (s.left = 0), i.height < r.height && (s.top = 0), i = Ie(i = Ue(i, s), o({ visibleArea: i, type: "move" }));
} }, areaRestrictionsAlgorithm: { type: Function, default: function(e) {
  var t = e.visibleArea, n = e.boundaries, o = e.imageSize, r = e.imageRestriction, i = e.type, s = {};
  return r === "fill-area" ? s = { left: 0, top: 0, right: o.width, bottom: o.height } : r === "fit-area" && (pe(n) > pe(o) ? (s = { top: 0, bottom: o.height }, t && i === "move" && (t.width > o.width ? (s.left = -(t.width - o.width) / 2, s.right = o.width - s.left) : (s.left = 0, s.right = o.width))) : (s = { left: 0, right: o.width }, t && i === "move" && (t.height > o.height ? (s.top = -(t.height - o.height) / 2, s.bottom = o.height - s.top) : (s.top = 0, s.bottom = o.height)))), s;
} }, sizeRestrictionsAlgorithm: { type: Function, default: function(e) {
  return { minWidth: e.minWidth, minHeight: e.minHeight, maxWidth: e.maxWidth, maxHeight: e.maxHeight };
} }, positionRestrictionsAlgorithm: { type: Function, default: function(e) {
  var t = e.imageSize, n = {};
  return e.imageRestriction !== "none" && (n = { left: 0, top: 0, right: t.width, bottom: t.height }), n;
} } }, data: function() {
  return { transitionsActive: !1, imageLoaded: !1, imageAttributes: { width: null, height: null, crossOrigin: null, src: null }, defaultImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, appliedImageTransforms: { rotate: 0, flip: { horizontal: !1, vertical: !1 } }, boundaries: { width: 0, height: 0 }, visibleArea: null, coordinates: de({}, Ls) };
}, computed: { image: function() {
  return { src: this.imageAttributes.src, width: this.imageAttributes.width, height: this.imageAttributes.height, transforms: this.imageTransforms };
}, imageTransforms: function() {
  return { rotate: this.appliedImageTransforms.rotate, flip: { horizontal: this.appliedImageTransforms.flip.horizontal, vertical: this.appliedImageTransforms.flip.vertical }, translateX: this.visibleArea ? this.visibleArea.left / this.coefficient : 0, translateY: this.visibleArea ? this.visibleArea.top / this.coefficient : 0, scaleX: 1 / this.coefficient, scaleY: 1 / this.coefficient };
}, imageSize: function() {
  var e = function(t) {
    return t * Math.PI / 180;
  }(this.imageTransforms.rotate);
  return { width: Math.abs(this.imageAttributes.width * Math.cos(e)) + Math.abs(this.imageAttributes.height * Math.sin(e)), height: Math.abs(this.imageAttributes.width * Math.sin(e)) + Math.abs(this.imageAttributes.height * Math.cos(e)) };
}, initialized: function() {
  return !!(this.visibleArea && this.imageLoaded);
}, settings: function() {
  var e = Ir(this.resizeImage, { touch: !0, wheel: { ratio: 0.1 }, adjustStencil: !0 }, { touch: !1, wheel: !1, adjustStencil: !1 });
  return { moveImage: Ir(this.moveImage, { touch: !0, mouse: !0 }, { touch: !1, mouse: !1 }), resizeImage: e };
}, coefficient: function() {
  return this.visibleArea ? this.visibleArea.width / this.boundaries.width : 0;
}, areaRestrictions: function() {
  return this.imageLoaded ? this.areaRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction, boundaries: this.boundaries }) : {};
}, transitionsOptions: function() {
  return { enabled: this.transitionsActive, timingFunction: "ease-in-out", time: 350 };
}, sizeRestrictions: function() {
  if (this.boundaries.width && this.boundaries.height && this.imageSize.width && this.imageSize.height) {
    var e = this.sizeRestrictionsAlgorithm({ imageSize: this.imageSize, minWidth: Te(this.minWidth) ? 0 : qn(this.minWidth), minHeight: Te(this.minHeight) ? 0 : qn(this.minHeight), maxWidth: Te(this.maxWidth) ? 1 / 0 : qn(this.maxWidth), maxHeight: Te(this.maxHeight) ? 1 / 0 : qn(this.maxHeight) });
    if (e = function(o) {
      var r = o.areaRestrictions, i = o.sizeRestrictions;
      o.imageSize;
      var s = o.boundaries, a = o.positionRestrictions;
      o.imageRestriction;
      var l = Y(Y({}, i), { minWidth: i.minWidth !== void 0 ? i.minWidth : 0, minHeight: i.minHeight !== void 0 ? i.minHeight : 0, maxWidth: i.maxWidth !== void 0 ? i.maxWidth : 1 / 0, maxHeight: i.maxHeight !== void 0 ? i.maxHeight : 1 / 0 });
      a.left !== void 0 && a.right !== void 0 && (l.maxWidth = Math.min(l.maxWidth, a.right - a.left)), a.bottom !== void 0 && a.top !== void 0 && (l.maxHeight = Math.min(l.maxHeight, a.bottom - a.top));
      var u = Lr(r), c = Yl(s, u);
      return u.width < 1 / 0 && (!l.maxWidth || l.maxWidth > c.width) && (l.maxWidth = Math.min(l.maxWidth, c.width)), u.height < 1 / 0 && (!l.maxHeight || l.maxHeight > c.height) && (l.maxHeight = Math.min(l.maxHeight, c.height)), l.minWidth > l.maxWidth && (l.minWidth = l.maxWidth, l.widthFrozen = !0), l.minHeight > l.maxHeight && (l.minHeight = l.maxHeight, l.heightFrozen = !0), l;
    }({ sizeRestrictions: e, areaRestrictions: this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }), imageSize: this.imageSize, boundaries: this.boundaries, positionRestrictions: this.positionRestrictions, imageRestriction: this.imageRestriction, visibleArea: this.visibleArea, stencilSize: this.getStencilSize() }), this.visibleArea && this.stencilSize) {
      var t = this.getStencilSize(), n = Lr(this.getAreaRestrictions({ visibleArea: this.visibleArea, type: "resize" }));
      e.maxWidth = Math.min(e.maxWidth, n.width * t.width / this.boundaries.width), e.maxHeight = Math.min(e.maxHeight, n.height * t.height / this.boundaries.height), e.maxWidth < e.minWidth && (e.minWidth = e.maxWidth), e.maxHeight < e.minHeight && (e.minHeight = e.maxHeight);
    }
    return e;
  }
  return { minWidth: 0, minHeight: 0, maxWidth: 0, maxHeight: 0 };
}, positionRestrictions: function() {
  return this.positionRestrictionsAlgorithm({ imageSize: this.imageSize, imageRestriction: this.imageRestriction });
}, classes: function() {
  return { cropper: $t(), image: Re($t("image"), this.imageClass), stencil: $t("stencil"), boundaries: Re($t("boundaries"), this.boundariesClass), stretcher: Re($t("stretcher")), background: Re($t("background"), this.backgroundClass), foreground: Re($t("foreground"), this.foregroundClass), imageWrapper: Re($t("image-wrapper")), cropperWrapper: Re($t("cropper-wrapper")) };
}, stencilCoordinates: function() {
  if (this.initialized) {
    var e = this.coordinates, t = e.width, n = e.height, o = e.left, r = e.top;
    return { width: t / this.coefficient, height: n / this.coefficient, left: (o - this.visibleArea.left) / this.coefficient, top: (r - this.visibleArea.top) / this.coefficient };
  }
  return this.defaultCoordinates();
}, boundariesStyle: function() {
  var e = { width: this.boundaries.width ? "".concat(Math.round(this.boundaries.width), "px") : "auto", height: this.boundaries.height ? "".concat(Math.round(this.boundaries.height), "px") : "auto", transition: "opacity ".concat(this.transitionTime, "ms"), pointerEvents: this.imageLoaded ? "all" : "none" };
  return this.imageLoaded || (e.opacity = "0"), e;
}, imageStyle: function() {
  var e = this.imageAttributes.width > this.imageAttributes.height ? { width: Math.min(1024, this.imageAttributes.width), height: Math.min(1024, this.imageAttributes.width) / (this.imageAttributes.width / this.imageAttributes.height) } : { height: Math.min(1024, this.imageAttributes.height), width: Math.min(1024, this.imageAttributes.height) * (this.imageAttributes.width / this.imageAttributes.height) }, t = { left: (e.width - this.imageSize.width) / (2 * this.coefficient), top: (e.height - this.imageSize.height) / (2 * this.coefficient) }, n = { left: (1 - 1 / this.coefficient) * e.width / 2, top: (1 - 1 / this.coefficient) * e.height / 2 }, o = de(de({}, this.imageTransforms), {}, { scaleX: this.imageTransforms.scaleX * (this.imageAttributes.width / e.width), scaleY: this.imageTransforms.scaleY * (this.imageAttributes.height / e.height) }), r = { width: "".concat(e.width, "px"), height: "".concat(e.height, "px"), left: "0px", top: "0px", transform: "translate(".concat(-t.left - n.left - this.imageTransforms.translateX, "px, ").concat(-t.top - n.top - this.imageTransforms.translateY, "px)") + tu(o) };
  return this.transitionsOptions.enabled && (r.transition = "".concat(this.transitionsOptions.time, "ms ").concat(this.transitionsOptions.timingFunction)), r;
} }, watch: { src: function() {
  this.onChangeImage();
}, stencilComponent: function() {
  var e = this;
  this.$nextTick(function() {
    e.resetCoordinates(), e.runAutoZoom("setCoordinates"), e.onChange();
  });
}, minWidth: function() {
  this.onPropsChange();
}, maxWidth: function() {
  this.onPropsChange();
}, minHeight: function() {
  this.onPropsChange();
}, maxHeight: function() {
  this.onPropsChange();
}, imageRestriction: function() {
  this.reset();
}, stencilProps: function(e, t) {
  ["aspectRatio", "minAspectRatio", "maxAspectRatio"].find(function(n) {
    return e[n] !== t[n];
  }) && this.$nextTick(this.onPropsChange);
} }, created: function() {
  this.debouncedUpdate = Pr(this.update, this.debounce), this.debouncedDisableTransitions = Pr(this.disableTransitions, this.transitionsOptions.time), this.awaiting = !1;
}, mounted: function() {
  this.$refs.image.addEventListener("load", this.onSuccessLoadImage), this.$refs.image.addEventListener("error", this.onFailLoadImage), this.onChangeImage(), window.addEventListener("resize", this.refresh), window.addEventListener("orientationchange", this.refresh);
}, unmounted: function() {
  window.removeEventListener("resize", this.refresh), window.removeEventListener("orientationchange", this.refresh), this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.debouncedUpdate.clear(), this.debouncedDisableTransitions.clear();
}, methods: { getResult: function() {
  var e = this.initialized ? this.prepareResult(de({}, this.coordinates)) : this.defaultCoordinates(), t = { rotate: this.imageTransforms.rotate % 360, flip: de({}, this.imageTransforms.flip) };
  if (this.src && this.imageLoaded) {
    var n = this;
    return { image: this.image, coordinates: e, visibleArea: this.visibleArea ? de({}, this.visibleArea) : null, imageTransforms: t, get canvas() {
      return n.canvas ? n.getCanvas() : void 0;
    } };
  }
  return { image: this.image, coordinates: e, visibleArea: this.visibleArea ? de({}, this.visibleArea) : null, canvas: void 0, imageTransforms: t };
}, zoom: function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = n.transitions, r = o === void 0 || o;
  this.onManipulateImage(new Sn({}, { factor: 1 / e, center: t }), { normalize: !1, transitions: r });
}, move: function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = n.transitions, r = o === void 0 || o;
  this.onManipulateImage(new Sn({ left: e || 0, top: t || 0 }), { normalize: !1, transitions: r });
}, setCoordinates: function(e) {
  var t = this, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = n.autoZoom, r = o === void 0 || o, i = n.transitions, s = i === void 0 || i;
  this.$nextTick(function() {
    t.imageLoaded ? (t.transitionsActive || (s && t.enableTransitions(), t.coordinates = t.applyTransform(e), r && t.runAutoZoom("setCoordinates"), s && t.debouncedDisableTransitions()), t.onChange()) : t.delayedTransforms = e;
  });
}, refresh: function() {
  var e = this, t = this.$refs.image;
  if (this.src && t)
    return this.initialized ? this.updateVisibleArea().then(function() {
      e.onChange();
    }) : this.resetVisibleArea().then(function() {
      e.onChange();
    });
}, reset: function() {
  var e = this;
  return this.resetVisibleArea().then(function() {
    e.onChange(!1);
  });
}, awaitRender: function(e) {
  var t = this;
  this.awaiting || (this.awaiting = !0, this.$nextTick(function() {
    e(), t.awaiting = !1;
  }));
}, prepareResult: function(e) {
  return this.roundResult ? function(t) {
    var n = t.coordinates, o = t.sizeRestrictions, r = t.positionRestrictions, i = { width: Math.round(n.width), height: Math.round(n.height), left: Math.round(n.left), top: Math.round(n.top) };
    return i.width > o.maxWidth ? i.width = Math.floor(n.width) : i.width < o.minWidth && (i.width = Math.ceil(n.width)), i.height > o.maxHeight ? i.height = Math.floor(n.height) : i.height < o.minHeight && (i.height = Math.ceil(n.height)), Ie(i, r);
  }(de(de({}, this.getPublicProperties()), {}, { positionRestrictions: Zn(this.positionRestrictions, this.visibleArea), coordinates: e })) : e;
}, processAutoZoom: function(e, t, n, o) {
  var r = this.autoZoomAlgorithm;
  r || (r = this.stencilSize ? h5 : this.autoZoom ? v5 : m5);
  var i = r({ event: { type: e, params: o }, visibleArea: t, coordinates: n, boundaries: this.boundaries, aspectRatio: this.getAspectRatio(), positionRestrictions: this.positionRestrictions, getAreaRestrictions: this.getAreaRestrictions, sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize() });
  return de(de({}, i), {}, { changed: !Ds(i.visibleArea, t) || !Ds(i.coordinates, n) });
}, runAutoZoom: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.transitions, o = n !== void 0 && n, r = o5(t, P5), i = this.processAutoZoom(e, this.visibleArea, this.coordinates, r), s = i.visibleArea, a = i.coordinates, l = i.changed;
  o && l && this.enableTransitions(), this.visibleArea = s, this.coordinates = a, o && l && this.debouncedDisableTransitions();
}, normalizeEvent: function(e) {
  return function(t) {
    var n = t.event, o = t.visibleArea, r = t.coefficient;
    if (n.type === "manipulateImage")
      return Y(Y({}, n), { move: { left: n.move && n.move.left ? r * n.move.left : 0, top: n.move && n.move.top ? r * n.move.top : 0 }, scale: { factor: n.scale && n.scale.factor ? n.scale.factor : 1, center: n.scale && n.scale.center ? { left: n.scale.center.left * r + o.left, top: n.scale.center.top * r + o.top } : null } });
    if (n.type === "resize") {
      var i = Y(Y({}, n), { directions: Y({}, n.directions) });
      return vt.forEach(function(a) {
        i.directions[a] *= r;
      }), i;
    }
    if (n.type === "move") {
      var s = Y(Y({}, n), { directions: Y({}, n.directions) });
      return c5.forEach(function(a) {
        s.directions[a] *= r;
      }), s;
    }
    return n;
  }(de(de({}, this.getPublicProperties()), {}, { event: e }));
}, getCanvas: function() {
  if (this.$refs.canvas) {
    var e = this.$refs.canvas, t = this.$refs.image, n = this.imageTransforms.rotate !== 0 || this.imageTransforms.flip.horizontal || this.imageTransforms.flip.vertical ? function(a, l, u) {
      var c = u.rotate, d = u.flip, p = { width: l.naturalWidth, height: l.naturalHeight }, v = Xl(p, c), x = a.getContext("2d");
      a.height = v.height, a.width = v.width, x.save();
      var b = Et(Pe(Y({ left: 0, top: 0 }, p)), c);
      return x.translate(-(b.left - v.width / 2), -(b.top - v.height / 2)), x.rotate(c * Math.PI / 180), x.translate(d.horizontal ? p.width : 0, d.vertical ? p.height : 0), x.scale(d.horizontal ? -1 : 1, d.vertical ? -1 : 1), x.drawImage(l, 0, 0, p.width, p.height), x.restore(), a;
    }(this.$refs.sourceCanvas, t, this.imageTransforms) : t, o = de({ minWidth: 0, minHeight: 0, maxWidth: 1 / 0, maxHeight: 1 / 0, maxArea: this.maxCanvasSize, imageSmoothingEnabled: !0, imageSmoothingQuality: "high", fillColor: "transparent" }, this.canvas), r = function(a) {
      return a.find(function(l) {
        return u = l, !Number.isNaN(parseFloat(u)) && isFinite(u);
        var u;
      });
    }, i = St({ sizeRestrictions: { minWidth: r([o.width, o.minWidth]) || 0, minHeight: r([o.height, o.minHeight]) || 0, maxWidth: r([o.width, o.maxWidth]) || 1 / 0, maxHeight: r([o.height, o.maxHeight]) || 1 / 0 }, width: this.coordinates.width, height: this.coordinates.height, aspectRatio: { minimum: this.coordinates.width / this.coordinates.height, maximum: this.coordinates.width / this.coordinates.height } });
    if (o.maxArea && i.width * i.height > o.maxArea) {
      var s = Math.sqrt(o.maxArea / (i.width * i.height));
      i = { width: Math.round(s * i.width), height: Math.round(s * i.height) };
    }
    return function(a, l, u, c, d) {
      a.width = c ? c.width : u.width, a.height = c ? c.height : u.height;
      var p = a.getContext("2d");
      p.clearRect(0, 0, a.width, a.height), d && (d.imageSmoothingEnabled && (p.imageSmoothingEnabled = d.imageSmoothingEnabled), d.imageSmoothingQuality && (p.imageSmoothingQuality = d.imageSmoothingQuality), d.fillColor && (p.fillStyle = d.fillColor, p.fillRect(0, 0, a.width, a.height), p.save()));
      var v = u.left < 0 ? -u.left : 0, x = u.top < 0 ? -u.top : 0;
      p.drawImage(l, u.left + v, u.top + x, u.width, u.height, v, x, a.width, a.height);
    }(e, n, this.coordinates, i, o), e;
  }
}, update: function() {
  this.$emit("change", this.getResult());
}, applyTransform: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = this.visibleArea && t ? p5(this.sizeRestrictions, this.visibleArea) : this.sizeRestrictions, o = this.visibleArea && t ? Zn(this.positionRestrictions, this.visibleArea) : this.positionRestrictions;
  return f5({ transform: e, coordinates: this.coordinates, imageSize: this.imageSize, sizeRestrictions: n, positionRestrictions: o, aspectRatio: this.getAspectRatio(), visibleArea: this.visibleArea });
}, resetCoordinates: function() {
  var e = this;
  if (this.$refs.image) {
    this.$refs.cropper, this.$refs.image;
    var t = this.defaultSize;
    t || (t = this.stencilSize ? y5 : b5);
    var n = this.sizeRestrictions;
    n.minWidth, n.minHeight, n.maxWidth, n.maxHeight;
    var o = nn(t) ? t({ boundaries: this.boundaries, imageSize: this.imageSize, aspectRatio: this.getAspectRatio(), sizeRestrictions: this.sizeRestrictions, stencilSize: this.getStencilSize(), visibleArea: this.visibleArea }) : t, r = this.defaultPosition || g5, i = [o, function(s) {
      var a = s.coordinates;
      return de({}, nn(r) ? r({ coordinates: a, imageSize: e.imageSize, visibleArea: e.visibleArea }) : e.defaultPosition);
    }];
    this.delayedTransforms && i.push.apply(i, Zt(Array.isArray(this.delayedTransforms) ? this.delayedTransforms : [this.delayedTransforms])), this.coordinates = this.applyTransform(i, !0), this.delayedTransforms = null;
  }
}, clearImage: function() {
  var e = this;
  this.imageLoaded = !1, setTimeout(function() {
    var t = e.$refs.stretcher;
    t && (t.style.height = "auto", t.style.width = "auto"), e.coordinates = e.defaultCoordinates(), e.boundaries = { width: 0, height: 0 };
  }, this.transitionTime);
}, enableTransitions: function() {
  this.transitions && (this.transitionsActive = !0);
}, disableTransitions: function() {
  this.transitionsActive = !1;
}, updateBoundaries: function() {
  var e = this, t = this.$refs.stretcher, n = this.$refs.cropper;
  return this.initStretcher({ cropper: n, stretcher: t, imageSize: this.imageSize }), this.$nextTick().then(function() {
    var o = { cropper: n, imageSize: e.imageSize };
    if (nn(e.defaultBoundaries) ? e.boundaries = e.defaultBoundaries(o) : e.defaultBoundaries === "fit" ? e.boundaries = function(r) {
      var i = r.cropper, s = r.imageSize, a = i.clientHeight, l = i.clientWidth, u = a, c = s.width * a / s.height;
      return c > l && (c = l, u = s.height * l / s.width), { width: c, height: u };
    }(o) : e.boundaries = function(r) {
      var i = r.cropper;
      return { width: i.clientWidth, height: i.clientHeight };
    }(o), !e.boundaries.width || !e.boundaries.height)
      throw new Error("It's impossible to fit the cropper in the current container");
  });
}, resetVisibleArea: function() {
  var e = this;
  return this.appliedImageTransforms = de(de({}, this.defaultImageTransforms), {}, { flip: de({}, this.defaultImageTransforms.flip) }), this.updateBoundaries().then(function() {
    e.priority !== "visible-area" && (e.visibleArea = null, e.resetCoordinates());
    var t, n, o, r, i, s, a = e.defaultVisibleArea || w5;
    e.visibleArea = nn(a) ? a({ imageSize: e.imageSize, boundaries: e.boundaries, coordinates: e.priority !== "visible-area" ? e.coordinates : null, getAreaRestrictions: e.getAreaRestrictions, stencilSize: e.getStencilSize() }) : e.defaultVisibleArea, e.visibleArea = (t = { visibleArea: e.visibleArea, boundaries: e.boundaries, getAreaRestrictions: e.getAreaRestrictions }, n = t.visibleArea, o = t.boundaries, r = t.getAreaRestrictions, i = Y({}, n), s = pe(o), i.width / i.height !== s && (i.height = i.width / s), Ie(i, r({ visibleArea: i, type: "move" }))), e.priority === "visible-area" ? e.resetCoordinates() : e.coordinates = e.fitCoordinates({ visibleArea: e.visibleArea, coordinates: e.coordinates, aspectRatio: e.getAspectRatio(), positionRestrictions: e.positionRestrictions, sizeRestrictions: e.sizeRestrictions }), e.runAutoZoom("resetVisibleArea");
  }).catch(function() {
    e.visibleArea = null;
  });
}, updateVisibleArea: function() {
  var e = this;
  return this.updateBoundaries().then(function() {
    e.visibleArea = e.fitVisibleArea({ imageSize: e.imageSize, boundaries: e.boundaries, visibleArea: e.visibleArea, coordinates: e.coordinates, getAreaRestrictions: e.getAreaRestrictions }), e.coordinates = e.fitCoordinates({ visibleArea: e.visibleArea, coordinates: e.coordinates, aspectRatio: e.getAspectRatio(), positionRestrictions: e.positionRestrictions, sizeRestrictions: e.sizeRestrictions }), e.runAutoZoom("updateVisibleArea");
  }).catch(function() {
    e.visibleArea = null;
  });
}, onChange: function() {
  var e = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
  e && this.debounce ? this.debouncedUpdate() : this.update();
}, onChangeImage: function() {
  var e, t = this;
  if (this.imageLoaded = !1, this.delayedTransforms = null, this.src) {
    if (function(r) {
      if (Ps(r))
        return !1;
      var i = window.location, s = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/.exec(r) || [], a = { protocol: s[1] || "", host: s[2] || "", port: s[3] || "" }, l = function(u) {
        return u.port || ((u.protocol || i.protocol) === "http" ? 80 : 433);
      };
      return !(!a.protocol && !a.host && !a.port || a.protocol && a.protocol == i.protocol && a.host && a.host == i.host && a.host && l(a) == l(i));
    }(this.src)) {
      var n = Te(this.crossOrigin) ? this.canvas : this.crossOrigin;
      n === !0 && (n = "anonymous"), this.imageAttributes.crossOrigin = n || null;
    }
    if (this.checkOrientation) {
      var o = (e = this.src, new Promise(function(r) {
        M5(e).then(function(i) {
          var s = T5(i);
          r(i ? { source: e, arrayBuffer: i, orientation: s } : { source: e, arrayBuffer: null, orientation: null });
        }).catch(function(i) {
          console.warn(i), r({ source: e, arrayBuffer: null, orientation: null });
        });
      }));
      setTimeout(function() {
        o.then(t.onParseImage);
      }, this.transitionTime);
    } else
      setTimeout(function() {
        t.onParseImage({ source: t.src });
      }, this.transitionTime);
  } else
    this.clearImage();
}, onFailLoadImage: function() {
  this.imageAttributes.src && (this.clearImage(), this.$emit("error"));
}, onSuccessLoadImage: function() {
  var e = this, t = this.$refs.image;
  t && !this.imageLoaded && (this.imageAttributes.height = t.naturalHeight, this.imageAttributes.width = t.naturalWidth, this.imageLoaded = !0, this.resetVisibleArea().then(function() {
    e.$emit("ready"), e.onChange(!1);
  }));
}, onParseImage: function(e) {
  var t = this, n = e.source, o = e.arrayBuffer, r = e.orientation;
  this.imageAttributes.revoke && this.imageAttributes.src && URL.revokeObjectURL(this.imageAttributes.src), this.imageAttributes.revoke = !1, o && r && r > 1 ? Wl(n) || !Ps(n) ? (this.imageAttributes.src = URL.createObjectURL(new Blob([o])), this.imageAttributes.revoke = !0) : this.imageAttributes.src = function(i) {
    for (var s = [], a = new Uint8Array(i); a.length > 0; ) {
      var l = a.subarray(0, 8192);
      s.push(String.fromCharCode.apply(null, Array.from ? Array.from(l) : l.slice())), a = a.subarray(8192);
    }
    return "data:image/jpeg;base64," + btoa(s.join(""));
  }(o) : this.imageAttributes.src = n, nn(this.defaultTransforms) ? this.appliedImageTransforms = dr(this.defaultTransforms()) : ro(this.defaultTransforms) ? this.appliedImageTransforms = dr(this.defaultTransforms) : this.appliedImageTransforms = function(i) {
    var s = dr({});
    if (i)
      switch (i) {
        case 2:
          s.flip.horizontal = !0;
          break;
        case 3:
          s.rotate = -180;
          break;
        case 4:
          s.flip.vertical = !0;
          break;
        case 5:
          s.rotate = 90, s.flip.vertical = !0;
          break;
        case 6:
          s.rotate = 90;
          break;
        case 7:
          s.rotate = 90, s.flip.horizontal = !0;
          break;
        case 8:
          s.rotate = -90;
      }
    return s;
  }(r), this.defaultImageTransforms = de(de({}, this.appliedImageTransforms), {}, { flip: de({}, this.appliedImageTransforms.flip) }), this.$nextTick(function() {
    var i = t.$refs.image;
    i && i.complete && (function(s) {
      return !!s.naturalWidth;
    }(i) ? t.onSuccessLoadImage() : t.onFailLoadImage());
  });
}, onResizeEnd: function() {
  this.runAutoZoom("resize", { transitions: !0 });
}, onMoveEnd: function() {
  this.runAutoZoom("move", { transitions: !0 });
}, onMove: function(e) {
  var t = this;
  this.transitionsOptions.enabled || this.awaitRender(function() {
    t.coordinates = t.moveAlgorithm(de(de({}, t.getPublicProperties()), {}, { positionRestrictions: Zn(t.positionRestrictions, t.visibleArea), coordinates: t.coordinates, event: t.normalizeEvent(e) })), t.onChange();
  });
}, onResize: function(e) {
  var t = this;
  this.transitionsOptions.enabled || this.stencilSize && !this.autoZoom || this.awaitRender(function() {
    var n = t.sizeRestrictions, o = Math.min(t.coordinates.width, t.coordinates.height, 20 * t.coefficient);
    t.coordinates = t.resizeAlgorithm(de(de({}, t.getPublicProperties()), {}, { positionRestrictions: Zn(t.positionRestrictions, t.visibleArea), sizeRestrictions: { maxWidth: Math.min(n.maxWidth, t.visibleArea.width), maxHeight: Math.min(n.maxHeight, t.visibleArea.height), minWidth: Math.max(n.minWidth, o), minHeight: Math.max(n.minHeight, o) }, event: t.normalizeEvent(e) })), t.onChange(), t.ticking = !1;
  });
}, onManipulateImage: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!this.transitionsOptions.enabled) {
    var n = t.transitions, o = n !== void 0 && n, r = t.normalize, i = r === void 0 || r;
    o && this.enableTransitions();
    var s = x5(de(de({}, this.getPublicProperties()), {}, { event: i ? this.normalizeEvent(e) : e, getAreaRestrictions: this.getAreaRestrictions, imageRestriction: this.imageRestriction, adjustStencil: !this.stencilSize && this.settings.resizeImage.adjustStencil })), a = s.visibleArea, l = s.coordinates;
    this.visibleArea = a, this.coordinates = l, this.runAutoZoom("manipulateImage"), this.onChange(), o && this.debouncedDisableTransitions();
  }
}, onPropsChange: function() {
  this.coordinates = this.applyTransform(this.coordinates, !0), this.onChange(!1);
}, getAreaRestrictions: function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.visibleArea, n = e.type, o = n === void 0 ? "move" : n;
  return this.areaRestrictionsAlgorithm({ boundaries: this.boundaries, imageSize: this.imageSize, imageRestriction: this.imageRestriction, visibleArea: t, type: o });
}, getAspectRatio: function(e) {
  var t, n, o = this.stencilProps, r = o.aspectRatio, i = o.minAspectRatio, s = o.maxAspectRatio;
  if (this.$refs.stencil && this.$refs.stencil.aspectRatios) {
    var a = this.$refs.stencil.aspectRatios();
    t = a.minimum, n = a.maximum;
  }
  if (Te(t) && (t = Te(r) ? i : r), Te(n) && (n = Te(r) ? s : r), !e && (Te(t) || Te(n))) {
    var l = this.getStencilSize(), u = l ? pe(l) : null;
    Te(t) && (t = Is(u) ? u : void 0), Te(n) && (n = Is(u) ? u : void 0);
  }
  return { minimum: t, maximum: n };
}, getStencilSize: function() {
  if (this.stencilSize)
    return e = { currentStencilSize: { width: this.stencilCoordinates.width, height: this.stencilCoordinates.height }, stencilSize: this.stencilSize, boundaries: this.boundaries, coefficient: this.coefficient, coordinates: this.coordinates, aspectRatio: this.getAspectRatio(!0) }, t = e.boundaries, n = e.stencilSize, o = e.aspectRatio, ur(pe(r = nn(n) ? n({ boundaries: t, aspectRatio: o }) : n), o) && (r = St({ sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minWidth: 0, minHeight: 0 }, width: r.width, height: r.height, aspectRatio: { minimum: o.minimum, maximum: o.maximum } })), (r.width > t.width || r.height > t.height) && (r = St({ sizeRestrictions: { maxWidth: t.width, maxHeight: t.height, minWidth: 0, minHeight: 0 }, width: r.width, height: r.height, aspectRatio: { minimum: pe(r), maximum: pe(r) } })), r;
  var e, t, n, o, r;
}, getPublicProperties: function() {
  return { coefficient: this.coefficient, visibleArea: this.visibleArea, coordinates: this.coordinates, boundaries: this.boundaries, sizeRestrictions: this.sizeRestrictions, positionRestrictions: this.positionRestrictions, aspectRatio: this.getAspectRatio(), imageRestriction: this.imageRestriction };
}, defaultCoordinates: function() {
  return de({}, Ls);
}, flip: function(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o = n.transitions, r = o === void 0 || o;
  if (!this.transitionsActive) {
    r && this.enableTransitions();
    var i = de({}, this.imageTransforms.flip), s = C5({ flip: { horizontal: e ? !i.horizontal : i.horizontal, vertical: t ? !i.vertical : i.vertical }, previousFlip: i, rotate: this.imageTransforms.rotate, visibleArea: this.visibleArea, coordinates: this.coordinates, imageSize: this.imageSize, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), a = s.visibleArea, l = s.coordinates;
    e && (this.appliedImageTransforms.flip.horizontal = !this.appliedImageTransforms.flip.horizontal), t && (this.appliedImageTransforms.flip.vertical = !this.appliedImageTransforms.flip.vertical), this.visibleArea = a, this.coordinates = l, this.onChange(), r && this.debouncedDisableTransitions();
  }
}, rotate: function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = t.transitions, o = n === void 0 || n;
  if (!this.transitionsActive) {
    o && this.enableTransitions();
    var r = de({}, this.imageSize);
    this.appliedImageTransforms.rotate += e;
    var i = $5({ visibleArea: this.visibleArea, coordinates: this.coordinates, previousImageSize: r, imageSize: this.imageSize, angle: e, positionRestrictions: this.positionRestrictions, sizeRestrictions: this.sizeRestrictions, getAreaRestrictions: this.getAreaRestrictions, aspectRatio: this.getAspectRatio() }), s = i.visibleArea, a = i.coordinates, l = this.processAutoZoom("rotateImage", s, a);
    s = l.visibleArea, a = l.coordinates, this.visibleArea = s, this.coordinates = a, this.onChange(), o && this.debouncedDisableTransitions();
  }
} }, emits: ["change", "error", "ready"] }, I5 = { key: 0, ref: "canvas", style: { display: "none" } }, L5 = { key: 1, ref: "sourceCanvas", style: { display: "none" } };
su.render = function(e, t, n, o, r, i) {
  return f(), j("div", { ref: "cropper", class: i.classes.cropper }, [B("div", { ref: "stretcher", class: i.classes.stretcher }, null, 2), B("div", { class: i.classes.boundaries, style: i.boundariesStyle }, [(f(), j(Le(n.backgroundWrapperComponent), { class: i.classes.cropperWrapper, "wheel-resize": i.settings.resizeImage.wheel, "touch-resize": i.settings.resizeImage.touch, "touch-move": i.settings.moveImage.touch, "mouse-move": i.settings.moveImage.mouse, onMove: i.onManipulateImage, onResize: i.onManipulateImage }, { default: F(function() {
    return [B("div", { class: i.classes.background, style: i.boundariesStyle }, null, 6), B("div", { class: i.classes.imageWrapper }, [B("img", { ref: "image", crossorigin: r.imageAttributes.crossOrigin, src: r.imageAttributes.src, class: i.classes.image, style: i.imageStyle, onMousedown: t[1] || (t[1] = ft(function() {
    }, ["prevent"])) }, null, 46, ["crossorigin", "src"])], 2), B("div", { class: i.classes.foreground, style: i.boundariesStyle }, null, 6), ze((f(), j(Le(n.stencilComponent), _t({ ref: "stencil", image: i.image, coordinates: r.coordinates, "stencil-coordinates": i.stencilCoordinates, transitions: i.transitionsOptions }, n.stencilProps, { onResize: i.onResize, onResizeEnd: i.onResizeEnd, onMove: i.onMove, onMoveEnd: i.onMoveEnd }), null, 16, ["image", "coordinates", "stencil-coordinates", "transitions", "onResize", "onResizeEnd", "onMove", "onMoveEnd"])), [[At, r.imageLoaded]]), n.canvas ? (f(), j("canvas", I5, null, 512)) : P("", !0), n.canvas ? (f(), j("canvas", L5, null, 512)) : P("", !0)];
  }), _: 1 }, 8, ["class", "wheel-resize", "touch-resize", "touch-move", "mouse-move", "onMove", "onResize"]))], 6)], 2);
};
function D5({ maxWidth: e, maxHeight: t, name: n, errorMessage: o }, {
  emit: r
}) {
  const i = A(""), s = A(""), a = A(""), l = A(""), u = E(() => s.value ? Math.round((s.value.length * (3 / 4) - 2) / 1024 * 100) / 100 : 0), c = E(() => u.value === 0 || u.value >= 5 && u.value <= 1e3);
  he(a, () => {
    const b = new Image();
    b.src = a.value, b.onload = () => {
      const h = document.createElement("canvas");
      let S = b.width, g = b.height;
      S > g ? S > e.value && (g = Math.round(g *= e.value / S), S = e.value) : g > t.value && (S = Math.round(S *= t.value / g), g = t.value), h.width = S, h.height = g;
      const C = h.getContext("2d");
      C && C.drawImage(b, 0, 0, S, g), l.value = h.toDataURL(i.value, 0.7), p();
    };
  });
  const d = ({ imageSize: b, visibleArea: h }) => ({
    width: (h || b).width,
    height: (h || b).height
  }), p = () => {
    r("update", {
      sizeOk: c,
      imageCropped: s.value,
      name: n.value ?? null
    });
  };
  return {
    computedSize: u,
    sizeOk: c,
    crop: (b) => {
      s.value = b.canvas.toDataURL(), p();
    },
    upload: (b) => {
      const { files: h } = b.target;
      if (h && h[0]) {
        if (i.value = h[0].type, !["image/jpeg", "image/png"].includes(i.value)) {
          gt.dispatch("notification/error", {
            text: o.value,
            timeout: 5e3
          }), i.value = "";
          return;
        }
        const S = new FileReader();
        S.readAsArrayBuffer(h[0]), S.onload = (g) => {
          if (g.target && g.target.result) {
            const C = new Blob([g.target.result]);
            window.URL = window.URL || window.webkitURL, a.value = window.URL.createObjectURL(C);
          }
        };
      }
    },
    defaultSize: d,
    image: l
  };
}
const B5 = z({
  name: "ImageUploader",
  components: {
    Cropper: su,
    CheckIcon: Ha,
    PencilIcon: Uu,
    XMarkIcon: b0,
    XCircleIcon: Wa
  },
  props: {
    aspectRatio: {
      type: Number,
      default: null
    },
    defaultPictureUrl: {
      type: String,
      default: null
    },
    label: {
      type: String,
      required: !0
    },
    tip: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    constraintsMessage: {
      type: String,
      default: null
    },
    dragImageMessage: {
      type: String,
      default: null
    },
    replaceImageMessage: {
      type: String,
      default: null
    },
    selectImageMessage: {
      type: String,
      default: null
    },
    maxHeight: {
      type: Number,
      default: 800
    },
    maxWidth: {
      type: Number,
      default: 800
    },
    hasBorderTop: {
      type: Boolean,
      default: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    disabledText: {
      type: String,
      default: null
    },
    disabledSubText: {
      type: String,
      default: null
    }
  },
  emits: {
    update(e) {
      return e;
    }
  },
  setup(e, t) {
    const { computedSize: n, sizeOk: o, crop: r, upload: i, defaultSize: s, image: a } = D5(at(e), t);
    return {
      getColorClass: W,
      computedSize: n,
      sizeOk: o,
      crop: r,
      upload: i,
      defaultSize: s,
      image: a
    };
  },
  computed: {
    borderClass() {
      return this.hasBorderTop ? "sm:border-t sm:border-gray-200 sm:pt-5" : "";
    },
    imageMessage() {
      switch (this.disabled) {
        case !0:
          return this.disabledText;
        case !1:
        default:
          return this.image ? "" : this.dragImageMessage;
      }
    },
    constraintSubtitle() {
      switch (this.disabled) {
        case !0:
          return this.disabledSubText;
        case !1:
        default:
          return this.constraintsMessage;
      }
    }
  }
}), z5 = {
  for: "cover_photo",
  class: "block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
}, N5 = {
  key: 0,
  class: "mt-1 text-xs font-normal text-gray-500"
}, j5 = ["src"], V5 = { class: "mt-1 sm:col-span-2 sm:mt-0" }, F5 = { class: "mt-1 sm:col-span-2 sm:mt-0" }, H5 = { class: "relative rounded-md border-2 border-dashed border-gray-300" }, U5 = ["disabled"], W5 = {
  key: 0,
  class: "mx-auto h-12 w-12 text-gray-400",
  stroke: "currentColor",
  fill: "none",
  viewBox: "0 0 48 48",
  "aria-hidden": "true"
}, q5 = /* @__PURE__ */ m("path", {
  d: "M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), Z5 = [
  q5
], G5 = { class: "mt-1 text-xs text-gray-500" }, K5 = {
  key: 0,
  class: "mt-4"
}, Y5 = { class: "mx-auto mt-1 flex w-min text-sm text-gray-500" };
function X5(e, t, n, o, r, i) {
  const s = ne("XCircleIcon"), a = ne("cropper");
  return f(), y("div", {
    class: O(["sm:grid sm:grid-cols-3 sm:items-start sm:gap-4", e.borderClass])
  }, [
    m("div", null, [
      m("label", z5, [
        ce(R(e.label) + " ", 1),
        e.tip ? (f(), y("div", N5, R(e.tip), 1)) : P("", !0)
      ]),
      e.defaultPictureUrl !== null ? (f(), y("img", {
        key: 0,
        class: "w-16 flex-shrink-0 pt-2",
        src: e.defaultPictureUrl,
        alt: ""
      }, null, 8, j5)) : P("", !0)
    ]),
    m("div", V5, [
      m("div", F5, [
        m("div", H5, [
          m("input", {
            id: "file",
            disabled: e.disabled,
            name: "file",
            type: "file",
            accept: ".jpeg, .png, .jpg",
            class: O(["relative z-10 block h-full w-full opacity-0", [{ "cursor-pointer": !e.disabled }, e.image ? "p-10" : "p-20"]]),
            onChange: t[0] || (t[0] = (...l) => e.upload && e.upload(...l))
          }, null, 42, U5),
          m("div", {
            class: O(["absolute left-0 right-0 top-0 z-0 m-auto text-center", e.image ? "p-5" : "p-10"])
          }, [
            e.disabled ? (f(), j(s, {
              key: 1,
              class: "mx-auto h-12 w-12 text-gray-400"
            })) : (f(), y("svg", W5, Z5)),
            m("h4", null, R(e.imageMessage), 1),
            e.disabled ? P("", !0) : (f(), y("p", {
              key: 2,
              class: O(`font-medium ${e.getColorClass({ type: "text", value: "800" })} ${e.getColorClass({
                type: "text",
                value: "600",
                prefix: "hover"
              })} focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 ${e.getColorClass({ type: "ring", value: "800", prefix: "focus-within" })}`)
            }, R(e.image ? e.replaceImageMessage : e.selectImageMessage), 3)),
            m("p", G5, R(e.constraintSubtitle), 1)
          ], 2)
        ]),
        e.image ? (f(), y("div", K5, [
          B(a, {
            class: "cropper",
            src: e.image,
            "background-class": "bg-white",
            "stencil-props": {
              aspectRatio: e.aspectRatio
            },
            "default-size": e.defaultSize,
            onChange: e.crop
          }, null, 8, ["src", "stencil-props", "default-size", "onChange"]),
          m("div", Y5, [
            (f(), j(Le(e.sizeOk ? "CheckIcon" : "XMarkIcon"), {
              class: O(["mr-1 h-5 w-5", e.sizeOk ? "text-green-500" : "text-red-400"])
            }, null, 8, ["class"])),
            ce(" " + R(e.computedSize) + "Ko ", 1)
          ])
        ])) : P("", !0)
      ])
    ])
  ], 2);
}
const T7 = /* @__PURE__ */ Ee(B5, [["render", X5]]), Q5 = ["for"], J5 = ["id", "name", "value", "disabled"], e2 = {
  key: 0,
  value: "-1",
  disabled: "",
  selected: ""
}, t2 = ["value"], n2 = {
  key: 1,
  class: "mt-2 text-sm text-gray-500"
}, o2 = {
  key: 2,
  id: "headline-error",
  class: "mt-2 text-sm text-red-600"
}, P7 = /* @__PURE__ */ z({
  __name: "Select",
  props: {
    id: {},
    label: { default: "" },
    tips: { default: "" },
    errors: { default: [] },
    options: {},
    modelValue: {},
    optionKey: { default: "name" },
    disabled: { type: Boolean, default: !1 },
    pattern: { default: "" },
    bgColor: { default: "bg-white" },
    placeholder: { default: "" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = E(() => {
      const i = ["mt-1 block w-full shadow-sm px-3 focus:outline-none sm:text-sm"];
      return i.push(
        W({
          type: "ring",
          value: "800",
          prefix: "focus"
        }),
        W({ type: "border", value: "800", prefix: "focus" })
      ), n.errors.length > 0 && i.push("border-red-300 text-red-900 placeholder-red-300"), n.pattern === "b2c" ? (i.push(" py-4 rounded-xl border-transparent focus:border-transparent focus:ring-0 focus:ring-transparent"), i.push(n.modelValue === -1 ? "text-gray-400" : "text-gray-800")) : i.push("rounded-md border border-gray-300 py-2"), i.push(n.bgColor), i;
    });
    return (i, s) => (f(), y("div", null, [
      i.label ? (f(), y("label", {
        key: 0,
        for: i.id,
        class: "block w-full text-left text-sm font-medium text-gray-900"
      }, R(i.label), 9, Q5)) : P("", !0),
      m("select", {
        id: i.id,
        name: i.label ? i.label : i.id,
        value: i.modelValue,
        class: O(r.value),
        disabled: i.disabled,
        onChange: s[0] || (s[0] = (a) => o("update:modelValue", T(Vt)(a)))
      }, [
        i.placeholder ? (f(), y("option", e2, R(i.placeholder), 1)) : P("", !0),
        (f(!0), y(K, null, se(i.options, (a) => (f(), y("option", {
          key: a.id,
          value: a.id
        }, R(a[i.optionKey]), 9, t2))), 128))
      ], 42, J5),
      i.tips ? (f(), y("p", n2, R(i.tips), 1)) : P("", !0),
      i.errors ? (f(), y("p", o2, R(i.errors[0]), 1)) : P("", !0)
    ]));
  }
});
function r2({ apiKey: e }, {
  emit: t
}) {
  const n = A(""), o = A(null), r = A(!1), i = A(null), s = A([]);
  return ae(() => {
    const u = "google-maps-script-import";
    if (document.getElementById(u))
      return;
    const c = document.createElement("script");
    c.setAttribute("src", `https://maps.googleapis.com/maps/api/js?key=${e.value}&libraries=places`), c.setAttribute("id", u), document.head.appendChild(c), i.value = null;
  }), he(i, () => {
    var u, c;
    i.value !== null && (t("update:modelValue", (u = i.value) == null ? void 0 : u.place_id), (c = i.value) != null && c.structured_formatting && (n.value = i.value.structured_formatting.main_text), r.value = !1);
  }), {
    autocompleteGooglePlaceId: () => {
      const u = {
        input: n.value,
        types: ["establishment"],
        sessionToken: o.value
      }, c = new google.maps.places.AutocompleteService();
      n.value.length > 3 ? (o.value === null && (o.value = new google.maps.places.AutocompleteSessionToken()), c.getPlacePredictions(u, (d, p) => {
        p == "OK" && (s.value = d);
      }), r.value = !0) : (r.value = !1, u.sessionToken = null);
    },
    autocompleteString: n,
    open: r,
    predictionsArray: s,
    selectedItem: i,
    renewGooglePlaceId: () => {
      i.value = null, r.value = !1, n.value = "", ke().then(() => {
        n.value;
      });
    }
  };
}
const i2 = z({
  name: "GooglePlace",
  components: {
    CheckIcon: Ha,
    ArrowTopRightOnSquareIcon: f0,
    Listbox: ko,
    ListboxOption: In,
    ListboxOptions: Eo,
    ListboxLabel: Oa
  },
  props: {
    label: {
      type: String,
      default: null
    },
    id: {
      type: String,
      required: !0
    },
    modelValue: {
      type: String,
      default: ""
    },
    linkConfigured: {
      type: String,
      required: !0
    },
    googleTest: {
      type: String,
      required: !0
    },
    askWrongOne: {
      type: String,
      required: !0
    },
    buttonLabel: {
      type: String,
      required: !0
    },
    apiKey: {
      type: [String, Boolean],
      default: ""
    }
  },
  emits: {
    "update:modelValue"(e) {
      return e;
    }
  },
  setup(e, t) {
    const { predictionsArray: n, open: o, autocompleteString: r, autocompleteGooglePlaceId: i, selectedItem: s, renewGooglePlaceId: a } = r2(at(e), t);
    return {
      getColorClass: W,
      predictionsArray: n,
      open: o,
      autocompleteString: r,
      autocompleteGooglePlaceId: i,
      selectedItem: s,
      renewGooglePlaceId: a
    };
  }
}), s2 = { class: "relative" }, a2 = ["for"], l2 = ["id"], u2 = {
  key: 1,
  class: "flex"
}, c2 = { class: "relative flex flex-grow items-center border border-gray-300 pl-3 text-gray-500 focus-within:z-10" }, d2 = { class: "hidden sm:inline" }, p2 = /* @__PURE__ */ m("span", { class: "inline sm:hidden" }, "OK", -1), f2 = ["href"], h2 = {
  key: 2,
  class: "text-xs font-normal text-gray-500"
};
function v2(e, t, n, o, r, i) {
  const s = ne("ListboxLabel"), a = ne("CheckIcon"), l = ne("ArrowTopRightOnSquareIcon"), u = ne("ListboxOption"), c = ne("ListboxOptions"), d = ne("Listbox");
  return f(), y("div", s2, [
    e.label ? (f(), y("label", {
      key: 0,
      for: e.id,
      class: "mb-1 block w-full text-left text-sm font-medium text-gray-900"
    }, R(e.label), 9, a2)) : P("", !0),
    B(d, {
      modelValue: e.selectedItem,
      "onUpdate:modelValue": t[4] || (t[4] = (p) => e.selectedItem = p),
      as: "div",
      class: "w-full"
    }, {
      default: F(() => [
        B(s, { class: "block text-sm font-medium text-gray-700" }),
        e.selectedItem ? (f(), y("div", u2, [
          m("div", c2, [
            B(a, {
              class: "mr-2 h-6 w-6 text-green-400",
              "aria-hidden": "true"
            }),
            m("span", d2, R(e.linkConfigured), 1),
            p2
          ]),
          m("a", {
            href: `http://search.google.com/local/writereview?placeid=${e.selectedItem.place_id}`,
            target: "_blank",
            class: "relative -ml-px inline-flex items-center space-x-2 rounded-r-md border border-gray-300 bg-gray-50 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500"
          }, [
            B(l, {
              class: "h-5 w-5 text-gray-400",
              "aria-hidden": "true"
            }),
            ce(" " + R(e.googleTest), 1)
          ], 8, f2)
        ])) : ze((f(), y("input", {
          key: 0,
          id: e.id,
          ref: "autocompleteStringRef",
          "onUpdate:modelValue": t[0] || (t[0] = (p) => e.autocompleteString = p),
          placeholder: "place",
          autocomplete: "off",
          type: "search",
          name: "name",
          class: O(`block w-full flex-1 ${e.getColorClass({ type: "ring", value: "800", prefix: "focus" })} ${e.getColorClass({
            type: "border",
            value: "800",
            prefix: "focus"
          })} min-w-0 rounded-md border-gray-300 text-xs sm:text-sm`),
          onKeyup: t[1] || (t[1] = (...p) => e.autocompleteGooglePlaceId && e.autocompleteGooglePlaceId(...p)),
          onFocus: t[2] || (t[2] = (p) => e.autocompleteString !== null ? e.autocompleteString = null : "")
        }, null, 42, l2)), [
          [rn, e.autocompleteString]
        ]),
        ze(m("div", null, [
          B(Gt, {
            "leave-active-class": "transition ease-in duration-100",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: F(() => [
              B(c, {
                static: "",
                class: "absolute z-10 mt-0.5 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
              }, {
                default: F(() => [
                  (f(!0), y(K, null, se(e.predictionsArray, (p) => (f(), j(u, {
                    key: p.place_id,
                    as: "template",
                    value: p
                  }, {
                    default: F(({ active: v, selected: x }) => [
                      m("li", {
                        class: O([
                          v ? "bg-indigo-600 text-white" : "text-gray-900",
                          "relative cursor-pointer select-none py-2 pl-3 pr-9 hover:bg-gray-100"
                        ])
                      }, [
                        m("div", {
                          class: O([x ? "font-semibold" : "font-normal", "truncate"])
                        }, R(p.structured_formatting.main_text), 3),
                        m("div", {
                          class: O([v ? "text-indigo-200" : "text-gray-500", "truncate"])
                        }, R(p.structured_formatting.secondary_text), 3)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"]))), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 512), [
          [At, e.open]
        ]),
        e.selectedItem !== null ? (f(), y("p", h2, [
          ce(R(e.askWrongOne) + " ", 1),
          m("button", {
            type: "button",
            class: O(`${e.getColorClass({ type: "text", value: "600" })} underline`),
            onClick: t[3] || (t[3] = (...p) => e.renewGooglePlaceId && e.renewGooglePlaceId(...p))
          }, R(e.buttonLabel), 3)
        ])) : P("", !0)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]);
}
const I7 = /* @__PURE__ */ Ee(i2, [["render", v2]]), m2 = {
  categoriesLabel: "Catégories",
  emojiUnsupportedMessage: "Votre navigateur ne soutient pas les emojis en couleur.",
  favoritesLabel: "Favoris",
  loadingMessage: "Chargement en cours…",
  networkErrorMessage: "Impossible de charger les emojis.",
  regionLabel: "Choisir un emoji",
  searchDescription: "Quand les résultats sont disponisbles, appuyez la fleche vers le haut ou le bas et la touche entrée pour choisir.",
  searchLabel: "Rechercher",
  searchResultsLabel: "Résultats",
  skinToneDescription: "Quand disponible, appuyez la fleche vers le haut ou le bas et la touch entrée pour choisir.",
  skinToneLabel: "Choisir une couleur de peau (actuellement {skinTone})",
  skinTonesLabel: "Couleurs de peau",
  skinTones: [
    "Défaut",
    "Clair",
    "Moyennement clair",
    "Moyen",
    "Moyennement sombre",
    "Sombre"
  ],
  categories: {
    custom: "Customisé",
    "smileys-emotion": "Les smileyes et les émoticônes",
    "people-body": "Les gens et le corps",
    "animals-nature": "Les animaux et la nature",
    "food-drink": "La nourriture et les boissons",
    "travel-places": "Les voyages et les endroits",
    activities: "Les activités",
    objects: "Les objets",
    symbols: "Les symbols",
    flags: "Les drapeaux"
  }
};
function g2() {
  const e = {
    emoji: ""
  };
  return {
    emojiSelected: (n, o) => {
      e.emoji = n.detail.unicode, o();
    },
    form: e
  };
}
const b2 = z({
  name: "EmojiPickerInput",
  components: { Popover: Gr, PopoverButton: Ta, PopoverPanel: Pa, ChevronUpDownIcon: Vr },
  props: {
    modelValue: {
      type: String,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  setup() {
    const e = A(!1), t = m2, { emojiSelected: n, form: o } = g2();
    return ae(async () => {
      if (typeof window < "u") {
        const r = await import("./index-ad95baff.mjs"), i = r.default || r;
        customElements.get("emoji-picker") || customElements.define("emoji-picker", i), e.value = !0;
      }
    }), {
      fr: t,
      emojiSelected: n,
      form: o,
      emojiPickerLoaded: e
    };
  }
}), y2 = { class: "w-full text-4xl" }, w2 = {
  type: "button",
  white: !0
}, x2 = { class: "-ml-1 w-6 text-left" }, $2 = ["i18n", "onEmojiClick"];
function C2(e, t, n, o, r, i) {
  const s = ne("ChevronUpDownIcon"), a = ne("PopoverButton"), l = ne("PopoverPanel"), u = ne("Popover");
  return f(), y("div", y2, [
    B(u, { class: "relative" }, {
      default: F(() => [
        B(a, { class: "relative" }, {
          default: F(() => [
            m("button", w2, [
              m("span", x2, R(e.modelValue), 1),
              B(s, { class: "absolute right-0 mr-1 h-4 w-4" })
            ])
          ]),
          _: 1
        }),
        B(l, { class: "absolute z-10" }, {
          default: F(({ close: c }) => [
            e.emojiPickerLoaded ? (f(), y("emoji-picker", {
              key: 0,
              class: "light my-2 ml-0",
              i18n: e.fr,
              locale: "fr",
              onEmojiClick: (d) => (e.emojiSelected(d, c), e.$emit("update:modelValue", e.form.emoji))
            }, null, 40, $2)) : P("", !0)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]);
}
const L7 = /* @__PURE__ */ Ee(b2, [["render", C2]]), S2 = {
  key: 0,
  class: "mb-1.5 block w-full text-left text-sm font-normal text-gray-800"
}, k2 = { class: "w-full" }, E2 = ["disabled", "maxlength"], O2 = { class: "relative mt-1.5 flex w-full items-center justify-between text-xs" }, A2 = {
  key: 0,
  class: "text-gray-500"
}, D7 = /* @__PURE__ */ z({
  __name: "Textarea",
  props: {
    isDisabled: { type: Boolean },
    maxLength: {},
    modelValue: {},
    label: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, r = sn(n, "modelValue", t);
    return (i, s) => (f(), y(K, null, [
      n.label ? (f(), y("label", S2, R(i.label), 1)) : P("", !0),
      m("div", k2, [
        ze(m("textarea", _t({
          "onUpdate:modelValue": s[0] || (s[0] = (a) => mo(r) ? r.value = a : null),
          type: "text"
        }, i.$attrs, {
          disabled: i.isDisabled,
          maxlength: i.maxLength,
          class: [
            `flex-1 ${T(W)({ type: "ring", value: "800", prefix: "focus" })} ${T(W)({
              type: "border",
              value: "800",
              prefix: "focus"
            })} block w-full min-w-0 rounded-md border-gray-200 sm:text-sm`,
            i.isDisabled && "bg-gray-50 text-gray-400"
          ]
        }), null, 16, E2), [
          [rn, T(r)]
        ]),
        m("div", O2, [
          i.$slots.tips ? (f(), y("p", A2, [
            G(i.$slots, "tips")
          ])) : P("", !0)
        ])
      ])
    ], 64));
  }
}), _2 = ["checked"], R2 = { key: 1 }, Vs = /* @__PURE__ */ z({
  __name: "MultiSelectOptionItem",
  props: {
    option: {},
    selectedOptions: {},
    displayedValueKey: {},
    emptyListDefaultValue: {}
  },
  emits: ["onOptionSelected"],
  setup(e, { emit: t }) {
    const n = e, o = E(() => {
      var s;
      return n.selectedOptions.some((a) => a.id === n.option.id) || n.selectedOptions.length === 0 && n.option.id === ((s = n.emptyListDefaultValue) == null ? void 0 : s.id);
    }), r = t, i = () => {
      n.option.isDisabled || r("onOptionSelected", n.option);
    };
    return (s, a) => (f(), j(T(In), {
      as: "li",
      class: O([s.option.isDisabled && "pointer-events-none text-gray-300"]),
      disabled: s.option.isDisabled,
      onClick: ft(i, ["stop"])
    }, {
      default: F(({ active: l }) => [
        s.$slots.default ? (f(), y("div", R2, [
          G(s.$slots, "default", { option: s.option })
        ])) : (f(), y("div", {
          key: 0,
          class: O([
            l && `${T(W)({ type: "bg", value: "50" })}`,
            "relative flex cursor-pointer select-none items-center gap-4 rounded-md py-2 pl-4 pr-4"
          ])
        }, [
          m("input", {
            checked: o.value,
            type: "checkbox",
            class: O([
              "h-4 w-4 rounded border-solid border-gray-300",
              T(W)({ type: "ring", value: "800", prefix: "focus" }),
              !s.option.isDisabled && s.option.isDisabled ? "bg-gray-200 text-gray-400" : T(W)({ type: "text", value: "800" })
            ])
          }, null, 10, _2),
          m("span", {
            class: "block truncate",
            onClick: a[0] || (a[0] = ft(() => {
            }, ["prevent"]))
          }, R(s.option[s.displayedValueKey]), 1)
        ], 2))
      ]),
      _: 3
    }, 8, ["class", "disabled"]));
  }
}), M2 = {
  key: 0,
  class: "mx-2 flex flex-wrap gap-2"
}, T2 = {
  key: 0,
  class: "flex items-center rounded border bg-gray-100 px-2"
}, P2 = { key: 0 }, I2 = {
  key: 1,
  class: "mx-2 flex flex-wrap gap-2"
}, L2 = { class: "flex items-center rounded border bg-gray-100 px-2" }, D2 = {
  key: 2,
  class: "flex items-center border border-transparent px-2"
}, B2 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }, z2 = { class: "sticky top-0 z-10 w-full bg-white py-2" }, N2 = ["placeholder"], j2 = { class: "inline-flex w-full text-sm font-normal text-gray-500" }, V2 = { class: "text-xs font-medium text-gray-800" }, F2 = {
  key: 0,
  class: "text-sm text-gray-400"
}, H2 = {
  key: 3,
  class: "pt-1"
}, U2 = ["placeholder", "onKeydown"], B7 = /* @__PURE__ */ z({
  __name: "MultiSelect",
  props: {
    allSelectedText: { default: "" },
    customOptionPlaceholder: { default: "" },
    displayedValueOfKey: { default: "name" },
    emptyListDefaultValue: { default: null },
    emptyListText: { default: "No item" },
    emptySearchResultText: { default: "No result" },
    hasAllSelectedState: { type: Boolean, default: !1 },
    hasCustomOption: { type: Boolean, default: !1 },
    isDisabled: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    modelValue: {},
    options: {},
    placeholder: { default: "Select" },
    position: { default: "bottom" },
    searchBarPlaceholder: { default: "Search item" },
    showSearchBar: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "loadMore", "search", "open", "close"],
  setup(e, { emit: t }) {
    const n = e, o = A(n.options), r = A(null), i = A(null), s = A(null), a = t, l = E(() => n.options.every(($) => $.listName)), u = E(() => {
      if (l.value)
        return o.value.reduce(($, k) => {
          var _;
          return $ + (((_ = k.options) == null ? void 0 : _.length) || 0);
        }, 0);
    }), c = A(n.modelValue), d = E(() => {
      var $, k;
      return l.value ? u.value === (($ = c.value) == null ? void 0 : $.length) : c.value.length === ((k = o.value) == null ? void 0 : k.length);
    }), p = ($) => {
      let k;
      $ === null ? k = [] : k = c.value.filter((_) => _.id !== $), c.value = k, a("update:modelValue", k);
    }, v = () => {
      if (!r.value)
        return;
      const k = { id: Math.max(0, ...n.options.map((M) => M.id || 0)) + 1, name: r.value, isCustom: !0 }, _ = [...c.value, k];
      c.value = _, a("update:modelValue", _), r.value = "";
    }, x = ($) => {
      $.target.scrollHeight - $.target.scrollTop === $.target.clientHeight && a("loadMore", s.value);
    }, b = E(() => c.value && n.emptyListDefaultValue && c.value.length === 0), h = E(() => {
      let $ = n.options.length ? [...n.options] : [];
      return n.emptyListDefaultValue && !s.value && (l.value ? $ = [{
        listName: null,
        emptyListPlaceholder: null,
        options: [n.emptyListDefaultValue]
      }, ...$] : $ = [n.emptyListDefaultValue, ...$]), $;
    }), S = ($) => {
      let k = [];
      if (n.emptyListDefaultValue && $.id === n.emptyListDefaultValue.id)
        k = [], a("update:modelValue", k), c.value = k;
      else {
        k = [...c.value], k = k.filter((U) => {
          var L;
          return U.id !== ((L = n.emptyListDefaultValue) == null ? void 0 : L.id);
        });
        const _ = k.findIndex((U) => U.id === $.id);
        _ !== -1 ? k.length === 1 ? (k = [], a("update:modelValue", k), c.value = k) : (k.splice(_, 1), a("update:modelValue", k), c.value = k) : (k.push($), a("update:modelValue", k), c.value = k);
      }
      return s.value = "", c.value;
    };
    he([() => n.options, () => n.emptyListDefaultValue, () => l.value], () => {
      h.value;
    }), he(
      () => n.modelValue,
      ($) => {
        c.value = $;
      }
    );
    const g = E(() => {
      var $;
      return (($ = o.value) == null ? void 0 : $.length) > 8 || u.value > 8 || n.showSearchBar;
    }), C = () => {
      a("open"), g.value && setTimeout(() => {
        i.value && i.value.focus();
      }, 50);
    }, w = () => {
      a("close");
    };
    return ae(() => {
      l.value, h.value;
    }), ($, k) => (f(), j(T(ko), {
      by: "id",
      as: "div",
      class: "relative w-full",
      multiple: ""
    }, {
      default: F(() => [
        B(T(Zr), {
          "data-disabled": $.isDisabled,
          disabled: $.isDisabled,
          class: O([
            $.isDisabled ? "border-gray-200 bg-gray-100 text-gray-400" : "cursor-pointer border-gray-300 bg-white text-gray-800",
            "relative w-full rounded-md border py-1.5 pr-10 text-left shadow-sm sm:text-sm sm:leading-6"
          ])
        }, {
          default: F(() => {
            var _;
            return [
              c.value && ((_ = c.value) == null ? void 0 : _.length) > 0 ? (f(), y("div", M2, [
                d.value && $.hasAllSelectedState ? (f(), y("div", T2, [
                  ce(R($.allSelectedText) + " ", 1),
                  B(T(bt), {
                    class: "ml-2 h-4 w-4 text-gray-400",
                    onClick: k[0] || (k[0] = ft((M) => p(null), ["prevent"]))
                  })
                ])) : (f(!0), y(K, { key: 1 }, se(c.value, (M, U) => (f(), y("div", {
                  key: U,
                  class: O([
                    "flex items-center rounded border bg-gray-100 px-2",
                    M.isDisabled ? "pointer-events-none text-gray-400" : ""
                  ])
                }, [
                  ce(R(M[$.displayedValueOfKey]) + " ", 1),
                  M.isDisabled ? P("", !0) : (f(), y("div", P2, [
                    B(T(bt), {
                      class: "ml-2 h-4 w-4 text-gray-400",
                      onClick: ft((L) => p(M.id), ["prevent"])
                    }, null, 8, ["onClick"])
                  ]))
                ], 2))), 128))
              ])) : b.value ? (f(), y("div", I2, [
                m("div", L2, [
                  ce(R($.emptyListDefaultValue[$.displayedValueOfKey]) + " ", 1),
                  B(T(bt), {
                    class: "ml-2 h-4 w-4 text-gray-400",
                    onClick: k[1] || (k[1] = ft((M) => p(null), ["prevent"]))
                  })
                ])
              ])) : (f(), y("div", D2, R($.placeholder), 1)),
              m("span", B2, [
                B(T(Gs), {
                  class: "h-5 w-5 text-gray-400",
                  "aria-hidden": "true"
                })
              ])
            ];
          }),
          _: 1
        }, 8, ["data-disabled", "disabled", "class"]),
        B(Gt, {
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0",
          onEnter: C,
          onLeave: w
        }, {
          default: F(() => [
            B(T(Eo), {
              class: O([
                "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm",
                {
                  "bottom-12": $.position === "top",
                  "px-2 pb-2": g.value,
                  "p-2": !g.value
                }
              ]),
              onScroll: x
            }, {
              default: F(() => [
                ze(m("div", z2, [
                  ze(m("input", {
                    ref_key: "searchInput",
                    ref: i,
                    "onUpdate:modelValue": k[2] || (k[2] = (_) => s.value = _),
                    type: "text",
                    placeholder: $.searchBarPlaceholder,
                    class: "focus:ring-none block min-h-4 w-full rounded-md border-solid border-gray-300 py-2 pl-10 text-sm placeholder:pl-2 placeholder:text-gray-400",
                    onKeyup: k[3] || (k[3] = (_) => a("search", s.value)),
                    onKeydown: [
                      k[4] || (k[4] = Yo(ft(() => {
                      }, ["stop"]), ["space"])),
                      k[5] || (k[5] = Yo(ft(() => {
                      }, ["stop"]), ["enter"]))
                    ]
                  }, null, 40, N2), [
                    [rn, s.value]
                  ]),
                  B(T(Ua), { class: "pointer-events-none absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 transform text-gray-200" })
                ], 512), [
                  [At, g.value]
                ]),
                $.options.length === 0 && !$.hasCustomOption && !$.emptyListDefaultValue ? (f(), j(T(In), {
                  key: 0,
                  as: "ul",
                  class: ""
                }, {
                  default: F(() => [
                    m("span", j2, R(s.value ? $.emptySearchResultText : $.emptyListText), 1)
                  ]),
                  _: 1
                })) : P("", !0),
                l.value ? (f(), j(T(Oa), { key: 1 }, {
                  default: F(() => [
                    (f(!0), y(K, null, se(h.value, (_, M) => (f(), y("div", { key: M }, [
                      m("span", V2, R(_.listName), 1),
                      _.options.length < 1 ? (f(), y("p", F2, R(_.emptyListPlaceholder), 1)) : P("", !0),
                      (f(!0), y(K, null, se(_.options, (U) => (f(), j(Vs, {
                        key: U.id,
                        option: U,
                        "selected-options": c.value,
                        "displayed-value-key": $.displayedValueOfKey,
                        "empty-list-default-value": $.emptyListDefaultValue,
                        onOnOptionSelected: (L) => S(U)
                      }, null, 8, ["option", "selected-options", "displayed-value-key", "empty-list-default-value", "onOnOptionSelected"]))), 128))
                    ]))), 128))
                  ]),
                  _: 1
                })) : (f(!0), y(K, { key: 2 }, se(h.value, (_) => (f(), j(Vs, {
                  key: _.id,
                  option: _,
                  "selected-options": c.value,
                  "displayed-value-key": $.displayedValueOfKey,
                  "empty-list-default-value": $.emptyListDefaultValue,
                  onOnOptionSelected: (M) => S(_)
                }, bu({ _: 2 }, [
                  $.$slots.option ? {
                    name: "default",
                    fn: F((M) => [
                      G($.$slots, "option", _t({ ref_for: !0 }, M))
                    ]),
                    key: "0"
                  } : void 0
                ]), 1032, ["option", "selected-options", "displayed-value-key", "empty-list-default-value", "onOnOptionSelected"]))), 128)),
                $.hasCustomOption && !l.value ? (f(), y("li", H2, [
                  ze(m("input", {
                    "onUpdate:modelValue": k[6] || (k[6] = (_) => r.value = _),
                    type: "text",
                    placeholder: $.customOptionPlaceholder,
                    class: O([
                      "block w-full rounded-md border border-solid border-gray-300 shadow-sm placeholder:text-gray-800 sm:text-sm",
                      `${T(W)({ type: "ring", value: "400", prefix: "focus" })} ${T(W)({
                        type: "border",
                        value: "400",
                        prefix: "focus"
                      })}`
                    ]),
                    onKeydown: [
                      Yo(ft(v, ["prevent"]), ["enter"]),
                      k[7] || (k[7] = (_) => _.stopPropagation())
                    ]
                  }, null, 42, U2), [
                    [
                      rn,
                      r.value,
                      void 0,
                      { trim: !0 }
                    ]
                  ])
                ])) : P("", !0),
                $.isLoading ? (f(), j(wr, {
                  key: 4,
                  type: "default"
                })) : P("", !0)
              ]),
              _: 3
            }, 8, ["class"])
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), Yn = A("blue");
function W2() {
  const e = (o, r) => {
    const i = yu(r);
    document.documentElement.style.setProperty(`--color-${o}`, `${i == null ? void 0 : i.r}, ${i == null ? void 0 : i.g}, ${i == null ? void 0 : i.b}`), document.documentElement.style.setProperty(`--color-${o}-hover`, `${i == null ? void 0 : i.r}, ${i == null ? void 0 : i.g}, ${i == null ? void 0 : i.b}, .75`);
  }, t = (o) => o != null && o.primary ? "primary" : o != null && o.theme ? o.theme : "blue";
  return {
    getColor: t,
    setColor: (o) => (o != null && o.primary && e("primary", o.primary), o != null && o.secondary && e("secondary", o.secondary), Yn.value = t(o), xe("$themeColor", Yn), Yn),
    themeColor: Yn
  };
}
const z7 = {
  install: (e, t) => {
    const n = t == null ? void 0 : t.colors, { setColor: o } = W2(), r = o(n);
    e.provide("$themeColor", r), e.config.globalProperties.$pongoNotification = (i, s) => {
      gt.dispatch(`notification/${i}`, s);
    }, e.component("PongoNotification", Eb);
  }
};
export {
  X2 as BrickAdvancedCard,
  w7 as BrickBackLink,
  dp as BrickBadge,
  Y2 as BrickCard,
  S7 as BrickChip,
  b7 as BrickCodeValidator,
  cp as BrickContainer,
  x7 as BrickCopyBox,
  K2 as BrickCountryDropdown,
  m7 as BrickDisclosure,
  C7 as BrickDisclosureGroup,
  Zd as BrickDropdown,
  B7 as BrickFormMultiSelect,
  D7 as BrickFormTextarea,
  Q2 as BrickProductCard,
  y7 as BrickQrCode,
  $7 as BrickReward,
  v7 as BrickSpinner,
  J2 as BrickSwitch,
  Hi as BrickTag,
  k7 as BrickTextareaWithVars,
  g7 as BrickTitle,
  l7 as PongoAlbum,
  i7 as PongoBreadcrumb,
  rt as PongoButton,
  t7 as PongoConfirmButton,
  r7 as PongoDetailTitle,
  n7 as PongoDownloadCsvButton,
  _7 as PongoFormCheckbox,
  R7 as PongoFormColorPicker,
  L7 as PongoFormEmojiPickerInput,
  I7 as PongoFormGooglePlace,
  T7 as PongoFormImageUploader,
  Py as PongoFormInput,
  A7 as PongoFormMaskInput,
  M7 as PongoFormRadio,
  P7 as PongoFormSelect,
  a7 as PongoHeadline,
  wr as PongoLoader,
  G2 as PongoModal,
  Eb as PongoNotification,
  qi as PongoPagination,
  u7 as PongoPopover,
  Dl as PongoPopperTooltip,
  c7 as PongoProgressBar,
  p7 as PongoRadioGroup,
  f7 as PongoSelector,
  h7 as PongoSelectorItem,
  s7 as PongoTab,
  e7 as PongoTable,
  d7 as PongoTip,
  o7 as PongoTooltip,
  z7 as default,
  vb as useNotification,
  W2 as useTheme
};
